let langEN = {
  add: "Add",
  after: "After",
  app: "Applications",
  activated: "Enabled",
  stoped: "Stopped",
  all: "All",
  allMember: "All members",
  avg: "Average",
  array: "Array",
  allow: "Allow",
  abuseReport: "Report abuse",
  ascending: "Ascend",
  average: "average",
  back: "Back",
  backTo: "Back to ",
  batchAdd: "Batch add",
  batchEdit: "Batch edit",
  before: "Before",
  bind: "Bind",
  between: "Between {{begin}} and {{end}}",
  bold: "Bold",
  batchOperation: "Batch ops",
  briefing: "Briefing",
  cancel: "Cancel",
  checked: "Checked",
  china: "China",
  city: "City",
  close: "Close",
  clear: "Clear",
  clearConfig: "Clear config",
  clearLink: "Unlink",
  collect: "Put up",
  color: "Color",
  comment: "Comment",
  config: "Config",
  contact: "Contact",
  contacts: "Contacts",
  copy: "Copy",
  generate: 'Generate',
  copies: "{{- name}}_copy",
  count: "Count",
  county: "County",
  current: "Current",
  custom: "Customize",
  chart: "Chart",
  data: "Data",
  dataSource: "Data source",
  date: "Date",
  change: "Change",
  datetime: "Date & time",
  detail: "Detail",
  displayName: "Display name",
  create: "Add",
  createDate: "Create date",
  dash: "Report",
  dashboard: "Applications",
  "go.dashboard": "Back to dashboard",
  day: " ",
  days: "Days",
  deal: "Deal",
  defaults: "Default value",
  default: "Default",
  delete: "Delete",
  deleted: "Deleted",
  description: "Description",
  dingtalk: "DingTalk",
  done: "Done",
  doned: "Done",
  disabled: "Disabled",
  disable: "Disable",
  district: "District",
  download: "Download",
  dynamic: "Feed",
  dynamicEmpty: "No news",
  dynamicParameter: "Dynamic",
  dynamicNotifier: "Dynamic",
  department: "Department",
  descending: "Descend",
  error: "Error",
  line: "Row",
  lineHeight: "Row Height",
  height1: "Height",
  middle: "Middle",
  low: "Low",
  adaptive: 'Adaptive',
  auto: "Auto",
  Left: "Left ",
  "subform.mobile.mode": "Mobile Style",
  "chinese.descending": "Descend by Chinese",
  "ascii.descending": "Descend by Ascii",
  "chinese.ascending": "Ascend by Chinese ",
  "ascii.ascending": "Ascend by Ascii ",
  earliest: "Earliest",
  excel: "Worksheet",
  etl: "Data view",
  edit: "Edit",
  qickedit: 'Quick Edit',
  'qickedit.open': 'Open Quick Edit',
  'qickedit.close': 'Close Quick Edit',
  'data.manager.qickedit': 'After opening the shortcut edit, in the data management interface, editing data does not trigger the formula linkage extension validation',
  editable: "Editable",
  equal: "Equal",
  empty: "Empty",
  emptyValue: "Empty value",
  enabled: "Enabled",
  enable: "Enable",
  export: "Export",
  explain: "Explanation",
  expr: "Expression",
  every: "Every",
  exemption: "Limit Exemption",
  fail: "Fail",
  field: "Field",
  filter: "Filter",
  fixedChars: "Fixed characters",
  fontFamily: "Font family",
  fontSize: "Font size",
  format: "Format",
  formerName: "Original name：{{- name}}",
  formula: "Formula",
  functionIntro: "Feature introduction",
  future: "Future",
  free: "Trial",
  email: "Email",
  already: "Already",
  fullScreen: "Full screen",
  exitfullScreen: "Exit Full screen",
  fx: "Platform",
  form: "Form",
  gather: "Summary",
  goHome: "Back home",
  goImport: "Continue importing",
  group: "Group",
  halfLine: "1/2 line",
  help: "Help",
  helpCenter: "Help center",
  hide: "Hide",
  home: "Home",
  hongkong: "Hong Kong, China",
  hour: "Hour",
  IDNum: "ID number",
  iSee: "I see",
  import: "Import",
  invite: "Invite",
  incNumber: "Auto count",
  italic: "Italic",
  language: "Language",
  label: "Label",
  latLng: "Latitude：{{latitude}}, longitude：{{longitude}}",
  learnMore: "Learn more",
  leaveNotSaveTip: "After leaving the current page, the changes you made will not be saved",
  latest: "Latest",
  layout: "Layout",
  legend: "Legend",
  loading: "Loading...",
  loadMore: "Load more",
  log: "Log",
  source: "Source",
  more: "More",
  move: "Move",
  macao: "Macao, China",
  max: "Max",
  min: "Min",
  mingdao: "Mingdao",
  minute: "Minute",
  meaning: "Meaning",
  member: "Member",
  outsider: "External Contact",
  outsiderGroup: "External Contact Group",
  meter: "M",
  meters: "{{meters}}m",
  mobileNum: "Phone number",
  modify: "Edit",
  modifyConfig: "Edit config",
  manager: "Admin",
  money: "Money",
  month: "Month",
  months: "Month(s)",
  must: "Must",
  name: "Name",
  nextStep: "Next",
  new: "Create",
  navigator: "Navigator",
  nickname: "Nickname",
  nothing: "None",
  notSupport: "Do not support",
  support: "Support",
  off: "off",
  official: "Official",
  ok: "Ok",
  on: "on",
  openBrowser: "Open in Browser",
  openDashboard: "Open applications",
  operationSuccess: "Operation success",
  operationFailed: "Operation failed",
  open: "Open",
  openLink: "Public link",
  operator: "Operator",
  option: "Option",
  optional: "Optional",
  or: "Or",
  organization: "Organization",
  other: "Other",
  'other.ext': "<Other>",
  print: "Print",
  pause: "Pause",
  paused: "Paused",
  qrCode: "Qr code",
  query: "search",
  querying: "searching...",
  past: "Past",
  colorful: "Colorful",
  params: "Parameters",
  password: "Password",
  passForget: "Forget password",
  passReset: "Reset password",
  emailPassReset: "Email Reset password",
  phonePassReset: "Phone Reset password",
  preview: "Preview",
  previewFail: "Preview failed",
  province: "Province",
  phone: "Phone",
  'phone.email': "Phone/Email",
  "phone.code.qr.tip": "Mobile phone scan code upload",
  prevStep: "Previous",
  quarter: "Quarter",
  read: "Read",
  recover: "Recover",
  remove: "Remove",
  redo: "Redo",
  refresh: "Refresh",
  release: "Publish",
  rename: "Rename",
  "rename.group": "Rename Group",
  "delete.group": "Delete Group",
  renew: "Renew",
  resigned: "Deleted",
  robot: "Robot",
  role: "Role",
  required: "Required",
  report: "Report",
  reselect: "Reselect",
  reimport: "Reimport",
  save: "Save",
  "save.as": "Save as",
  scanCode: "Scan qr code",
  search: "Search",
  second: "Second",
  share: "Share",
  searching: "Searching...",
  select: "--select--",
  selectAll: "Select all",
  selectAllSearchResult: "Select all search result",
  send: "Send",
  setting: "Setting",
  settingDone: "Setting done",
  server: "Server",
  show: "Show",
  signin: "Sign in",
  signout: "Sign out",
  signup: "Sign up",
  sinaWeibo: "Weibo",
  skip: "Skip",
  state: "Status",
  submit: "Submit",
  sum: "Sum",
  success: "Success",
  sort: "Sort",
  'sort.value.same': "Sort by same value",
  tax: "Tax",
  taiwan: "Taiwan, China",
  talkLater: "Later",
  telNum: "Phone number",
  text: "Text",
  tencentQQ: "QQ",
  time: "Datetime",
  times: "Times",
  timeBegin: "Start time",
  timeEnd: "End time",
  timeout: "Timeout",
  timestamp: "Timestamp",
  title: "Title",
  today: "Today",
  total: "Total",
  transparent: "Transparent",
  translate: "Convert",
  type: "Type",
  unbind: "Unbind",
  unbindqywx: "Unbind WeChat Work",
  unchecked: "Unchecked",
  underline: "Underline",
  undo: "Undo",
  unbindSuccess: "Unbind success",
  unbindFail: "Unbind fail",
  unfilled: "Unfilled",
  unknown: "Unknown",
  unlimited: "Unlimited",
  unnamed: "Unnamed",
  unnamedData: "Unnamed data",
  unread: "Unread",
  update: "Update",
  updated: "Updated",
  updater: "Updater",
  upgrade: "Upgrade",
  username: "Username",
  use: "Use",
  validate: "Validate",
  validCode: "Valid code",
  variable: "Variable",
  verify: "Verify",
  view: "View",
  visible: "Visible",
  wework: "Wechat Work",
  wechat: "WeChat",
  "wechat.enhance.title": "WeChat enhancement",
  "wechat.enhance.desc": "After opening, only support to fill in WeChat, you can get the WeChat information of the person who filled it. It is only suitable for the scenarios where the form outside chain and the form inside chain directly access the link",
  "wechat.enhance.getEditorInfo": "Get the information of the person who filled in",
  "wechat.enhance.notice": "Note: Obtain information through WeChat public account ",
  "wechat.enhance.get.automatic": "Silent acquisition",
  "wechat.enhance.get.automatic.tooltip": "Fill in the form directly, the background automatically obtains, only obtains WeChat OpenID",
  "wechat.enhance.get.fromDialog": "Popup",
  "wechat.enhance.get.fromDialog.tooltip": "A window will pop up to request authorization before filling in the form, and after confirmation by the person filling in, you can get WeChat personal information",
  "wechat.enhance.scan.fill": "Please use WeChat scan code to fill in",
  wechatQRCode: "Please log in using Wechat Scanning QR Code",
  week: "Week",
  when: "When",
  wholeLine: "Whole line",
  widget: "Field",
  widgetName: "Field name",
  year: "Year",
  years: "Years",
  yes: "Yes",
  zipCode: "Zip code",
  zoomIn: "Zoom in",
  zoomOut: "Zoom out",
  top: "Top",
  bottom: "Bottom",
  left: "Left",
  right: "Right",
  "account.setting": "Account setting",
  "account.bind": "Account binding",
  "account.fx.bind": "Bind an  existing account",
  "account.mode": "Account mode",
  "account.mode.weChat": "WeChat Work integration mode",
  "account.mode.dingTalk": "DingTalk integration mode",
  "account.mode.public": "Public mode",
  "account.info.update.fail": "Fail to update account information",
  "account.unbind": "Unbind account",
  "account.unbind.confirm": "Are you sure to unbind the {{type}} account?",
  "account.cancel": "Close corporate account",
  "account.cancel.apply": "Corporate account closing request",
  "account.cancel.apply.publicLetter": "Apply for an official letter",
  "account.cancel.apply.publicLetter.name": "Cancellation application letter template",
  "account.cancel.apply.publicLetter.download": "Please download {{- link}} first, fill in and affix the official seal,then take a photo and upload.",
  "account.cancel.warning": "Closing the corporate account will clear Contacts， the existing data and apps which can not be recovered. Operate with Caution!",
  "account.cancel.tip": "If you are sure to close the account, please fill in the following information carefully, we will contact you within 3 working days and complete the follow-up work of closing the account, please keep your phone available.",
  "account.cancel.success.tip": "You have submitted a cancellation request, we will contact you within 3 working days and complete the follow-up work of closing the account, please keep your phone available.",
  "account.cancel.reason": "Account closing reason",
  "account.passForget.login": "Back to sign in",
  "account.passForget.loginName.placeholder": "Use your phone or email When signing up",
  "account.passForget.loginName.errTip": "Phone number/email error",
  "account.passReset.success": "Reset success",
  "account.passReset.fail": "Fail to reset password!",
  "account.passReset.login": "Sign in now",
  "account.passReset.newPass.placeholder": "New Password, at least 6 characters",
  "account.register.account": "Sign up a account",
  "account.register.captcha.placeholder": "Captcha",
  "account.register.phone.errTip": "Incorrect phone number",
  "account.register.email.errTip": "Incorrect email",
  "account.register.email.placeholder": "Please enter your email",
  "account.register.hasAccount": "Already have a account?",
  "account.register.incomplete": "Registration information incomplete!",
  "account.register.invite.guide": "There are no members on your team, invite members now to work together",
  "account.register.password.placeholder": "Password, at least 6 characters",
  "account.register.phone.placeholder": "Your phone number",
  "account.register.readAccept": "By clicking sign up, you have read and agree to",
  "account.register.signin": "Sign in directly",
  "account.register.success": "Registration success",
  "account.register.switch.email": "Can not sign up with phone number? Click here",
  "account.register.switch.phone": "Can not sign up with email? Click here",
  "account.register.term": "Terms of service",
  "account.register.userName.errTip": "Username supports letters, numbers, and underscore, which needs to start with letter and require at least 3 characters",
  "account.register.phone.exist": "The phone number already exists, please log in directly",
  "account.register.validCode.placeholder": "Received valid code",
  "account.signin.account": "Sign in",
  "account.signin.dingtalk": "DingTalk",
  "account.signin.wechat": "WeChat Work",
  "account.signin.wechat1": "Wechat Index",
  "account.signin.sso": "Single Sign On",
  "account.signin.sso.tip": "Please configure after single sign-on and then check",
  "account.signin.autoSignin": "Remember me",
  "account.signin.forgetPass": "Forgot password?",
  "account.signin.hasNoAccount": "No account yet? ",
  "account.signin.register": "Sign up now",
  "account.signin.otherAccount": "More sign",
  "account.signin.wechatOpenTip": "No WeChat Work account yet？",
  "account.signin.dingtalkOpenTip": "No DingTalk account yet？",
  "account.signin.corpOpen": "Create new account",
  "account.signin.qrcode": "Click to sign in with QR code",
  "account.signin.signinWithFX": "Sign in with general account",
  "account.signin.user.placeholder": "Phone number/email/username",
  "account.signin.user.emptyTip": "Please enter phone number/email/username",
  "account.signin.phone.email": "Please enter phone number/email number",
  "account.signin.failTip": "Incorrect username or password",
  "account.signin.wework.member": "Member",
  "account.signin.wework.admin": "Administration",
  "account.signin.banner.text": "Click to get \"Device Management 2.0\" scheme",
  "account.signinCorp.dingtalkTitle": "Use DingTalk scanning QR code to sign in the corporate application system",
  "account.signinCorp.wechatTitle": "Use WeChat Work scanning QR code to sign in the corporate application system",
  "account.success.teamJoin": "You've joined the team",
  "account.success.enter": "Enter",
  "account.info": "My account information",
  "align.top": "Top align",
  "align.center": "Center align",
  "align.bottom": "Bottom align",
  "align.left": "Left align",
  "align.right": "Right align",
  "repeat.tip": 'This content already exists, duplicate submissions are not allowed',
  "validate.tip": 'Please fill in correctly【{{name}}】',
  "api.aliasOrId": "Field alias/field id",
  "api.alias.format.tip": "There is a format error",
  "api.alias.notSaveTip": "After leaving the current page, your settings will not be saved",
  "api.alias.reserve.tip": "There exists reserved words ",
  "api.alias.repeat.tip": "There exists duplicate values",
  "api.alias.set": "Set field alias",
  "api.alias.set.tip": "Use field alias to replace field id when delivering data, sending API requests and returning response data",
  "api.alias.rule.lowercase": "Lowercase",
  "api.alias.rule.number": "Digits",
  "api.alias.rule.underline": "Underline",
  "api.alias.set.info": "Field aliases are only allowed to be combined with {{- lowercase}}, {{- number}} and {{-underline}}, and must begin with {{-begin}}",
  "api.auth": "Authentication method",
  "api.auth.token": "Use a simple token for authenticate {{- where}}, APIKey is not generated by default, click {{- button}} to generate. Generate method: {{- step1}} >> {{- step2}} >> {{- step3}}, click {{- document}} on the right to view the corresponding API documentation.",
  "api.auth.genTokenInAccount": "(generate or manage your APIKey in the Account Center)",
  "api.auth.key": "API Key",
  "api.auth.key.reset": "You can also reset or delete the generated APIKey.",
  "api.auth.setHttpHeaders": "Set {{- auth}} value as {{- yourKey}} by HTTP Headers for security authentication",
  "api.auth.example": "For example:",
  "api.auth.warning": "Please note that API key has the same permissions as your account, be sure to keep it confidential!",
  "api.create": "Create single data api",
  "api.createData": "Create data",
  "api.create.desc": "Add a piece of data to the specified form",
  "api.CeateKey": "Create API Key",
  "api.CeateKey.success": "Create successfully",
  "api.doc": "API document",
  "api.doc.alias.idNotChange": 'Once added, the widget will be represented by a fixed widget id prefixed with "_widget_". The widget id will not change regardless of how you modify the widget.',
  "api.doc.alias.set": "Each widget has a corresponding field. Users can set their own {{- alias}}. {{- setTip}}",
  "api.doc.alias.set.tip": "If an alias is set, in all subsequent APIs, the {{- widgetAlias}} will be used as the actual field name of the widget, else {{- widgetId}} will be used.",
  "api.desc": "You can integrate data with other external data through the API we provide.",
  "api.delete": "Delete single data api",
  "api.delete.desc": "Delete data from the form according to the specified data id , and the deleted data will enter the recycle bin.",
  "api.deleteData": "Delete data",
  "api.selectApp": "Please select an app to view API documentation",
  "api.error.example": "When the status code is 400, the server will return the specific error code and error message, the code table is as follows:",
  "api.error.table": "Error code table",
  "api.error.table.tip": "All API use {{- code}} response method to indicate the cause of the error. The returned response HTTP status code is {{- successCode}} if correct. The returned response HTTP status code is {{- errorCode400}} if error, {{- errorCode}} and {{- errorMessage}} will be returned as well",
  "api.error.table.example": "The status code table is as follows:",
  "api.error.statusCode": "Status code",
  "api.error.res": "Error code will be returned",
  "api.error.code": "Code",
  "api.error.2009": "No app operate permission",
  "api.error.3005": "Parameter is incorrect",
  "api.error.4000": "Data submission failed",
  "api.error.4001": "Data does not exist",
  "api.error.8301": "Signature verification failed",
  "api.error.8302": "No permissions to access the API",
  "api.error.8303": "Request frequency limits are exceeded",
  "api.error.statusAndErrorCode": "Code + message",
  "api.error.message": "Message",
  "api.key.view.click": "Click to view API Key",
  "api.getMultiData": "Get multiple data",
  "api.getOneData": "Get single data",
  "api.intro": "Introduction",
  "api.key.reset": "Reset API Key",
  "api.key.reset.confirm": "Are you sure to reset API Key?",
  "api.key.reset.tip": "After resetting API key, the existing API will stop working.",
  "api.key.reset.success": "Reset successfully",
  "api.key.delete": "Delete API Key",
  "api.key.delete.confirm": "Are you sure to delete API Key?",
  "api.key.delete.tip": "After deleting API key, the existing API will stop working.",
  "api.key.warning": "Please note that API key has the same permissions as your manager account, be sure to keep it confidential!",
  "api.key.auth": "Security authentication",
  "api.key.auth.tip": "To ensure information security, please enter your sign in password",
  "api.limit": "Frequency limit",
  "api.limit.num": "5 times/sec",
  "api.notSupport": "In addition, the system fields and the fields listed below{{- notSupport}} adding and editing data: ",
  "api.notSupport.file": "Image, attachment, signature",
  "api.notSupport.link": "Link data, link query",
  "api.overview": "The following API documentation is built specifically for you based on the configuration of the current form, providing a complete sample data structure and request path. If you delete/add a widget or modify the widget title, the relative information of the widget in that document will update accordingly.",
  "api.params.data": "Data content",
  "api.params.desc.dataId": "The id of the last piece of data of the queried results last time, if it is blank, left empty",
  "api.params.desc.fields": "Data field that need to be queried",
  "api.params.desc.data": "Data content, the same as data submission",
  "api.params.desc.filter": "Data filter",
  "api.params.desc.items": "Only in subform widgets; he array contains information for each subform widget",
  "api.params.desc.isTriggerFlow": "It is used to field whether to trigger the flow，the flow is not triggered by default.",
  "api.params.desc.isStartTrigger": "It is used to field whether to start the trigger, the trigger is not started by default.",
  "api.params.desc.limit": "The amount of data queried, can be 1 to 100, 100 by default",
  "api.params.desc.name": "Field name、field id(you can set field alias)",
  "api.params.desc.title": "Widget title",
  "api.params.desc.type": "Widget type; each widget type has a corresponding data type",
  "api.query": "Query multiple data api",
  "api.query.desc": "The return data of this API will always be {{- order}}.",
  "api.query.order": "In positive order of submission time",
  "api.query.single": "Query single data api",
  "api.query.single.desc": "Get the data in the form according to the specified data id.",
  "api.req.example": "Request example: ",
  "api.req.params": "Request parameter: ",
  "api.req.noParams": "Request parameter: none",
  "api.res": "Response content: ",
  "api.res.example": "Response data sample: ",
  "api.res.getFields": "Each form widget represents a field, and the field id does not change as long as the widget is not deleted.",
  "api.res.order": "Sort in ascending order by data id",
  "api.res.success": "Respond successfully",
  "api.rule": "Rule:",
  "api.rule.host": "The base url is",
  "api.rule.https": "All API requests must be authenticated and initiated via HTTPS",
  "api.rule.post": "All requests should use the post method",
  "api.rule.utf8": "The transfer-Encoding is UTF-8",
  "api.rule.json": "All data are in JSON format",
  "api.supply.phoneAndPass": "Please provide your phone and password",
  "api.supply.phoneAndPass.tip": "API key has the same permissions as your manager account, for the security of your account，please bind your phone and set password first.",
  "api.update": "Edit single data api",
  "api.updateData": "Edit data",
  "api.update.desc": "Edit data in the form according to the specified data id.",
  "api.warning": 'Please note that once a widget is added, the fixed widget id prefixed with "_widget_" will not change.',
  "api.widget.info": "Widget information",
  "api.widget.alias": "Field alias",
  "api.widget.linkquery": "Link query widget",
  "api.widget.separator": "Separator widget",
  "api.widget.valueTable": "Widget and data type comparison table",
  "api.widgets": "Widget query API",
  "api.widgets.desc": "Get the widgets information for the specified form, except {{- separator}} and {{- linkquery}}. You can refer to {{- widgetsTable}} for details.",
  "app.category.quickStart": "Novice",
  "app.category.rank": "Recommended",
  "app.category.application": "Usage",
  "app.category.common": "Industry",
  "app.category.feature": "Feature",
  "app.category.it": "IT",
  "app.category.manufacturing": "Manufacture",
  "app.category.trade": "Retail trade",
  "app.category.service": "Service",
  "app.category.education": "Education",
  "app.category.housing": "Housing",
  "app.category.financial": "Financial",
  "app.category.medicine": "Medicine",
  "app.category.government": "Government",
  "app.category.logistics": "Logistics",
  "app.category.businessService": "Commerce",
  "app.category.hr": "Hr",
  "app.category.audit": "Audit",
  "app.category.office": "Office",
  "app.category.inventory": "Inventory",
  "app.category.store": "Store",
  "app.category.crm": "Crm",
  "app.category.sales": "Sales",
  "app.category.project": "Project",
  "app.category.production": "Production",
  "app.category.assetEquipment": "Equipment",
  "app.category.formula": "Formula",
  "app.category.flow": "Flow",
  "app.category.aggregate": "Aggregate",
  "app.category.print": "Print",
  "app.category.dataRely": "Data linkage",
  "app.category.dataAuth": "Data permissions",
  "app.category.dataAuth1": "Data",
  "app.category.notify": "Publishi notification",
  "app.category.association": "Option association",
  "app.category.dataSubmit": "Submission Ext",
  "app.category.signature": "Signature",
  "app.category.dashboard": "Report",
  "app.list": "App list",
  "app.set.share": "Publish form/report",
  "app.set.auth": "Report data permissions",
  "app.set.bridge.emptyTip": "Please select the form that needs to be used cross-app",
  "app.set.url": "App url",
  "app.set.url.tip": "Custom app url, can be used to open the app directly",
  "app.set.url.placeholder": "Please enter the url",
  "app.set.entry": "1. select form/report",
  "app.set.auth.fail1": "Permission acquisition failed!",
  "app.set.auth.fail2": "Please select the page you want to authorize first!",
  "app.set.filter.tip": "Add filter condition to create a data view of the report",
  "app.set.save.fail1": "The app name cannot be empty!",
  "app.set.save.fail2": "The app url contains illegal characters!",
  "app.set.auth.tip": "Member not in the list? click to sync members",
  "app.set.range": "2.select share targets",
  "app.set.data.auth.member": "1.select department/member",
  "app.set.data.auth.filter": "2.set filter condition",
  "app.mine": "My Apps",
  "my.app": "My Apps",
  "dash.mine": "My charts",
  "dash.mine.empty": "No charts",
  "dash.favorites.empty": "No favorites",
  "form.theme.imageMore.center": "The original image is in the center",
  "form.theme.imageMore.centerCover": "Center fill",
  "form.theme.imageMore.stretchCover": "Stretch filling",
  "dash.image.position": "filling method",
  "image.upload.rules":'Support jpg, jpeg, png, gif format, a single sheet less than 5M',
  "image.upload.rules.one": 'Support jpg, jpeg, png, gif format, a single sheet less than {{count}} M',
  "image.upload.length.rules": 'No more than 10 images',
  "image.upload.size.rules": 'more than 5M',
  "image.upload.size.rules.one": 'more than {{count}}M',
  "image.between.rotations": "Interval between rotations",
  "dash.image.automatic.seeding":"Automatic wheel seeding",
  "app.carousel.map": "carousel map",
  "app.recent.use": "recent use",
  "app.rich.text": "rich Text",
  "app.notice.board": "notice board",
  "app.favorites": "Favorites",
  "app.favorites.tip": "Favorite",
  "app.favorites.cancel": "Unfavorite",
  "app.favorites.fail": "Favorite is invalid",
  "app.favorites.max.tip": "Can only collect up to {{count}} favorites",
  "app.template.owned": "My app templates",
  "app.notFound": "Application does not exist or does not have access permission, please contact the team administrator",
  "app.dotGuide.appList": "The app created is displayed here. Click to enter app management",
  "app.create": "Create an app",
  "app.create.new": "Create a new app",
  "app.empty": "There is currently no accessible app",
  "app.empty.tip": "You don't currently have an app, please go to the Applications to create an app",
  "app.empty.tip.creatOwnCorp": "You do not currently have any team, please create",
  "app.create.tip": "Please contact your manager to share form/report with you",
  "app.create.empty": "Create a blank app",
  "app.create.empty.tip": "Create a new app from scratch",
  "app.create.fromTemplate": "Create in template center",
  "app.create.fromTemplate.tip": "Install template, start work quickly",
  "app.custom": "Customize app",
  "app.custom.tip": "Personalize for you",
  "app.manage": "Manage app",
  "app.install.report.convert": "App is successfully installed and reports are upgraded to reports at installation time",
  "app.install.guide": "Click to install app",
  "app.installing": "App is installing...",
  "app.name": "App name",
  "app.name.update.fail": "Fail to change the name!",
  "app.copy": "Copy app",
  "app.copy.confirm": 'Do you want to copy "{{- name}}"?',
  "app.copy.tip": "The duplicate copies the app's forms, reports, etc，but does not copy in-app data",
  "app.copy.success": "App has been copied",
  "app.copy.fail": "Fail to copy app",
  "app.delete": "Delete app",
  "app.delete.success": "App has been deleted",
  "app.delete.warning": "Delete the app will delete the form, report and data within, which cannot be restored.",
  "app.delete.warning.extraFunc": "There is a form referred to by {{- func}} feature. Deleting an app will also delete forms, reports, data, and the data permissions for the form, which can not be restored.",
  "app.delete.typeName": "If you determine the deletion, please enter the app name: ",
  "app.desc": "App description",
  "app.desc.placeholder": "Please enter the corresponding description to help other users understand the app's function",
  "app.style.edit": "Custom style",
  "app.state.review": "Auditing",
  "app.publish.template": "Publish to Template Center",
  "app.publish.enable.tip": "Disabled report will not be published to Template Center, enable the report first if it need to be published",
  "app.publish.continue": "Continue to publish",
  "app.cannot.publish": "This app can not be published to Template Center.",
  "app.publish.template.confirm": "Are you sure to publish this app to Template Center?",
  "app.publish.template.fail": "Fail to publish app!",
  "app.publish.template.tip": "The app and part of its data will be submitted to Template Center, if you don't want to make the current data public，please copy this app and prepare sample data before publishing.",
  "app.publish.noLongerDisplay": "Do not show again",
  "app.review.tip": "This app is under review, please wait…",
  "app.noAuth.operate": "You do not have app operation permissions",
  "app.noAuth.visit": "You do not have access to this app",
  "app.noAuth.visit.tip": "There are no auth in the current corp {{corp}}. Please contact the administrator to assign privileges or switch to another corp.",
  "app.deleted.tip": "The app has been deleted, go to Applications",
  "app.visit.enter": "Enter app view mode",
  "app.edit.enter": "Enter app edit mode",
  "app.trial": "{{day}} day(s) {{hour}} hour(s) {{minute}} minute(s) left",
  "app.trial.tip": "Advanced features will be counted in usage after the trial ends",
  "auth.group": "Permission group",
  "auth.group.empty": "No related permission group",
  "auth.group.submit.name": "Submit data",
  "auth.group.submit.description": "Members in this group can only submit data, and members that have been shared with this page will automatically join this group.",
  "auth.group.manage.name": "Manage all",
  "auth.group.manage.description": "Members in this group can manage all the data",
  "auth.group.manage.description.dash": "Members in this group can manage all data and have all menu permissions",
  "auth.group.manage.description.dash.chart": "Members in this group can view all data and have all menu permissions",
  "auth.group.review.name": "View all",
  "auth.group.review.description": "Members in this group can view all the data",
  "auth.group.manageOwn.name": "Manage own",
  "auth.group.manageOwn.description": "Members in this group can manage data submitted by themselves",
  "auth.group.manageOwn.description.dash": "Members in this group can manage their own data and have all menu permissions",
  "auth.group.manageOwn.description.chart": "Members in this group can view their own data and have all menu permissions",
  "auth.group.deleteTip1": "This permission group has more than one member,",
  "auth.group.deleteTip2": "After deletion, the permission group will expire and cannot be restored",
  "app.set": "App settings",
  "app.group": "App Group",
  "app.log": "App log",
  "app.defaultName": "Unnamed app",
  "app.edit.group.create": "New group",
  "app.edit.group.placeholder": "Please enter group name",
  "app.edit.group.fail1": "Fail to create group",
  "app.edit.group.fail2": "Group Info can not be empty",
  "app.edit.group.fail3": "Failed to get group information",
  "app.edit.group.empty": "--no group--",
  "app.edit.group.deleteTip": "Non-empty group can not be deleted!",
  "app.edit.group.moveTo": "Move to 「{{- groupName}}」",
  "app.edit.sequenceChange": "Manual sort",
  "app.edit.sequenceDone": "Finish sort",
  "app.edit.move.success": "Move successfully",
  "app.edit.folder.select": "Please select the target folder",
  "app.edit.menu.guideTip": "Support drag and drop sorting",
  "app.edit.exist": "Created",
  "app.edit.coopForm.create": "Create form",
  "app.edit.coopForm.createTip": "Form is used to collect data. It features collaboration, and can be used for report",
  "app.edit.flowForm.create": "Create flow form",
  "app.edit.flowForm.createTip": "Flow form is used for reimbursement, leave request and other workflow",
  "app.edit.dash.create": "Create report",
  "app.edit.dash.createTip": "Report is a data visualization tool, suitable for data presentation and analysis",
  "app.edit.report.create": "Create report",
  "app.edit.report.createTip": "Report is used for aggregation, presentation and trend analysis, etc.",
  "app.edit.formCreate.empty": "Create blank form",
  "app.edit.formCreate.excel": "Create form from Excel",
  "app.edit.toCoopForm": "Switch to form",
  "app.edit.toCoopForm.msg": "Switch to form, flow-related features will not be available, are you sure to switch?",
  "app.edit.toFlowForm": "Switch to flow form",
  "app.edit.toFlowForm.msg": "Switch to process form, permissions settings in Data Management will not be available, are you sure to switch?",
  "app.edit.change.success": "Switch successfully",
  "app.edit.copyToCurrent": "Duplicate to this app",
  "app.edit.copyToOther": "Duplicate to another app",
  "app.edit.target.select": "Please select the target app",
  "app.edit.copy.success": "Duplicate successfully",
  "app.edit.copy.fail": "Fail to duplicate",
  "app.edit.delete.confirm": "If you determine the deletion, please enter form name: ",
  "app.edit.appBridge": "Cross-app",
  "app.edit.delete.hasAppBridge": "This form has {{count}} piece(s) of data and has been referred by {{ref}} feature！Deleting the form will empty the data and the data use permissions which can not be restored.",
  "app.edit.delete": "This form has {{count}} piece(s) of data！Deleting the form will empty the data which can not be restored.",
  "app.edit.dashDelete.msg": "Deleting the report will also delete the access permission to this report which can not be restored.",
  "app.edit.entryDelete.msg": "Deleting the report will also delete the access permission to this report which can not be restored.",
  "app.load.empty.title": "This app has been deleted",
  "app.load.empty.msg": "This app has been deleted by the manager, please open another app in Applications",
  alliance: "Service Provider Alliance",
  "alliance.guide.title": "Join Promotion Alliance",
  "alliance.guide.subTitle": "Get high promotion rewards",
  "alliance.guide.join": "Join now",
  "alliance.guide.step.title": "Gain promotional revenue in three steps",
  "alliance.guide.step1": "First: fill in the personal info，and apply to join Promotion Alliance",
  "alliance.guide.step2": "Second: get the promotion link and promote our product",
  "alliance.guide.step3": "Third: if you recommend a user to purchase advanced version, you will get cash sharing at least 400 yuan",
  "alliance.guide.bannerText": "Promote preemptive, enjoy the early bonus",
  "alliance.guide.company": "Company introduction",
  "alliance.guide.phone": "Consultation hotline",
  "alliance.guide.social": "User chat group",
  "alliance.guide.marketing": "Market collaboration",
  "alliance.guide.copyRight": "©2016-2020 Platform Inc. All Rights Reserved.",
  "alliance.apply.state.noApply": "Reason for application doesn't meet the requirement",
  "alliance.apply.state.empty": "This page does not exist!",
  "alliance.apply.state.noPass": "Sorry, Your application failed to pass the audit",
  "alliance.apply.broadcast": "Promoting Platform will bring economic income, in order to avoid possible economic disputes, please ensure that you have full ownership of the Platform account. If you are unsure of the ownership of this account, we recommend that you sign up for a new account.",
  "alliance.apply.reason": "Reason: ",
  "alliance.apply.forbidden": "Sorry, your account has been banned",
  "alliance.apply.inquiry": "If there is any doubt, please consult",
  "alliance.apply.check.fail": "Incorrect item",
  "alliance.apply.submit": "Apply",
  "alliance.apply.reSubmit": "Reapply",
  "alliance.apply.success": "Your application has been submitted, please wait for review",
  "alliance.apply.successTip": "Promotion Alliance is in the small scaled testing phase, some users' application may be affected, do not worry, we will review your application as soon as possible.",
  "alliance.apply.faq": "FAQ",
  "alliance.apply.faq.q1": "What is Platform Promotion Alliance?",
  "alliance.apply.faq.a1": "Platform Promotion Alliance is a type of Platform partner, participating in Platform Alliance can get promotion rewards, application migration, participation in support programs to help career development and other preferential treatment.",
  "alliance.apply.faq.q2": "Should I join Platform Promotion Alliance?",
  "alliance.apply.faq.a2": "First of all, you recognize Platform, believe in the development of Platform, have legal online resources or customer resources, or need to migrate applications, hope that with the help of Platform to promote career development, etc. Welcome to join Promotion Alliance to get more rewards.",
  "alliance.apply.faq.q3": "What will you get for recommending Platform to friends?",
  "alliance.apply.faq.a3": "Generous commission rewards, a person with ability can get Platform official resources to help you better promotion.",
  "alliance.manage.alliance": "Promote",
  "alliance.manage.own": "My promotion",
  "alliance.manage.account": "My account",
  "alliance.manage.datum": "Information",
  "alliance.account.income": "Total earn amount",
  "alliance.account.cashed": "Total withdrawal amount",
  "alliance.account.cashable": "Withdrawable amount",
  "alliance.account.apply": "Apply for withdrawal",
  "alliance.account.record": "Trading",
  "alliance.account.category": "Category",
  "alliance.account.order": "Recommend amount",
  "alliance.account.cash": "Withdraw",
  "alliance.account.tax": "Tax deduction",
  "alliance.account.tax.tooltip": "Our company withholds and pays relevant taxes according to the national legal policy, and the payment proportion shall be subject to the actual settlement amount",
  "alliance.account.ordered": "Credited",
  "alliance.account.state.waiting": "In audit",
  "alliance.account.state.denied": "Fail to withdraw",
  "alliance.account.state.paid": "Withdraw successfully",
  "alliance.account.money": "Yuan",
  "alliance.profile.authenticated": "Authenticated",
  "alliance.profile.fullName.errMsg": "Please enter your name",
  "alliance.profile.alipay": "Alipay",
  "alliance.profile.alipay.errMsg": "Please enter Alipay account",
  "alliance.profile.pass": "Withdrawal password",
  "alliance.profile.placeholder": "Withdrawal password should be 8 to 20 digits, containing letter and number.",
  "alliance.profile.noPassTip": "You have an ongoing withdrawal and can not modify Alipay.",
  "alliance.profile.phone": "Phone",
  "alliance.profile.apply.tip1": "1. It is recommended to bind Alipay account with real-name authentication;",
  "alliance.profile.apply.tip2": "2. Fill in the Alipay nickname and Alipay certified name, so that we can check the validity of Alipay account.",
  "alliance.profile.alipay.nickname": "Alipay nickname",
  "alliance.profile.alipay.nickname.errMsg": "Please enter Alipay nickname",
  "alliance.profile.alipay.name": "Alipay certified name",
  "alliance.profile.alipay.name.errMsg": "Please enter Alipay certified name",
  "alliance.share.onLine": "Online promotion",
  "alliance.share.link": "Promotion link",
  "alliance.share.link.tip": "Friends will go to the registration page containing your recommendation code by clicking this link",
  "alliance.share.link.copy": "Copy the promotion link",
  "alliance.share.link.result": "How to improve the promotion effect",
  "alliance.share.rule": "Platform Alliance rules in detail",
  "alliance.share.income": "My promotion income",
  "alliance.share.income.get": "How to get promotion income",
  "alliance.share.income.text": "Recommend one advanced version customer: 10% of the customer's first purchase of Platform Order Amount as a promotion award; recommend two or more advanced version customers: 20% of the customer's first purchase of Platform Order Amount as a promotion award.",
  "alliance.share.allIncome": "Total gained",
  "alliance.share.allCash": "Total withdrawal",
  "alliance.share.accurateLink": "Precise promotion",
  "alliance.share.accurateLink.title": "What is precise promotion",
  "alliance.share.accurateLink.description": "Precise promotion refers to sharing the application you make, through the app installation link, with the person who may need it，and he can use this app after signing up Platform account.",
  "alliance.share.accurateLink.tip1": "For the convenience of your app management, the app installation link is disabled by default. If you need to share app installation link, enable it first.",
  "alliance.share.accurateLink.tip2": "If you publish a link that does not conform to {{-linkDescription}}, Platform has the right to ban your app's external link at any time.",
  "alliance.share.state.forbidden": "Banned",
  "alliance.share.state.using": "In use",
  "alliance.share.state.noUsing": "No in use",
  "alliance.share.app.link.on": "Enable app link",
  "alliance.share.app.link.off": "Disable app link",
  "alliance.share.app.open.title": "Are you sure to enable app installation link?",
  "alliance.share.app.open.msg": "After enabled, other users can install this app through the app installation link that you share.",
  "alliance.share.app.open.success": "Enable successfully",
  "alliance.share.app.open.fail": "This app can not enable app installation link",
  "alliance.share.app.enter": "Enter app",
  "alliance.share.app.forbidden.title": "Are you sure to disable app installation link?",
  "alliance.share.app.forbidden.msg": "After disabled, other users will not be able to install this app through the app installation link. Users who have installed this app will not be affected.",
  "alliance.share.app.forbidden.success": "Disable successfully",
  "alliance.share.app.copy": "Copy app installation link",
  "alliance.share.title": "{{- name}} share an app to you: {{- appName}}. Click the link to install: ",
  "alliance.user.register": "Registered",
  "alliance.user.registerTime": "Register date",
  "alliance.user.orderPrice": "Actual pay amount",
  "alliance.user.payTime": "Pay date",
  "alliance.cash.alipay": "Alipay: ",
  "alliance.cash.amount": "Withdrawal amount: ",
  "alliance.cash.taxTip": "The amount of cash raised is the amount before tax. Our company will withhold and pay relevant taxes according to the national statutory policy. The actual payment amount will be subject to the actual settlement amount.",
  "alliance.cash.applyTip": "The application you submitted will be processed in the middle of each month, please be patient.",
  "alliance.cash.pass": "Withdrawal pass: ",
  "alliance.cash.pass.errMsg": "Please enter withdrawal password",
  "alliance.cash.fullName": "Real name",
  "alliance.cash.fullName.emptyTip": "Please enter name",
  "alliance.cash.IDNum.emptyTip": "Please enter ID number",
  "alliance.cash.certification.tip": "(Please make sure the photo is recognizable, upload images within 5MB) ",
  "alliance.cash.idCard.front": "Front of ID card",
  "alliance.cash.idCard.back": "Back of ID card",
  "alliance.cash.idCard.emptyTip": "Please upload photo of ID card",
  "alliance.cash.apply.infoTitle": "The profile information is incomplete. Do you want to complete the information now?",
  "alliance.cash.apply.info": "You need to perform real-name authentication, and set the Alipay and withdrawal password before you can withdraw it.",
  "alliance.cash.apply.text4Ok": "To complete",
  "alliance.cash.apply.minCount": "(More than {{ count }} can be withdrawn)",
  "alliance.cash.apply.fail": "Your withdrawal application failed",
  "alliance.cash.apply.success": "Withdrawal application has been submitted",
  "alliance.cash.apply.success.tip1": "Will deal with your withdrawal application within two work days.",
  "alliance.cash.apply.success.tip2": "Estimated accounting time: ",
  "alliance.cash.certification.success": "Real-name authentication has been submitted",
  "alliance.cash.certification.success.tip1": "Will deal with your real-name authentication within two work days.",
  "alliance.cash.certification.success.tip2": "Estimated processing time: ",
  "alliance.cash.certification.title": "Real-name authentication",
  "aggregate.defaultName": "Unnamed aggregate table",
  "aggregate.delete.msg": "Deleting aggregate table will also delete the data use permissions which can not be restored.",
  "aggregate.create": "Create aggregate table",
  "aggregate.design": "Aggregate table design",
  "aggregate.fieldAdd.tip": "Please add fields from the right panel",
  "aggregate.tip": "Aggregate table can preprocess the form data and be referred again in the form, often used in the purchase-sales-stock and other scenes",
  "bind.click": "Click to bind",
  "bind.fail": "Fail to bind",
  "bindTip.back": "Click to go back register page",
  "bindTip.login": "Seconds later it will redirect to sign in page",
  "bindTip.social": "Sign in with QQ/Weibo",
  "bindTip.tip": "Due to business adjustments,No longer supports new QQ/Weibo account sign in, please use other methods to sign in or sign up. We are sorry for the inconvenience caused to you.",
  "content.empty": "No content",
  "content.type": "Please enter content",
  "coupon.renew": "Renew exclusive coupon",
  "coupon.validity": "Term of validity: {{dateRange}}",
  "coupon.count": "My coupon: {{count}}",
  "copy.translate.dash": "Copy and convert to report",
  "corp.create": "Create my team",
  "corp.current": "Current team",
  "corp.enter": "Enter team",
  "corp.name": "{{- user}}'s team",
  "corp.name.label": "My Team",
  "corp.name.update": "Edit team name",
  "corp.name.update.success": "Edit team name successfully",
  "corp.name.placeholder": "Please enter team name",
  "corp.name.notEmpty": "Team name cannot be empty",
  "corp.name.tooLong": "Team name is a maximum of {{length}} digits",
  "corp.joined": "The team I joined",
  "corp.owned": "My team",
  "corp.owner": "Corporate creator",
  "corp.url": "Corporate account url",
  "corp.dd.url": "Dingtalk scan URL",
  "corp.url.tip": "Current enterprise-specific login entry",
  "corp.url.placeholder": "Begun with letter, the minimum length is {{length}}",
  "corp.url.validate.fail": "Does not meet the format requirements",
  "corp.url.update.success": "Edit corporate account url successfully",
  "corp.authInfo": "Authorization information",
  "corp.email": "Corporate email",
  "corp.email.invalid.tip": "Please enter correct corporate email",
  "corp.join.success": "Join the team successfully",
  "corp.unbind.confirm": "Confirm to unbind corporate suite",
  "corp.unbind.msg": "After unbinding corporate suite, the Contacts will be empty and the member nickname in the submitted data will not be displayed, please backup the data before unbind.",
  "corp.dingtalk.unbind": "Unbind DingTalk",
  "corp.dingtalk.authorization": "DingTalk authorization",
  "corp.dingtalk.authorization.explain": "DingTalk application binding instructions",
  "corp.dingtalk.href": "Need to contact [Team Administrator] to log in DingTalk Open Platform <a href='{{url}}' target='_blank' style='color: #00FFD2;'>{{url }}</a> for binding configuration",
  "corp.dingtalk.text1": "DingTalk application binding adopts DingTalk [internal development] mode for docking",
  "corp.dingtalk.text2": "Why adopt the [internal development] model",
  "corp.dingtalk.text3": "Using the [Enterprise Internal Development] mode can obtain more capabilities: for example, automatic synchronization of the address book, etc., saving a lot of time",
  "corp.dingtalk.help": "Please follow the <a style='color: #FFB200;'><i class='icon-bsy-guide'></i>parameter configuration operation guide</a> to complete the operation",
  "corp.dingtalk.start.btn": "Start",
  "corp.dingtalk.Step.help": "<i class='icon-bsy-guide'></i>Parameter configuration operation guide",
  "corp.dingtalk.Step.unbind": "Do you want to unbind the authorization?",
  "corp.dingtalk.Step.unbind.tip": "After unbinding DingTalk, the account will be restored to the original address book information of this account, the application and data information will be retained, and the original DingTalk application can be restored by rebinding it.",
  "corp.dingtalk.Step.unbin.btn": "Unbind authorization",
  "corp.qywework.Step.unbin.btn": "Remove corporate WeChat authorization",
  "corp.dingtalk.Step1.title": "Step1: Fill in basic information",
  "corp.dingtalk.Step2.title": "Step2: Create an application and fill in application credentials and configuration access address",
  "corp.feishu.Step2.title": "Step2: Configure event subscription request URL",
  "corp.dingtalk.Step3.title": "Step3: Activate address book permissions and to-do permissions",
  "corp.feishu.Step3.title": "Step3: Configure the access address and application permissions and publish the application",
  "corp.dingtalk.Step4.title": "Step4: Publish the application and configure scan code login parameters",
  "corp.dingtalk.Step1.title.tip": "(Please open the link first <a href='https://open-dev.dingtalk.com/v2/fe/app#/corp/app' style='color :var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/corp/app</a>Create application)",
  "corp.feishu.Step1.title.tip": "(Please open the link first <a href='https://open.feishu.cn/' style='color:var(--bsy-base-color);' target='_blank'>https ://open.feishu.cn/</a>Create application)",
  "corp.dingtalk.team.Step1.title.tip": "(Custom)",
  "corp.dingtalk.Step2.title.tip": "(Please open the link first <a href='https://open-dev.dingtalk.com/v2/fe/app#/corp/app' style='color :var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/corp/app</a>Create application)",
  "corp.dingtalk.Step3.title.tip": "(Continue in the link <a href='https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal }}/4' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}} /4</a> complete the following operations)",
  "corp.dingtalk.Step4.title.tip": "(Continue in the link <a href='https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal }}/12' style='color:var(--bsy-base-color);' target='_blank'>https://open-dev.dingtalk.com/v2/fe/app#/appMgr/inner/h5/{{agentIdVal}} /12</a> complete the following operations)",
  "corp.dingtalk.Step1.corpId.title": "Corporate information parameters <span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step1.name.title": "Team name<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step1.corpId.title.tip": "(Get in DingTalk Open Platform [Home])",
  "corp.feishu.Step1.corpId.title.tip": "(Get the following parameters in Feishu application, see parameter configuration operation guide for details)",
  "corp.dingtalk.Step1.corpId.waterMark": "Please enter the team ID",
  "corp.dingtalk.Step1.SSOsecret.title": "Development information<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step1.SSOsecret.title.tip": "(obtained in the first [Basic Information] of DingTalk Open Platform)",
  "corp.dingtalk.Step1.SSOsecret.waterMark": "Please enter the free registration key",
  "corp.dingtalk.Step2.app.title": "1. App credentials <span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step2.app.title.tip": "(Obtained after creating the application at the link above)",
  "corp.dingtalk.Step2.agent.waterMark": "Please enter AgentId",
  "corp.dingtalk.Step2.AppKey.waterMark": "Please enter AppKey",
  "corp.dingtalk.Step2.AppSecret.waterMark": "Please enter AppSecret",
  "corp.dingtalk.Step3.corpId.title": "2. Configure access address <span style='color:#F5222D;'>*</span>",
  "corp.feishu.Step3.corpId.title": "1. Configure access address <span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step3.corpId.title.tip": "(Please copy and paste the following address information to the [Development Management] link above, see the parameter configuration operation guide for details)",
  "corp.dingtalk.Step3.SSOsecret.title": "1. Open address book permissions<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step3.SSOsecret.title2": "2. Open to-do permission<span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step3.SSOsecret.title.tip": "(Please go to the DingTalk open platform to operate, see the parameter configuration operation guide for details)",
  "corp.dingtalk.Step3.Tip": "Note: The above permissions must be opened to enter the next step",
  "corp.dingtalk.Step3.ip": "Server Exit IP",
  "corp.dingtalk.Step3.index": "Application Homepage Address",
  "corp.dingtalk.Step3.pc": "PC home page address",
  "corp.dingtalk.Step3.address": "Backstage management address",
  "corp.dingtalk.Step4.corpId.title": "1. Scan code to log in to the application authorization information <span style='color:#F5222D;'>*</span>",
  "corp.feishu.Step4.corpId.title": "Subscription event request URL <span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step4.corpId.title.tip": "(Please copy and paste the following authorization information to the relevant location of the link above, see the parameter configuration operation guide for details)",
  "corp.feishu.Step4.corpId.title.tip": "(Please copy and paste the following parameters to the relevant location, see the parameter configuration operation guide for details)",
  "corp.feishu.corpId.title.tip": "(See the parameter configuration operation guide for details)",
  "corp.feishu.Step42.corpId.title.tip": "(Please copy and paste the following URL information to the relevant location, see the parameter configuration operation guide for details)",
  "corp.dingtalk.Step4.SSOsecret.title": "2. Login information parameter <span style='color:#F5222D;'>*</span>",
  "corp.dingtalk.Step4.SSOsecret.title.tip": "(Obtained in DingTalk Open Platform [Application Development-Mobile Application Access-Login])",
  "corp.dingtalk.Step4.name": "Name",
  "corp.dingtalk.Step4.desc": "Description",
  "corp.dingtalk.Step4.logo": "Authorized LOGO Address",
  "corp.dingtalk.Step4.url": "Callback domain name",
  "corp.dingtalk.Step4.appId.waterMark": "Please enter appId",
  "corp.dingtalk.Step4.appSecret.waterMark": "Please enter appSecret",
  "corp.dingtalk.SSO.tip": "Used for DingTalk backend to enter",
  "corp.dingtalk.add.SSOsecret.waterMark": "Please enter SSOsecret",
  "corp.dingtalk.add.SSOsecret.errorEmpty": "SSOsecret cannot be empty",
  "corp.authorization": "Authorization",
  "corp.dingtalk.authorization.ok": "Confirm authorization",
  "corp.dingtalk.authorization.tip": "Note: binding SSOSecret can enable login-free access to Platform Applications from DingTalk admin panel ",
  "corp.dingtalk.authorization.success": "Authorize successfully",
  "corp.dingtalk.print.fail": "System printing is not supported in the client, please open in the browser to operate",
  "corp.dingtalk.print.ok": "Go now",
  "corp.dingtalk.print.cancel": "Do not print",
  "corp.wechat.bindFail1": "Fail to bind WeChat",
  "corp.wechat.bindFail2": "Fail to bind WeChat, this WeChat account has been bound to Platform account",
  "corp.wechat.title": "Platform·quickly create corporate management applications",
  "corp.wechat.enter": "Enter Applications",
  "corp.wework.bind.tip": "To bind Wechat Work, {{- info}}",
  "corp.wework.bind.info": "Click here",
  "corp.bind.confirm": "Bind existing account",
  "corp.bind.confirm.msg": "Binding an existing Platform account will merge the apps in that account into the current account, and the user and permission data in that account will also be erased, which is irreversible. Are you sure to bind an existing account?",
  "corp.bind.ok": "Confirm to bind",
  "corp.integrate.wechat.account": "integrate your own WeChat official account",
  "corp.request": "Apply",
  "corp.switch": "Team switching",
  "code.reget": "Retrieve ({{num}})",
  "city.withMark": "(city)",
  "day.short": " ",
  "day.week.Monday":"Monday",
  "day.week.Tuesday":"Tuesday",
  "day.week.Wednesday":"Wednesday",
  "day.week.Thursday":"Thursday",
  "day.week.Friday":"Friday",
  "day.week.Saturday":"Saturday",
  "day.week.Sunday":"Sunday",
  "dash.data.component": "Component",
  "dash.add.tip": "Add components from the upper left corner for data display and analysis.",
  "dash.add.tip.learnMore": "Understanding these  Components",
  "dash.auth.errorTip": "Only signed-in user can view data",
  "dash.auth.noAuth": "You do not have permission to view data",
  "dash.areaChart": "Area chart",
  "dash.aggregateFunc": "Aggregate function",
  "dash.auto.calc": "Auto calculation",
  "dash.axis.x": "X axis",
  "dash.axis.y": "Y axis",
  "dash.barChart": "Bar chart",
  "dash.config.error": "Component configuration error",
  "dash.chart": "Statistical table",
  "dash.chart.add": "Add chart",
  "dash.chart.design": "Chart design",
  "dash.chart.relySet": "Chart link",
  "dash.chart.customizeRelySet": "Chart custom linkage",
  "dash.chart.relyEmpty": "There are no charts that support linkage",
  "dash.chart.tip": "1 dimension, 1 or more metric(s)\n2 dimensions, 1 metric",
  "dash.chart.type": "Chart type",
  "dash.chart.unnamed": "Unnamed chart",
  "dash.chart.sort.empty": "There are no fields that support sorting",
  "dash.calendar.empty": "No data on this day",
  "dash.copy.success": "Copy successfully",
  "dash.copy.title": "{{- title }}_copy",
  "dash.copy.maxCountExceed": "Fail to copy. There is a maximum of {{ limit }} charts",
  "dash.data.manage": "Data management components",
  "dash.data.manageTable": "Data management table",
  "dash.data.manage.select": "Select component Type",
  "dash.data.manage.selectPlaceholder": "Please select",
  "dash.data.manage.formSelect": "Please select data source",
  "dash.data.manage.dateSelect": "Please select time dimension",
  "dash.data.manage.date": "Time dimension",
  "dash.data.manage.filterAdd": "Add data source filter conditions",
  "dash.data.manage.getAuth": "Data acquisition permission",
  "dash.data.manage.allData": "All data",
  "dash.data.manage.userAuth": "Use members' permissions on data source form",
  "dash.data.manage.formTip": "User can view only the data that he has permissions on, depending on the permission group to which he is assigned in the data source form.",
  "dash.data.manage.allTip": "User can view all data in the component",
  "dash.data.manage.authTip": "Data permissions of the data source form have not been configured yet, and users cannot view data via this component. You can configure data permissions now, or after you complete configuring the component settings",
  "dash.dataSource.empty": "No alternative data source",
  "dash.thresholds.tip": "Member users must bind email or follow WeChat service account in order to receive reminders.",
  "dash.thresholds.set": "How to set",
  "dash.thresholds.name": "Alert name",
  "dash.thresholds.filter": "Warning condition",
  "dash.thresholds.field.placeholder": "Select the metric field",
  "dash.thresholds.num.placeholder": "Enter a numeric value",
  "dash.thresholds.mem.tip": "Make sure that the report has been published to the following departments or members",
  "dash.thresholds.msg.wx": "WeChat Reminder",
  "dash.thresholds.msg.wechat": "WeChat Work Reminder",
  "dash.thresholds.msg.dd": "DingTalk Reminder",
  "dash.thresholds.nameTip": "Please enter the alert name",
  "dash.thresholds.nameTip2": "The alert name cannot exceed the {{count}} Word",
  "dash.thresholds.filterTip": "The warning condition is not set complete",
  "dash.thresholds.timeTip": "Alert time is not set complete",
  "dash.thresholds.msgTip": "Alert Reminder method is not set complete",
  "dash.thresholds": "Data alert",
  "dash.thresholds.add": "Add alert",
  "dash.thresholds.setTip": "How do I set up data alerts?",
  "dash.thresholds.deleteConfirm": "Are you sure to delete this alert?",
  "dash.guideline": "Auxiliary line",
  "dash.guideline.add": "Add a guideline",
  "dash.guideline.label": "Auxiliary line name",
  "dash.guideline.label.placeholder": "Please enter a guideline name, up to {{ count }} characters",
  "dash.guideline.label.required": "Please enter a guideline name",
  "dash.guideline.label.length": "The guideline name cannot exceed {{ count }} characters",
  "dash.guideline.dynamic": "Dynamic value",
  "dash.guideline.nameAndValue": "Name and value",
  "dash.chart.thresholds.maxCountTip": "A single chart can open up to {{ count }} data alerts",
  "dash.countdown": "Trial period countdown:",
  "dash.color": "color settings",
  "dash.color.bg": "indicator background color",
  "dash.color.custom00": "Scorching",
  "dash.color.custom01": "Hope",
  "dash.color.custom02": "Low profile",
  "dash.color.custom03": "Macaron",
  "dash.color.custom04": "Texture",
  "dash.color.custom05": "Beach",
  "dash.color.custom06": "Forest",
  "dash.color.custom07": "Blue",
  "dash.color.custom08": "Vivid",
  "dash.color.custom09": "Garden",
  "dash.color.customMap01": "Starry Sky",
  "dash.color.customMap02": "Aurora",
  "dash.color.customMap03": "Moon Color",
  "dash.color.customMap04": "Zhaoxia",
  "dash.color.customMap05": "Cuckoo",
  "dash.color.customMap06": "Early Morning",
  "dash.color.customMap07": "Daylight",
  "dash.color.set": "Color scheme",
  "dash.color.item": "Support settings",
  "dash.color.empty": "Please add dimensions/metrics first",
  "dash.color.preset": "Preset color",
  "dash.color.valueSize.s": "Loose",
  "dash.color.valueSize.m": "Standard",
  "dash.color.valueSize.l": "Compact",
  "dash.display": "Display mode",
  "dash.chartLabel": "Data tag",
  "dash.chartLabel.display": "Show data labels",
  "dash.xFields.display": "Show dimension value",
  "dash.chartLabel.value.display": "Show indicator value",
  "dash.percent.display": "Show percentage",
  "dash.legend.display": "Show legend",
  "dash.legend.position": "The legend is shown in the chart",
  "dash.legend.type": "Type",
  "dash.legend.type.plain": "Normal Legend",
  "dash.legend.type.scroll": "Legend with pagination",
  "dash.position.bottom": "Bottom",
  "dash.position.top": "Top",
  "dash.position.left": "Left side",
  "dash.position.right": "Right side",
  "dash.xAxis.display": "Show tick labels",
  "dash.cond": "Filter",
  "dash.cond.add.fail": "Fail to add, the same field can not be repeatedly added as filter condition",
  "dash.cond.delete": "Delete filter condition",
  "dash.cond.drag.tip": "Drag the field on the left here to add filter condition",
  "dash.cond.edit": "Edit filter condition",
  "dash.cond.set": "Set filter condition",
  "dash.cond.set.fail": "Filter condition is set incorrectly",
  "dash.columnChart": "Column chart",
  "dash.columnChart.stack": "Stacked column chart",
  "dash.data.canExport": "Exportable data",
  "dash.defaultName": "Unnamed report",
  "dash.design": "Report design",
  "dash.dimension": "Dimension",
  "dash.dimension.single": "Single",
  "dash.dimension.sticky": "Dimension freeze",
  "dash.dimension.add.fail": "Fail to add, the same field can not be repeatedly added as dimension",
  "dash.dimension.drag.tip": "Drag the field on the left here to add dimension",
  "dash.dimension.map.drag.tip": "Drag the left address or locate the field here to add a dimension",
  "dash.dimension.provinceCity": "Province-city",
  "dash.dimension.provinceCityDistrict": "Province-city-district",
  "dash.dimension.x": "Dim(row)",
  "dash.dimension.y": "Dim(col)",
  "dash.dimension.x.sticky": "Freeze row dimension",
  "dash.dimension.y.sticky": "Freeze column dimension",
  "dash.dimension.yearQuarter": "Year-Quarter",
  "dash.dimension.yearMonth": "Year-Month",
  "dash.dimension.yearWeek": "Year-Week",
  "dash.dimension.yearMonthDay": "Year-Month-Day",
  "dash.dotGuide.func": "The basic function of statistical table is to make classified statistics for data, and dimension is the basis for data classification",
  "dash.dotGuide.metric": "Metric is the data to be statistics which will be summarized and calculated according to the grouping method set in dimension",
  "dash.dotGuide.drag": "Drag the field to Dimension and Metric to complete the addition.",
  "dash.dotGuide.type": "After you set the Dimension and Metric for the chart, you can select suitable chart type.",
  "dash.error.chartNumExceed": "Fail to add. There is a maximum of {{ limit }} charts",
  "dash.error.canNotDeleteMetric": "This metric is being used and can not be deleted",
  "dash.externalLink": "Report view link",
  "dash.enable": "Enable report",
  "dash.enable.done": "Report is enabled",
  "dash.enable.title": "Your report has been converted to report, but is still disabled",
  "dash.enable.tip1": "The disabled report cannot be published, you can adjust the design of report when it's disabled",
  "dash.enable.tip2": "Attention, once you enable the report, users who can access the original reports will get accessibility of report. we advise that you make sure the report be set properly and completely cover the original reports before enable it ",
  "dash.field.add.guide": "Drag the field to add Data",
  "dash.field.add.fail": "Fail to add, the same field can not be repeatedly added",
  "dash.field.changeName": "Edit display name",
  "dash.field.changeName.tip": "Please enter display name",
  "dash.field.drag.tip": "Drag the field on the left here to add display field",
  "dash.field.delete": "Delete field",
  "dash.field.groupResultShow": "Quick measure",
  "dash.field.group.showReal": "None",
  "dash.field.group.showPercent": "Percentage",
  "dash.field.group.showGrowth": "Growth",
  "dash.field.group.showConversion": "Conversion",
  "dash.field.growthRate.yoy": "Year-over-year growth rate",
  "dash.field.growthRate.yoy2": "Year-over-year growth rate",
  "dash.field.growthRate.qoq": "Quarter-over-quarter growth rate",
  "dash.field.growthRate.mom": "Month-over-month growth rate",
  "dash.field.growthRate.mom2": "Month-over-month growth rate",
  "dash.field.growthRate.wow": "Week-over-week growth rate",
  "dash.field.growthRate.wow2": "Week-over-week growth rate",
  "dash.field.growthRate.dod": "Day-over-day growth rate",
  "dash.field.growthValue.yoy": "Year-over-year growth amount",
  "dash.field.growthValue.yoy2": "Year-over-year growth amount",
  "dash.field.growthValue.qoq": "Quarter-over-quarter growth amount",
  "dash.field.growthValue.mom": "Month-over-month growth amount",
  "dash.field.growthValue.mom2": "Month-over-month growth amount",
  "dash.field.growthValue.wow": "Week-over-week growth amount",
  "dash.field.growthValue.wow2": "Week-over-week growth amount",
  "dash.field.growthValue.dod": "Day-over-day growth amount",
  "dash.field.subformSet": "Subform field setting",
  "dash.growth.disabled.tip": "The year-on-year / month on month ratio can only be set when there is only one date and time field in the dimension.",
  "dash.filter": "Filter component",
  "dash.clear.filter": "Clear filter",
  "dash.descriptionBtn": "Text component",
  "dash.image": "Image component",
  "dash.real.time": "Real-time time",
  "dash.filter.quick":"Quick filter",
  "dash.embedded.iframe": "Embedded page",
  "dash.embedded.layout.container": "Container assembly",
  "dash.description.empty": "No text content",
  "dash.filter.add": "Add filter",
  "dash.filter.btn": "Filter button",
  "dash.filter.sizer": "Filter Sizer",
  "dash.filter.btn.info": "Filter button is used to solve the problem of slow filtering caused by massive data. Add filter component before adding filter button",
  "dash.filter.name": "Filter name",
  "dash.filter.selectChart": "1.Select the chart you want to filter",
  "dash.filter.selectField": "2.Select filter field",
  "dash.filter.setDefault": "3.Set filter",
  "dash.filter.chart.empty": "There is no available chart currently, please add a chart or edit an existing chart configuration",
  "dash.filter.method": "Filtering method",
  "dash.filter.select.text": "Options",
  "dash.filter.select.custom": "Text",
  "dash.filter.select.input": "Query",
  "dash.filter.field.emptyTip": "No optional fields, please adjust the filter field or chart",
  "dash.filter.chart.emptyMsg": "Please select a filter chart",
  "dash.filter.fields.emptyMsg": "Please select a filter field",
  "dash.filter.title.emptyMsg": "Please enter a filter name",
  "dash.format.input.tip": "Please enter custom format",
  "dash.format.preview": "Preview",
  "dash.lineChart": "Line chart",
  "dash.link.canceled": "Linkage has been canceled",
  "dash.link.empty": "There is currently no chart linked to this chart",
  "dash.max.exceed.title": "The amount of data after the summary calculation is too large, only the first 2000 items are displayed",
  "dash.max.exceed.msg": "You can add or modify filters to narrow the data range",
  "dash.metric": "Metric",
  "dash.metric.left": "Metric (left)",
  "dash.metric.right": "Metric (right)",
  "dash.metric.add": "Add metric",
  "dash.metric.add.tip": "Please add metric first",
  "dash.metric.drag.tip": "Drag field on the left here to add metric",
  "dash.metric.delete.tip": "Delete this metric?",
  "dash.metric.edit": "Edit metric",
  "dash.metric.exist": "Existing metric",
  "dash.metric.add.success": "Calculated field added successfully",
  "dash.metric.inputExpr.tip": "Please enter a formula",
  "dash.metricTable": "Metric table",
  "dash.metricTable.tip": "0 dimension, 1 metric\n1 dimension, 1 metric",
  "dash.multiAxesChart": "Two axis chart",
  "dash.multiAxesChart.tip": "1 dimension, 1 or more metric(s)",
  "dash.multiAxesChart.type": "Two axis chart type",
  "dash.multiAxesChart.left": "Left axis",
  "dash.multiAxesChart.right": "Right axis",
  "dash.pivotTable": "Pivot table",
  "dash.pivotTable.tip": "1 dimension, 1 or more metric(s)\nmultiple dimensions, 1 or more metric(s)",
  "dash.pieChart": "Pie chart",
  "dash.pieChart.tip": "1 dimension, 1 metric",
  "dash.radarChart": "Radar chart",
  "dash.mapChart.tip": "1 geographic dimension, 1 indicator",
  "dash.mapChart.display": "Map display range",
  "dash.drilling": "Drilldown",
  "dash.mapChart.drilling": "Map Drilldown",
  "dash.mapChart.drilling.p": "Drilldown to province",
  "dash.mapChart.drilling.pc": "Drilldown to province and city",
  "dash.mapChart.drilling.c": "Drilldown to city",
  "dash.mapChart.drilling.none": "Disabled",
  "dash.mapChart.type": "Map type",
  "dash.funnelChart.type": "Funnel type",
  "dash.pieChart.type": "Pie type",
  "dash.columnChart.type": "Column type",
  "dash.barChart.type": "Bar type",
  "dash.mapChart.displayEffect": "Show effect",
  "dash.mapChart.bubble": "Bubble Map",
  "dash.mapChart.area": "Regional map",
  "dash.funnel.common": "Common Funnel",
  "dash.funnel.customized": "Customized Funnel",
  "dash.mapChart.unknownCountry": "There are {{- count }} unknown place names",
  "dash.mapChart.unknownProvince": "The province has {{- count }} unknown place names",
  "dash.mapChart.unknownCity": "The city has {{- count }} unknown place names",
  "dash.release": "Publish report",
  "dash.release.mem": "Publish report to team members, and members can view the report after signing in",
  "dash.release.link": "Publish report as public link, you don't need to sign in to view report",
  "dash.release.team": "Report access intranet",
  "dash.source": "Data source",
  "dash.source.description1": "That is, using the data entered in the existing form as the data source, it can perform various data processing operations with other forms or the data entered in this form",
  "dash.source.description2": "Example：",
  "dash.source.description3": "After the data is entered on the page, it can be horizontally connected, added and merged, grouped and summarized with the data of other input sources.",
  "dash.source.description4": "The following figure takes the additional merge as an example",
  "dash.source.etl": "Data view output table",
  "dash.source.stale": "Data source is invalid",
  "dash.source.stale.tip": "Data source is invalid, please change data source and reconfigure the chart",
  "dash.source.select": "Please select data source of the chart",
  "dash.source.update": "Change data source",
  "dash.source.update.tip": "Change data source will clear the current chart configuration, are you sure to change?",
  "dash.subform.fields.set": "Please set the fields that need to display",
  "dash.subform.fields.select": "Select display field",
  "dash.sort.maxCount.tip": "You can add {{- count}} sorting rules at most",
  "dash.sort.add": "Add sorting rule",
  "dash.sort.empty": "No sorting rule, please add",
  "dash.sort.setting": "Sorting rule setting",
  "dash.sort.field.empty": "There are no fields that support sorting",
  "dash.sort.rule": "The priority of sort rules is based on their order (high to low)",
  "dash.table": "Data table",
  "dash.table.editCustomField": "Edit custom field",
  "dash.table.addCustomField.tip": "Edit formulas using mathematical operators",
  "dash.table.inputName.tip": "Please enter field name",
  "dash.top.limit": "Only positive integer between 1 and 1000",
  "dash.permission": "Data acquisition permissions",
  "dash.permission.all": "All data in the data source form",
  "dash.permission.form": "Use members' permissions on data source form",
  "dash.permission.all.desc": "User can view all data in the component",
  "dash.permission.form.desc": "User can view only the data that he has permissions on, depending on the permission group to which he is assigned in the data source form.",
  "dash.notify": "Timed reminder",
  "dash.notify.sub": "Remind members to view reports regularly",
  "dash.notify.help": "How do I set a timed reminder?",
  "dash.xAxis.showTag": "Display all labels",
  "dash.xAxis.showTag.warning": "Checking this item will cause the label to overlap and affect the display, please be careful",
  "dash.xAxis.tag.direction": "Rotation",
  "dash.xAxis.tag.horizontal": "Horizontal",
  "dash.xAxis.tag.vertical": "Vertical",
  "dash.xAxis.tag.leftBank": "Left side",
  "dash.xAxis.tag.rightBank": "Right side",
  "dash.yAxis.title.tip": "Please enter the title",
  "dash.statistical.table.tip": "Provide a variety of chart styles to summarize the data",
  "dash.list.tip": "Extract some or all of the data into a table for viewing",
  "dash.calendar.tip": "Presents and manages data in a calendar based on member permissions",
  "dash.manage.table.tip": "Presents and manages data in tabular form based on member permissions",
  "dash.filter.tip": "To solve the problem of slow filtering caused by excessive data volume, please add a filter before adding a filter button",
  "dash.filter.btn.tip": "Used to filter report data",
  "dash.showSubtotal.tip": "sub Total",
  "dash.description.tip": "Descriptive description of data analysis results",
  "dash.mobileLayout": "mobile layout",
  "dash.mobileLayout.tip": "Open the mobile layout, you can customize the component size, location, etc.",
  "dash.mobileLayout.open": "On",
  "dash.mobileLayout.close": "Close mobile layout",
  "dash.mobileLayout.hide": "Hidden component",
  "dash.mobileLayout.hideEmpty": "There are no hidden components\n (hidden components are not displayed on the mobile side)",
  "dash.mobileLayout.closeTip": "After leaving the current page, the existing settings will not be saved and this operation cannot be restored.",
  "dash.mobileLayout.closeConfirm": "Are you sure you want to turn off the mobile style?",
  "dash.mobileLayout.closeMsg": "After closing, the existing settings will not be saved and this operation cannot be restored.",
  "dashboard.desc": "Platformcan  can create and switch app, manage contacts, handle to-do tasks",
  "dashboard.dingtalk.trial.tip": "The current version is a trial version. It will expire in {{- days}} days. {{- click}}.",
  "dashboard.dingtalk.trial.click": "Click here to upgrade",
  "dashboard.dingtalk.trial.marketQr": "Open the DinkTalk mobile app and scan the QR code.",
  "dashboard.broadcast.vipTrial": "Want to experience all the powerful features of Platform? you can get 30-days free trial of advanced features now",
  "dashboard.broadcast.overLimit": "The usage has exceeded the system limit, in order to ensure the proper use after the expiration of the trial, please upgrade your version. ",
  "dashboard.dotGuide.app1": "The application  consisting primarily of forms, process forms, and  reports and so on. Forms and reports created will appear in the list on the left",
  "dashboard.dotGuide.app2": "The configured app can be accessed and used immediately. Click here to enter visit mode",
  "dashboard.dotGuide.formAndReport": "You can submit data via form and view data via report",
  "dashboard.dotGuide.enter": "Click to enter Application",
  "dashboard.enter": "Enter Applications",
  "dashboard.guide.title": "User guide",
  "dashboard.guide.invite.title": "Invite members to join",
  "dashboard.guide.invite.desc": "Quickly invite members in user guide (you can also invite members after switching to Contacts in the upper-left corner)",
  "dashboard.guide.invite.corp": "Users who install Platform through DinkTalk/Wechat Work can skip this step",
  "dashboard.guide.invite.action": "invite",
  "dashboard.guide.create.title": "Create flows/forms/reports",
  "dashboard.guide.create.desc": "Create an app and add a flow/form/report to your app",
  "dashboard.guide.create.action": "Learn how to create",
  "dashboard.guide.publish.title": "Publish to members to fill in and view",
  "dashboard.guide.publish.desc": "Publish flow/form/report to members to start",
  "dashboard.guide.publish.action": "Learn members use method",
  "data.access.tip": "View data by signing in",
  "data.batch.export.file": "Batch export files",
  "data.batch.edit": "Batch edit",
  "data.batch.edit.peview.btn": "Modify and preview",
  "data.batch.edit.peview": "Batch Modify Data Preview",
  "data.batch.edit.peview.subtitle": "<i class='icon-bsy-warning'></i>Please carefully compare whether the [Modified Value] is the result you need, and confirm that the modified result is irrevocable",
  "data.batch.edit.subtitle": "This operation will modify <span style='color:red;'>{{len}}</span> pieces of data",
  "data.batch.edit.tip": "Data batch edit will not be revoked, please be careful;",
  "data.batch.edit.tip.distinct": "Fields that do not allow duplicate values cannot be modified;",
  "data.batch.edit.tip.field": "Image, attachment, location, signature, link data, link query and separator fields don't support batch editing",
  "data.batch.edit.tip.empty": "If you want to empty field, just leave this item blank",
  "data.batch.edit.field.select": "Please select the fields you want to edit",
  "data.batch.edit.warning.distinct": "This field is not allowed to repeat, thus it does not support batch editing",
  "data.batch.edit.record.view": "View edit log",
  "data.batch.edit.warning.field": "This field does not support batch editing",
  "data.batch.edit.busy": "Data is being edit, you can not batch edit",
  "data.batch.print.qrCode": "Batch print QR code",
  "data.batch.transfer": "Batch transfer charger",
  "data.batch.transfer.busy": "Charger is transferring, you can not batch transfer charger.",
  "batch.export.app.packge.title": "App Export",
  "batch.export.app.packge": "Batch export app",
  "move.sort": "Move sort",
  "app.group.empty": "Drag the application to this place to add or click",
  "data.doCount": "Count up data",
  "data.counting": "Counting...",
  "data.doCount.timeout": "Count timeout, the amount exceeds the count scope",
  "data.comment.empty": "No comment",
  "data.comment.noSupport.tip": "Data in Recycle Bin do not support adding comment",
  "data.comment.publish": "Comment",
  "data.delete.all": "Clear all",
  "data.delete.noAuth.tip": "Have no permission to delete this data",
  "data.display": "Data display",
  "data.display.order": "Display order",
  "data.display.top.before": "Display the first",
  "data.display.top.after": "data",
  "data.transfer.all": "Transfer all",
  "data.transfer.selected": "Transfer selected",
  "data.edit.all": "Edit all",
  "data.edit.selected": "Edit selected",
  "data.clear": "Clear data",
  "data.current": "current data",
  "data.empty": "No data",
  "data.dock.empty": "The enterprise has not shared the application/form with you, please contact the responsible person of the other party to handle",
  "data.content.empty": "No content",
  "data.empty.publish.tip": "No data, you can share form with team members or publicly to collect data",
  "data.first": "This is the first piece of data on this page",
  "data.last": "This is the last piece of data on this page",
  "data.link.tip": "You need to sign in and be authorized to visit data link",
  "data.noFlow.inProgress": "No processing flow",
  "data.noFlow.inProgress.selected": "No processing flow is selected, please reselect.",
  "data.next": "Next",
  "data.edit.next": "Edit next",
  "data.view.next": "View next",
  "data.next.tip": "View next data, shortcut key is →",
  "data.openLink": "Public link",
  "data.openLink.tip": "View data through public link",
  "data.openLink.desc": "You can view data through public link without signing in",
  "data.openLink.subtitle": "You can access form and report via public link without signing in",
  "data.pdf": "PDF preview",
  "data.prev": "Previous",
  "data.none": "No data",
  "data.permission.get": "Data acquisition permissions",
  "data.edit.prev": "Edit previous",
  "data.view.prev": "View previous",
  "data.prev.tip": "View previous data, shortcut key is ←",
  "data.print": "Print file is generating, please wait",
  "data.qr.private": "QR code of data internal link",
  "data.qr.public": "QR code of data external link",
  "data.rely": "Data linkage",
  "data.cancelOperation": "Cancel",
  "data.operation.select": "Please select the data you need to operate",
  "data.select": "Select {{- count}} piece(s) of data",
  "data.select.all": "You select all data",
  "data.print.selected": "Print selected",
  "data.print.all": "Print all",
  "data.file.export.selected": "Export attachments in selected data",
  "data.file.export.all": "Export attachments in all data",
  "data.file.export.waitingTip": "Packing attachments, please wait",
  "data.file.export.packingTip": "You can close the page and the system will continue to package the attachments",
  "data.recover.select": "Recover selected",
  "data.recover.all": "Recover all",
  "data.recover.confirm": "Are you sure to recover the selected data？",
  "data.recover.tip": "{{- selectText}}, after recovering, data can be viewed in Data Management",
  "data.hardDelete.confirm": "Are you sure to completely delete the selected data?",
  "data.hardDelete.tip": "{{- selectText}}，data can not be recovered after completely deletion",
  "data.selected": 'Selected Data',
  "data.any": "Any data",
  "data.id": "Data ID",
  "data.id.only": "The only ID of data",
  "data.label": "Data title",
  "data.label.add.field": "Add field",
  "data.label.subTitle": "Data title is used to identify data, applicable to table first column title, link data, data detail, etc.",
  "data.label.firstField": "The value of the first field",
  "data.label.custom": "Custom title",
  "data.label.tip": "Enter text or add fields, you need to add at least one field",
  "data.label.required": "Custom title can not be empty",
  "data.label.fail1": "There should be at least one field in custom title",
  "data.label.fail2": "Data title support up to 20 fields",
  "data.auth": "Data permission",
  "data.auth.short": "Data",
  "data.auth.title": "What data can be accessed",
  "data.auth.subTitle": "Set the corresponding data permission, let team members manage data",
  "data.auth.add": "Add permission group",
  "data.auth.create": "Create permission group",
  "data.auth.edit": "Edit permission group",
  "data.auth.select": "Select permission group",
  "data.auth.required": "Permission group name can not be empty",
  "data.auth.name": "Name",
  "data.auth.name.title": "Name and description",
  "data.auth.name.placeholder": "Fill in permission group name",
  "data.auth.description.placeholder": "Fill in description",
  "data.auth.options": "Operation",
  "data.auth.options.short": "Operation",
  "data.auth.options.coopTitle": "What can be done with data",
  "data.auth.options.flowTitle": "What can be done with flow",
  "data.auth.field.title": "What fields can be viewed and edited",
  "data.notify": "Push notification",
  "data.notify.subTitle": "By setting push notification, you can view notification by the set date",
  "data.notify.create": "Create notification",
  "data.notify.delete.confirm": "Are you sure to delete this push notification?",
  "data.notify.delete.msg": "After deleting the push notification, the target will no longer receive notification, and this operation can not be restored",
  "data.notify.time": "Notify time",
  "data.notify.overTime": "End reminder time",
  "data.notify.dataCreate": "Notify after data submit",
  "data.notify.dataUpdate": "Notify after data edit",
  "data.notify.custom": "Custom time notify",
  "data.notify.custom.tip": "Tip: before you set a custom time notify, publish this form with members or add a member to the relevant collaboration permission group.",
  "data.notify.update.tip": "Tip: if notify target is not in the relevant permission group, he will not be able to view data when receiving notification.",
  "data.notify.update.any": "Notify after any field edit",
  "data.notify.update.detail.single": "Notify after {{- field}} field edit",
  "data.notify.update.detail.multi": "Notify after any field in the {{- fields}} edit",
  "data.notify.field.set": "Notice field setting",
  "data.notify.field.set.tip": "Please select at least one notice field",
  "data.notify.field.set.desc": "Please select the field that will trigger notification when editing data",
  "data.notify.update.fields": "Notify after specific field edit",
  "data.notify.update.fields.tip": "Tip: if more than one notify fields are set, editing any field wil trigger notification",
  "data.notify.update.set": "Notify after specific field edit",
  "data.notify.byWidget": "Notify according to date & time field in the form",
  "data.notify.byWidget.tip": "Tip: if notify target is not in the relevant permission group, he will not be able to view data when receiving notification.",
  "data.notify.byWidget.placeholder": "Please select date & time field in the form",
  "data.notify.startTime.set": "Please set notify start time",
  "data.notify.customRange": "Notify at {{time}}",
  "data.notify.customRange.repeat": "({{repeat}} notify once，end at {{time}})",
  "data.at.repeat": "（Repeat {{repeat}} and end at {{time}}）",
  "data.notify.widgetLabel": "In {{- label}}",
  "data.notify.today": "At that day, ",
  "data.notify.current": "Notify at that time",
  "data.notify.widgetResult": "Notify at {{time}}",
  "data.notify.offsetTime": "{{time}} notify",
  "data.notify.condition": "Notify condition",
  "data.notifier": "Notify target: ",
  "data.notify.type": "Notify method",
  "data.notify.everyday": "Every day",
  "data.notify.everyWeek": "Every week",
  "data.notify.everyTwiceWeek": "Every two weeks",
  "data.notify.everyMonth": "Every month ",
  "data.notify.everyYear": "Every year ",
  "data.notify.leave.msg": "After leaving the current page, Push Notification settings will not be saved",
  "data.notify.defaultMsg": "Please deal with it in time",
  "data.notify.title": "How to set Push Notification?",
  "data.notify.over": "Please set notify end time",
  "data.notify.target": "Notify target",
  "data.notify.target.set": "Click to set notify target",
  "data.notify.onlyOnce": "Notify only once",
  "data.notify.once": "{{time}} notify once",
  "data.notify.customRepeat": "Custom repeat",
  "data.notify.repeatText": " {{ repeat}}",
  "data.notify.repeatType": "Repeat type",
  "data.notify.mode": "Notify type",
  "data.notify.lastDay": "Last calendar day",
  "data.notify.assign": "Assigned date",
  "data.notify.relative": "Relative date",
  "data.notify.repeat.week": "Repeat by week",
  "data.notify.repeat.month": "Repeat by month",
  "data.notify.currentTime": "When",
  "data.notify.before": "Before",
  "data.notify.after": "After",
  "data.notify.accordWithCondition": "Data that meet the condition",
  "data.notify.condition.add": "Add condition",
  "data.notify.condition.addTip": "(please add field within the form to receive notification when data submitted meet the condition of form fields you set)",
  "data.notify.msg": "Notify text",
  "data.notify.corp": "{{corp}} notify",
  "data.notify.typeTip": "(multiple choice, select at least one Notification method)",
  "data.notify.corpTip": "Member must bind email or follow WeChat service account in order to receive notifications",
  "data.notify.corpText": "How to set?",
  "data.notify.createMsg": "There are new data submitted, please deal with it in time",
  "data.notify.customMsg": "It is the notify time, please deal with it in time",
  "data.notify.widgetMsg": "There are data in due time, please deal with it in time",
  "data.notify.updateMsg": "There are data edited，please deal with it in time",
  "data.notify.fail1": "Notify target not set",
  "data.notify.fail2": "Notify time not set",
  "data.notify.fail3": "End time not set",
  "data.notify.fail4": "Date & time field in the form not selected",
  "data.notify.fail5": "Repeat type not set completely",
  "data.submitPrompt": "After submission",
  "data.submitPrompt.subTitle": "Customize the content on submission function page",
  "data.submitPrompt.label": "After form submission",
  "data.submitPrompt.system": "Default content",
  "data.submitPrompt.custom": "Custom success page",
  "data.submitPrompt.insert": "Insert form field",
  "data.submitPrompt.maxWordCount": "Rich text has a limit of 200 words, the actual display content of the submission success page is the first 200 words",
  "data.submitPrompt.wordsCount": "You can enter {{words}} more characters",
  "data.submitPrompt.nextTip": 'Show "continue submitting" button ',
  "data.submitPrompt.tip": "You can add text, form fields, and system field and make rich text editing of text and fields",
  "data.submitPrompt.tip1": "The pop-up form is automatically closed after submission",
  "data.submitPrompt.href": "Jump to the specified link after the form is submitted",
  "data.submitPrompt.href.tip1": "New page opens",
  "data.submitPrompt.href.externalUrl": "external link",
  "data.submitPrompt.href.internalFrom": "Internal form",
  "data.submit.check": "Data submit validation",
  "data.submit.c.base": "Data submission, calculating",
  "data.submit.c.zhong": "",
  "data.submit.c.ing": "calculating",
  "data.submit.c.timeout.tip":"Is the submission time too long? Please contact the administrator to adjust the form design",
  "data.printTemplate": "Print template",
  "data.printTemplate.select": "Select print template",
  "data.printTemplate.system": "System",
  "data.printTemplate.custom": "Custom",
  "data.printTemplate.learnMore": "Learn more about print template",
  "data.printTemplate.failForFree": "User of free version cannot use custom print template feature",
  "data.printTemplate.empty": "You haven't created a print template for this form",
  "data.printTemplate.createCustom": "Create custom print template",
  "data.printTemplate.customEmpty": "No related print template",
  "data.printTemplate.set": "Print template setting",
  "data.printTemplate.subTitle": "Printing the form will be printed according to the template format in use",
  "data.printTemplate.emptyTip": "This template is not used anywhere",
  "data.printTemplate.create": "Create print template",
  "data.printTemplate.deleteMsg": "After deleting this template, the location where you originally used this template will use the default print template to print the form.",
  "data.printTemplate.rangeTip": "This template is used in the following locations",
  "data.printTemplate.rangeView": "View usage scope",
  "data.printTemplate.emptyInfo": "This template is not used by nodes in this flow version",
  "data.printTemplate.word.edit": "Edit word template information",
  "data.printTemplate.word.name": "Print template name",
  "data.printTemplate.word.push": "Upload template",
  "data.operation.record": "Operation record",
  "data.api": "Webhook",
  "data.api.subTitle": "Webhook can push the form data to the server you specify",
  "data.api.create": "Create webhook",
  "data.api.custom": "Push to the custom server",
  "data.api.fr": "Push to FineReport server",
  "data.api.log": "Webhook log",
  "data.api.deleteTitle": "Are you sure to delete this webhook?",
  "data.api.deleteMsg": "The target server will not receive data after deleting webhook, which can not be restored",
  "data.api.fail.tip1": "{{count}} data push failed. Please adjust the configuration and push again.",
  "data.api.fail.tip2": "More than 100 data push failed and webhook were paused. The system keeps the first 100 failure data for you. Please adjust the configuration and push again.",
  "data.api.trigger.create": "Push when new data submitted",
  "data.api.trigger.update": "Push when data edited",
  "data.api.trigger.remove": "Push when data deleted",
  "data.api.trigger.recover": "Push when data recovered",
  "data.api.trigger.formUpdate": "Push when form configure change",
  "data.api.trigger.comment": "Push when there are new comments",
  "data.api.trigger.comment.edit": "Push when a comment is modified",
  "data.api.flow.status": "When adding new data, modifying data, or changing process status, push data and process status information",
  "data.api.serverUrl": "Server address: {{- url}}",
  "data.api.serverUrl.config": "Server address",
  "data.api.push.now": "Pushing now, please wait a moment.",
  "data.api.push.finish": "Push finish",
  "data.api.push.finish.detail": "{{- success}} data push successfully，{{- fail}} data push failures",
  "data.api.push.again": "Retry push",
  "data.api.push.again.tip": "Are you sure you want to re-push the data?",
  "data.api.push.again.detail": "Before re-pushing, make sure that your webhook is properly configured.",
  "data.api.push.discard": "Discard push",
  "data.api.push.discard.tip": "Are you sure you want to discard these data?",
  "data.api.push.discard.detail": "Discarding the push deletes the failed record, which is irrevocable.",
  "data.api.pushTime": "Date push time: {{time}}",
  "data.api.doc.title": "Field comparison table and JSON sample",
  "data.api.form.structure": "Form structure",
  "data.api.flowState.explain": "2 means that the flow is closed manually; 1 means that the flow is complete; 0 means that the flow is in process",
  "data.api.leaveMsg": "After leaving the current page, your webhook settings will not be saved",
  "data.api.log.fail": "Webhook failure log",
  "data.api.log.success": "Webhook success log",
  "data.api.allLog": "All log",
  "data.api.logTip": "Keep only 6 months of webhook logs",
  "data.api.logTime": "Webhook time",
  "data.api.logUrl": "Webhook address",
  "data.api.logResult": "Webhook result",
  "data.api.logDetail": "Webhook detail",
  "data.api.logEmpty": "No webhook log",
  "data.api.fail": "Fail to push",
  "data.api.code": "Status code",
  "data.api.server": "Target server",
  "data.api.server.custom": "Custom server",
  "data.api.server.fr": "FineReport server",
  "data.api.server.test": "Server connecting test",
  "data.api.secret.create": "Generate Secret",
  "data.api.server.target": "Please enter target server address",
  "data.api.server.connecting": "Connecting server...",
  "data.api.server.connectSuccess": "Connect successfully",
  "data.externalLink": "Data external link",
  "data.externalLink.subTitle": "Share data in the form as public link, and accessing data without signing in",
  "data.externalLink.allEnabled": "All fields are viewable and editable",
  "data.externalLink.enabledCount": "All fields are viewable, {{count}} fields are editable",
  "data.externalLink.enabled": "All fields are viewable",
  "data.externalLink.visibleEnabledCount": "{{visibleCount}} fields are viewable, {{enableCount}} fields are editable",
  "data.externalLink.visibleCount": "{{count}} fields are viewable",
  "data.externalLink.auth": "Permission config",
  "data.externalLink.info": "What fields can be view and edit in data external link",
  "data.view": "View data",
  "date.ago.minute": "{{value}} minutes ago",
  "date.day": "{{day}} days",
  "date.days": "{{day}} days",
  "date.number": "{{number}}",
  "date.hours": "{{hour}} hours",
  "date.minutes": "{{minute}} minutes",
  "date.end": "End date",
  "date.just": "Just now",
  "date.lastMonth": "Last month",
  "date.lastWeek": "Last week",
  "date.lastSevenDays": "Last 7 days",
  "date.month": "{{month}} month",
  "date.quarter": "The {{quarter}}(th) quarter",
  "date.static": "Fixed value",
  "date.formula": "Formula Calculated Value",
  "date.start": "Start date",
  "date.thisMonth": "This month",
  "date.thisWeek": "This week",
  "date.today": "Today",
  "date.today.after": "After today",
  "date.today.before": "Before today",
  "date.today.time": "Today {{hour}}:{{minute}}",
  "date.week": "{{week}} week",
  "date.year": "{{year}} year",
  "date.thisYear": "This Year",
  "date.lastYear": "Last Year",
  "date.year_quarter": "{{year}} the {{quarter}}(th) quarter",
  "date.year_month": "{{year}}-{{month}}",
  "date.year_week": "{{year}} the {{week}}(th) week",
  "date.year_month_day": "{{year}}-{{month}}-{{day}}",
  "date.month_day": "{{month}}-{{day}}",
  "date.yesterday": "Yesterday",
  "date.sunday": "Sunday",
  "date.monday": "Monday",
  "date.tuesday": "Tuesday",
  "date.wednesday": "Wednesday",
  "date.thursday": "Thursday",
  "date.friday": "Friday",
  "date.saturday": "Saturday",
  "date.sunday.short": "Sun",
  "date.monday.short": "Mon",
  "date.tuesday.short": "Tue",
  "date.wednesday.short": "Wed",
  "date.thursday.short": "Thu",
  "date.friday.short": "Fri",
  "date.saturday.short": "Sat",
  "date.sunday.custom": "Sun",
  "date.monday.custom": "Mon",
  "date.tuesday.custom": "Tue",
  "date.wednesday.custom": "Wed",
  "date.thursday.custom": "Thu",
  "date.friday.custom": "Fri",
  "date.saturday.custom": "Sat",
  "date.january": "Jan",
  "date.january.short": "Jan",
  "date.january.short.chain": "Jan",
  "date.february": "Feb",
  "date.february.short": "Feb",
  "date.february.short.chain": "Feb",
  "date.march": "Mar",
  "date.march.short": "Mar",
  "date.march.short.chain": "Mar",
  "date.april": "Apr",
  "date.april.short": "Apr",
  "date.april.short.chain": "Apr",
  "date.may": "May",
  "date.may.short": "May",
  "date.may.short.chain": "May",
  "date.june": "June",
  "date.june.short": "June",
  "date.june.short.chain": "June",
  "date.july": "July",
  "date.july.short": "July",
  "date.july.short.chain": "July",
  "date.august": "Aug",
  "date.august.short": "Aug",
  "date.august.short.chain": "Aug",
  "date.september": "Sept",
  "date.september.short": "Sept",
  "date.september.short.chain": "Sept",
  "date.october": "Oct",
  "date.october.short": "Oct",
  "date.october.short.chain": "Oct",
  "date.november": "Nov",
  "date.november.short": "Nov",
  "date.november.short.chain": "Nov",
  "date.december": "Dec",
  "date.december.short": "Dec",
  "date.december.short.chain": "Dec",
  "date.format": "yyyy-MM-dd HH:mm",
  "dataTable.deleteAllTip": "You currently select all data, and the data can be recovered in the Recycle Bin after deletion",
  "dataTable.deleteAllTip.mergeAuth": "According to the settings of data permission, you may not be able to delete all visible data.",
  "dataTable.deleteAllSelectDataTip": "Are you sure to delete the selected data?",
  "dataTable.dataRecover": "Recover deleted data? learn more about advanced versions",
  "dataTable.deleteTip": "You currently select {{- length}} pieces of data, and the data can be recovered in the Recycle Bin after deletion",
  "dataTable.deleteTipForFree": "You currently select {{- length}} pieces of data, the deleted data can not be recovered in free version",
  "dataTable.deleteAllTipForFree": "You currently select all data, the deleted data can not be recovered in free version",
  "dataTable.deleteAllDataTip": "Are you sure to empty all data?",
  "dataTable.editor.exit": "Exit editing",
  "dataLimitTip.link": "This month's data amount has run out, and new data can not be submitted, please contact the link publisher to upgrade version",
  "dataLimitTip.account": "This month's data amount has run out, and new data can not be submitted, please contact the account creator to upgrade version",
  "dataLimitTip.account.admin": "Your data traffic has run out this month and you can't submit new data, please upgrade your version",
  "dingtalkCorp.corpSelect": " select corporate",
  "dingtalkCorp.empty.title": "You are not in member list",
  "dingtalkCorp.empty.subTitle": "Please contact your manager to sync members",
  "dingtalkCorp.bind": "Bind your Platform account",
  "delete.hard": "Hard delete",
  "delete.multi": "Batch delete",
  "delete.selected": "Delete selected",
  "delete.all": "Delete all",
  "delete.success": "Delete successfully",
  "delete.fail": "Fail to delete",
  "delete.confirm": 'Are you sure to delete "{{- name}}"?',
  "dept.add": "Add department",
  "dept.add.level.fail": "The level of the department is more than {{- level}}, so the department cannot be created",
  "dept.current": "Department of current user",
  "dept.delete.tip": "Delete department will delete the permissions associated with the department, this operation is irreversible",
  "dept.empty": "No related department",
  "dept.manager": "Supervisor",
  "dept.manager.grade.suffix": "Level of manager：",
  "dept.manager.set": "Set department manager",
  "dept.set": "Set department",
  "dept.sub.add": "Add sub department",
  "dept.name.placeholder": "Please enter name",
  "dept.name.required": "Please enter department name",
  "dept.name.notEmpty": "Department name can not be empty",
  "dept.name.tooLong": "Department name can not be more than {{length}} characters",
  "dept.select.tip": "Please select at least one department",
  "dept.manager.grade.one": "Direct department manager",
  "dept.manager.grade.two": "Department manager of higher level",
  "dept.manager.grade.three": "Department manager of the third level",
  "dept.manager.grade.four": "Department manager of the fourth level",
  "dept.manager.grade.five": "Department manager of the fifth level",
  "combine.date": "Date summary",
  "combine.yearAndMonth": "Year, month",
  "combine.yearAndMonthAndDay": "Year, month, day",
  "combine.address": "Address summary",
  "combine.provinceAndCity": "Province, city",
  "combine.detail": "Association interpretation",
  "combine.rule": "Summary method",
  "combine.percent": "Summary percentage",
  "contact.all": "All contacts",
  "contact.edit": "Edit contact",
  "contact.search": "Search contact",
  "contact.search.emptyTip": "There are no search results in the current group. Please check the search value or search in All Contacts",
  "contact.all.search.emptyTip": "No search results, please check the search value",
  "contact.group": "Contact group",
  "contact.group.default": "Ungrouped",
  "contact.group.add": "Add group",
  "contact.group.delete.confirm": 'Are you sure to delete "{{- name}}"?',
  "contact.group.delete.tip": "After deleting a group, the contacts in the group remain in All Contacts.",
  "contact.group.placeholder": "Please enter contact group name",
  "contact.group.name.notEmpty": "Contact group name can not be empty",
  "contact.group.name.tooLong": "Contact group name can not be more than 32 characters",
  "contact.add": "Add contact",
  "contact.add.success": "Add contact successfully",
  "contact.delete": "Delete contact",
  "contact.delete.confirm": "Are you sure to delete selected contact?",
  "contact.delete.tip": "Deleting a contact will also delete the contact's permissions, which can not be restored",
  "contact.delete.select.tip": "Please select contact to be deleted",
  "contact.notSave.warning": "Your contacts are not saved, are you sure to leave the current page?",
  "contact.notSave.tip": "After leaving the current page, your contact information will not be saved",
  "contact.phone.valid.tip": "Incorrect phone format",
  "contact.note": "Note",
  "contact.name.placeholder": "Please enter name",
  "contact.name.tooLong": "Group name can not be more than {{length}} characters",
  "contact.position": "Contact job",
  "contact.phone": "Contact phone number",
  "contact.template": "Address Book Template",
  "contact.template.import.tip": "Up to 200 members can be imported at a time. Members who are already in the address book or have incorrect information are not imported",
  "custom.color": "Custom color",
  "custom.login": "Custom login page",
  "custom.login.style": "Custom Index Style",
  "custom.login.mode": "login method",
  "custom.login.range.tip": "Applies to the corporate account URL and the internal link posted to the member",
  "custom.login.config.close.title": "Are you sure you want to close the configuration page?",
  "custom.login.config.close.msg": "The changed configuration item after closing is not saved and cannot be restored",
  "custom.login.auto.close.option": "Automatic login option",
  "custom.login.language.option": "Language Options",
  "custom.login.register.entrance": "Register entry",
  "custom.login.showFigure": "Show figure",
  "custom.login.corpLogo": "Corp logo",
  "custom.login.save.title": "You have not turned on single sign-on and confirmed saving?",
  "custom.login.save.mag": "You have checked Single Sign-On in Index Method. After saving the configuration, login will fail when using single sign-on.",
  "design.withMark": "(design)",
  "dataSource.update.confirm": "Are you sure to change data source?",
  "dataSource.update.tip": "Changing data source will empty existing field configuration, condition filter and other options, which can not be restored",
  "dataSource.update.msg": "Changing data source will empty existing field configuration, are you sure to change?",
  "dataSource.singleForm": "Single form data",
  "dataSource.multiForm": "Multiple forms linkage",
  "dataSource.joinField.required": "Please select form fields to set up linkage",
  "dataSource.joinField.invalid.warning": "The type of selected link fields don't match or link field doesn't exist",
  "dataSource.joinTable.required": "Please select link form first",
  "effective.client.tip": "This feature is only available for WeChat  service account/WeChat Work and DingTalk client",
  "email.invalid.warning": "Please enter correct email",
  "email.bind": "Bind email",
  "email.new": "New email",
  "email.current": "Current email",
  "email.set.success": "Set email successfully",
  "email.verify": "Verify email",
  "email.update": "Edit email",
  "email.update.success": "Edit email successfully",
  "email.unbind": "Unbind email",
  "email.unbind.success": "Unbind email successfully",
  "email.unbind.confirm": "Are you sure to unbind email?",
  "email.unbind.tip": "Unbinding email needs to verify the authenticity of the current bound email, and after unbinding you will not be able to sign in to Platform through the original email. If you want to continue using email to sign in, you can rebind a new email.",
  "equidistance.horizontal": "Horizontal align",
  "equidistance.vertical": "Vertical align",
  "error.1": "Bad request",
  "error.201": "Operation failed, please refresh the page and try again",
  "error.1000": "Account does not exist",
  "error.1001": "Password is incorrect",
  "error.1002": "The account has not been activated",
  "error.1003": "Fail to bind WeChat",
  "error.1004": "URL has been used",
  "error.1005": "Email already exists",
  "error.1006": "Information doesn't confirm to the standard",
  "error.1007": "Fail to sign up",
  "error.1008": "Username is already taken, please change it",
  "error.1009": "Email is already taken",
  "error.1010": "User does not exist",
  "error.1011": "Password format doesn't meet the rule",
  "error.1012": "You have not set password",
  "error.1013": "Password is incorrect for more than 5 times, the account has been locked, please try again or reset password after 1 hour",
  "error.1014": "Fail to create user",
  "error.1015": "Fail to cache user information",
  "error.1016": "User activation code has expired",
  "error.1017": "Username does not meet the format requirements",
  "error.1018": "Email does not meet the format requirements",
  "error.1019": "Nickname does not meet the format requirements",
  "error.1020": "User verification parameter does not exist",
  "error.1021": "User verification parameter does not match the current user",
  "error.1022": "User team does not exist",
  "error.1023": "Username and email can not be empty at the same time",
  "error.1024": "Phone number error",
  "error.1025": "CAPTCHA code error",
  "error.1026": "Valid code error",
  "error.1027": "Phone number already exists",
  "error.1028": "Operation too frequent, fail to acquire valid code. please try again after 1 minute.",
  "error.1029": "This feature is only for co-creation users",
  "error.1030": "User is not signed in",
  "error.1031": "Email valid code is incorrect",
  "error.1032": "Email is incorrect",
  "error.1033": "User has been banned from access",
  "error.1034": "Fail to get oauth access_token",
  "error.1035": "Fail to get oauth user information",
  "error.1036": "Fail to create user team",
  "error.1037": "User team has been created or the current user is bound to the corporate",
  "error.1038": "User has not made this type of binding or has been unbounded",
  "error.1039": "User needs to keep at least one sign in method",
  "error.1040": "Due to business adjustments, Platform no longer supports new QQ/Weibo account sign in, please use other methods to sign in or sign up. We are sorry for the inconvenience caused to you.",
  "error.1041": "This third-party account has been bound by another Platform user",
  "error.1042": "Current user can not get advanced feature trial",
  "error.1043": "User does not belong to the current team",
  "error.1044": "Your account does not meet the application conditions",
  "error.1045": "The current account has no bound phone number",
  "error.1046": "The current account is not a promoter",
  "error.1047": "The current account has not joined Promotion Alliance",
  "error.1048": "The current account promotion code has been disabled",
  "error.1049": "The current user has submitted a certification request, please do not repeat submitting",
  "error.1050": "Fail to create real-name authentication",
  "error.1051": "Real-name authentication information does not exist",
  "error.1052": "Real-name authentication information can not be edited now",
  "error.1053": "While in withdrawal or real-name authentication, it is not allowed to edit Alipay related information",
  "error.1054": "Current user has not received an invitation or has joined the team",
  "error.1055": "The DingTalk promotion application does not exist",
  "error.1056": "The DingTalk promotion application is unedited currently",
  "error.1057": "Invitation link has expired",
  "error.1058": "User does not have the operation permission required",
  "error.1059": "No changes have been made",
  "error.1061": "The number of contacts has reached the limit and new contact can not be created",
  "error.1062": "There exists a contact group with the same name",
  "error.1063": "The current user is not allowed to edit team name",
  "error.1064": "Team name doesn't confirm to the standard",
  "error.1065": "The current user has joined the team",
  "error.1066": "The API KEY already exists and cannot be created repeatedly",
  "error.1067": "Information against the standard is submitted",
  "error.1068": "Does not match the current corporate",
  "error.1069": "The current user needs to add persona information to get features of advanced version trial",
  "error.1070": "Unable to unbind when there is only one account sign in method",
  "error.1071": "Current phone number is incorrect",
  "error.1072": "Current email is incorrect",
  "error.1073": "User not in WeWork integration mode can not close corporate account",
  "error.1074": "You have submitted a close request, please wait",
  "error.1075": "Fail to bind WeChat, this WeChat account has already been bound to a Baidaoyun account",
  "error.1076": "Continuous multiple password errors",
  "error.1079": "The current account is not an Wechat Work manager",
  "error.1082": "Mobile phone number and mailbox cannot be empty at the same time",
  "error.1085": "Member name cannot exceed 12 characters",
  "error.1087": "The user id already exists",
  "error.1090": "Synchronized members cannot join other companies",
  "error.1092": "Member number up to 12 characters",
  "error.1101": "The management group does not exist",
  "error.1102": "The current department is not within the manageable range of the management group",
  "error.1103": "Please switch to the corresponding corporate first",
  "error.1104": "There is no manager group operation permission",
  "error.1105": "Illegal management group ID",
  "error.1106": "You can not remove yourself out of the management group",
  "error.1107": "There are other management group members",
  "error.1108": "Corporate creator can not join any management group",
  "error.1200": "Illegal role ID",
  "error.1201": "Corporate role information does not exist",
  "error.2000": "App name can not be empty",
  "error.2001": "App URL already exists",
  "error.2002": "App URL contains illegal characters",
  "error.2003": "App manager doesn't exist",
  "error.2004": "This app has been deleted, please select another app in Applications",
  "error.2005": "App can not be copied",
  "error.2006": "App can not be published",
  "error.2007": "Fail to publish app",
  "error.2008": "Fail to copy publishing app",
  "error.2009": "No app operation permission",
  "error.2010": "No cross-app operation permission",
  "error.2011": "This app has cross-app feature and does not support publishing to Template Center",
  "error.2012": "This app has been banned from accessing due to illegal content",
  "error.2013": "This app does not have enabled promotion link and can not be accessed",
  "error.2014": "You are not system manager or corporate creator, please sign in with the relevant account to install or send the link to the relevant personnel to install.",
  "error.2015": "This app has cross-app feature and does not support promotion link",
  "error.2016": "There is already a cognate app in promotion, this app can't enable promotion link",
  "error.2017": "This app has enabled promotion link, and does not support cross-app feature currently",
  "error.2018": "No app delete permission",
  "error.2019": "No app edit permission",
  "error.2020": "Only system manager can copy and publish app",
  "error.2021": "No app create permission",
  "error.2022": "No app install permission",
  "error.2023": "The default app can not be installed repeatedly",
  "error.2027": "Only system manager can adjust app order",
  "error.2029": "Fail to move, the dragging file has been deleted by other manager, please refresh the page",
  "error.2030": "Fail to move, the file list has been changed by other manager, please refresh the page",
  "error.2031": "App in trial does not support duplication",
  "error.2032": "App in trial does not support install link",
  "error.2033": "App in trial does not support publishing to Template Center",
  "error.3000": "Form does not exist",
  "error.3001": "Name can not be empty",
  "error.3002": "Unspecified type",
  "error.3003": "Parent node does not exist",
  "error.3004": "Member widget does not exist in the form",
  "error.3005": "Parameter is incorrect",
  "error.3006": "Aggregate table does not exist",
  "error.3007": "This form has been referenced by aggregate table and can not be deleted",
  "error.3008": "Data editing is not supported",
  "error.3009": "No enough operation permission",
  "error.3010": "Flow version of the form is incorrect",
  "error.3011": "Extension parameter of external link is incorrect",
  "error.3012": "Password is incorrect",
  "error.3013": "This page has been banned due to illegal content",
  "error.3014": "The number of aggregate tables in current app has reached the upper limit",
  "error.3015": "Please bind mobile phone first before publish external links",
  "error.3016": "Your form link is temporarily unavailable, we will review your form within 24 hours, and the link will be available after review.",
  "error.3017": "Form print template does not exist",
  "error.3018": "Fail to create form print template",
  "error.3019": "The number of print templates in current form has reached the upper limit",
  "error.3020": "Form notify configuration does not exist",
  "error.3021": "Form notify configuration has been modified and can not be executed",
  "error.3022": "Form notify period has exceeded the end time",
  "error.3023": "Current task is being executed and can not be modified",
  "error.3024": "Form permission group does not exist",
  "error.3025": "Form notify data has changed and can not be executed",
  "error.3026": "App is not installed, please install app before submitting data",
  "error.3027": "Fail to get auto-increase id of the form",
  "error.3028": "The server URL is not in the correct format",
  "error.3029": "The current team is {{corpName}}\nIf you confirm that the team is correct, please contact the administrator to assign page permissions",
  "error.3031": "Webhook group has reached the upper limit, please delete redundant groups and then create new group",
  "error.3032": "Fail to create webhook of form",
  "error.3033": "Webhook configuration of form does not exist",
  "error.3034": "Report widget doesn't exist",
  "error.3035": "Connection failed, please check your server configuration",
  "error.3036": "The number of images added has reached the upper limit",
  "error.3037": "Invalid QR code link of signature",
  "error.3038": "Form widget doesn't exist",
  "error.3039": "Form widget type does not match",
  "error.3040": "Form widget configuration is invalid",
  "error.3041": "The number of serial number exceeds the upper limit",
  "error.3042": "Alias configuration is invalid",
  "error.3043": "Report widget does not exist",
  "error.3044": "Form flow node configuration is invalid",
  "error.3045": "Report cache get is timeout",
  "error.3046": "External link form push failure",
  "error.3047": "No data need to be re-pushed",
  "error.3048": "Push task already exists",
  "error.3049": "Re-push failed",
  "error.3050": "Non-empty grouping cannot be deleted",
  "error.3057": "Report feature is offline, you can use report instead",
  "error.4000": "Fail to submit data",
  "error.4001": "Data does not exist",
  "error.4002": "Submit value is repeated",
  "error.4003": "No valid fields selected",
  "error.4004": "Operation failed, not allowed to close",
  "error.4005": "Operation failed, not allowed to revoke",
  "error.4006": "Operation failed, not allowed to rollback",
  "error.4007": "Operation failed, no flow charger",
  "error.4008": "Operation failed, the flow has been closed",
  "error.4009": "Operation failed, no permission",
  "error.4010": "No enough data operation permission",
  "error.4011": "No flow status changes when data is transferred",
  "error.4012": "Operation failed, the current form is performing other batch edit tasks, please try again later",
  "error.4013": "There are failed operations in batch editing",
  "error.4014": "Operation failed, no node can be rolled back to",
  "error.4015": "Operation failed, the candidate does not exist on the current node",
  "error.4016": "Operation failed, the flow can not be transferred to yourself",
  "error.4017": "You don't have permission to access data",
  "error.4018": "Data count statistics have been fixed",
  "error.4019": "Comment feature is only available for collaborative form",
  "error.4020": "Fail to comment",
  "error.4021": "One flow node can not have timeout transfer more than 10 times",
  "error.4101": "Data amount has exceed the usage limit",
  "error.4201": "The summary metric field is not configured correctly",
  "error.4202": "The summary condition field is not configured correctly",
  "error.4203": "The summary form is not configured correctly",
  "error.4204": "There exist duplicate summary metric fields",
  "error.4205": "There exist duplicate summary condition fields",
  "error.4206": "There are no editable fields, you can not import data",
  "error.4207": "There exist duplicate data table fields",
  "error.4208": "The data form is not configured correctly",
  "error.4209": "The summary formula is not configured correctly",
  "error.4210": "Unable to generate summary results and export Excel",
  "error.4211": "There is a circular reference in the formula",
  "error.4212": "When the dimension contains a subform field, the metric only supports subform fields, please adjust",
  "error.4213": "Fields from different subforms can not be summarized, please adjust",
  "error.4214": "Request timeout",
  "error.4215": "Multi multiple fields can not be summarized, please adjust",
  "error.4216": "Multi Field and subform field can not be summarized, please adjust",
  "error.4301": "Uploaded invalid Excel file",
  "error.4302": "The Excel document code is not provided",
  "error.4303": "The specified Excel table does not exist",
  "error.4304": "Unsupported Excel file format",
  "error.4305": "Encrypted Excel file",
  "error.4306": "There are no available fields in the imported form",
  "error.4307": "Fail to import data, the subform data in each data can not exceed 200. Your Excel data has exceeded the limit. Please adjust your Excel file",
  "error.4308": "Cannot import more than 10000 rows * 200 columns when importing data into department or member fields. Your Excel data has exceeded the limit. Please reimport after adjustment",
  "error.4309": "Data in the Excel file can not exceed 50000 rows or 200 columns",
  "error.4401": "Aggregate data calculation failed",
  "error.4402": "Aggregate calculation verification failed",
  "error.4403": "Aggregation verify formula is not configured correctly",
  "error.4501": "No package file",
  "error.4502": "No file field is selected",
  "error.4503": "The file packaging task has expired",
  "error.4504": "The file does not exist",
  "error.4505": "File packaging task failed",
  "error.4506": "The file packaging task has not been completed",
  "error.4507": "File creation failed",
  "error.4508": "Qiniu callback authentication parameter is incorrect",
  "error.4509": "OSS callback authentication parameter is incorrect",
  "error.4510": "File expiration time setting failed",
  "error.4511": "File task acquisition failed",
  "error.4512": "Not allowed to delete unfinished or expired file tasks",
  "error.4513": "There is a file packaging task being executed in this form",
  "error.4514": "Rename task contains widgets that do not conform to the type specification",
  "error.4515": "File information acquisition failed",
  "error.4516": "There are no attachments that can be exported",
  "error.4517": "Fail to get file",
  "error.4518": "Invalid signature Token",
  "error.4519": "Signature upload Token has expired",
  "error.4520": "WebSocket Token has expired",
  "error.4601": "The print service has not been initialized and printing is not available",
  "error.4602": "Invalid print template configuration, save failed",
  "error.4603": "Image failed to load in print template",
  "error.4604": "No valid print data is selected",
  "error.4605": "Invalid QR code print configuration, print failed",
  "error.4606": "Only custom print template supports batch printing",
  "error.4607": "You have a file being generated, please wait",
  "error.4608": "Batch print task creation failed",
  "error.4700": "ETL execution failed",
  "error.4701": "The current ETL is being executed",
  "error.4702": "Invalid ETL task Id",
  "error.4703": "ETL does not exist",
  "error.4704": "There is a loop in the ETL connection",
  "error.4705": "ETL cannot be executed without output node",
  "error.4706": "ETL is not configured correctly",
  "error.4707": "The Cartesian product exists in join node",
  "error.4708": "The amount of output data exceeds the limit",
  "error.4750": "There should be at least one input node in ETL",
  "error.4751": "Data from the same source can not be joined",
  "error.4752": "The input node can not be directly connected to the output node",
  "error.4753": "The input connection to the node is incorrect",
  "error.4754": "The join node must have at least one set of join fields",
  "error.4755": "The join node is not configured correctly",
  "error.4756": "There should be at least one set of group and summary fields in group statistics phase",
  "error.4757": "Please add at least one field",
  "error.4758": "There is an isolated node in the current ETL",
  "error.4759": "There exists multiple flows in the current ETL",
  "error.4800": "Trigger does not exist",
  "error.4801": "The number of triggers has reached the upper limit",
  "error.4802": "The number of execution actions exceeds the limit",
  "error.4803": "Please select the trigger form",
  "error.4804": "Invalid trigger action",
  "error.4805": "Please add an action",
  "error.4806": "Please select the target form",
  "error.4807": "Please specify the data to be edited",
  "error.4808": "Please specify the field to be edited",
  "error.4809": "Circular calculation error",
  "error.4810": "The trigger form is the target form of other smart assistants and is nested more than 3 levels",
  "error.4811": "The target form is the trigger form of other smart assistants and is nested more than 3 levels",
  "error.4812": "The usage of data edited by trigger exceeds the limit",
  "error.4813": "The trigger exceeds the maximum nesting level",
  "error.4814": "The trigger has been disabled",
  "error.4815": "The filter condition is not set correctly",
  "error.4817": "Main field or a single subform can not be assigned with a different subform",
  "error.4818": "Subform fields can not be assigned with main field",
  "error.4819": "Main field and subform field of the target form can not be assigned with subform fields at the same time",
  "error.4820": "Main field or a single subform can not be assigned with a different subform field",
  "error.4821": "Up to 200 new data",
  "error.4822": "The field editing is not set correctly",
  "error.4826": "Please specify the data to be deleted",
  "error.4827": "Filter condition target form subform does not support assignment from trigger form subform",
  "error.4828": "Filtering conditions do not support configuration subform",
  "error.4829": "Filter condition which does not configure target form subform fields will use trigger form primary field assignment",
  "error.4830": "Filter condition which does not configure the primary field of the target form will use trigger form subform field assignment",
  "error.4831": "Filter condition subfield does not support use trigger form primary field assignment",
  "error.4832": "Filter condition target form primary field can only be assigned using the same trigger form subform field",
  "error.4833": "Modifications to subfields of the target form are not supported",
  "error.4834": "Filtering conditions only support filtering subfields of the same subform of the target form",
  "error.4835": "Only subfields of the same subform of the target form are supported for assignment",
  "error.4836": "Target form subform do not support trigger form subform assignment",
  "error.4837": "The primary field of the target form can only be assigned using the same trigger form subform field",
  "error.4838": "Target form subform fields are inconsistent in field assignment and filtering conditions",
  "error.4839": "Trigger from subform fields are inconsistent in field assignment and filtering conditions",
  "error.5000": "Flow node deletion failed",
  "error.5001": "Unable to delete flow with child nodes",
  "error.5002": "This version of the flow is in use and can not be deleted",
  "error.5003": "The flow node does not exist",
  "error.5004": "Flow approval comments not submitted",
  "error.5005": "Unable to delete because there is data in this version",
  "error.5006": "Unable to transfer data to CC node",
  "error.5007": "Unable to perform transfer on a closed flow",
  "error.5008": "No corresponding charger",
  "error.5009": "No charger of the rolled back node",
  "error.5010": "Invalid flow data",
  "error.5011": "Unable to find transfer node",
  "error.5012": "Flow signature not submitted",
  "error.5013": "Please add node auto-processing",
  "error.5014": "Add 5 auto-processing at most",
  "error.5015": "Add only 1 auto-submit or auto-rollback",
  "error.5016": "Unable to set auto-submit and auto-rollback at the same time",
  "error.5017": "The notify target is not set",
  "error.5018": "Notify text can not be empty",
  "error.5019": "The time for auto-notify needs to be earlier than the time for auto-submit",
  "error.5020": "The time for auto-notify needs to be earlier than the time for auto-rollback",
  "error.5023": "This node does not allow batch forward",
  "error.5024": "The current user does not have permission to submit in this node",
  "error.5025": "The current node has been transferred",
  "error.5026": "Flow batch forward failed",
  "error.5028": "The data has expired and has been automatically cleaned for you",
  "error.6000": "The department with the same name already exists",
  "error.6001": "The parent department does not exist",
  "error.6002": "The department does not exist",
  "error.6003": "Unable to delete because there is a sub-department",
  "error.6004": "Fail to edit department",
  "error.6005": "Fail to create department",
  "error.6006": "Unable to delete because there are members within",
  "error.6007": "No member manage permission",
  "error.6008": "The department manager can only be a direct member of the department",
  "error.6009": "Unable to set department manager on root department",
  "error.6010": "WeChat Work mode cannot delete members",
  "error.6011": 'External contact group names can only be Chinese, English, numbers, underscores, (,),-, spaces; spaces cannot be at the beginning and end.',
  "error.7000": "Order creation failed",
  "error.7001": "Order does not exist",
  "error.7002": "Order has expired",
  "error.7003": "Order cancelled",
  "error.7004": "Order has been paid",
  "error.7005": "Order cannot be deleted",
  "error.7006": "Order cannot be invoiced",
  "error.7007": "There are unpaid orders",
  "error.7008": "Order invoicing failed",
  "error.7009": "Version of user amount can not be switched to other version.",
  "error.7010": "The purchased version can not be downgraded",
  "error.7011": "The current version can not purchase the specified service",
  "error.7012": "Renewal can not change version",
  "error.7013": "Please contact Platform customer service for assistance if version information is incorrect, call 400-011-1850",
  "error.7014": "User of free version can not purchase any service",
  "error.7015": "The total amount of invoice orders is less than 1,000 yuan and cannot be invoiced",
  "error.7016": "The coupon is invalid",
  "error.7017": "The current user can not get the trial",
  "error.7018": "Payment voucher not uploaded",
  "error.7019": "The current user has received  coupon",
  "error.7021": "You can not withdraw cash without setting Alipay account and withdrawal password",
  "error.7022": "You can not withdraw cash without setting Alipay account",
  "error.7023": "You can not withdraw cash without setting withdrawal password",
  "error.7024": "Withdrawal password is incorrect",
  "error.7925": "The amount of withdraw cash must not be less than 1,000 yuan",
  "error.7026": "The amount of withdraw cash can not exceed that of withdrawable cash",
  "error.7027": "Coupon activity has expired",
  "error.7028": "Coupon acquisition failed",
  "error.7029": "Order has expired",
  "error.7030": "This user has an unpaid order, please contact the user to cancel it and reorder",
  "error.7031": "Payment parameter signature verification failed",
  "error.7038": "The number of users can not be less than the version of the minimum limit",
  "error.7102": "System usage has exceeded the current version limit. You can go to Member Center to view version usage details and upgrade version.",
  "error.7103": "System usage has exceeded the limit，and the system has been suspended. You can go to Member Center to view version usage details and upgrade version to restore the system.",
  "error.7104": "The number of aggregate tables has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant aggregate tables and create new one.",
  "error.7105": "The number of aggregate tables in the app you install exceeds the current version limit. You can go to Member Center to view version usage details and upgrade version before installing the app.",
  "error.7106": "The number of aggregate tables has exceeded the current version limit. You can go to Member Center to view version usage details and upgrade version.",
  "error.7107": "Attachment upload has exceeded the current version limit. You can go to Member Center to view version usage details and upgrade version.",
  "error.7108": "The total data usage in your system has exceeded the current version limit. You can go to Member Center to view version usage details and upgrade version.",
  "error.7109": "The data usage of single-form in your system has exceeded the current version limit. You can go to Member Center to view version usage details and upgrade version.",
  "error.7110": "The number of members has exceeded the upper limit, in order not to affect your normal use, please upgrade the system as soon as possible, otherwise the system will be disabled.",
  "error.7111": "The number of members exceeds the limit. You can go to Member Center to view version usage details and upgrade version to sync or invite more members.",
  "error.7112": "The version you are currently using does not include custom printing feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7113": "The number of custom print templates has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant custom print templates and create new one.",
  "error.7114": "The number of custom print templates in the app you install exceeds the current version limit. You can go to Member Center to view version usage details and upgrade version before installing the app.",
  "error.7115": "The number of sub manager has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant sub managers.",
  "error.7116": "The number of sub manager has reached the upper limit. Please contact corporate creator to update version or delete redundant sub managers.",
  "error.7117": "You can only have one system manager in your current version. Please upgrade version if you need more.",
  "error.7118": "The number of sub manager has exceeded the current version limit. This feature has been disabled. Please contact account creator to update version or delete redundant sub managers.",
  "error.7119": "You can only have one system manager in your current version. Please contact account creator to update version.",
  "error.7120": "The version you are currently using does not include webhook feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7121": "The version you are currently using does not include recycle bin feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7122": "The version you are currently using does not include attachment export feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7123": "The version you are currently using does not include cross-app feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7124": "The version you are currently using does not include auto-sync feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7125": "The version you are currently using does not include custom submission success page feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7126": "The features included in this template have exceeded the version you are currently using, do you want to get a 30-day trial of advanced features",
  "error.7127": "The features included in this template have exceeded the version you are currently using, do you want to get a 7-day trial of advanced features",
  "error.7128": "The number of aggregate tables and print templates in the app you install exceeds the current version limit. You can go to Member Center to view version usage details and upgrade version before installing the app.",
  "error.7129": "The amount of data you copy has exceeded the free version limit. Please update version first",
  "error.7130": "The app you install contains signature widget.You can go to Member Center to view version usage details and upgrade version before installing the app.",
  "error.7132": "You can create up to 5 ETLs in current account, click view details to view ETLs usage. Delete redundant ETLs and create new one",
  "error.7133": "The number of ETLs has exceeded the current version limit. In order to avoid system limitations affecting your normal use, you can click view details and delete redundant ETLs.",
  "error.7135": "Only 5 smart assistants can be created for each account. Please delete redundant smart assistants and create new one.",
  "error.7136": "The number of smart assistants has exceeded the current version limit. In order to avoid system limitations affecting your normal use, you can click view details and delete redundant smart assistants.",
  "error.7137": "The number of ETLs in the app you install exceeds the current version limit. You can go to Member Center to view version usage details and upgrade version before installing the app.",
  "error.7138": "The number of smart assistants in the app you install exceeds the current version limit. You can go to Member Center to view version usage details and upgrade version before installing the app.",
  "error.7139": "The version you are currently using does not include custom style feature. You can go to Member Center to view version usage details and upgrade version.",
  "error.7201": "The amount of data has reached the upper limit. Please contact your Platform manager to upgrade version or adjust the system usage as soon as possible.",
  "error.7202": "The amount of data has reached the upper limit. Please contact the link publisher to upgrade version or adjust the system usage as soon as possible.",
  "error.7203": "The amount of data has exceeded the limit and data cannot be submitted. Please contact the link publisher to upgrade version to resume use.",
  "error.7204": "Your system usage has exceeded the limit. Please contact your Platform manager to upgrade version or adjust the system usage as soon as possible.",
  "error.7205": "System usage has exceeded the limit. Please contact the link publisher to upgrade version or adjust the system usage as soon as possible.",
  "error.7206": "System usage has exceeded the limit, and the system has been suspended. Please contact your Platform manager to upgrade version to resume use as soon as possible.",
  "error.7207": "System usage has exceeded the limit, and the system has been suspended. Please contact the link publisher to upgrade version to resume use as soon as possible.",
  "error.7208": "Fail to upload due to large file size. Please contact your Platform manager to upgrade version to get larger upload size limit",
  "error.7209": "The amount of data in a single-form has reached the upper limit. Please contact your Platform manager to upgrade version or adjust the system usage as soon as possible.",
  "error.7210": "The number of aggregate tables has reached the upper limit. Please contact your Platform manager to upgrade version or adjust the system usage as soon as possible.",
  "error.7211": "The number of custom print templates has reached the upper limit. Please contact your Platform manager to upgrade version or adjust the system usage as soon as possible.",
  "error.7212": "This account has run out of data amount for this month and can not submit new data. Please contact account creator to upgrade version.",
  "error.7213": "The signature feature has been disabled. Please contact corporate creator to upgrade version.",
  "error.7214": "The number of ETLs has exceeded the limit. Please contact corporate creator to upgrade version or adjust the system usage.",
  "error.7215": "The number of smart assistants has exceeded the limit. Please contact corporate creator to upgrade version or adjust the system usage.",
  "error.7216": "The amount of attachments exceeds the current version limit. Please contact your Platform manager to upgrade version as soon as possible.",
  "error.7217": "The amount of attachments exceeds the current version limit. Please contact the link publisher to upgrade version to resume use as soon as possible.",
  "error.8000": "Corporate authorization information does not exist",
  "error.8001": "Current user is already a corporate user",
  "error.8002": "Corporate user is not synchronized",
  "error.8003": "Corporate root department does not exist",
  "error.8004": "The first synchronization of the corporate organization failed",
  "error.8005": "Corporate app installation failed",
  "error.8006": "Fail to get corporate permanent authorization code",
  "error.8007": "Fail to get corporate authorization information",
  "error.8008": "Corporate suite activation failed",
  "error.8009": "Fail to get corporate authorization token ",
  "error.8010": "Fail to get vendor suite credentials",
  "error.8011": "Fail to get corporate pre-authorization code",
  "error.8012": "Fail to get corporate user list",
  "error.8013": "Corporate sign-in authorization credentials do not exist",
  "error.8014": "Illegal corporate backend path",
  "error.8015": "Authorization status code verification failed",
  "error.8016": "The current user and the user to be bound have purchased advanced version and can not be bound",
  "error.8017": "Corporate does not exist or has been dissolved",
  "error.8018": "Unbound from backend of DingTalk/WeChat first",
  "error.8019": "User enables auto-sync",
  "error.8020": "User did not follow the corporate account or official account",
  "error.8022": "The service is temporarily unavailable, please try again later",
  "error.8023": "CorpId or corpSecret error",
  "error.8024": "CorpId or ssoSecret error",
  "error.8025": "This corpId has been bound to another account",
  "error.8026": "CorpSecret needs root department permission",
  "error.8027": "Fail to get user information",
  "error.8101": "Invalid corporate manager",
  "error.8102": "There is no valid corporate Id",
  "error.8103": "The bound corporate does not meet the K12 certification standard",
  "error.8104": "This corporate has been used for certification by other Platform account",
  "error.8105": "The certification application has been submitted, please do not repeat certification",
  "error.8106": "The application information is in the incorrect format",
  "error.8107": "Fail to be submit the application information, please try again",
  "error.8108": "DingTalk URL error",
  "error.8109": "DingTalk account that has joined the Promoter Alliance does not support binding to other Platform accounts",
  "error.8110": "DingTalk account that has set phone or email does not support binding to other Platform accounts",
  "error.8111": "DingTalk account that has created app does not support binding to other Platform accounts",
  "error.8200": "Corporate suite error, waiting for conversion",
  "error.8201": "Proxy communication failed",
  "error.8202": "All proxy communication failed",
  "error.8301": "API signature verification failed",
  "error.8302": "No API request permission",
  "error.8303": "API request has reach frequency limit",
  "error.9001": "Queue task is not configured with valid processing method",
  "error.9002": "Queue task processing failed",
  "error.9003": "Queue task retry failed",
  "error.9004": "Queue task creation failed",
  "error.9005": "There is too many queuing tasks",
  "error.9006": "Invalid queue task cleanup failed",
  "error.9007": "Fail to acquire lock",
  "error.9008": "Fail to release lock",
  "error.9900": "Fail to send email",
  "error.9901": "Message doesn't exist",
  "error.9902": "Fail to send messages to some users",
  "error.9903": "Message template does not exist",
  "error.9904": "The remaining SMS is insufficient, and fail to acquire valid code. Please contact corporate creator to adjust form design or purchase SMS pack.",
  "error.9905": "Operation too frequent, failed to acquire valid code. please try again after 1 hour.",
  "error.9906": "Fail to send SMS",
  "error.9907": "The phone number is not verified or the SMS valid code has expired",
  "error.9908": "Fail to acquire valid code, please use this feature after installing app",
  "error.9909": "Please enter phone number or email in the correct format",
  "error.9914": "The additional notify target does not exist, who has been edited or has been deleted",
  "error.9915": "The additional notify target must at least have name and any one contacting method",
  "error.9916": "Please try again after 60 seconds",
  "error.9917": "The same email/phone number can be sent valid code at most twice a day",
  "error.10001": "Index failed",
  "error.10003": "User does not exist",
  "error.10007": "Configuration error",
  "error.10009": "Not allow to switch team",
  "error.10010": "Not allow to create team",
  "error.10011": "When single sign-on is enabled, binding operation is not allowed",
  "error.10012": "Please contact manager to add you to the current team",
  "error.10013": "Please contact manager to check single sign-on configuration",
  "error.10014": "Account not available",
  "error.4319": "Data_id does not match a field",
  "error.info.403": "Your browsing request is denied on the server, please confirm your access permission.",
  "error.info.404": "You may have entered the wrong address, or the page has been deleted or moved.",
  "error.status.400": "Bad request",
  "error.status.401": "User is not signed in",
  "error.status.402": "The current session has expired, please refresh the page and try again",
  "error.status.403": "No data request permission",
  "error.status.404": "Data resource not found",
  "error.status.429": "High traffic, please try again later.",
  "error.status.fail": "Fail to communicate with the server",
  "error.status.corpSwitch": "You have left the current corp and cannot operate",
  "error.status.corpSwitch.tip": "In the same browser, your account can only be in one corp. If you want to continue, switch corp in other tabs.",
  "error.title.403": "Request rejected",
  "error.title.404": "The page doesn't exist",
  "error.title.409": "No enough operation permission",
  "error.tip.corpName": "Current corp is {{corp}}",
  "error.tip.switchCorp": "If you want to continue, switch to the current team or contact administrator.",
  "error.tip.switchCorp.mobile": "You have not joined any team, please go to the PC to create a team or contact the administrator.",
  "error.qiniu.violation": "The uploaded attachment {{file}} contains illegal content",
  "etl.clear": "Clear input source",
  "etl.clear.confirm": "Are you sure to clear input source?",
  "etl.clear.info": "Clearing input source will also clear the configuration of the subsequent nodes containing the current input source. Are you sure to clear input source?",
  "etl.create": "Create",
  "etl.clickToViewIntro": "Click to view the feature introduction",
  "etl.dataProcess": "Data processing",
  "etl.dataSource": "Data source: ",
  "etl.dataFlow.empty": "The ETL can associate, aggregate, append, etc. one or more data sources to form an output table.\n You can use the output table as a data source in the report.",
  "etl.dataFlow.fail": "Fail to update ETL, please check the ETL settings",
  "etl.delete.msg": "Deleting ETL will also delete the output data of this ETL, and the deleted data can not be restored",
  "etl.design": "ETL design",
  "etl.doIt": "Execute",
  "etl.empty": "You don't currently have data output set<br/>Please create ETL and then view data.",
  "etl.empty.linkText": "What is ETL?",
  "etl.emptyTip": "Please add data source first and connect data source to this node",
  "etl.error.addInput": "Please add an input source",
  "etl.error.circle": "The node connection can not be a circle",
  "etl.error.directToOutput": "The input node can not connect directly to the output node",
  "etl.error.exceed": "Node input connection exceeds limit",
  "etl.error.expr": "Please enter expression",
  "etl.error.fieldName": "Please enter field name",
  "etl.error.formulaName": "Please enter calculated field name",
  "etl.error.isolateNode": "There is an isolated node or an isolated flow in the current ETL",
  "etl.error.noInputOrOutput": "The current ETL has no input/output nodes",
  "etl.error.finishRely": "Please complete the configuration of the dependent node first",
  "etl.error.line": "Please connect line to this node",
  "etl.error.line.two": "Please connect 2 lines to this node",
  "etl.error.line.more": "Please connect 2-4 lines to this node",
  "etl.existFields": "Existing fields",
  "etl.fail": "Fail to execute ETL and the output is no longer updated",
  "etl.dataUpdate": "Data update",
  "etl.filter": "Filter",
  "etl.group": "Group",
  "etl.group.addFields": "Add a group field",
  "etl.groups.addMetrics": "Add a summary field",
  "etl.group.metrics": "Summary fields",
  "etl.group.fields": "Group fields",
  "etl.group.rule": "Group method",
  "etl.group.atLeastOneField": "Please add at least one set of group and summary fields",
  "etl.hasStage": "The current ETL already has {{title}} node",
  "etl.inputAndOutput": "Input and output",
  "etl.input": "Input",
  "etl.input.data": "Input Data",
  "etl.input.subform.data": "Current line of subform",
  "etl.input.subform.data.tip": " (Common field and sub-form is currently editing the data of the row)",
  "etl.input.subform.data.tip1": "Refers to the row selected in the current sub-form.",
  "etl.input.subform.data.tip2": "Select input data in a row of the current table sub-form, and other input",
  "etl.input.subform.data.tip3": "The following figure takes the additional merge as an example",
  "etl.input.subform.data.tip4": "Send multiple data to the specified number by SMS",
  "etl.input.news.tip": "The output result set that will be connected to it is",
  "etl.input.news.tip1": "SMS/email/voice notification/WeChat reminder",
  "etl.input.news.tip2": "To the designated person",
  "etl.input.news.tip3": "Perform one or more data in the output table",
  "etl.input.news.tip4": "All data in the output table will be",
  "etl.input.news.tip5": "To the designated member or department or mobile phone number.",
  "etl.input.news.tip6": "SMS notification",
  "etl.input.news.tip7": "If there are multiple recipients, the eligible recipients will receive all eligible SMS content.",
  "etl.input.news.tip8": "1. If the recipient is a single member or mobile phone number, the content of a single message will be sent.",
  "etl.input.news.tip9": "2. If the recipient is multiple members or mobile phone numbers, each eligible recipient will receive the text message content of the first piece of data.",
  "etl.input.subformrely.tip": "Link the output result to the current sub-form. According to the type, it can be divided into: link current line of sub-form, link specified line of sub-form, add data in sub-form, delete data in sub-form.",
  "etl.input.subformrely.tip1": "According to the set conditions, take out the first piece of data that meets the conditions in the output table and link it to the row of the currently selected sub-sheet.",
  "etl.input.subformrely.tip2": "According to the set conditions, take out the first piece of data that meets the conditions in the output table and link it to the row of the matching sub-form data.",
  "etl.input.subformrely.tip3": "According to the set conditions, the matching data is added to the sub-form.",
  "etl.input.subformrely.tip4": "According to the set conditions, the data that meets the conditions in the target sub-form will be deleted.",
  "etl.input.data.description1": "That is, the data currently entered in the form is used as the data source, and various data processing operations can be performed with other forms or the data entered in this form",
  "etl.input.data.description2": "The input data is only triggered when",
  "etl.input.data.description3": "initialization, new data, edit, delete",
  "etl.input.data.description4": "Only refers to the current operation",
  "etl.input.data.description5": "A piece of data",
  "etl.input.data.description6": "example：",
  "etl.input.data.description7": "After data is entered on the page, it can be horizontally connected, added and merged, grouped and summarized with data from other data sources",
  "etl.input.data.description8": "The following figure takes the additional merge as an example",
  "etl.inputSource": "Input source",
  "etl.inputSource.select.empty": "No optional input source",
  "etl.inputSource.add": "Add input source",
  "etl.inputSource.update": "Change",
  "etl.inputSource.update.tip": "Are you sure to change the input source?",
  "etl.inputSource.update.confirm": "This operation will change the configuration of subsequent nodes, which can not be restored?",
  "etl.inputSource.select": "1.select source",
  "etl.field.select": "2.select fields",
  "etl.field.select.cur": "select fields",
  "etl.formula.empty.tip": "Please add a numeric field to the input source",
  "etl.input.emptyTip": "Please select form data to view",
  "etl.input.subform": "Subform",
  "etl.input.form": "Mainform",
  "etl.input.selected.field": "Selected fields",
  "etl.input.atLeastOneField": "Select at least 1 field",
  "etl.input.atLeastOneSubformField": "Select at least 1 subform field",
  "etl.input.multisubform.tip": "The selected input source contains multiple subforms, please select one subform to use",
  "etl.input.subformfield.empty": "There is no subform field",
  "etl.intro.join": " mainly joins two data tables according to the join field, and is divided into: inner join, left join and right join according to the join method.",
  "etl.intro.join.inner": ": According to the join field, return the data of the form where join fields on the left and right equals, that is, return the data intersection of the left and right forms.",
  "etl.intro.join.left": ": returns all the data of the left form, matching the data of the form on the right side line by line according to the join field, and leave blank if not matched.",
  "etl.intro.join.right": ": returns all the data of the right form, matching the data of the form on the left side line by line according to the join field, and leave blank if not matched",
  "etl.intro.union": " Supports 2-4  data tables，Merge into 1 data table according to the field correspondence,， often used to integrate scattered similar data",
  "etl.intro.filter": " Add a filter, only data that meets the filter will be retained. An example is as follows",
  "etl.intro.group": " In fact, it's grouping first and then summarizing.",
  "etl.intro.group.detail": "{{- group}} is to group the data with the same group field value, and {{- aggregate}} always calculate the value of the summary field from grouped data according to the specified summary method.",
  "etl.intro.map": " can sort and hide the fields in the data table; you can also add calculated fields to perform simple calculations on the current form data.",
  "etl.intro.tip": "Click here to view the feature description of each data processing node~",
  "etl.intro.view": "View now",
  "etl.io": "Input／output",
  "etl.join": "Join",
  "etl.join.inner": "Inner join",
  "etl.join.inner.info": "Return the data of the form where join fields on the left and right equals",
  "etl.join.left": "Left join",
  "etl.join.left.info": "Return all the data of the left form and the data matched on the right form",
  "etl.join.right": "Right join",
  "etl.join.right.info": "Return all the data of the right form and the data matched on the left form",
  "etl.join.rule.select": "Select join method",
  "etl.join.field.add": "Add join field",
  "etl.join.form.left": "Left form: ",
  "etl.join.form.right": "Right form: ",
  "etl.join.tip.atLeastOne": "There must be one set of join fields in join stage",
  "etl.join.tip.sameSource": "Data from the same source cannot be joined",
  "etl.join.tip.differentType": "The type of join fields don't match",
  "etl.join.fuzzy": "Set fuzzy association",
  "etl.join.fuzzy.precision": "Fuzzy association precision",
  "etl.join.fuzzy.time": "Set the time unit for fuzzy association match",
  "etl.join.cartesian product": "There is a Cartesian result set when previewing, it is suggested to change the join configuration, or edit data",
  "etl.lastUpdate": "Last update: {{time}}",
  "etl.log.just": "Within 1 minute",
  "etl.log.minute": "{{minute}} minute",
  "etl.log.execute": "Update log",
  "etl.log.startTime": "Start time: {{time}}",
  "etl.log.time": "Execute time: {{time}}",
  "etl.log.endTime": "End time: {{time}}",
  "etl.log.result": "Results: ",
  "etl.log.resultWithoutMark": "Results",
  "etl.log.fail.reason": "Fail reason: {{reason}}",
  "etl.log.fail.detail": "View error details",
  "etl.map": "Map",
  "etl.map.addCalcField": "Add calculated field",
  "etl.map.showOriginField": "Show original field",
  "etl.map.editField": "Edit field",
  "etl.map.hideField": "Hide field",
  "etl.map.editCalcField": "Edit calculated field",
  "etl.map.tip.atLeastOneField": "Please add at least one field",
  "etl.needSourceTable": "Please add the table you need to connect first and connect the relevant table to this node",
  "etl.output": "Output",
  "etl.output.emptyTip": "Please add data source and connect to this node, you can view data after clicking preview",
  "etl.output.table": "Output: ",
  "etl.output.tableInfo": "(output table can be used in the report)",
  "etl.preview.maxCount": "Preview up to {{count}} pieces of data",
  "etl.running": "Updating",
  "etl.stage.config": "Node configuration",
  "etl.stage.preview": "Data Preview",
  "etl.stage.preview.error": "Before previewing the data, please complete the node configuration",
  "etl.stage.preview.loading": "Loading",
  "etl.stage.title": "Node name: ",
  "etl.status.running": "Executing",
  "etl.save.success": "Save successfully, You can use the output data in the report",
  "etl.union": "Union",
  "etl.union.add.field.type.tip": "Only add field of same type",
  "etl.union.add.field.empty": "There is no field to add",
  "etl.union.result": "Union results",
  "etl.union.tip.atLeastOneField": "Add at least one field to each table",
  "etl.unnamed": "Unnamed ETL",
  "enable.withMark": "(enable)",
  "export.failTip": "Export failed",
  "export.fail.timeout": "Export time out",
  "export.excel.notice": "In preparation",
  "export.dataId": "Export data_id at the same time",
  "export.userAcount": "When exporting, members are accompanied by account information and department IDs, making it easy to import",
  "export.excel.notice.title": "Export file preparation...",
  "export.excel.notice.content": "You can do other things, and the preparation will be done in the background.\n When you are ready, you will receive a reminder with a download link in the message.",
  "export.excel.fileSuccess": "Exported file has been prepared",
  "export.excel.fileSuccess.content": "「{{ name }}」 The exported file has been prepared. Please download it as soon as possible before the download link expires after {{time}} hours.",
  "export.excel": "Export Excel",
  "export.data.all": "Export all data",
  "export.data.filtered": "Export filtered data",
  "export.field.select": "Please select export field",
  "export.field.mode": "Please select the method of images/attachments export",
  "export.field.mode.0": "The picture is saved in excel file(images calculation upload traffic)",
  "export.field.mode.1": "images/attachments are saved in the Excel peer directory and exported in zip format(images/attachments calculation upload traffic)",
  "export.field.mode.2": "images/attachments are saved in excel by hyperlink(Do not calculate upload traffic)",
  "export.file.all": "Export attachments in all data",
  "export.file.filtered": "Export attachments in filtered data",
  "export.file.widgetAndName": "Export attachments and naming methods",
  "export.file.name": "Naming method",
  "export.file.name.origin": "Original file name",
  "export.file.name.field": "By form field name",
  "export.file.empty": "There are no attachments in the form to export",
  "export.file.selectAll": "Attachment (all)",
  "export.generate.downloadLink": "Download link",
  "export.record": "Export log",
  "export.record.delete.confirm": "Are you sure to delete export log?",
  "export.record.delete.tip": "The exported attachment is not able to download after export log is deleted, which can not be restored",
  "export.record.none": "No export log",
  "export.record.view": "View export log",
  "export.link.expired.tip": "The download link has expired. Please re-export attachment if you need to download it",
  "export.link.tip": "The download link will expire in {{expireDate}}, please download it as soon as possible",
  "export.file.fail.tip": "Attachment export failed, please try again later",
  "export.file.select.tip": "Please select the attachments that need to be batch exported",
  "export.name.select.tip": "Please select the field used for naming",
  "external.link.password.form": "Please enter the password to fill in this form: ",
  "external.link.password.report": "Please enter the password to view this report: ",
  "external.link.password.dash": "Please enter the password to view this report: ",
  "external.link.scan": 'Use WeChat"scan"，and share it with friends',
  "external.link.tip": "This content is produced by the users and does not represent the official position",
  "fail.detail": "Error details",
  "field.add": "Add a field",
  "field.address": "Address field",
  "field.alias": "Field alias",
  "field.asyncData": "Link data in other form",
  "field.auth": "Field",
  "field.auth.short": "Field",
  "field.no_view_auth": "No view permission",
  "field.auth.add": "Go to add",
  "field.auth.emptyTip": "Please add a field to the form first",
  "field.auth.flowTip.warning": "The flow is enabled and the field permissions will be based on the settings of the flow node",
  "field.auth.flowTip.info": "After he flow is enabled, the field permissions will be based on the settings of the flow node",
  "field.auth.set": "Set operation permission",
  "field.auth.systemTip": "System field can not be edited",
  "field.auth.visibleTip": "Please select at least one visible field",
  "field.chargers": "Current node/charger",
  "field.createTime": "Submit time",
  "field.creator": "Submitter",
  "field.date": "Date field",
  "field.datetime": "Date & time field",
  "field.defaults.set": "Set default value",
  "field.defaults.today": "Fill day",
  "field.deleted.tip": "This field has been deleted",
  "field.deleted.tip1": "Configuration has expired, please reconfigure",
  "field.deleter": "Deleter",
  "field.deleted": "Deleted fields",
  "field.deleteTime": "Delete time",
  "field.dept": "Department field",
  "field.dept.empty": "There is no department field in the form",
  "field.ext": "Extension field",
  "field.edit.tip": "Select a field to set properties",
  "field.file.single": "Only one file can be uploaded",
  "field.flowState": "Flow status",
  "field.flow.chart": "Flow Chart",
  "field.form": "Link form",
  "field.formula.edit": "Edit formula",
  "field.formula.edit.done": "Formula has been set",
  "field.formula.empty.tip": "No variables available, please add or save the form and try again",
  "field.formula.deleted.tip": "Deleted fields exist, click to change",
  "field.img.camera": "Only photo by camera",
  "field.img.compress": "Automatically compress images",
  "field.img.watermark": "Add watermark when taking a photo",
  "field.img.watermarkTip": "Watermark includes the author, submission time, location, and is only available for DingTalk mobile client",
  "field.img.single": "Only one images can be uploaded",
  "field.id": "Field ID",
  "field.idOrAlias": "Field ID/alias",
  "field.scan.input": "Scan to input",
  "field.scan.barCode": "Scan bar code",
  "field.scan.editable": "Scan result editable",
  "field.scan.qrCode": "Scan QR code",
  "field.invalid": "Invalid field",
  "field.key": "Primary key field",
  "field.label": "Field title",
  "field.layout": "Layout",
  "field.layout.tip": "Open Form Attribute > need double-column to use",
  "field.layout.width": "The display width is ",
  "field.lineType": "Line type",
  "field.lineType.none": "None",
  "field.link": "Link field",
  "field.link.tip": "Only fields after this field can be associated, please adjust the order of the form fields and set them.",
  "field.linkFilter": "Data filtering",
  "field.linkFilter.add": "Add filters",
  "field.linkFilter.add.done": "Filters added",
  "field.linkFilter.form": "Link Field",
  "field.linkFilter.invalid": "Association condition settings are invalid, click Reset",
  "field.linkFilter.line": "Show data number",
  "field.linkFilter.line.single": "One",
  "field.linkFilter.line.multi": "Multiple",
  "field.linkFilter.msg.invalid": "The association condition setting is invalid, please reset it",
  "field.linkFilter.operation": "Association Table Operations",
  "field.linkFilter.operation.add": "Allow new associated table data",
  "field.linkFilter.scan": "Scan data qr codes after turning on to enter data",
  "field.linkFilter.tip": "Set link conditions to limit link data",
  "field.location.adjustable": "Allow fine tuning",
  "field.location.center.add": "Add positioning center",
  "field.location.center.select": "Please select Positioning center",
  "field.location.empty": "No search result",
  "field.location.lngLat.show": "Show lat-lon coordinate",
  "field.location.lngLat.tip": "Check to get the latitude and longitude coordinates of the current position, supporting to the 6th decimal",
  "field.location.radius": "Set the positioning radius of the positioning center. The recommended range is 500-1000",
  "field.location.range": "The range",
  "field.location.range.set": "Set positioning range",
  "field.location.range.tip": "Add multiple positioning keywords, you will pass verification when the position meets one of the keywords",
  "field.noRepeat": "No duplicate value",
  "field.number": "Number field",
  "field.number.integer": "Only integers are allowed",
  "field.number.integer.input": "Please enter integers",
  "field.number.range": "Limit value range",
  "field.number.range.btw": "Please enter value between {{min}}~{{max}}",
  "field.number.range.gte": "Please enter value greater than or equal to {{min}}",
  "field.number.range.lte": "Please enter value less than or equal to {{max}}",
  "field.name": "Field name",
  "field.name.type": "Enter field name",
  "field.option.add": "Add",
  "field.option.add.other": "Add other",
  "field.option.contact": "Option association setting",
  "field.option.contact.done": "Option association has been set",
  "field.option.line": "Each line represents an option",
  "field.options": "Option {{num}}",
  "field.optionalRange": "Optional range",
  "field.phone": "Phone field",
  "field.file": "File field",
  "field.rely.set": "Data linkage setting",
  "field.rely.set.done": "Data linkage has been set",
  "field.rely.network.error": "『{{name}}』The configuration is invalid, please contact the administrator to re-adjust the form design",
  "field.rely.request.error": "An error occurred in the interface request<br>field：{{name}}<br>error：{{msg}}({{time}} {{api}})",
  "field.rely.error": "Data linkage exception",
  "field.rely.disable.default": "In accordance with subform link setting, do not support default value",
  "field.rely.disable.option": "In accordance with subform link setting, do not support option association",
  "field.rely.disable.limit": "In accordance with subform link setting, do not support range linkage",
  "field.rely.doc": "What is data linkage?",
  "field.rely.msg.inComplete": "Please set complete data linkage condition",
  "field.rely.msg.invalid": "Invalid data linkage, please reset",
  "field.rely.invalid": "Invalid data linkage, click to reset",
  "field.rely.form": "Link form",
  "field.rely.form.placeholder": "Please select link form",
  "field.rely.currentForm": "Current form field",
  "field.rely.relyForm": "Link form field",
  "field.rely.subField": "Linked subform field",
  "field.rely.equal": "Equals",
  "field.rely.when": "Value",
  "field.rely.show": "Show",
  "field.rely.result": "Value",
  "field.rely.sub": "Subform field data linkage",
  "field.rely.sub.add": "Add subform field",
  "field.rely.sub.show": "Show as",
  "field.show": "Show field",
  "field.subform.auth.tip": "Check to configure the specific operation permissions of the subform, including adding new records, editing existing records, and deleting existing records.",
  "field.subform.auth.add": "Able to add record",
  "field.subform.auth.edit": "Able to edit existing record",
  "field.subform.auth.sort": "Able to sort existing record",
  "field.subform.auth.delete": "Able to delete existing record",
  "field.subform.copy.end": "Copy to the last line",
  "field.subform.copy.next": "Copy to the next line",
  "field.subform.insert.up": "Insert Row Up",
  "field.subform.insert.next": "Insert Row Down",
  "field.text": "Text field",
  "field.typeChange.rely": "This field contains data linkage/formula editing, can not be converted",
  "field.typeChange.formula": "This field contains formula editing, and can not be converted",
  "field.typeChange.contact": "This field contains an option association and can not be converted",
  "field.typeChange.async": "The options in the field are derived from other form data/have data linkage and cannot be converted",
  "field.type": "Field type",
  "field.updateTime": "Update time",
  "field.user": "Member field",
  "field.user.deptLimit": "Determined by department field",
  "field.width": "Field width",
  "field.width.half": "1/2 width",
  "field.width.normal": "Standard width",
  "field.width.double": "Double width",
  "field.update": "To",
  "field.userDept.add": "Add department or member",
  "field.detailOnly": "Only show when viewing in detail",
  "file.preview.noSupport": "The current file type does not support online preview",
  "file.preview.support": "Files that support preview?",
  "filter.addCondition": "Add filter condition",
  "filter.check.placeholder": "Please enter the option content, multiple values are separately with 'enter'.",
  "filter.flowNode.formEmptyTip": "Please select the form first",
  "filter.flowNode.list": "Process node history version name",
  "flow.node.prostatus": "Processing Status",
  "flow.node.protime": "Process processing time",
  "flow.node.outtime": "Process timeout period",
  "flow.node.pro.text": "Process timeliness statistics",
  "filter.method.eq": "Equal to",
  "filter.method.ne": "Not equal to",
  "filter.method.all": "Contain at the same time",
  "filter.method.all.address": "Belong to",
  "filter.method.in.one": "Equal to any",
  "filter.method.in.many": "Contain any",
  "filter.method.in.flowNode": "Contain",
  "filter.method.nin": "Not equal to any",
  "filter.method.nin.address": "Not belong to",
  "filter.method.lk": "Contain",
  "filter.method.ulk": "Not contain",
  "filter.method.ep": "Empty",
  "filter.method.nep": "Not empty",
  "filter.method.gt": "Greater than",
  "filter.method.gte": "Greater than or equal to",
  "filter.method.lt": "Less than",
  "filter.method.lte": "Less than or equal to",
  "filter.method.rg": "Select range",
  "filter.method.vf": "Verified",
  "filter.method.nvf": "Not verified",
  "filter.method.fm": "Dynamic Filtering",
  "filter.rel.tip": "Filter out data matching",
  "filter.rel.tip1": "Filter out data matching",
  "filter.rel.and": "All",
  "filter.rel.or": "Any",
  "filter.rel.cond": "Conditions",
  "filter.text.placeholder": "Please enter text content",
  "filter.condition": "Filter condition",
  "filter.condition.add": "Add filter condition",
  "filter.condition.stick": "Pinned display",
  "filter.condition.cancelStick": "Unpinned",
  "flow.activate": "Activate flow",
  "datahelper.curform": "Current data source - {{name}}",
  "datahelper.output.field.tip": "Set the current field to {{name}} field",
  "flow.attr": "Flow attribute",
  "flow.attr.base": "Basic attribute",
  "flow.attr.more": "More attribute",
  "flow.action.disable": "Disable",
  "flow.action.enable": "Enable",
  "flow.action.forward": "Submit",
  "flow.action.forward.tip": "Clicking this button while dealing with the flow will save the user's changes to the data in this node, and the flow data will be forwarded to subsequent nodes.",
  "flow.action.save": "Stash",
  "flow.action.save.success": "Stash successfully",
  "flow.action.save.tip1": "Clicking this button while dealing with the flow will save the user's changes to the data in this node, and the flow data will not be forwarded.",
  "flow.action.save.tip2": "Stash saves the data to the database, and will trigger 'no duplicate value' Valid of the field. ",
  "flow.action.print": "Submit & print",
  "flow.action.print.tip": "After enabled, clicking this button while dealing with the flow will save the user's changes to the data in this node, and the flow data will be forwarded to subsequent nodes. you will enters the print interface for data printing in the same time.",
  "flow.action.back": "Rollback",
  "flow.action.back.tip": "After enabled, clicking this button while dealing with the flow will save the user's changes to the data in this node, and the flow data will be rolled back to specified nodes.",
  "flow.action.transfer": "Transfer",
  "flow.action.transfer.candidates": "Transfer candidates",
  "flow.action.transfer.tip": "After enabled, clicking this button while dealing with the flow will save the user's changes to the data in this node, and the flow is transferred to specified chargers.",
  "flow.action.close": "Close",
  "flow.action.close.tip": "After enabled, clicking this button while dealing with the flow will save the user's changes to the data in this node, and the flow will be closed",
  "flow.action.revoke": "Revoke",
  "flow.action.validate.empty": "Please set button text",
  "flow.action.validate.exceed": "Exceeded button text limit",
  "flow.action.failTip": "Flow fail tip",
  "flow.action.time": "Deal time",
  "flow.action.activate": "Activate",
  "flow.action.sign": "Add Approver",
  "flow.action.sign.tip": "Once enabled, the user can click this button when processing the process to add a temporary approver. The field permissions, approval comments and node operation permissions of the temporary approver are consistent with the properties of this node.",
  "flow.action.sign_before": "Add Pre-approver",
  "flow.action.sign_after": "Add Post-approver",
  "flow.action.sign_parallel": "Add approver",
  "flow.sign.pane": "Add Approver",
  "flow.sign.pane.black1.title": "Ways to Add Approver",
  "flow.sign.pane.black1.tip": "Plase Ways to Add Approver",
  "flow.sign.pane.black1.type1": "Add Pre-approver",
  "flow.sign.pane.black1.type1.desc": "The approver added will handle this application before me.",
  "flow.sign.pane.black1.type2": "Add Post-approver",
  "flow.sign.pane.black1.type2.desc": "I have approved this application and the approver added will handle it later.",
  "flow.sign.pane.black1.type3": "Add approver",
  "flow.sign.pane.black1.type3.desc": "Add an approver for the current node",
  "flow.sign.pane.black2.title": "Select Approver",
  "flow.sign.pane.black2.tip": "Select Approver",
  "flow.auth.group.submit.description": "Member in this group can initiate flow, and members that have been shared with this form will automatically join this group",
  "flow.auth.group.review.name": "View all flow",
  "flow.auth.group.review.description": "Member in this group can view all flow",
  "flow.auth.group.manage.name": "Manage all flow",
  "flow.auth.group.manage.description": "Member in this group can manage all flow",
  "flow.back.allow": "Nodes that can be fallback to",
  "flow.back.parent": "Parent node",
  "flow.back.placeholder": "Please select node that can be rolled back to",
  "flow.back.range": "Node within the specified range",
  "flow.back.tip": "No node can be rolled back to",
  "flow.back.to": "Rollback to",
  "flow.batch.close": "Batch close flow",
  "flow.batch.forward": "Batch Submit",
  "flow.batch.close.tip": "This operation will terminate the ongoing flow and will not affect the completed flow",
  "flow.briefing.tip": "The selected fields are displayed in the process processing list of the access application.Show up to three",
  "flow.briefing.exceed": "Select up to 3 flow brief options",
  "flow.btnText": "Button text",
  "flow.btnText.limit": "The button text is at most {{limit}} characters",
  "flow.btnText.tip": "The edited button text will replace the default button text for node operations, which is valid for both PC and mobile clients",
  "flow.btnText.required": "This item is required",
  "flow.btnText.restore": "Restore default button text",
  "flow.candidate.tip": "No available charger",
  "flow.cc": "CC",
  "flow.cc.dynamic": "Dynamic CC",
  "flow.cc.enable": "Enable CC",
  "flow.cc.set": "Click to set CC",
  "flow.charger": "Charger",
  "flow.charger.current": "Current charger",
  "flow.charger.deptManager": "Department manager of node charger",
  "flow.charger.dynamic": "Dynamic charger",
  "flow.charger.name": "Charger name",
  "flow.charger.select": "Please select charger",
  "flow.charger.set": "Click to set charger",
  "flow.charger.change": "Adjust flow charger",
  "flow.charge.fail.noNextCharger": "No charger of the next node, please contact manager",
  "flow.charge.fail.noCondition": "Do not meet the flow condition, please contact manager",
  "flow.charge.fail.noBackCharger": "No charger of the rolled back node, please contact manager",
  "flow.create": "Launch",
  "flow.creator": "Initiator",
  "flow.createTime": "Initiate time",
  "flow.creator.depManager": "Department manager of initiator",
  "flow.close": "Close",
  "flow.batch.active": "Batch activate flow",
  "flow.batch.active.subtitle": '<span style="color:#4D609F" >*选择每个流程版本需要激活的流程节点可以批量激活<span>',
  "flow.batch.active.flow.hint": "请选择需要激活的流程节点",
  "flow.close.confirm": "Are you sure to close flow?",
  "flow.close.desc": "Save the operation in this node and close flow directly, the flow will no longer be forwarded",
  "flow.close.tip": "Data will not be forwarded after the flow is closed. Are you sure to close this flow?",
  "flow.close.all": "Close all flow",
  "flow.close.all.confirm": "Are you sure to close all flow?",
  "flow.close.all.done": "All flow are closed",
  "flow.close.selected": "Close selected flow",
  "flow.close.selected.confirm": "Are you sure to close selected flow?",
  "flow.close.selected.done": "Selected flow are closed",
  "flow.chart.empty": "No flow chart",
  "flow.cond": "Data flow condition",
  "flow.cond.add": "Add flow condition",
  "flow.cond.custom": "Use custom flow condition",
  "flow.cond.custom.tip": "When the data meets the flow condition, it will be forwarded to the node at the end of this connection line. when there is no flow condition, all data will be forwarded to the node at the end of this connection line.",
  "flow.cond.else": "Use Else condition",
  "flow.cond.else.tip": "When the data does not meet other flow conditions of the same level, it will be forwarded to the node at the end of this connection line.",
  "flow.comment.empty": "No approval comment",
  "flow.done": "This flow has been dealt with",
  "flow.done.tip": "This flow has been dealt with and can not be operated again. Please select another flow.",
  "flow.done.viewReason": "View detailed reason",
  "flow.done.clickToViewReason": "Click here to view detailed reason",
  "flow.drag.node.guide": "Drag to add node",
  "flow.enable": "Begin to use",
  "flow.enable.tip": "Draw a flow chart like example chart shown above, set the data flow way, you can build an online workflow",
  "flow.enable.qa": "If you have any questions, please refer to ",
  "flow.fail.hint.forward": "Fail to submit",
  "flow.fail.hint.autoBack": "Fail to auto-rollback",
  "flow.fail.hint.autoForward": "Fail to auto-submit",
  "flow.fail.hint.back": "Fail to rollback",
  "flow.fail.hint.charger": "No charger of the next node",
  "flow.fail.hint.cond": "Not meet the flow condition",
  "flow.fail.hint.reason": "Cause of error: ",
  "flow.fail.hint.title": "There is an error in the flow, you can contact the link publisher for help",
  "flow.fail.hint.detail": "Your data has been saved, please do not submit repeatedly",
  "flow.flowCreator": "Flow initiator",
  "flow.launch": "Launch",
  "flow.launch.empty": "There is currently no flow that can be initiated",
  "flow.list.empty": "There is no flow meets the filter condition",
  "flow.list.todo.empty": "There is no new to-do task",
  "flow.list.part.empty": "You have not participated in the flow",
  "flow.list.create.empty": "You have not initiated flow",
  "flow.list.multiNode": "Multiple nodes",
  "flow.list.current": "Currently: ",
  "flow.list.date.just": "Less than 1 minute",
  "flow.list.date.longAgo": "More than 30 days",
  "flow.list.date.remaining": "Remaining time",
  "flow.list.loaded": "All data has been loaded",
  "flow.logAndState": "Flow log/flow chart",
  "flow.log.enable": "Allow to view flow log and flow chart",
  "flow.log.tip": "After this function is turned on, you can view the flow log and flow chart when dealing with flow.",
  "flow.log.startTime": "Start time: {{time}}",
  "flow.log.dealTime": "Deal time: {{time}}",
  "flow.log": "Flow log",
  "flow.log.empty": "No flow log",
  "flow.manage": "Flow management",
  "flow.msg": "Flow notification",
  "flow.msg.dingtalk": "Use DingTalk to notify the node charger and CC",
  "flow.msg.wework": "Use WeChat Work to notify the node charger and CC",
  "flow.msg.wechat": "Use WeChat to notify the node charger and CC",
  "flow.msg.email": "Use email to notify the node charger and CC",
  "flow.node": "Flow node",
  "flow.node.action": "Node operation",
  "flow.node.action.tip": "Configure what the flow charger can do while he is dealing with the flow",
  "flow.node.attr": "Node attribute",
  "flow.node.auth.empty": "Node field permissions are not configured",
  "flow.node.cc": "CC node",
  "flow.node.cc.empty": "CC is not set",
  "flow.node.charger": "Node charger",
  "flow.node.charger.empty": "Node charger is not set",
  "flow.node.copy": "Copy node",
  "flow.node.current": "Current node",
  "flow.node.del": "Delete node",
  "flow.node.empty": "There exists node that has no charger or all fields are not visible",
  "flow.node.end": "Flow end",
  "flow.node.end.del": "Flow end can not be deleted",
  "flow.node.end.unconnect": "Flow end node is not connected, process cannot enable",
  "flow.node.end.desc": "The node without the subordinate node will be automatically connected to the flow end; if you need to end the flow midway, please connect the node that needs to end the flow to the flow end, and set the corresponding flow condition",
  "flow.node.isolated": "There is a node with no data flow, please enable flow after deleting the node",
  "flow.node.name": "Node name",
  "flow.node.path": "Node connection line",
  "flow.node.pt": "Node print template",
  "flow.node.pt.set": "Template setting",
  "flow.node.select": "Please select a node",
  "flow.back.node.select": "Please select a back node",
  "flow.node.signature.disable": "Signature is not available",
  "flow.node.start": "Flow initiation",
  "flow.node.start.del": "Flow initiation node can not be deleted",
  "flow.node.validate": "Node verify condition",
  "flow.node.validate.any": "All data can be submitted",
  "flow.node.validate.meet": "Data that meets the condition can be submitted",
  "flow.node.cancelReminder": "Submit does not trigger reminder",
  "flow.node.doing": "In process",
  "flow.node.done": "Solved",
  "flow.node.undone": "Pending",
  // "flow.node.flow_sub": "Subprocess",
  "flow.node.flow_sub": "sub-process initiator",
  "flow.node.flow_sub.name": "Sub-process form",
  "flow.node.flow_sub.set": "Click to set the initiator",
  "flow.node.flow_sub.tooltip": "When you move to this node, the process is automatically created for the selected process form.",
  "flow.node.flow_sub.transfer": "Data transfer",
  "flow.node.flow_sub.transfer.set": "Set data delivery rules",
  "flow.node.flow_sub.transfer.done": "Data transfer rules set",
  "flow.node.flow_sub.transfer.rule": "Flow rules",
  "flow.node.flow_sub.transfer.end": "The sub-process ends and goes to the next node",
  "flow.node.flow_sub.transfer.start": "Sub-process initiates and goes to the next node",
  "flow.node.flow_sub.transfer.warning": "Add up to {{ count}} sub-process nodes",
  "flow.node.flow_sub.rule.warning": "Select the sub-process form first",
  "flow.node.flow_sub.rule.same": "Are you sure you want to use this sub-form field to assign values?",
  "flow.node.flow_sub.rule.same.desc": "A single sub-form cannot use different sub-form fields to assign values. This operation will clear some of the set rules",
  "flow.node.flow_sub.auto.submit": "Auto-submit after sub-process initiated",
  "flow.node.flow_sub.transfer.tooltip": "When turned on, when the flow is transferred to the sub-process node, the process is automatically created for the initiator and submitted, directly into the subsequent node;",
  "flow.node.flow_sub.transfer.tooltip.desc": "When off, only the initiator is created to do, staying at the initiating node.",
  "flow.node.flow_sub.transfer.tip.in": "When the parent process flows to the child process node, the following parent process field values are assigned to the corresponding child process field.",
  "flow.node.flow_sub.transfer.tip.out": "When the child process flow is complete, the following sub-process field values are assigned to the corresponding parent process field.",
  "flow.node.flow_sub.complete.tip": "Please set the full delivery rule",
  "flow.node.flow_sub.form.fail": "Form deleted/no cross-app permissions",
  "flow.node.flow_sub.to": "Assign to",
  "flow.node.flow_sub.parent": "parent process",
  "flow.node.flow_sub.child": "sub-process",
  "flow.node.flow_sub.child.watermark": "Please select sub-process field",
  "flow.node.flow_sub.parent.watermark": "Please select the parent process field",
  "flow.node.flow_sub.add.rule": "Add rules",
  "flow.node.flow_sub.parent.child": "parent process - child process",
  "flow.node.flow_sub.child.parent": "child process - parent process",
  "flow.node.flow_sub.dynamic": "dynamic promoter",
  "flow.node.flow_sub.creator": "Sub-process initiator",
  "flow.node.flow_sub.close.confirm": "Are you sure you want to close the Data Transfer setting interface?",
  "flow.node.flow_sub.close.detail": "This setting will not be saved after closing, this operation cannot be restored",
  "flow.node.flow_sub.log.inprocess": "Sub-process in progress (complete {{ now}}/{{ total}})",
  "flow.node.flow_sub.log.complete": "The sub-process has been completed (complete {{ total}}/{{ total}})",
  "flow.node.flow_sub.empty": "The form of the sub-process node or the initiator is configured incorrectly",
  "flow.node.flow_sub.maximum": "There is a loop or nesting of more than three levels in the sub-process form setting",
  "form.sub.data.deleted": "The data has been deleted",
  "form.sub.chargers.empty": "Sub-process initiator has not been set",
  "flow.node.flow_sub.access.fail": "There is no corresponding data viewing permission",
  "form.chargersEmptyRule": "The candidate responsible person cannot be empty if the person in charge is empty",
  "form.chargersEmptyRule.items1": "Not enabled",
  "form.chargersEmptyRule.items2": "Skip and go to the next node",
  "form.chargersEmptyRule.items3": "Transfer to the designated person in charge",
  "form.chargersEmptyRule.spareChargers.empty": "The candidate responsible person cannot be empty if the person in charge is empty",
  "form.chargersEmptyRule.spareChargers.log": "The system automatically transfers to the candidate person in charge",
  "form.sub.form.empty": "Sub-process form is not set",
  "form.sub.form.error": "Sub-process form configuration error",
  "form.sub.invalid.in": "You can contact the administrator to activate to the previous node and resubmit",
  "form.sub.invalid.msg": "Trigger failed",
  "mobile.flow.node.doing": "In process",
  "mobile.flow.node.done": "Solved",
  "mobile.flow.node.undone": "Pending",
  "flow.node.selectActivate": "Select active node",
  "flow.node.activate.required": "Active node can not be empty",
  "flow.node.activate.success": "Success to active node",
  "flow.node.activate.fail": "Fail to active node",
  "flow.node.required": "Current node can not be empty",
  "flow.part": "I participate",
  "flow.print.allow": "Allow to print when viewing",
  "flow.release": "Enable flow",
  "flow.release.confirm": "Are you sure to enable flow?",
  "flow.release.tip": "After enabled, newly submitted data will be forwarded according to this version of flow.",
  "flow.release.empty.tip": "Your flow has not been enabled. Please enable the flow in flow setting.",
  "flow.revoke.allow": "Allow revoke after initiation",
  "flow.revoke.tip": "the initiator can withdraw the process when the subsequent node owner has not processed it",
  "flow.Urge": "Urge",
  "flow.Urge.one": "Urge",
  "flow.Urge.allow": "Allow process initiator to remind",
  "flow.Urge.tip": "After the function is turned on, when the person in charge of a node has not yet processed, the initiator can send a reminder notification to him",
  "flow.Urge.process.all": "All nodes in process",
  "flow.rule": "Flow rule",
  "flow.rule.any": "Flow to the next node after any charger forwards",
  "flow.rule.all": "Flow to the next node after all charger forward",
  "flow.save.fail": "Fail to save flow",
  "flow.save.log": "Stash log",
  "flow.save.success": "Flow save success",
  "flow.schedule": "Node limit-time action",
  "flow.schedule.arrive": "When node is arrived",
  "flow.schedule.action.add": "Add auto action",
  "flow.schedule.action.detail": "Auto action detail",
  "flow.schedule.action.defaultMessage": "There are pending node to be dealt with, please handle it in time",
  "flow.schedule.action.op": "Action method",
  "flow.schedule.action.set": "Auto action setting",
  "flow.schedule.action.set.tip": "How to add auto action?",
  "flow.schedule.back": "Auto-rollback",
  "flow.schedule.back.time": "Auto-rollback time",
  "flow.schedule.back.to": "Rolled back to",
  "flow.schedule.brief.timeLimit": " {{ time }} after node is arrived",
  "flow.schedule.del.confirm": "Are you sure to delete node limit-time action?",
  "flow.schedule.del.tip": "After deleting the node limit-time action, the auto action you set will also be deleted. this operation is irreversible.",
  "flow.schedule.doc": "How to set limit-time action?",
  "flow.schedule.forward": "Auto-submit",
  "flow.schedule.forward.time": "Auto-submit time",
  "flow.schedule.forward.execDataExtend": "Perform extended functions",
  "flow.schedule.limit": "Node dealing deadline",
  "flow.schedule.limit.on": "On node dealing deadline",
  "flow.schedule.limit.custom": "Custom time",
  "flow.schedule.limit.widget": "Date & time field in the form",
  "flow.schedule.limit.widget.tip": "Please select date & time field",
  "flow.schedule.node.tooltip": "Node limit-time action has been set",
  "flow.schedule.notify": "Auto-notify",
  "flow.schedule.notify.msg": "Notify text",
  "flow.schedule.notify.time": "Auto-notify time",
  "flow.schedule.op.forward": "Auto-submit",
  "flow.schedule.op.back": "Auto-rollback",
  "flow.schedule.set": "Set limit-time action",
  "flow.schedule.timeLimit": "On node dealing deadline {{ time }}{{ op }}",
  "flow.schedule.tip": "Set dealing deadline for node, and auto-notify node charger to deal with it. If it is not dealt for a long time, it can be automatically forwarded or rolled back to avoid the flow stalling.",
  "flow.schedule.validate.actionEmpty": "Please add node auto action",
  "flow.schedule.validate.actionConflict": "There is a conflict between the node dealing deadline and the auto action time",
  "flow.schedule.validate.target": "Notify target not set",
  "flow.schedule.validate.msg": "Notify text can not be empty",
  "flow.schedule.validate.maxCount": "Fail to add, you can add at most {{ count }} auto actions",
  "flow.schedule.validate.onlyOne": "{{ hasSet }} has been set, you can add at most one {{ action }}",
  "flow.schedule.validate.cannot": "{{ hasSet }} has been set, you can not add {{ action }}",
  "flow.schedule.validate.earlier": "The time of auto-notify needs to be earlier than that of {{ action }}",
  "flow.state.inProcess": "In process",
  "flow.state.complete": "Completed",
  "flow.state.closed": "Closed",
  "flow.setting": "Flow setting",
  "flow.transfer": "Transfer charger",
  "change.flow.node": "Node management",
  "flow.transfer1": "transfer",
  "flow.transfer.set": "Click to set transfer candidate",
  "flow.transferTip": "Only transfer the current charger of this data, and it does not affect the flow configuration.",
  "flow.transfer.noChange": "Current charger has not changed",
  "flow.transfer.required": "Current charger can not be empty",
  "flow.transfer.success": "Charger transfer success",
  "flow.transfer.fail": "Fail to transfer charger",
  "flow.currentTransfer": "Current charger of this node",
  "flow.todo": "My to-do",
  "flow.todo.count": "My to-do {{ count }}",
  "flow.my.cc": "CC me",
  "flow.my.transactors": "I dealt with",
  "flow.todo.current": "Current to-do",
  "flow.todo.mission": "TODO",
  "flow.version": "Flow version",
  "flow.version.add": "Add version",
  "flow.version.add.fail": "Fail to add new version",
  "flow.version.affix.current": "The flow is enabled. If you need to add or delete nodes and connection lines, please ",
  "flow.version.affix.history": "You can not add or delete nodes and connection lines in history version. If you need to add or delete nodes and connection lines, please switch to the version in design, or ",
  "flow.version.btn": "Version management",
  "flow.version.current": "Enabled",
  "flow.version.del.confirm": "Are you sure to delete flow version?",
  "flow.version.del.fail": "Fail to delete version",
  "flow.version.del.tip": "After deleting, you will no longer be able to edit and enable this flow version.",
  "flow.version.design": "Design",
  "flow.version.desc": "Version description",
  "flow.version.desc.edit": "Edit version description",
  "flow.version.desc.label": "Version description: ",
  "flow.version.history": "History",
  "flow.version.label": "Version: ",
  "flow.version.manage": "Manage flow version",
  "flow.version.name": "Flow version(V{{name}})",
  "flow.vip.signature.admin": "There are advanced features in the flow that are beyond the current version: signatures. This feature is disabled. For full functionality, please go to Member Center to upgrade version.",
  "flow.vip.signature.mem": "There are advanced features in the flow that are beyond the current version: signatures. This feature is disabled. For full functionality, please contact corporate creator to upgrade version.",
  "form.allFields": "All form field",
  "form.attr": "Form attribute",
  "form.attr.field": "Field attribute",
  "form.cache": "Form frontend cache",
  "form.cache.tip": "When accessing the form, it will automatically loads the last unfilled content. this is based on the browser cache, thus it is not available across devices.",
  "form.comment": "Comment",
  "form.comment.copied": "Approval comment has been copied",
  "form.comment.copy": "Copy and continue",
  "form.comment.disable": "Disable",
  "form.comment.enable": "Enabled(optional)",
  "form.comment.flow": "After approval comments enabled, the node charger must fill in the approval comments as required when dealing with the flow",
  "form.comment.notNull": "Approval comment is required",
  "form.comment.notNull.signature": "Approval comments(signature) is required",
  "form.comment.notNull.text": "Approval comments(text) is required",
  "form.comment.required": "Enabled(required)",
  "form.comment.save": "Approval comments will not be saved, whether to copy the approval comments before continuing?",
  "form.comment.save.desc": "The system will not save the approval comments you have filled in. Click Copy and Continue and we will automatically copy the approval comments you have filled out.",
  "form.comment.signature.notNull": "(signature)",
  "form.comment.text": "Text",
  "form.config.basic": "Basic setting",
  "form.config.ext": "Form Setting",
  "form.config.Development": "Development",
  "form.copy.empty": "There is no target app available",
  "form.copy.tip": "When you copy a form to another app, references to other forms are not preserved. Data linkage, references to other form fields in the formula, etc. are lost.",
  "form.copy.withData": "Copy data at the same time",
  "form.copy.withData.tip": "The copied data is counted in data amount, please make sure your version meets the requirements.",
  "form.data": "Data management",
  "form.data.manage": "Data management",
  "form.data.auth": "Data permission group",
  "form.data.auth1": "Permission group",
  "buttom.print.auth": "Expand Button",
  "form.data.deleted": "Data has been deleted",
  "form.data.select": "You selected {{length}} piece(s) of data,",
  "form.data.recover": "Recover in the recycle bin after data is deleted",
  "form.data.canNotRecover": "Data deleted cannot be recovered in free version",
  "form.design": "Form design",
  "form.fields": "Form field",
  "form.fields.add": "Drag from the left to add a field",
  "form.fields.basis": "Basic field",
  "form.fields.delete": "If you delete this field, its corresponding form data will also be cleared. Are you sure to delete?",
  "form.fields.enhance": "Enhanced field",
  "form.fields.member": "Department and member field",
  "form.fields.system": "System field",
  "form.guide.add1": "Click on the field name to add a form field",
  "form.guide.add2": "Click on the appropriate field to add to the design panel",
  "form.guide.data": "Set data permissions here, members can sign in to the system to view a specific range of data",
  "form.guide.field": "The added fields are displayed here, you can edit the field title, set field permissions in the field attribute on the right",
  "form.guide.flow.design": "Flow settings can set the flow rules of data. After the flow is enabled, the data will flow according to the set rules.",
  "form.guide.flow.node": "Flow nodes are the most widely used in flow design, drag and drop to add flow nodes to the design panel",
  "form.guide.flow.version": "The flow is already enabled. To add a flow node, click Add new version",
  "form.guide.flow.charger": "You can set the node operation permission on the right after add the node by dragging and dropping, don't forget to set charger",
  "form.guide.flow.launch": "After all the nodes are set up and connected, click here to enable the flow and the data can flow according to the set flow",
  "form.guide.flow.rename": "Click to rename flow form",
  "form.guide.rename": "Click to rename form",
  "form.guide.release": "Publish form consists of publish to team member and public link. Please select the appropriate method according to the scene",
  "form.guide.save": "Click here to save the form design and continue editing the form the next time",
  "form.guide.share": "Share the form here, you can share the form to a team member or an external person to fill out",
  "form.item.image.limit": "Fail to upload, the maximum size limit for a single images is 20M",
  "form.item.file.limit": "Fail to upload, the maximum size limit for a single file is 20M",
  "form.item.error.format": "This item is in the incorrect format",
  "form.layout": "Computer-side form layout",
  "form.layout.mobile": "Mobile form layout",
  "form.layout.standard": "Standard",
  "form.layout.compact": "Compact",
  "form.layout.normal": "One column",
  "form.layout.dc": "Two column",
  "form.flow": "Flow",
  "form.release": "Publish form",
  "form.release.mem": "Publish form to the team members, and members can fill out the form after signing in",
  "form.release.link": "Publish form as public link and fill out the form without signing in",
  "form.release.auth": "Fail to load form permissions",
  "form.load.fail": "Fail to load form",
  "form.link": "Form access intranet",
  "form.link.subTitle": "Team members need to log in and be authorized to access to this link",
  "form.externalLink": "Pulic link",
  "form.externalLink.name": "Form filling link",
  "form.externalLink.label": "Fill in with password",
  "form.ext": "External link extension",
  "form.ext.desc": "Add an extension field to the form external link to mark the data source",
  "form.ext.list": "Extension list ({{length}})",
  "form.ext.listTitle": "Extension list",
  "form.ext.required": "The extension field cannot be empty",
  "form.ext.failTip": "Extension external link value already exists, please re-enter",
  "form.ext.add.success": "Add successfully",
  "form.ext.add.fail": "Fail to add",
  "form.query": "Public query",
  "form.query.subTitle": "Public query link is used to view data, usually in address book query, progress query, score query, etc.",
  "form.fields.display": "Display content",
  "form.public.queryLink": "Public query link",
  "form.public.queryLink.needPass": "Query by password",
  "form.public.queryLink.shareTo": "Share to",
  "form.public.queryLink.shareMsg": "I created {{- entry}} on @Platform, welcome everyone to check out {{- name}}",
  "form.public.innerlinkshare": "Share Inlink",
  "form.public.publiclinkshare": "Share Link",
  "form.public.innerlinkshare.copy.success": "Data inline link copied successfully",
  "form.public.publiclinkshare.copy.success": "Data link link copy successful",
  "form.publish": "Form publish",
  "form.pass.required": "Password can not be empty",
  "form.defaultName": "Unnamed form",
  "form.name": "Name",
  "form.search.empty": "No search result",
  "form.search.placeholder": "Search name",
  "form.set": "Form setting",
  "form.group": "Group",
  "form.submit.async": "Do not leave the page while the form data is in calculation",
  "form.submit.async.desc": "Please do not submit until the calculation completes, otherwise data will be lost. If this prompt appears repeatedly, please contact the manager to adjust the form design",
  "form.submit.continue": "Continue adding",
  "form.submit.fail": "Fail to submit",
  "form.submit.fail.back": "Fail to rollback, can not find the charger of the rollback node",
  "form.submit.fail.charger": "Fail to forward, can not find the charger of the next node",
  "form.submit.fail.charger.desc": "The flow has been temporarily saved to My To-Do. You can contact the manager to check the node charger and resubmit.",
  "form.submit.fail.cond": "Fail to submit, it does not meet the flow condition",
  "form.submit.fail.cond.desc": "The flow has been temporarily saved to My To-Do. You can contact the manager to check the flow condition and resubmit.",
  "form.submit.fail.subflow": "Subflow failed and does not meet the subflow node inflow conditions",
  "form.submit.fail.subflow.desc": "The process has been temporarily stored in My To Do. You can contact the administrator to check the process design and submit it again.",
  "form.submit.fail.approval": "Fail to submit",
  "form.submit.fail.approval.desc": "The total number of process managers does not meet the minimum number requirement set for proportional approval",
  "form.submit.invalid": "There exists a value that does not conform to the standard",
  "form.submit.repeat": "This is a duplicate value",
  "form.submit.contain.repeat": "There exist duplicate values",
  "form.submit.rule": "Assign value to invisible field",
  "form.submit.rule.tip": "Set the way in which invisible field values are handled according to needs",
  "form.submit.rule.always": "Always recalculate",
  "form.submit.rule.alwaysTip": "The calculation and the submit logic of the invisible fields, are consistent with which of those fields in visible time",
  "form.submit.rule.keep": "Keep the original value",
  "form.submit.rule.keepTip": "The original value of the invisible field remains unchanged",
  "form.submit.rule.nullTip": "Invisible fields are submitted as empty values",
  "form.submit.rule.alwaysTip.extra": "The calculation and submission logic of invisible fields are the same as when they are visible (special fields are assigned according to the corresponding rules set)",
  "form.submit.rule.keepTip.extra": "The original value of the invisible field remains unchanged (special fields are assigned according to the corresponding rules set)",
  "form.submit.rule.nullTip.extra": "Invisible fields are submitted as empty values (special fields are assigned according to the corresponding rules set)",
  "form.submit.rule.special": "Special field assignment rules",
  "form.submit.rule.special.tip": "The fields set here are assigned according to the corresponding rules below when they are not visible, and are not affected by the default assignment rules",
  "form.submit.rule.special.set": "Special field assignment rules have been set",
  "form.submit.rule.warning": "Are you sure you want to change the default assignment rule?",
  "form.submit.rule.warning.detail": "After replacing the default assignment rules, the special field assignment rules that have been set will be cleared",
  "form.submit.rule.set": "Set special field assignment rules",
  "form.submit.validate": "Form submission Valid",
  "form.submit.validate.flow": "The flow is enabled, and the submission Valid in the flow is based on the node settings",
  "form.submit.Confirm.settings": "Form submission confirmation settings",
  "form.submit.Confirm.settings.tips.1": "Fields that need to be prompted for confirmation",
  "form.submit.Confirm.settings.tips.2": "Select confirmation field",
  "form.submit.Confirm.settings.tips.3": "Fill in the prompt",
  "form.submit.Confirm.settings.tips.4": "Please confirm the following fields are correct",
  "form.submit.upload.Expired": "There are expired attachments, please upload again before submitting the data",
  "form.submit.async2": "Calculation failed, please check the network and try again",
  "form.submit.async2.desc": "「{{name}}」Calculation failed. If this prompt repeatedly appears, please contact the administrator to adjust the form design.",
  "form.field.visible.label": "Field visible and hidden rules",
  "form.field.visible.add": "Add explicit and implicit rules",
  "form.field.visible.added": "{{- number}} explicit and implicit rules have been set",
  "form.field.visible.maxrule": "Each form can add up to {{- number}} explicit and implicit rules",
  "form.field.visible.maxcond": "Add at most {{- number}} conditions to each explicit and implicit rule",
  "form.field.visible.tip": "Let the field be displayed when certain conditions are met, otherwise it is hidden.",
  "form.field.visible.question": "How to set explicit and implicit rules?",
  "form.field.visible.delete": "Are you sure you want to delete this explicit/hidden rule?",
  "field.visible.filter.inComplete": "Please set a complete condition",
  "field.visible.fields.inComplete": "Please set the field to be displayed",
  "field.visible.fields.hasUsed": "A display field has been set by other explicit/hidden rules",
  "subField.visible.label": "Subfield visible and hidden rules",
  "subField.visible.tip": "Let the subfields of the subform be displayed when certain conditions are met, otherwise hidden.",
  "subField.visible.add": "Add explicit and implicit rules",
  "subField.visible.added": "{{- number}} explicit and implicit rules have been set",
  "subField.trigger.show": "Show the following subfields",
  "form.field.contact.tip": "The option association has been upgraded to \"Field Explicit and Hidden Rule\", please configure it in the form properties. ",
  "form.field.trigger.before": "Satisfy the following",
  "form.field.trigger.after": "Conditional time",
  "form.field.trigger.show": "Show the following fields",
  "form.theme.align": "Alignment",
  "form.theme.background": "Page background",
  "dash.theme.component.background": "Component background",
  "form.theme.banner": "Form header style",
  "form.theme.button": "Submit button",
  "form.theme.button.errtip": '"Submit" and "Submit and Print" buttons must be turned on',
  "form.theme.color": "Color",
  "form.theme.custom": "Custom style",
  "form.theme.external": "Public link style",
  "form.theme.image": "Image",
  "form.theme.image.tip": "Support images in jpg、gif、png format, no more than 5M",
  "form.theme.style": "Style",
  "form.theme.system": "Theme style",
  "form.theme.title": "Title style",
  "form.validator.add": "Add verify condition",
  "form.validator.add.error": "Deleted fields exit, please change now",
  "form.vip.signature.admin": "There are advanced features in the form that are beyond the current version: signature. This feature is disabled. For full functionality, please go to Member Center to upgrade version.",
  "form.vip.signature.mem": "There are advanced features in the form that are beyond the current version: signature. This feature is disabled. For full functionality, please contact the corporate creator to upgrade version.",
  "formula.add": "Add formula",
  "formula.advance": "Advanced function",
  "formula.subform": "Subform function",
  "formula.date": "Date function",
  "formula.empty": "There is no corresponding function",
  "formula.edit.example": "Example of formula editing: ",
  "formula.example": "E.g: ",
  "formula.example.language.grade": "Chinese grade",
  "formula.example.math.grade": "Math grade",
  "formula.example.baseVideo": "View formula quick start video>",
  "formula.example.advanceVideo": "View formula advanced usage video>",
  "formula.example.doc": "See the help documentation for all formulas",
  "formula.func": "Function",
  "formula.input.tip": "Select the field name and function from the left panel, or enter function",
  "formula.input.placeholder": "Please enter the prompt text",
  "formula.inputEnglish": "Please edit the formula in English input mode",
  "formula.current.form.tip": "No variables available, please add or save the form and try again",
  "formula.set.success": "Formula set successfully",
  "formula.valid.set.success": "The Valid condition is set successfully.",
  "formula.field.empty.tip": "No variables available, please add",
  "formula.learnMore": "Learn more",
  "formula.common": "Common function",
  "formula.logic": "Logic function",
  "formula.math": "Math function",
  "formula.omit": "Omission",
  "formula.search": "Search function",
  "formula.text": "Text function",
  "formula.usage": "Usage: ",
  "formula.tooLong": "Expression length exceeds limit",
  "formula.field.aggregate.already": "The fields that have been aggregated can not be aggregated again",
  "formula.field.aggregate.conflict": "The fields of aggregation cannot be calculated with the fields that are not aggregated",
  "formula.field.subform.conflict": "Main fields can not be calculated with subform fields",
  "formula.field.subform.different": "The fields form different subforms can not be calculated with each other",
  "formula.field.number.conflict": "Numeric type metrics and non-numeric type metrics cannot be calculated with each other",
  "formula.valid.fail": "The function formula is incorrect",
  "formula.valid.fail.tip": "Validate failed text: ",
  "formula.valid.field.tip": "There exist invalid fields, please delete",
  "formula.valid.map.tip": "The MAP function is deprecated, please use the MAPX function instead",
  "formula.abs.intro": "ABS function can get the absolute value of a number",
  "formula.abs.usage": "ABS(number)",
  "formula.abs.example": "ABS(-8) returns 8, which is the absolute value of -8",
  "formula.and.intro": "If all parameters are true, the AND function returns a boolean value of true, otherwise it returns a boolean value of false",
  "formula.and.usage": "AND(logical expression 1, logical expression 2,...)",
  "formula.and.example": "AND({Chinese grade}>90,{math grade}>90,{English grade}>90), if all scores are greater than 90, return true, otherwise return false",
  "formula.average.intro": "The AVERAGE function can get the arithmetic mean of a set of values",
  "formula.average.usage": "AVERAGE(number 1, number 2,...)",
  "formula.average.usage.one.para": "AVERAGE(number 1)",
  "formula.average.example": "AVERAGE({Chinese grade},{math grade}, {English grade}) returns the average score of the three courses",
  "formula.average.example.one.para": "AVERAGE ({Language score}), return the average score of Chinese grades",
  "formula.ceiling.intro": "The CEILING function rounds a number up to the nearest integer or to the nearest multiple of significance.",
  "formula.ceiling.usage": "CEILING(number, significance)",
  "formula.ceiling.example": "CEILING(7,6) returns 12, because 12 is a multiple of 6, which is also the nearest integer that 7 is rounded up to",
  "formula.char.intro": "The CHAR function translate number code in computer's character set into characters",
  "formula.char.usage": "CHAR(number)",
  "formula.char.example": "CHAR(10) returns a newline character",
  "formula.count.intro": "The COUNT function can get the number of parameters",
  "formula.count.usage": "COUNT(value, value,...)",
  "formula.count.usage.one.para": "COUNT(value)",
  "formula.count.example": "COUNT(Peter, Mary, Jack, Lily) returns 4,  which is the number of people",
  "formula.count.example.one.para": "COUNT ({Language score}), returns the number of valid language grades",
  "formula.concatenate.intro": "The CONCATENATE function can merge multiple texts into one text",
  "formula.concatenate.usage": "CONCATENATE(text 1, text 2,...)",
  "formula.concatenate.example": 'CONCATENATE("Jay Chou ","is a singer") will return "Jay Chou is a singer"',
  "formula.countif.intro": "The COUNTIF function can get the number of parameters in the array that meet the condition",
  "formula.countif.usage": 'COUNTIF(array,"condition")',
  "formula.countif.example": 'COUNTIF(subform.gender, "female")，you can get the number of data in the subform filled with"female"; COUNTIF([1,2,3,4],">2")，you can get the number of numbers greater than 2 in 1, 2, 3, 4, and the result is 2.',
  "formula.date.intro": "The DATE function can convert a timestamp to a date object",
  "formula.date.usage": "DATE(timestamp)",
  "formula.datedelta.intro": "The DATEDELTA function can add/subtract the specified number of days to the specified date",
  "formula.datedelta.usage": "DATEDELTA(specified date, number of days to add or subtract)",
  "formula.datediff.intro": "The DATEDIFF function calculates the difference between two times",
  "formula.datediff.usage": "DATEDIFF(time1,time2,type)",
  "formula.day.intro": "The DAY function can get the day of a date in that month",
  "formula.day.usage": "DAY(timestamp)",
  "formula.days.intro": "The DAYS function returns the number of days between two dates.",
  "formula.days.usage": "DAYS(end date, start date)",
  "formula.days360.intro": "DAYS360 returns the number of days between two days based on a 360-day year",
  "formula.days360.usage": "DAYS360(end date, start date)",
  "formula.exact.intro": "The EXACT function can compare whether two texts are identical, returning true if they are identical, otherwise returning false",
  "formula.exact.usage": "EXACT(text 1, text 2)",
  "formula.exact.example": "EXACT({phone number},{prize winning number}), if the two are the same, return true, if not the same, return false",
  "formula.false.intro": "FALSE function returns boolean false",
  "formula.false.usage": "FALSE()",
  "formula.fixed.intro": "The FIXED function rounds the number to the specified number of decimals and outputs it as text",
  "formula.fixed.usage": "FIXED(number, decimals)",
  "formula.fixed.example": 'FIXED(3.1415,2) returns "3.14"',
  "formula.floor.intro": "The FLOOR function rounds number down, toward zero, to the nearest multiple of significance",
  "formula.floor.usage": "FLOOR(number, significance)",
  "formula.floor.example": "FLOOR(7,6) returns 6, because 6 is a multiple of 6, which is also the nearest integer that 7 is rounded down to",
  "formula.getusername.intro": " The GETUSERNAME function can get the nickname of the current user",
  "formula.getusername.usage": "GETUSERNAME()",
  "formula.hour.intro": "The HOUR function can return the number of hours on a date",
  "formula.hour.usage": "HOUR(timestamp)",
  "formula.if.intro": "The IF function determines whether a condition is satisfied; if satisfied it returns a value; if not satisfied, it returns another value",
  "formula.if.usage": "IF(logical expression, value if true, value if false)",
  "formula.if.example": 'IF({Chinese grade}>60,1,2), returning 1 when the Chinese score >60, otherwise 2.',
  "formula.ifs.intro": "The IFS function checks if one or more conditions are met and returns a value that meets the first TRUE condition, and IFS can replace multiple nested IF statements.",
  "formula.ifs.usage": "IFS(logic_1,returned value when logic_1 is true,logic_2,returned value when logic_2 is true,...)",
  "formula.ifs.example": 'IFS({Chinese grade}>90,"excellent",{Chinese grade}>80,"good",{Chinese grade}>=60,"pass",{Chinese grade}<60,"fail")，it returns the evaluation according on the score.',
  "formula.int.intro": "The INT function can get the integer part of a number",
  "formula.int.usage": "INT(number)",
  "formula.int.example": "INT(3.1415) returns 3, which is the integer part of 3.1415",
  "formula.ip.intro": "The IP function can get the current user's ip address",
  "formula.ip.usage": "IP()",
  "formula.isempty.intro": "The ISEMPTY function can be used to determine whether a value is an empty text, an empty object, or an empty array",
  "formula.isempty.usage": "ISEMPTY(text)",
  "formula.isoweeknum.intro": "The ISOWEEKNUM function returns the ISO week number of the year for a given date",
  "formula.isoweeknum.usage": "ISOWEEKNUM(date)",
  "formula.large.intro": "The LARGE function can get the kth maximum in the dataset",
  "formula.large.usage": "LARGE(array, k)",
  "formula.large.example": 'LARGE({student_grade.math_grade},1) returns the first "math grade" in the "student grade"',
  "formula.left.intro": "The LEFT function can return a specified number of characters starting from the first character of a text",
  "formula.left.usage": "LEFT(text, length)",
  "formula.left.example": 'LEFT("Jay Chou is a singer", 3) returns "Jay", that is, the first 3 characters of "Jay Chou is a singer" from left to right',
  "formula.len.intro": "The LEN function can get the length of characters in the text",
  "formula.len.usage": "LEN(text)",
  "formula.len.example": 'LEN("Odyssey") returns 7, because there are 7 characters in the text',
  "formula.log.intro": "The LOG function Returns the logarithm of a number to the base you specify",
  "formula.log.usage": "LOG(number, base)",
  "formula.log.example": "LOG(100,10) returns 2, which is the logarithm of 10 as the base 10",
  "formula.lower.intro": "The LOWER function converts all uppercase letters in a text to lowercase letters",
  "formula.lower.usage": "LOWER(text)",
  "formula.lower.example": 'LOWER("JAYZ") returns "jayz"',
  "formula.mapx.intro": "The MAPX function is an advanced function that can be used to fetch data across forms",
  "formula.mapx.usage": "MAPX(operation, map_value, map_field, result_field)",
  "formula.max.intro": "The MAX function can get the maximum value of a set of values",
  "formula.max.usage": "MAX(number 1, number 2,...)",
  "formula.max.usage.one.para": "MAX(number 1)",
  "formula.max.example": "MAX({Chinese grade},{math grade},{English grade}) returns the highest score in the three courses",
  "formula.max.example.one.para": "MAX ({Language Grade}), returning the highest score in Chinese",
  "formula.mid.intro": "The MID function returns the specified number of characters from the specified position in the text",
  "formula.mid.usage": "MID(text,start position, specified number)",
  "formula.mid.example": 'MID("Platform", 5, 6) returns "daoyun"',
  "formula.min.intro": "The MIN function can get the minimum value of a set of values",
  "formula.min.usage": "MIN(number 1, number 2,...)",
  "formula.min.usage.one.para": "MIN(number 1)",
  "formula.min.example": "MIN({Chinese grade},{math grade},{English grade}) returns the lowest score in the three courses",
  "formula.min.example.one.para": "MIN ({Language score}), return the lowest score of the language score",
  "formula.minute.intro": "The MINUTE function can return the number of minutes of a date",
  "formula.minute.usage": "MINUTE(timestamp)",
  "formula.mod.intro": "The MOD function returns the remainder after number is divided by divisor",
  "formula.mod.usage": "MOD(number, divisor)",
  "formula.mod.example": "MOD(4,3) returns 1, which is the remainder of 4/3",
  "formula.month.intro": "The MONTH function returns the month of a date",
  "formula.month.usage": "MONTH(timestamp)",
  "formula.not.intro": "The NOT function returns a Boolean value that is the opposite of the specified expression.",
  "formula.not.usage": "NOT(logical expression)",
  "formula.not.example": "NOT({Chinese grade}>60), if the Chinese score is greater than 60, return false, otherwise true",
  "formula.networkdays.intro": "The NETWORKDAYS function can get the number of workdays between two dates, and weekends and any other specified dates are excluded.",
  "formula.networkdays.usage": "NETWORKDAYS(start_date,end_date,[holiday_1,holiday_2, ...])",
  "formula.now.intro": "The NOW function can get the current time",
  "formula.now.usage": "NOW()",
  "formula.or.intro": "If any argument is true, the OR function returns a boolean value of true; if all arguments are false, a boolean value of false is returned.",
  "formula.or.usage": "OR(logical expression 1, logical expression 2,...)",
  "formula.or.example": "OR({Chinese grade}>90,{math grade}>90,{English grade}>90), any course score > 90, return true, otherwise false",
  "formula.power.intro": "The POWER function can get the result of a numerical power",
  "formula.power.usage": "POWER(number,power)",
  "formula.power.example": "POWER(3, 2) returns 9, which is 3 squared",
  "formula.product.intro": "The PRODUCT function can get the product of a set of values",
  "formula.product.usage": "PRODUCT(number 1, number 2,...)",
  "formula.product.example": "PRODUCT({unit price}, {quantity}) gets the total price, which is the product of the unit price and the quantity",
  "formula.rand.intro": "The RAND function returns a uniformly distributed random number greater than or equal to 0 and less than one",
  "formula.rand.usage": "RAND()",
  "formula.rand.example": "RAND() returns 0.424656",
  "formula.recno.intro": "The RECNO function is continuously accumulated based on the number of times the current form is accessed. The starting value is 1",
  "formula.recno.usage": "RECNO()",
  "formula.replace.intro": "The REPLACE function can replace part of the text with a different text based on the specified number of characters",
  "formula.replace.usage": "REPLACE(text, start position, replacement length, new text)",
  "formula.replace.example": 'REPLACE("free version",0,4,"advanced") returns "advanced version"',
  "formula.rept.intro": "The REPT function can repeat the text a certain number of times",
  "formula.rept.usage": "REPT(text, number of repetitions)",
  "formula.rept.example": 'REPT("Platform",3) returns "PlatformPlatformPlatform"',
  "formula.right.intro": "The RIGHT function returns the last characters in a text string, based on the number of characters you specify",
  "formula.right.usage": "RIGHT(text,length)",
  "formula.right.example": 'RIGHT("Jay Chou",4) returns "Chou", which is the last 4 characters in the string "Jay Chou"',
  "formula.round.intro": "The ROUND function rounds a number to a specified number of digits.",
  "formula.round.usage": "ROUND(number,digits)",
  "formula.round.example": "ROUND(3.1485,2) returns 3.15",
  "formula.small.intro": "The SMALL function can return the kth minimum in the dataset",
  "formula.small.usage": "SMALL(array,k)",
  "formula.small.example": 'SMALL({student_grade.math_grade}, 1) returns the last "math grade" in "student grade"',
  "formula.sqrt.intro": "The SQRT function can get the positive square root of a number",
  "formula.sqrt.usage": "SQRT(number)",
  "formula.sqrt.example": "SQRT(9) returns 3，which is the square root of 9",
  "formula.sum.intro": "The SUM function can get the sum of a set of values",
  "formula.sum.usage": "SUM(number 1, number 2,...)",
  "formula.sum.usage.one.para": "SUM(number 1)",
  "formula.sum.example": "SUM({Chinese grade},{math grade}, {English grade}) returns the total score of the three courses",
  "formula.sum.example.one.para": "SUM ({Language score}), return the total score of the language score",
  "formula.sumproduct.intro": "The SUMPRODUCT function multiplies corresponding components in the given arrays, and returns the sum of those products and can be used for weighted summation",
  "formula.sumproduct.usage": "SUMPRODUCT(array, array, ...)",
  "formula.sumproduct.example": "SUMPRODUCT([1,2,3],[0.1,0.2,0.3]) returns 1.4，which is 1×0.1 + 2×0.2 + 3×0.3",
  "formula.search.intro": "The SEARCH function can get the starting position of text 1 in text 2",
  "formula.search.usage": "SEARCH(text 1,text 2)",
  "formula.search.example": 'SEARCH("version","free version") returns 6',
  "formula.second.intro": "The SECOND function can return the number of seconds for a date",
  "formula.second.usage": "SECOND(timestamp)",
  "formula.split.intro": "The SPLIT function can split text into arrays by the specified separator",
  "formula.split.usage": "SPLIT(text,separator)",
  "formula.split.example": 'SPLIT("Platform-App Customization Tool","-") returns "Platform, App Customization Tool"',
  "formula.systime.intro": "The SYSTIME function can get the current server time",
  "formula.systime.usage": "SYSTIME()",
  "formula.text.intro": "The TEXT function can convert numbers to text",
  "formula.text.usage": "TEXT(number)",
  "formula.text.example": 'TEXT(3.1415) returns "3.1415"',
  "formula.time.intro": "The TIME function can return a decimal number of a specific time",
  "formula.time.usage": "TIME(hour_number,minute_number,second_number)",
  "formula.timestamp.intro": "The TIMESTAMP function converts a date object into a timestamp",
  "formula.timestamp.usage": "TIMESTAMP(date)",
  "formula.today.intro": "The TODAY function returns the current date",
  "formula.today.usage": "TODAY()",
  "formula.trim.intro": "The TRIM function can remove spaces at the beginning and end of the text",
  "formula.trim.usage": "TRIM(text)",
  "formula.trim.example": 'TRIM("   Platform   ") returns "Platform"',
  "formula.true.intro": "The TRUE function returns a boolean value of true",
  "formula.true.usage": "TRUE()",
  "formula.union.intro": "UNION merges multiple text arrays, and duplicate text is displayed only once",
  "formula.union.usage": "UNION(text1，text2，text3，text4) or UNION([array])",
  "formula.union.example": 'UNION("Alen","Tom","Ben","Tom","Ben") will return ["Alen","Tom","Ben"]',
  "formula.upper.intro": "The UPPER function converts all lowercase letters in a text to uppercase letters",
  "formula.upper.usage": "UPPER(text)",
  "formula.upper.example": 'UPPER("jayz") returns "JAYZ"',
  "formula.uuid.intro": "The UUID function is a random code generator and can be applied to generate random serial number, etc.",
  "formula.uuid.usage": "UUID()",
  "formula.value.intro": "The VALUE function converts text to number",
  "formula.value.usage": "VALUE(text)",
  "formula.value.example": 'VALUE("3.1415") returns 3.1415',
  "formula.weeknum.intro": "The WEEKNUM function returns the week number of a specific date. ",
  "formula.weeknum.usage": "WEEKNUM(date)",
  "formula.workday.intro": "The WORKDAY function can get a date that spans specified number of workdays before or after a given date, and weekends and any other specified dates are excluded.",
  "formula.workday.usage": "WORKDAY(date,number_of_workdays,[holiday_1, holiday_2, ...])",
  "formula.xor.intro": "The XOR function Returns a logical Exclusive Or of all arguments.",
  "formula.xor.usage": "XOR(logical expression 1, logical expression 2,...)",
  "formula.xor.example": "XOR({Chinese grade}>90,{math grade}>90), if both are >90, return false; if both are <90, return false; if one is >90, the other one is <90, return true",
  "formula.year.intro": "The YEAR function returns the year of a date",
  "formula.year.usage": "YEAR(timestamp)",
  "formula.auto.toMetric": "Automatically added as metric item",
  "formula.edit": "Formula editing",
  "formula.edit.subtitle": "Edit the formula using the addition and subtraction operators",
  "formula.edit.inputName.tip": "Please enter a metric name",
  "formula.edit.sample": "Example of formula editing: ",
  "formula.edit.sample.field1": "Imports quantity",
  "formula.edit.sample.field2": "Exports quantity",
  "formula.field.tip": "Please select the included field name from the left panel",
  "formula.field.required": "Field name is required",
  "formula.error": "The formula is incorrect",
  "format.data": "Data format",
  "format.preset": "Preset format",
  "format.custom": "Custom format",
  "format.custom.date.sample": "E.g. yyyy-mm-dd",
  "format.thousand": "Thousands",
  "format.hundred": "Percentage",
  "format.decimal": "Decimals",
  "format.subform.SUBFORMLESS.intro": "Compare whether the field value1 in the subform is less than value2. If less than value2, return true, otherwise return false.",
  "format.subform.SUBFORMLESS.usage": "SUBFORMLESS(value1, value2)",
  "format.subform.SUBFORMLESS.example": "This function formula can only process fields in subforms, and cannot use fields other than subforms. It is generally used in form submission validation to determine whether the data in the subform is legal.",
  "format.subform.SUBFORMGREATER.intro": "Compare whether the field value1 in the subform is greater than value2. If it is greater than value2, return true, otherwise return false.",
  "format.subform.SUBFORMGREATER.usage": "SUBFORMGREATER(value1, value2)",
  "format.subform.SUBFORMGREATER.example": "This function formula can only process fields in subforms, and cannot use fields other than subforms. It is generally used in form submission validation to determine whether the data in the subform is legal.",
  "format.subform.SUBFORMEQUAL.intro": "Compare whether the field value1 in the subform is equal to value2, it returns true if it equals, otherwise it returns false.",
  "format.subform.SUBFORMEQUAL.usage": "SUBFORMEQUAL(value1, value2)",
  "format.subform.SUBFORMEQUAL.example": "This function formula can only process fields in subforms, and cannot use fields other than subforms. It is generally used in form submission validation to determine whether the data in the subform is legal.",
  "format.subform.SUBFORMLESSOREQUAL.intro": "Compare whether the field value1 in the subform is less than or equal to value2, if less than or equal to value2, return true, otherwise return false.",
  "format.subform.SUBFORMLESSOREQUAL.usage": "SUBFORMLESSOREQUAL(value1, value2)",
  "format.subform.SUBFORMLESSOREQUAL.example": "This function formula can only process fields in subforms, and cannot use fields other than subforms. It is generally used in form submission validation to determine whether the data in the subform is legal.",
  "format.subform.SUBFORMGREATEROREQUAL.intro": "Compare whether the field value1 in the subform is greater than or equal to value2, if greater than or equal to value2, return true, otherwise return false.",
  "format.subform.SUBFORMGREATEROREQUAL.usage": "SUBFORMGREATEROREQUAL(value1, value2)",
  "format.subform.SUBFORMGREATEROREQUAL.example": "This function formula can only process fields in subforms, and cannot use fields other than subforms. It is generally used in form submission validation to determine whether the data in the subform is legal.",
  "format.subform.SUBFORMNOTEQUAL.intro": "Compare whether the field value1 in the subform is not equal to value2, and it returns true if it is not equal, otherwise it returns false.",
  "format.subform.SUBFORMNOTEQUAL.usage": "SUBFORMNOTEQUAL(value1, value2)",
  "format.subform.SUBFORMNOTEQUAL.example": "This function formula can only process fields in subforms, and cannot use fields other than subforms. It is generally used in form submission validation to determine whether the data in the subform is legal.",
  "get.immediate": "Get immediately",
  "go.pcPlatform": "Please use PC to operate",
  "item.required": "This item is required",
  "info.Incomplete": "Please fill in the complete information",
  "invalid.username": "The username is not in the correct format",
  "invalid.email": "The email is not in the correct format",
  "invalid.phone": "The phone number is not in the correct format",
  "invalid.nickname": "The nickname can not be empty",
  "invalid.password": "The password must be at least 6 digits",
  "invalid.confirmPass": "The passwords you entered do not match.",
  "invalid.url": "URL is not in the correct format",
  "invite.manual.add.tip1": "Members cannot change what you enter when joining, please enter the correct information",
  "invite.manual.add.tip2": "Send the invitation according to the contact information entered; input the mobile phone and email at the same time, only send the mobile invitation",
  "invite.name.placeholder": "Required, up to 12 characters",
  "invite.phone.placeholder": "International mobile phone, please add country code",
  "invite.phone.or.email.required": "Mobile phone or email required",
  "invite.phone.and.email.required": "Mobile phone and email required",
  "invite.importing": "Importing",
  "invite.import.fail.detail": "Import failure details",
  "invite.failList.download": "Download failure list",
  "invite.failList.download.expire.tip": "Please download this list within 1 hour",
  "invite.accept.switch.tip": "The current login account is different from the invited account",
  "invite.accept.switch": "Switch login account",
  "image.add": "Add images",
  "image.insert.url": "Image URL",
  "image.maxLimitTip": "The images size exceeds the limit",
  "image.reset.title": "Are you sure to revert to the default images?",
  "image.reset.tip": "This operation is irreversible",
  "image.recommend.size": "（Recommended size：{{- width}}*{{- height}}px）",
  "image.upload": "Upload images",
  "image.upload.tip": "Image size can not be more than 1MB, uploading up to 10 per time",
  "image.upload.max.toast": "Upload up to 10 per time",
  "image.url.invalid": "Illegal URL",
  "image.url.tip": "Enter the images URL to insert images",
  "image.url.placeholder": "Please enter the images URL",
  "image.maxLimitTip1": "The images size cannot exceed {{count}} MB",
  "image.select": "Select",
  "import.createSuccess.count": "You have successfully created and imported {{- count}} pieces of data to form [{{- name}}]",
  "import.contact.empty": "The Contacts does not match: {{- name}}",
  "import.contact.multi": "The Contacts contains multiple {{- name}}",
  "import.contact.isallowBlank": "Field does not allow null values",
  "import.contact.isnoRepeat": "Field does not allow duplicate values",
  "import.contact.emptyUser": "The following members are not matched in the Contacts. Please re-import after changing the member name",
  "import.contact.sameUser": "There is a member with the same name in the Contacts. Please re-import after changing the member name.",
  "import.contact.emptyDept": "The following departments are not matched in the Contacts. Please re-import after changing the department name",
  "import.contact.sameDept": "There is a department with the same name in the Contacts. Please re-import after changing the department name.",
  "import.dept.fail": "One or more departments failed to match",
  "import.doing": "Importing data...",
  "import.excel": "Import Excel data",
  "import.excel.select": "Select Excel",
  "import.excel.preview": "Preview data",
  "import.excel.form.config": "Configure Form",
  "import.excel.data": "Import data",
  "import.excel.failTip1": "There can not be merged cells",
  "import.excel.failTip2": "Support xls, xlsx format files within {{size}}MB",
  "import.excel.failTip3": "The data in the file can not exceed 50,000 rows and 200 columns(if department and member fields are imported, then it can not exceed 10000 rows and 200 columns)",
  "import.excel.failTip4": "Subform details also take up rows",
  "import.excel.helpTip": "To view more import instructions and examples, please check",
  "import.excel.labelSet.tip": "Choose the header line, and the data before it wont't be imported",
  "import.excel.limitTip": "Preview the first {{limit}} data at most",
  "import.excel.flow": "Imported data triggering process",
  "import.excel.flowAsync": "Import complete, start triggering process...",
  "import.excel.flowAsync.title": "Successfully imported {{- count }} data to the form 「{{ name }}」",
  "import.excel.flowAsync.success": "The process submitted successfully {{- success }}, the submission failed {{- fail }}",
  "import.excel.flowAsync.fail": "The process submitted successfully {{- success}}, the submission failed {{- fail}}, and the failed submission data has been temporarily saved to 「My To Do」",
  "import.update.confirm": "Are you sure you want to import and update the data?",
  "import.update.confirm.tip": 'When there is a duplicate value in "data_id" in the imported data, the data matching the repeated update will be imported one by one.',
  "import.upsert.confirm": "Are you sure you want to import and update and insert data?",
  "import.upsert.confirm.tip": 'When there is a duplicate value for "data_id" in the imported data, the data that matches the repeated updates will be imported one by one. \nWhen "data_id" is empty or Unmatched, data will be inserted.',
  "import.fail": "Fail to import",
  "import.warning.tip": "There are currently {{count}} e rrors that have not been processed. If they are not processed, the system will automatically blank the error items. Please confirm whether to continue importing ?",
  "import.failDetail.view": "View question Details",
  "import.fail.view": "Question Details",
  "import.fail.count": "There exist {{- count}} errors in table, please edit it before importing. If it is not modified, the error data will be empty after import, Keep the original value of the address field",
  "import.failTip": "You have many import data error, please return to the previous step to check the field type, or re-import in the original excel after editing. If it is not modified, the error data will be empty after import",
  "import.failTip.second": "Tip: When a member/department rename causes more errors, you can download the {{- tip1}}，and re-import after modifying Excel by {{- tip2}}.",
  "import.failTip.second.tip1": "Specific error message",
  "import.failTip.second.tip2": "Error message description",
  "import.field.empty": "The imported field name can not be empty",
  "import.form": "Form import",
  "import.formName.empty": "The form name cannot be empty",
  "import.notAllowed": "Do not import",
  "import.prev.text": "Please switch the worksheet or return to the previous step to reselect Excel",
  "import.recommend": "Recommend",
  "import.rowHead": "Header line",
  "import.success.count": "You have successfully imported {{- count}} pieces of data to form [{{- name}}]",
  "import.template": "Standard template",
  "import.tip": "Import instruction and examples",
  "import.user.fail": "One or more members failed to match",
  "layout.vertical": "Vertical",
  "layout.horizontal": "Horizontal",
  "loadMore.click": "Click to load more",
  "log.execute": "Execution log",
  "log.execute.empty": "No execution log",
  "log.update.tip": "(auto update within 1h after change)",
  "link.copy": "Copy link",
  "link.copySuccess": "Link has been copied",
  "link.management.specification": "Platform External Link Specification",
  "manager.normal": "Normal admin group",
  "manager.add": "Add",
  "manager.create.tip": "Click to add admin",
  "manager.creator": "Creator",
  "manager.placeholder": "Please enter manage group name",
  "manager.name.notEmpty": "The manage group name can not be empty",
  "manager.name.tooLong": "The manage group name can not exceed {{length}} words",
  "manager.delete.warning": "Deleting the normal manage group will also delete the related managers and permissions, which can not be restored. If you are sure to delete, please enter the group name: ",
  "manager.delete.success": "The manage group has been deleted!",
  "manager.system": "System admin",
  "manager.appAuth": "App Permissions",
  "manager.appAuth.tip": "Management permissions to all apps",
  "manager.appAuth.edit.tip": "Click to select editable app",
  "manager.funcAuth": "Function permissions",
  "manager.funcAuth.tip": "All function permissions",
  "manager.funcAuth.app": "Able to add/delete app",
  "manager.funcAuth.contacts": "Contacts management",
  "manager.sync": "Sync address book members",
  "manager.contacts.range": "Contacts management range",
  "manager.contacts.range.tip": "Management permissions to all members",
  "manager.contacts.range.edit.tip": "Click to select manageable department",
  "manager.contacts.range.empty.tip": "When no department is selected, all departments can be managed by default",
  "role.contacts.range": "Role Management",
  "role.contacts.range.tip": "Have administrative permissions on all role groups",
  "role.contacts.range.edit.tip": "Edit Management Role Range",
  "role.contacts.range.empty.tip": "When no role is selected, all roles can be managed by default",
  "outsider.contacts.range": "External contact management scope",
  "outsider.contacts.range.tip": "Have management authority for all external contacts",
  "outsider.contacts.range.edit.tip": "Click to select manageable external contact groups",
  "outsider.contacts.range.empty.tip": "When no group is selected, all external contact groups can be managed by default",
  "member.one": "Member 1",
  "member.two": "Member 2",
  "member.id": "Member ID",
  "member.id.format": "Only letters, numbers and underscores are supported",
  "member.id.length": "Member number up to 12 characters",
  "member.id.placeholder": "Members are uniquely identified in the enterprise, it is recommended to use a unified ID within the company system such as the job number",
  "member.import.complete": "Successfully imported {{-successCount}} members",
  "member.import.not.complete": "Successfully imported {{-successCount}} members, failed {{-failCount}} names",
  "member.async.busy": "Syncing",
  "member.async.busy.tip": "Members are syncing...",
  "member.async.start": "Start syncing",
  "member.async.start.tip": "You can do other things, the syncing will continue in the background.",
  "member.async.error": "Fail to sync members",
  "member.async.error.tip": "Fail to sync corporate contacts, please try again later",
  "member.async.auto": "Auto-sync",
  "member.async.auto.set.success": "Set auto-sync successfully",
  "member.async.lastTime": "Last sync: {{lastTime}}",
  "member.async.manual": "Manually sync members",
  "member.async.manual.control": "Manually sync",
  "member.async.weChat": "Sync members from Wechat Work",
  "member.async.success": "Sync corporate contacts successfully",
  "member.async.time": "Sync time",
  "member.async.log": "Member sync log",
  "member.async.log.empty": "No sync log",
  "member.async.log.result": "Sync result",
  "member.async.log.tip": "Save the sync log for the last six months",
  "member.async.log.type": "Sync type",
  "member.async.log.view": "View sync log",
  "member.add": "Add member",
  "member.invite": "Invite member",
  "member.invite.accept": "Accept",
  "member.invite.accept.confirm": "Would you like to accept the invitation of{{- inviter}}",
  "member.invite.accept.guide": "Administrator invites you to join the team and work together",
  "member.invite.dept.required": "Please set member Department",
  "member.invite.name.length": "Name, up to 12 characters",
  "member.invite.name.required": "Please enter member name",
  "member.invite.name.length.tip": "Member name up to 12 characters",
  "member.invite.phone.required": "Please input mobile phone / email",
  "member.invite.phoneOrMail.invalid": "Incorrect phone / email format",
  "member.invite.after": "After the invited joins your team, ",
  "member.invite.alreadyBindWorkWx": "Bound Wechat Work",
  "member.invite.batch": "You can batch manage members.",
  "member.invite.begin": "There are no members in the team. Let's invite members now.",
  "member.invite.bindWorkWxInNewTab": "Please bind Wechat Work in the newly opened page",
  "member.invite.byLink": "Public link",
  "member.invite.department": "You can assign him/her to different departments.",
  "member.invite.form": "You can publish the form to him/her to fill out.",
  "member.invite.manual": "Add members manually",
  "member.invite.import": "Batch import members",
  "member.invite.phoneOrEmail": "Phone/email",
  "member.invite.phoneOrEmail.label": "Phone number/email: ",
  "member.invite.phoneOrEmail.notEmpty": "Enter the phone number or email",
  "member.invite.phoneOrEmail.invalid": "Please enter the phone number or email in the correct format",
  "member.invite.phone.tip": "When inviting non-Chinese mainland users by phone number, please add the international telephone area code before the phone number, for example: +886912345689",
  "member.invite.link": "Invitation link",
  "member.invite.link.tip": "After the invitation link is enabled, user can visit this link to join your team",
  "member.invite.link.Audit": "Invite review",
  "member.invite.link.Audit.tip": "After you turn on the invitation review, you need to pass the review before you can join your team",
  "member.invite.link.Audit.list": "Invite List",
  "member.invite.mail.limit.tip": "Up to 200 SMS and 200 invitation emails at a time",
  "member.invite.mail.rate.limit.tip": "Each phone phone number or email is invited up to 3 times a day",
  "member.invite.mail.invited.tip": "All members have joined the team,Registered User,please do not invite repeatedly",
  "member.invite.list": "Members in the invitation",
  "member.reinvite": "Invite all again",
  "member.joined": "Joined",
  "member.inviting": "Inviting",
  "member.invite.list.empty": "There are no members in the invitation",
  "member.invite.error.tip": "Invitation sent, please do not repeat",
  "member.invite.list.tip": "Show only members who have been invited but have not yet added a team",
  "member.invite.manager": "You can set him/her as a manager to help manage application.",
  "member.invite.notBind": "Skip binding",
  "member.invite.rate.limit.tip": "The invitation has been sent, please do not operate repeatedly",
  "member.invite.wait": "After bound Wechat Work successfully, it may take a few minutes to synchronize the contacts of Wechat Work, please be wait patiently.",
  "member.search": "Search members",
  "member.search1": "Search members",
  "member.search2": "Search members support name, mobile phone and email",
  "member.searching": "Searching, please wait...",
  "member.search.emptyTip.departmentRoot": "No search results, please check the search value",
  "member.search.emptyTip.public": "There is no search result in the current department. Please check the search value or search in all members",
  "member.list.fail": "Fail to get member list!",
  "member.dept.set": "Set member's department",
  "member.dept.alter": "Adjust department",
  "member.dept.alter.select.tip": "Please select the members who need to adjust department",
  "member.dept.set.success": "Adjust successfully",
  "member.remove": "Delete member",
  "member.delete.confirm": "Are you sure to delete selected members?",
  "member.delete.tip": "Delete a member will also delete the member permission, which can not be restored",
  "member.delete.success": "Select members successfully",
  "member.delete.fail": "Fail to delete members",
  "member.delete.owner.tip": "Corporate creator can not be deleted",
  "member.delete.select.tip": "Please select the members you want to delete",
  "member.allow.edit.name": "Allow members to change their name",
  "member.name.valid.empty": "Please enter a member name",
  "member.name.valid.length": "Member name up to 12 characters",
  "member.username.update.tip": "This number can only be modified once",
  "member.username.update.not": "Modifying this number is not supported",
  "member.not.invite.tip": "{{-count}} members did not join",
  "member.not.verify.tip": "{{-count}} phones/mailboxes are not verified",
  "member.invite.again": "Invite again",
  "member.invite.all.again": "All again invite",
  "member.verify.all.again": "Send all Valid",
  "member.verify.success.tip": "The Valid message was sent successfully!",
  "member.verify.error.tip": "Verified message sent, please do not repeat",
  "member.email.verify.tip": "If the unverified mailbox cannot receive the message, please verify it in time.",
  "member.phone.verify.tip": "Unverified phone can't receive the message, please verify it in time.",
  "member.number.internal.tip": "The unique identity of the member within the enterprise",
  "member.number.wechat.tip": 'The unique identifier of the member in the enterprise, synchronized from the enterprise WeChat "account"',
  "member.number.dingtalk.tip": 'The unique identifier of the member in the enterprise, synchronized with the "member UserID"',
  "member.team.join": "I joined",
  "member.team.create": "I created",
  "member.team.current": "Current corporate：{{- corp}}",
  "member.team.current.tip": "The name of the administrator who has not opened the modification permission cannot be modified. If you need to modify, please contact the administrator.",
  "member.phone.verified": "The phone has been verified and cannot be modified. If you need to modify, please contact the member to re-bind in the account center.",
  "member.email.verified": "The mailbox has been verified and cannot be modified. If you need to modify, please contact the member to re-bind in the account center.",
  "member.role.list.empty": "No optional role",
  "migrate.report.tip": "This feature will copy the original report and convert it to a report without affecting the original report.",
  "migrate.report.member.tip": "The converted report is not enabled by default and is not open to members; after it is enabled, it can be opened to users accessing the original report",
  "migrate.report.select.tip": "Please select the report that needs to be converted",
  "migrate.report.empty": "There is no report to convert",
  "migrate.report.title": "Report → Report Conversion",
  "migrate.waiting": "Converting, please wait...",
  "migrate.waiting.tip": "You can close the page and the system will continue to convert for you",
  "migrate.done": "Conversion completed",
  "migrate.success": "Conversion success",
  "migrate.done.tip": "{{-count}} reports are completely converted to reports.",
  "migrate.not.complete.tip": "{{-count}} reports are successfully converted to reports, but there are some issues that need to be manual adjusted",
  "migrate.fail.tip": "{{-count}} report conversion failed",
  "migrate.record.view.tip": "Please check the details in the conversion history",
  "migrate.done.single.tip": "This report has been completely converted to a report.",
  "migrate.done.single.not.complete.tip": "This report has been converted to a report, but there are still some issues that need to be manually adjusted. Please check the details in the conversion history.",
  "migrate.done.fail.tip": "The report has more than 50 components, please reduce components and try again",
  "migrate.dash.enable.tip": "The converted report is not enabled by default and is not accessible to members. You can enable it yourself as needed. It will be accessible to users who have access to the original reports when enabled",
  "migrate.record.view": "History",
  "migrate.record.title": "Report → Report Conversion history",
  "migrate.record.expire.tip": "Only keep the last week conversion history",
  "migrate.record.export.tip": "Only keep the last week conversion history, please handle the conversion issue as soon as possible or {{-exportBtn}}",
  "migrate.record.export": "Export conversion history",
  "migrate.record.empty": "No conversion history",
  "migrate.complete": "Complete conversion",
  "migrate.not.complete": "Not completely converted",
  "migrate.fail": "Fail to convert",
  "migrate.report.banner": "Reports→Report conversion is now available to help you convert your reports into report which is more aesthetic and easy to use.",
  "migrate.immediate": "Convert",
  "mobile.layout": "Mobile layout",
  "mobile.layout.card": "Card mode",
  "mobile.layout.card.setting": "Card setting",
  "mobile.layout.card.image": "Show images field in title",
  "mobile.layout.card.createInfo": "Show submitter and time in title",
  "mobile.layout.card.label": "Show field title in card content",
  "mobile.layout.card.tip": "When viewing data on mobile phone, each piece of data is displayed as a separate card for quick overview",
  "mobile.layout.example.label": "Flexible app platform",
  "mobile.layout.example.createInfo": "Yun",
  "mobile.layout.fx.user": "User",
  "mobile.layout.table": "Table mode",
  "mobile.layout.table.tip": "When viewing data on mobile phone, one data per line is displayed, and you can swipe left and right to see the full data.",
  "mobile.layout.image.select": "Please select the images field in the form",
  "mobile.layout.preview": "Style preview",
  "mobile.layout.product.position": "Product position",
  "mobile.layout.product.title": "Product name",
  "mobile.layout.project.member": "Project member",
  "msg.corp_owner": "Account creator",
  "msg.system_admin": "System admin",
  "msg.dotGuide.closeGuide": "Close guide",
  "msg.qrCode": "Scan QR code, share this link",
  "msg.helpCenterGuide.info": "For more help, please click here and we will be happy to help you",
  "msg.method": "Notify method",
  "msg.system.notification": "System notification",
  "msg.mail.notification": "Email notification",
  "msg.sms.free": "(free)",
  "msg.sms.notification": "SMS notification",
  "msg.sms.notification.tip": "Only notify webhook failure",
  "msg.sms.purchase.tip": "The number of available SMS messages for the current account is 0, and the SMS notify can not be enabled. If you want to continue using this feature, you can purchase SMS package and then enable it.",
  "msg.notification": "Pop-up message",
  "msg.notification.tip": "New notification will pop up in the upper right corner of the page when enabled",
  "msg.notification.tooltip": "Enable SMS notification will cost SMS package",
  "msg.placeholder.mail": "Please enter email",
  "msg.placeholder.phone": "Please enter phone number",
  "msg.readAll": "Mark all as read",
  "msg.read": "Mark as read",
  "msg.target.add": "Add notify target",
  "msg.target.delete.title": "Are you sure to delete this notify target?",
  "msg.target.delete.content": "The target will no longer receive any notification after deletion",
  "msg.target.email.empty": "can not receive notification for email is empty",
  "msg.target.email.unverified": "can not receive notification for email is not verified",
  "msg.target.empty": "No notify target",
  "msg.target.empty.add": "No notify target, click ",
  "msg.target.list": "Notify target list",
  "msg.target.phone.empty": "can not receive notification for phone number is empty",
  "msg.target.phone.unverified": "can not receive notification for phone number is not verified",
  "msg.target.set": "Set notify target",
  "msg.target.set.selected": "Selected",
  "msg.target.set.count": "(up to 5)",
  "msg.target.update": "Edit information",
  "msg.target.tooltip.mail": "Bind email to receive notification",
  "msg.target.tooltip.sms": "Bind phone to receive notification",
  "msg.target.add.format": "The format is incorrect",
  "msg.target.add.repeat": "There exist duplicate items",
  "msg.type": "Message type",
  "msg.type.manage_group": "Add/delete manage group",
  "msg.type.manager": "Add/delete manager",
  "msg.type.app": "Add/delete app",
  "msg.type.dept_user": "Add/delete department or member",
  "msg.type.app_rename": "Edit app name",
  "msg.type.api": "API Key operate log",
  "msg.type.webhook": "Webhook notify",
  "msg.type.etl_cron_job": "ETL execution failure",
  "msg.type.corp_sync": "Member sync result",
  "msg.validate": "Verify",
  "msg.validate.send.all": "SMS and email verifications have been send",
  "msg.validate.send.email": "Email Valid has been send",
  "msg.validate.send.phone": "SMS Valid has been send",
  "manage.group.system.name": "System admin group",
  "message": "Message",
  "message.expire.tip": "Save message history of the last six months",
  "message.app.expire.tip": "Save operation history of the last six months",
  "message.sms.expire.tip": "Save sending logs of the last six months",
  "message.system.log": "System log",
  "message.usage.notify": "Usage",
  "message.operation.notify": "Operation",
  "message.team.invite": "Invitation",
  "message.setting": "Notification",
  "message.empty": "No message",
  "message.notification": "You have a new「{{type}}」 message",
  "message.webhook": "Message webhook",
  "message.webhook.desc": "Use this to push messages to the your server",
  "message.webhook.leave.confirm": "Your change will not be saved after you leave the current page.",
  "message.webhook.error": "When push failures are more than 100 times, then webhook will automatically close, please adjust the config.",
  "message.webhook.state.pushing": "Pushing",
  "message.webhook.state.pause": "Push pause",
  "message.webhook.state.fail": "Push failed",
  "message.webhook.toMyServer": "Push to my server",
  "message.webhook.close.confirm": "Are you sure you want to close the message webhook?",
  "message.webhook.close.tip": "When you close it, you can't push messages with the message webhook.",
  "appLog.template": "{{- operator}} {{- event}} the form「{{- entry}}」",
  "appLog.template.rename": "{{- operator}} renamed「{{- oriEntry}}」as「{{- entry}}」",
  "appLog.template.copy": "{{- operator}} copied the form「{{- entry}}」",
  "member.select.list": "List of department members",
  "member.select.setting": "Click to set",
  "member.select.dept.manager": "{{- name}} | department manager",
  "member.select.group.tip": "There is no contact in this group",
  "member.select.role.empty": "No role",
  "member.select.role.empty.tip": "You can create and assign a role in Contacts",
  "member.select.depart.empty": "No department",
  "member.select.depart.empty.tip": "Please sync or add in Contacts",
  "member.select.member.empty": "No member",
  "member.select.user.empty": "No relevant contact",
  "member.select.role.emptyTip": "No relevant role",
  "metric.calc": "Calculation metric",
  "metric.calc.add": "Add calculation metrics",
  "metric.add.success": "The indicator was added successfully",
  "more.feature": "More custom features",
  "multi.tab.show": "Multi-tab display",
  "multi.tab.name": "Tab",
  "multi.tab.nameWithNum": "Tab {{num}}",
  "multi.tab.add": "Add tab",
  "multi.tab.delete.tip": "When you delete a tab, the fields in this tab will move outside, are you sure you want to delete it?",
  "nav.getTrial": "Get trial",
  "nav.guide": "Guide",
  "nav.profile": "Account center",
  "nav.appstore": "Template center",
  "nav.pack": "Purchase version",
  "nav.update": "Update log",
  "nav.template": "Template center",
  "nav.service": "Support",
  "nav.feedback": "Feedback",
  "nav.service.guide": "You can always contact support here.",
  "nav.doc": "Document",
  "nav.video": "Video",
  "nav.message": "Message management",
  "nav.message.tooltip": "Message",
  "nav.mobile.tooltip": "Mobile",
  "nav.mobile.title": "Platform does not have an app, but you can choose more",
  "nav.mobile.msg": "You can use Platform on mobile phone in multiple ways.",
  "nav.mobile.more": "Need other app solutions? Please click here to tell us",
  "nav.register.dingtalk": "Sign up DingTalk",
  "nav.register.wework": "Sign up Wechat Work",
  "nav.trial": "Apply trial",
  "nav.sso": "Integrate Platform into other external systems/products",
  "nav.wechat": "WeChat service account",
  "nav.wechat.or.dingtalk": "Use in Wechat Work or DingTalk",
  "nav.wechat.integrate": "Integrate your WeChat official account",
  "nav.wechat.fx": "Platform WeChat service account",
  "nav.wechat.scan": "Scan QR code to follow Platform WeChat service account, use Platform in WeChat",
  "name.update": "Edit name",
  "name.placeholder": "Enter name",
  "nickname.update": "Edit nickname",
  "nickname.update.success": "Edit nickname successfully",
  "nickname.placeholder": "Enter nickname",
  "nickname.tooLong": "The nickname is at most {{length}} words",
  "nickname.user.label": "Corporate address book name",
  "newValue.label": "New value: ",
  "order.add": "Add",
  "order.add.aggregate": "Aggregate table package * {{value}}/app",
  "order.add.api": "Data API",
  "order.add.backup": "Recycle bin * {{value}} days",
  "order.add.customLogin": "Custom login page feature",
  "order.add.data": "Total data amount package 100,000 * {{value}}",
  "order.add.data.form": "Data per form limit package * {{value}} 0,000",
  "order.add.etl": "ETL * {{value}}",
  "order.add.manager": "Sub manager * {{value}}",
  "order.add.trigger": "Smart Assistant * {{value}}",
  "order.add.upload": "Attachment upload package * {{value}}GB",
  "order.add.sms": "SMS package 1000 * {{value}}",
  "order.add.sso": "Single sign-on feature",
  "order.add.userMaxCount": "Can buy up to {{-count}} users ",
  "order.calculate.loading": "Calculating",
  "order.calculate.fail": "Unable to calculate",
  "order.confirm": "Confirm",
  "order.confirm.tip": "Are you sure to submit this order?",
  "order.confirm.noMember": "There are no members in this account",
  "order.contract": "Purchase Agreement",
  "order.contract.accept": "I have read and agreed to",
  "order.contract.application": "How do I apply for a contract?",
  "order.contract.contact": "If you need a contract, please call the hotline: {{phone}}",
  "order.contract.hotLine": "Hotline: {{hotLine}}",
  "order.copy": "Copies",
  "order.corp.name": "Team name: {{- name}}",
  "order.corp.owner": "Corporate creator: {{- owner}}",
  "order.coupon": "Coupon",
  "order.coupon.empty.useful": "No available coupon",
  "order.coupon.empty.useless": "No unavailable coupon",
  "order.coupon.limit": "Discount only applies to {{value}} version",
  "order.coupon.useful": "Available coupon",
  "order.coupon.useless": "Unavailable coupon",
  "order.category.service": "Implementation order",
  "order.data.add": "Total data amount upgrade package",
  "order.data.add.count": "Additional data package: {{value}}",
  "order.data.add.price": "¥500.00/package/year 1 package = 100,000 pieces of data",
  "order.data.api.tip": "API provides an easy way for users with programming skills to integrate Platform data and other external data.",
  "order.data.count": "Total data amount: {{value}} 0,000",
  "order.data.given": "Gift data amount: {{value}} 0,000",
  "order.data.own": "Owned data amount: {{value}} 0,000",
  "order.data.own.pack": "Version data amount {{value}} 0,000",
  "order.data.own.add": "+ additional purchased data {{value}} 0,000",
  "order.data.own.given": "+ gift from data growth plan {{value}} 0,000",
  "order.data.pack": "Version data amount: {{value}} 0,000",
  "order.user.totalCount": "Total number of users: {{value}} people",
  "order.user.existingCount": "Number of users already: {{value}} people",
  "order.user.pack": "Number of users to buy the package",
  "order.duration": "Duration",
  "order.duration.more": "Longer time",
  "order.detail": "Order detail",
  "order.effectiveTime": "(valid after payment is confirmed)",
  "order.effectiveTerm": "In order to keep in line with the validity period of other payment functions, the validity period and price of this purchase have been adjusted automatically for you.",
  "order.given": "Gift",
  "order.my": "My order",
  "order.package": "Version",
  "order.package.contrast": "View version details and comparisons",
  "order.price": "Order amount: ",
  "order.product.info": "Product information",
  "order.currency": "¥",
  "order.purchased": "Purchased",
  "order.receipt": "Invoice and contract",
  "order.receipt.notice": "Invoice and contract information",
  "order.receipt.apply": "Apply for an invoice",
  "order.receipt.application": "How to apply for an invoice?",
  "order.receipt.how": "You can apply for invoicing after payment, or you can apply for invoicing at any time at the order management page in account settings",
  "order.receipt.expire": "If you do not apply for an invoice within six months, you will not be able to apply again if expired.",
  "order.receipt.mail": "If the invoice amount is less than 1000 yuan, you need to pay the invoice fee (the express method is SF freight collect, and the freight invoice is provided by SF). When the invoice amount is more than 1000 yuan, Platform bears the invoice mailing fee",
  "order.receipt.contact": "If you have other questions, please contact Platform {{-service}} or call the service hotline: {{phone}}",
  "order.receipt.notAllowed": "Orders that are invoiced in advance cannot be merged for invoicing",
  "order.service": "Service",
  "order.createTime": "Order time: ",
  "order.delete.confirm": "Are you sure to delete the order?",
  "order.delete.confirm.tip": "You can not recover after deletion, are you sure to delete this order?",
  "order.delete.success": "Delete successfully",
  "order.delete.failed": "Fail to delete",
  "order.no": "Order number",
  "order.no.withColon": "Order number: ",
  "order.invoice.amount": "Invoice amount",
  "order.invoice.createTime": "Create time",
  "order.invoice.companyName": "Company name",
  "order.invoice.sendState": "Delivery Status",
  "order.invoice.sent": "Sent",
  "order.invoice.refuse": "Refused",
  "order.invoice.refuse.reason": "Refused reason: ",
  "order.invoice.toSend": "To be sent",
  "order.invoice.merge": "Merge invoice",
  "order.invoice.my": "My invoice",
  "order.invoice.state": "Status",
  "order.invoice.state.label": "Invoice Status: ",
  "order.invoice.do": "Confirm",
  "order.invoice.tooLow": "The amount is less than {{minCash}}, and it can not be invoiced",
  "order.price.all": "Total price",
  "order.price.origin": "Original price: ",
  "order.state": "Order status",
  "order.state.label": "Order Status: ",
  "order.state.paid": "Paid",
  "order.state.unpaid": "Unpaid",
  "order.state.paid.uncollected": "Pending",
  "order.state.canceled": "Canceled",
  "order.state.unreceipted": "Not invoiced",
  "order.state.receipting": "Invoicing",
  "order.state.receipted": "Invoiced",
  "order.state.expired": "Expired",
  "order.submit.success.tip": "Order submission successful, please pay as soon as possible",
  "order.termOfValidity": "Term of validity",
  "order.info": "Order information",
  "order.inquiry": "If there is any doubt, please contact us: {{phone}}",
  "order.amount": "Order amount",
  "order.pay": "Pay",
  "order.pay.done": "Pay done",
  "order.pay.fail": "Fail to pay",
  "order.pay.fail.tip": "Your payment information is not detected, please repay!",
  "order.pay.immediate": "Pay now",
  "order.pay.price": "Pay amount:",
  "order.pay.success": "Pay successfully",
  "order.payment": "Payment",
  "order.payment.confirm": "Confirm the information is correct",
  "order.payment.confirm.tip": "After the transfer voucher is uneditable after submission, please confirm the information is correct",
  "order.payment.modify": "Return to edit",
  "order.payment.account.name": "Payment account name",
  "order.payment.account.no": "Payment account number",
  "order.payment.alipay.tip": "Please complete the payment on the newly opened Alipay page. Please do not close this window until the payment is completed.",
  "order.payment.proof": "Transfer voucher",
  "order.payment.proof.tip": "We will process the order for you as soon as we receive the transfer and the voucher you submitted, thank you for your patience.",
  "order.payment.tip": "If you have not completed the payment, please click",
  "order.payment.transfer.submit": "Submit voucher",
  "order.payment.transfer.tip1": "Please follow the steps below for corporate account payment",
  "order.payment.transfer.tip2": "For your legal rights, please note your order number when transferring",
  "order.payment.transfer.tip3": "After the remittance is completed, please submit the voucher picture of the remittance success (the screenshot of the offline remittance or the screenshot of the online transfer) to the system",
  "order.payment.transfer.tip4": "We will open the service for you as soon as we receive the transfer and the voucher you submitted, thank you for your patience,",
  "order.payment.transfer.tip5": "You can ",
  "order.payment.transfer.tip6": "Submit voucher later",
  "order.payment.unionpay": "UnionPay Payment",
  "order.payment.unionpay.tip": "Please complete the payment on the newly opened payment page. Please do not close this window until the payment is completed.",
  "order.payTime": "Pay time",
  "order.payProof": "Pay voucher",
  "order.payProof.submit": "Submit payment voucher",
  "order.payProof.refuse": "Payment voucher is refused",
  "order.payProof.audit": "Payment voucher is under review",
  "order.operation": "Operation",
  "order.operation.cancel": "Cancel order",
  "order.operation.cancel.confirm": "If you have transferred offline, canceling the order will result in the inability to verify your transfer information, are you sure to cancel the order",
  "order.operation.cancel.success": "Cancel successfully",
  "order.operation.cancel.failed": "Fail to cancel",
  "order.operation.invoice": "Invoice",
  "order.repay": "Repay",
  "order.select.tip": "Please select order",
  "order.user": "User * {{value}}",
  "order.userStd": "Standard Edition * {{value}} people",
  "order.user.add": "Additional purchased user number",
  "order.user.purchase": "Purchased user number: ",
  "order.user.unit": "At least 10 people, and the number must be a multiple of 5",
  "order.user.count": "X{{count}}",
  "order.user.count.own": "Currently purchased user number: {{count}}",
  "order.user.count.total": "User number after purchase: ",
  "order.validity": "Term of validity: {{time}}",
  "operation.auth.importTip": "Form Valid and formulas are not triggered when importing, enable with caution",
  "operation.auth.batchPrintTip": "Only custom print templates support batch printing",
  "operation.auth.selectTip": "Please select at least one action that can be performed",
  "role.add": "Add role",
  "role.create.tip": "Please contact your system manager to create role",
  "role.empty": "There is no role currently",
  "role.delete.confirm": 'Are you sure to delete "{{- name}}"?',
  "role.delete.tip": "Deleting a role will delete the permissions of the role at the same time, but does not delete the contact members assigned to this role.",
  "role.name": "Role name",
  "role.name.placeholder": "Please enter role name",
  "role.name.notEmpty": "The role name can not be empty",
  "role.name.tooLong": "Role name can not exceed {{length}} characters",
  "role.desc1": "Use roles to make collaboration and processes easier",
  "role.desc2": "What is role? A more flexible and convenient business group outside the organizational structure for scenarios such as indiscriminate cross-departmental collaboration tasks and flow approvals",
  "role.removeMember.confirm": "Are you sure to remove the selected member?",
  "role.removeMember.tip": "Removing a member will also remove the current role of the selected member, but will not delete the selected member in Contacts",
  "role.list": "Role list",
  "role.select": "Please select a member role",
  "role.select.tip": "Click to select a role",
  "job.select.tip": "Click to select position",
  "password.update": "Edit password",
  "password.update.success": "Edit password successfully",
  "password.set": "Set password",
  "password.set.warning": "Please set password",
  "password.signIn": "Signin password",
  "password.signIn.error": "Signin password is incorrect",
  "password.new": "New password",
  "password.new.retype": "Enter the new password again",
  "password.original": "Original password",
  "password.minLength": "Minimum length is {{length}}",
  "password.tooShort": "The password length is less than {{length}}",
  "password.confirm": "Confirm password",
  "persona.template.has.vip": "The template contains advanced features",
  "persona.template.exceed.msg": "The features contained in this template has exceeded your current version. Please install it in Template Center after getting the trial.",
  "persona.company.size": "{{num}} people",
  "persona.company.size.above": "Above {{num}} people",
  "persona.emptyTip.company": "Team name can not be empty",
  "persona.emptyTip.referrer": "Channel cannot be empty",
  "persona.emptyTip.industry": "Industry type can not be empty",
  "persona.header": "Complete information and experience 30-day Platform advanced features for free",
  "persona.header.hasTrial": "Complete information and enjoy the precise service of big data",
  "persona.industries.internet": "IT",
  "persona.industries.manufacturing": "Manufacture",
  "persona.industries.trade": "Trade",
  "persona.industries.service": "Service",
  "persona.industries.education": "Education",
  "persona.industries.construction": "Construction",
  "persona.industries.finance": "Finance",
  "persona.industries.government": "Government",
  "persona.industries.medical_medicine": "Medical_medicine",
  "persona.industries.media": "Media",
  "persona.industries.transportation": "Logistics",
  "persona.industries.leasing": "Leasing",
  "persona.industries.estate": "Estate",
  "persona.industries.agriculture": "Farming, forestry, animal husbandry, and fishery",
  "persona.industries.scientific": "Scientific service",
  "persona.industries.social": "Social organization",
  "persona.industries.mining": "Mining",
  "persona.industries.resident": "Resident",
  "persona.industries.electricity": "Supply of electric power, heat, gas and water",
  "persona.industries.environment": "Environment",
  "persona.job.boss": "Boss",
  "persona.job.manager": "Manager",
  "persona.job.staff": "Staff",
  "persona.recommend.skip": "Skip install",
  "persona.recommend.template": "App template",
  "persona.referrers.friend": "Friend's recommendation",
  "persona.referrers.friend.corp": "Company colleagues recommend",
  "persona.referrers.friend.private": "Recommended in private",
  "persona.referrers.friend.circle": "Friend Circle",
  "persona.referrers.search": "Web Search",
  "persona.referrers.search.form": 'Search "Form"',
  "persona.referrers.search.flow": 'Search "Flow"',
  "persona.referrers.search.cooperate": 'Search "Collaboration software"',
  "persona.referrers.zhihu": "Zhihu",
  "persona.referrers.zhihu.fx": "Platform official accounts",
  "persona.referrers.zhihu.influencer": "Zhihu influencer",
  "persona.referrers.weChat": "WeChat official accounts",
  "persona.referrers.weChat.fx": "Platform official accounts",
  "persona.referrers.weChat.excel": "Excel accounts",
  "persona.referrers.weChat.data": "Data accounts",
  "persona.referrers.weChat.manage": "Management accounts",
  "persona.referrers.other.dingding": "Alibaba DingTalk",
  "persona.referrers.other.wework": "Wechat Work",
  "persona.referrers.other.toutiao": "Toutiao",
  "persona.referrers.other.qq": "QQ",
  "persona.referrers.other.online": "Online courses",
  "persona.referrers.other.maimai": "Maimai",
  "persona.your.company.industry": "Your team/business is in the industry of:",
  "persona.your.company.name": "Your team/business name:",
  "persona.your.company.size": "Your team/business size:",
  "persona.your.job": "Your job:",
  "persona.your.phone": "Your phone number:",
  "persona.your.referrer": 'Where did you learn about "Platform":',
  "persona.broadcast.title": "Your information is not complete yet. Improving account information will help us serve you better.",
  "persona.show.yes": "Complete now",
  "phone.bind": "Bind phone",
  "phone.bind.success": "Bind phone number successfully",
  "phone.current": "Current phone",
  "phone.new": "New phone number",
  "phone.invalid.warning": "Please enter the correct phone number",
  "phone.update": "Update phone",
  "phone.update.success": "Edit phone number successfully",
  "phone.unbind": "Unbind phone",
  "phone.unbind.confirm": "Are you sure to unbind your phone?",
  "phone.unbind.tip": "You need to verify the authenticity of the currently bound phone number to unbind phone. After unbinding, you will not be able to sign in to Platform through the original phone number. If you want to continue using phone number to sign in, you can rebind a new phone number.",
  "phone.unbind.success": "Unbind phone number successfully",
  "phone.stop": "Phone is suspended?",
  "phone.verify": "Verify phone",
  "phone.conflict": "Phone number already exists",
  "publish.immediate": "Publish now",
  "publish.skip": "Not yet",
  "publish.continue": "Continue",
  "publish.flow.title": "The flow is not enabled, do you want to continue publishing?",
  "publish.flow.msg": "You can continue publishing form, but the submitted data will not flow according to the process outlined in the flow chart.",
  "print.batch": "Batch print",
  "print.batch.expired.tip": "The download link has expired and can not be downloaded. If you need to download, please re-select the print data",
  "print.batch.expired.tip1": "The download link has expired, please regenerate the PDF",
  "print.batch.fail.tip": "Fail to batch print, please try again later",
  "print.batch.log": "Batch print log",
  "print.batch.log.deleteConfirm": "Are you sure to delete the print log?",
  "print.batch.log.deleteTip": "The file generated will not be downloadable after the print log is deleted, which can not be restored",
  "print.batch.log.none": "No batch print log",
  "print.batch.packing.tip": "You can close this page, and the system will continue to generate files",
  "print.batch.waiting.tip": "The PDF file is being generated, please wait (you can close the page and the system will continue to generate the PDF)",
  "print.batch.finished.tip": "The download link has been completed and will expire at {{time}}, please download as soon as possible",
  "print.batch.finished.tip1": "下载链接已完成，将于{{time}}失效，请尽快下载",
  "print.batch.failed.tip": "PDF export failed, the print file is too large, please adjust the print template or reduce the number of prints and try again",
  "print.batch.failed.tip1": "The download link has expired, please adjust the print template or reduce the number of prints and try again",
  "print.batch.running.tip": "PDF exporting, please wait",
  "print.batch.running.tip1": "The download link has not been generated, please wait",
  "print.batch.delete.tip1": "After deleting the link record, the PDF file generated this time cannot be downloaded. Are you sure to delete this record?",
  "print.begin.point": "Start print point (based on current cell)",
  "print.border": "Border",
  "print.border.none": "No",
  "print.border.weight": "Border weight",
  "print.bg": "Background",
  "print.bg.enable": "Print background",
  "print.bg.tip": "Please upload a background images that matches the aspect ratio of the paper",
  "print.cellHeight.auto": "Dynamic cell height (recommended)",
  "print.cellHeight.auto.tip": "When the form content exceeds the cell, the cell height is automatically stretched to print the entire content",
  "print.cellHeight.fix": "Fixed cell height",
  "print.cellHeight.fix.tip": "Prints exactly according to the cell size set by the template, and the content exceeding the cell will be omitted",
  "print.clear": "Clear content",
  "print.data.all": "Print all data",
  "print.data.filtered": "Print filtered data",
  "print.delete.row": "Delete row",
  "print.delete.col": "Delete col",
  "print.hf": "Header and footer",
  "print.hf.set": "Header and footer setting",
  "print.insert.delete": "Insert/delete",
  "print.hide.cancel": "Cancel hide",
  "print.hide.col": "Hide columns",
  "print.hide.row": "Hide rows",
  "print.insert.number": "Insert page number",
  "print.insert.count": "Insert total page number",
  "print.insert.row.above": "Insert 1 row up",
  "print.insert.row.below": "Insert 1 row down",
  "print.insert.row": "Insert row",
  "print.insert.col": "Insert col",
  "print.insert.col.left": "Insert 1 column left",
  "print.insert.col.right": "Insert 1 column right",
  "print.insert.img": "Insert images",
  "print.insert.img.cell": "Insert cell images",
  "print.insert.img.count": "Float images can not exceed {{count}}",
  "print.insert.img.float": "Insert float images",
  "print.log.view": "View print log",
  "print.merge": "Merge cells",
  "print.merge.confirm": "Are you sure to merge cells?",
  "print.merge.confirm.tip": "The selected area contains multiple data. After merging the cells, only the value in the top left corner of all edited cells will be retained",
  "print.name": "Unnamed template",
  "print.page.bottom": "Footer from bottom: ",
  "print.page.count": "{total page number}",
  "print.page.number": "{page number}",
  "print.page.count.text": "total page number",
  "print.page.number.text": "page number",
  "print.page.top": "Header from top: ",
  "print.paper.dir": "Paper orientation",
  "print.paper.dir.p": "Portrait",
  "print.paper.dir.l": "Landscape",
  "print.paper.height": "Height: ",
  "print.paper.padding": "Page margin",
  "print.paper.padding.top": "Top: ",
  "print.paper.padding.bottom": "Bottom: ",
  "print.paper.padding.left": "Left: ",
  "print.paper.padding.right": "Right: ",
  "print.paper.set": "Print paper setting",
  "print.paper.size": "Paper size",
  "print.paper.width": "Width: ",
  "print.preview.loading.tip": "Generating preview, please wait",
  "print.qrcode.data": "Data QR code",
  "print.qrcode.data.tip": "Print each data as the corresponding QR code, and the team members can scan code to view the corresponding data",
  "print.qrcode.field": "Field QR code",
  "print.qrcode.field.tip": "Print the contents of one field in each data as the corresponding QR code, scan code to enter the corresponding content",
  "print.qrcode.field.empty": "Please select the field you want to print",
  "print.qrcode.field.placeholder": "Please select field",
  "print.qrcode.layout.number": "QR code layout",
  "print.qrcode.padding.tip": "Note: The paper setting only supports A4 paper. If the margin is too large, the QR code may not be printed completely.",
  "print.qrcode.type": "QR code type",
  "print.repeat": "Repeat print settings (please set after selecting a single line)",
  "print.repeat.cross": "Repeat printing this line of content when spanning pages",
  "print.repeat.times": "Repeat prints times: ",
  "print.repeat.title": "When the content on this page exceeds one page of paper, the line content is automatically printed on the top of the next paper",
  "print.record": "Print record",
  "print.save.tip": "The current template is not saved",
  "print.set.bgImg": "Set background images",
  "print.set.cellHeight": "Cell height setting",
  "print.set.paper": "Paper Setting",
  "print.set.repeat": "Repeat print setting",
  "print.sheet.add": "Add a new print sheet",
  "print.sheet.delete": "Are you sure to delete this sheet?",
  "print.sheet.delete.tip": "After deleting this sheet, it will no longer be printed with this template",
  "print.sheet.exceed": "The number of sheets exceeds the limit",
  "print.sheet.name": "Sheet {{num}}",
  "print.system.sequence": "Sequence",
  "print.unMerge": "Unmerge cells",
  "print.usage.empty": "No relevant results",
  "print.usage.flow": "Only nodes in enabled flow are displayed, please go to the node properties to set print templates of node in other versions",
  "print.usage.flow.empty": "The flow version is not enabled",
  "print.usage.flow.empty.desc": "Please enable flow in the flow setting and then set the print template for the flow node",
  "print.usage.range": "Template usage range",
  "print.usage.set": "Set successfully",
  "print.template.name": "Name",
  "print.template.scenes": "Scenes",
  "print.template.type": "Type",
  "print.template.time": "Time",
  "print.template.op": "Operator",
  "print.template.log.type.data": "Data printing",
  "print.template.log.type.batch_qr": "Batch printing of QR",
  "print.template.log.type.batch_data": "Batch printing",
  "print.template.log.scenes.flow": "Submit and print",
  "print.template.log.scenes.manage": "Data management",
  "print.template.log.scenes.group": "Data authority group",
  "print.template.log.scenes.report": "Report",
  "print.template.log.scenes.button": "Button print",
  "print.template.log.scenes.publicQuery": "Public inquiry",
  "profile.person": "Personal",
  "profile.corp": "Corporate",
  "profile.api": "Data API",
  "profile.api.contact": "Contact us to open data API",
  "profile.api.empty": "You do not have data API feature",
  "profile.api.intro": "Data API provides a simple way for programming users to integrate Platform data and other external data",
  "profile.bind.emailOrPhone": "Please bind email or phone",
  "profile.bind.emailOrPhone.pass": "Please bind email or phone, and set password",
  "profile.complete.warning": "Please fill in all the information",
  "platform.empty": "Nothing here",
  "platform.empty.tip1": "Please go to App Edit to add forms and reports",
  "platform.empty.tip2": "Please contact your Platform manager to share the form/report with you",
  "platform.filter.count": "(filter out {{filterCount}} / {{totalCount}} in total)",
  "platform.filter.totalCount": "({{totalCount}} in total)",
  "platform.flow.currentNode.select": "Please select the current node first",
  "platform.flow.filter.add": "Add field filter condition",
  "platform.flow.todo.latest": "Latest",
  "platform.flow.todo.earliest": "Earliest",
  "platform.flow.create.latest": "Latest",
  "platform.flow.create.earliest": "Earliest",
  "platform.flow.transactors.latest": "Latest",
  "platform.flow.transactors.earliest": "Earliest",
  "platform.flow.cc.latest": "Latest",
  "platform.flow.cc.earliest": "Earliest",
  "query.condition": "Query condition",
  "query.condition.set": "Set query condition",
  "query.alter": "Change query condition",
  "query.complete.warning": "Query conditions must be complete",
  "query.pass.tip": "Please enter the password to query this data: ",
  "query.pass.error": "Wrong password",
  "query.pass.type": "Please enter password",
  "page.leave.confirm": "Are you sure to leave the current page?",
  "receipt.type": "Invoice type",
  "receipt.type.special": "Company special invoice(paper)",
  "receipt.type.plain": "Company general invoice(paper)",
  "receipt.type.personal": "Government, institution, individual(paper)",
  "receipt.type.plain.electric": "Company general invoice(Electronic)",
  "receipt.electric.tip": "Electronic invoice has the same legal effect as traditional paper invoice, and can be used as reimbursement voucher",
  "receipt.tax.cert": "General taxpayer certificate",
  "receipt.content.appPlatform": "Platform Application Platform",
  "receipt.content.techService": "Technical service Fee",
  "receipt.tax": "Tax rate: {{taxRate}}",
  "receipt.info": "Invoice information",
  "receipt.downloadTemplate": "Download template",
  "receipt.downloadWordTemplate": "Download Word template",
  "receipt.companyName": "Company name",
  "receipt.taxNo": "Tax number",
  "receipt.taxNo.placeholder": "Please enter the 18-digit tax number",
  "receipt.taxNo.required": "Please enter the 15/18-digit tax number",
  "receipt.fullName": "Name",
  "receipt.regAddress": "Register address",
  "receipt.regPhone": "Register phone",
  "receipt.bank": "Bank",
  "receipt.account": "Account",
  "receipt.content": "Invoice content",
  "receipt.sendMsg": "Sending information",
  "receipt.receiverAddress": "Mailing address",
  "receipt.submitSuccess.tip": "Your invoice has been submitted and we will send the invoice within 1-2 working days",
  "receipt.confirmInfo": "Confirm the information is correct",
  "receipt.returnAndEdit": "Return to edit",
  "receipt.submit.tip": "The invoice information can not be edited after submission, please confirm the information is correct",
  "receipt.send.warning": "The invoicing amount is less than 1,000 yuan, and the freight fee is required. (The delivery method is SF freight collect, you can ask the courier for the freight invoice)",
  "pagination.limit": "{{limit}} / page",
  "pagination.count": "{{count}} in total",
  "pagination.count.filtered": "Filtered out {{count}}",
  "recommend.app.all": "All templates",
  "recommend.app.done": "Start exploring Platform",
  "recommend.app.title": "Install official templates to get you doing business quickly",
  "recommend.app.info": "Pick the following official templates for you to help you get started quickly, with a maximum of 3 items",
  "recommend.color": "Recommended",
  "receiver.validate.success": "Verify successfully",
  "receiver.validate.success.tip": "You have become the notify target of team {{- name}}",
  "receiver.validate.fail": "The link has expired",
  "receiver.validate.fail.tip": "Please contact the team's account creator to resend the Valid",
  "release.team": "Team member",
  "release.team.link": "Team member needs to sign in and be authorized to visit this link",
  "report.release": "Publish report",
  "report.release.mem": "Publish report to team members, and members can view the report after signing in",
  "report.release.link": "Publish report as public link, you don't need to sign in to view report",
  "report.release.team": "Report visit link",
  "report.externalLink": "Report view link",
  "report.defaultName": "Unnamed report",
  "report.chart.legend": "Series {{val}}",
  "report.chart.legend.label": "Series",
  "report.chart.category": "Category {{val}}",
  "report.chart.category.label": "Category",
  "report.load.fail": "Fail to load report",
  "report.form.empty.tip": "You have not created a form yet. It is recommended that you create the form and enter the data before using the report",
  "report.design": "Report design",
  "report.dataSource.empty.tip": "Please set the data source in the right panel",
  "report.field.empty.tip": "Please add a field from the right panel",
  "report.parameter.empty.tip": "Please drag the widget first and add the field",
  "report.dataTable": "Data table",
  "report.combinedTable": "Summary table",
  "report.barChart": "Column chart",
  "report.lineChart": "Line chart",
  "report.pieChart": "Pie chart",
  "report.areaChart": "Area chart",
  "report.radarChart": "Radar chart",
  "report.shift": "Shift chart",
  "report.rili": "Calendar chart",
  "report.map": "Map chart",
  "report.empty.tip": "Drag into the left widget to draw the report",
  "report.field.empty.toast": "Please add a field first",
  "report.widget.filter": "Conditional filter",
  "report.link": "Linkage",
  "report.value": "Value",
  "report.dataAuth.editable": "Edit data",
  "report.dataAuth.removable": "Delete data",
  "report.dataAuth.exportable": "Export data",
  "report.stickyHead": "Frozen table head",
  "report.stickyHead.row": "Freeze row header",
  "report.stickyHead.col": "Freeze col header",
  "report.rowHead": "Row header",
  "report.colHead": "Col header",
  "report.metric": "Metric",
  "report.data.auth": "Report data table permission group",
  "richtext.clear": "Clear format",
  "richtext.height": "Line height",
  "richtext.strikethrough": "Strikethrough",
  "richtext.resizeFull": "Adjust to 100%",
  "richtext.resizeHalf": "Adjust to 50%",
  "richtext.resizeQuarter": "Adjust to 25%",
  "richtext.floatLeft": "Left float",
  "richtext.floatRight": "Right float",
  "richtext.floatNone": "No float",
  "richtext.dragImageHere": "Drag the images here",
  "richtext.selectFromFiles": "Upload from local",
  "richtext.image.url": "Image address",
  "richtext.remove": "Delete images",
  "richtext.original": "Original Size",
  "richtext.link": "Link",
  "richtext.insert.link": "Insert link",
  "richtext.unlink": "Unlink",
  "richtext.edit": "Edit link",
  "richtext.textToDisplay": "Text",
  "richtext.openInNewWindow": "Open in new tab",
  "richtext.table": "Table",
  "richtext.insert.hr": "Horizontal line",
  "richtext.style": "Style",
  "richtext.normal": "Normal",
  "richtext.blockquote": "Blockquote",
  "richtext.pre": "Pre",
  "richtext.h1": "H1",
  "richtext.h2": "H2",
  "richtext.h3": "H3",
  "richtext.h4": "H4",
  "richtext.h5": "H5",
  "richtext.h6": "H6",
  "richtext.unordered": "Unordered",
  "richtext.ordered": "Ordered",
  "richtext.codeview": "Code view",
  "richtext.paragraph": "Paragraph",
  "richtext.outdent": "Outdent",
  "richtext.indent": "Indent",
  "richtext.justify": "Justify",
  "richtext.font.color": "Color",
  "richtext.recent": "Recent",
  "richtext.background": "Background",
  "richtext.foreground": "Foreground",
  "richtext.reset": "Reset",
  "richtext.resetToDefault": "Reset to default",
  "richtext.shortcuts": "Shortcuts",
  "richtext.textFormatting": "Text format",
  "richtext.action": "Action",
  "richtext.paragraphFormatting": "Paragraph format",
  "richtext.documentStyle": "Document style",
  "richtext.specialChar": "Special character",
  "richtext.select": "Select special character",
  "search.max.show.tip": "Show only the first {{- count}} search results",
  "serial.number": "Serial number",
  "sms.available": "Available SMS amount: ",
  "sms.log": "SMS send log",
  "sms.log.empty": "No send log",
  "sms.log.used": "Used",
  "sms.log.detail.prefix": "SMS Valid - ",
  "sms.number": "SMS amount：",
  "sms.order": "Purchase",
  "sms.pack": "SMS package",
  "sms.pack.detail": "SMS package",
  "sms.pack.number": "SMS package number：",
  "sms.pack.number.detail": "1000",
  "sms.pack.order": "Purchase SMS pack",
  "sms.pack.price": "¥90.00",
  "sms.send.fail": "Fail to send, Please check if the phone number is entered correctly.",
  "sms.send.success": "Send successfully",
  "sms.send.status": "Status",
  "sms.send.status.question1": "Why does it fail to send?",
  "sms.send.status.question2": 'Why it shows "successfully sent" and I don\'t receive SMS message?',
  "sso": "Single sign-on",
  "sso.desc": "Apply to the corporate account URL",
  "sso.config.guide": "How to configure?",
  "sso.config.title": "Configure",
  "sso.config.method.tip": "Please select a SSO method",
  "sso.config.saml.tip": "Please obtain the following information from the identity authentication service provider supporting the SAML authentication protocol and fill in",
  "sso.config.saml.title": "SAML 2.0 Endpoint (HTTP)",
  "sso.config.idp.title": "IdP public key",
  "sso.config.algo.title": "SAML encryption algorithm",
  "sso.config.cert.title": "Authentication key",
  "sso.config.certAlgo.title": "Authentication encryption algorithm",
  "sso.config.issuer.title": "Issuer URL",
  "sso.config.secret.title": "Generate Key",
  "sso.config.signin.title": "IdP signin api",
  "sso.config.signout.title": "IdP signout api",
  "sso.config.signout.tip": "If this is completed, user will logout of all apps under the IdP after logging out",
  "sso.config.slo.title": "SLO Endpoint (HTTP)",
  "sso.config.slo.tip": "If this is completed, user will logout of all SAML apps under the IdP after logging out",
  "sso.custom.api": "Custom",
  "sso.saml": "SAML 2.0 Endpoint",
  "sso.saml.short": "SAML 2.0",
  "sso.secret.maxLength": "Authentication key exceeds max length",
  "sso.cert": "Cerification address",
  "sso.custom": "IdP Endpoint",
  "sso.meta": "Metadata address",
  "sso.signout": "logout address",
  "sso.clearConfig.title": "Are you sure to clear the configuration?？",
  "sso.clearConfig.msg": "After clearing, you will not be able to use single sign-on",
  "sso.item.required": "Information is incomplete",
  "submit.success": "Submit successfully",
  "submit.fail": "Fail to submit",
  "submit.verify": "Submit Valid",
  "submit.select": "Submit selected",
  "submit.end": "End submission",
  "submit.finish": "Submit completed",
  "submit.break": "Submit break",
  "submit.timeout": "Submit timeout",
  "satisfaction.survey.title": "User satisfaction survey of Platform",
  "satisfaction.survey.subtitle": "Participate and have a chance to win a 20% discount coupon",
  "send.verify.email": "Send Valid email",
  "send.verify.sms": "Send Valid SMS",
  "survey.recommend.question": "How likely are you to recommend Platform to your friends?",
  "survey.recommend.not": "Never",
  "survey.recommend.able": "Very likely",
  "survey.research.question": "Are you willing to let your company's Platform users participate in the survey?",
  "survey.research.question.tip": "If you want, we will give you feedback on your research results after the survey, so that you could understand the satisfaction of members with Platform.",
  "survey.recommend.unwilling": "Unwilling",
  "survey.recommend.willing": "Willing",
  "survey.clickToParticipate": "Click to participate",
  "survey.confirm": "Are you sure you don't want to participate in this survey?",
  "survey.confirm.manager.tip": "If you are unable to participate in this survey after closing, you will lose the chance to win a 20% discount coupon on Platform.",
  "survey.confirm.member.tip": "If you are unable to participate in this survey after closing, administrators won't know your satisfaction with Platform",
  "survey.confirm.info": "Return to the activity page",
  "survey.thank": "Thank you for your participation",
  "survey.confirm.close": "Do you really want to give up discount coupons and Platform?",
  "template.case": "Use case",
  "template.copy.other": "Copy to other forms of the same application",
  "template.copy.other.tip": "When copying the print template to other forms in the current application, only all styles and text in the template are retained, and form fields are not retained",
  "template.copy.current": "Copy to current form",
  "template.copy.empty": "No target form to select",
  "template.copy.form.empty.tip": "Please select the target form",
  "template.demand.submit": "Submit template needs",
  "template.install": "Install app",
  "template.install.fail": "Fail to install",
  "template.install.withData": "Keep sample data",
  "template.install.withData.tip": "The copied data is counted in data amount, please make sure your version meets the requirements.",
  "template.install.withoutData": "Don't keep sample data",
  "template.install.toGroup": "App install to group",
  "template.copy.toGroup": "Copy app to the following group",
  "template.install.target.group": "Please select the group of app installs",
  "template.not.found": "No related results found",
  "template.not.suitable": "No suitable template?",
  "template.publisher": "Publisher: {{- publisher}}",
  "template.search.tip": "Search template",
  "template.search.result": '"{{- keyword}}" search result',
  "template.share": "Please copy the following link to share the app",
  "template.trial": "The template contains advanced features, do you want to get a trial?",
  "template.trial.time": "The features contained in this template has exceeded the version you are currently using. Do you want to get a {{day}}-day trial of advanced features?",
  "template.upgrade": "The features contained in this template has exceeded the version you are currently using. Please upgrade your account if you need it.",
  "template.welcome": "Welcome to template center",
  "template.desc": "The template center is a platform for users to publish and exchange applications.",
  "template.tip.share": "If you only need to let your team members use your app, then share the app with team members",
  "template.tip.appLink": "If you only need to share your app to a specific user, then join the promotion alliance and share the app link.",
  "template.tip.data": "When an app is published to the Template Center, some of the data in the app will also be published. If there is privacy data in this app, please copy the app and prepare sample data before publishing.",
  "transfer.tip": "This operation only adjusts the charger in the generated flow data, and does not affect the flow configuration",
  "transfer.charger.original": "Original charger",
  "transfer.charger.original.label": "Original charger: ",
  "transfer.charger.original.select": "Please select original charger",
  "transfer.charger.new": "New charger",
  "transfer.charger.new.label": "New charger: ",
  "transfer.charger.new.select": "Please select new charger",
  "transfer.charger.duplicate": "The original charger is the same as the new charger",
  "transfer.record": "Transfer log",
  "transfer.record.none": "No transfer log",
  "transfer.record.view": "View transfer log",
  "transfer.success": "Transfer successfully",
  "transfer.busy": "Transferring, please wait",
  "transfer.busy.tip": "You can close the page and the transferring will continue",
  "transfer.time.label": "Transfer time: ",
  "transfer.count": "Transfer data: {{count}}",
  "transfer.count.success": "Success: {{count}}",
  "transfer.count.fail": "Failed: {{count}}",
  "trigger.create": "Create smart assistant",
  "trigger.empty": "Smart Assistant can automatically add, edit or delete data in the target form after the data changes in the trigger form.",
  "trigger.afterCreate": "After adding data",
  "trigger.afterUpdate": "After editing data",
  "trigger.afterRemove": "After deleting data",
  "trigger.conditions": "When the specified conditions are met",
  "trigger.entry.add": "Add new data to {{- name}}",
  "trigger.entry.update": "Edit the data in {{- name}}",
  "trigger.entry.remove": "Delete the data in {{- name}}",
  "trigger.log.review": "View execution log",
  "trigger.log.failure.detail": "Fail details",
  "trigger.log.failure.detail.view": "View fail details",
  "trigger.log.failure.index": "Index",
  "trigger.log.failure.reason": "Fail reason",
  "trigger.log.time": "Time",
  "trigger.log.user": "Executor",
  "trigger.log.count": "({{count}}",
  "trigger.log.create.empty": "(0, no data to add)",
  "trigger.log.update.empty": "(0, no data to edit)",
  "trigger.log.remove.empty": "(0, no data to delete)",
  "trigger.log.fail": "(Failed-{{msg}})",
  "trigger.log.fail.count": "({{count}} failed)",
  "trigger.log.error.1": "Fail to execute",
  "trigger.log.error.4809": "Circular calculation error",
  "trigger.log.error.4806": "Can not find the target form",
  "trigger.log.error.3002": "Can not find the target form",
  "trigger.log.error.4813": "The trigger exceeds the maximum nesting level",
  "trigger.log.error.4812": "The usage of data edited by trigger exceeds 100",
  "trigger.log.error.4817": "Main field or a single subform can not be assigned with a different subform",
  "trigger.log.error.4821": "Up to 200 new data",
  "trigger.log.error.4012": "Data is being edited by others",
  "trigger.log.error.9007": "Data is being edited by others",
  "trigger.log.error.9008": "Data is being edited by others",
  "trigger.log.error.4000": "Fail to submit data",
  "trigger.log.error.7212": "Run out of data amount for this month",
  "trigger.log.error.7206": "Run out of total data amount/single-form data amounts",
  "trigger.log.error.4403": "Aggregation verify formula is not configured correctly",
  "trigger.log.error.4001": "Data does not exist",
  "trigger.log.error.4815": "No valid filters generated",
  "trigger.log.error.4822": "The field editing is not set correctly",
  "trigger.log.error.4823": "The trigger condition is not set correctly",
  "trigger.log.error.4824": "The amount of data deleted by trigger exceeds 100",
  "trigger.log.error.4825": "The trigger data does not exist",
  "trigger.log.error.2010": "No cross-app operation permission",
  "trigger.log.error.4827": "Filter condition target form subform does not support assignment from trigger form subform",
  "trigger.log.error.4828": "Filtering conditions do not support configuration subform",
  "trigger.log.error.4829": "Filter condition which does not configure target form subform fields will use trigger form primary field assignment",
  "trigger.log.error.4830": "Filter condition which does not configure the primary field of the target form will use trigger form subform field assignment",
  "trigger.log.error.4831": "Filter condition subfield does not support use trigger form primary field assignment",
  "trigger.log.error.4832": "Filter condition target form primary field can only be assigned using the same trigger form subform field",
  "trigger.log.error.4833": "Modifications to subfields of the target form are not supported",
  "trigger.log.error.4834": "Filtering conditions only support filtering subfields of the same subform of the target form",
  "trigger.log.error.4835": "Only subfields of the same subform of the target form are supported for assignment",
  "trigger.log.error.4836": "Target form subform do not support trigger form subform assignment",
  "trigger.log.error.4837": "The primary field of the target form can only be assigned using the same trigger form subform field",
  "trigger.log.error.4838": "Target form subform fields are inconsistent in field assignment and filtering conditions",
  "trigger.log.error.4839": "Trigger from subform fields are inconsistent in field assignment and filtering conditions",
  "trigger.log.filter.empty": "There is no execution log meets the filter condition",
  "trigger.depend.subform.tip": "Are you sure to use a subform field to assign?",
  "trigger.depend.subform.conflict.tip": "Main field or a single subform can not be assigned with a different subform field. This operation may clear some of the field assignment methods that have been set and can not be restored.",
  "trigger.depend.subform.subfield.tip": "Main field and subform field of the target form can not be assigned with subform fields at the same time. This operation may clear some of the field assignment methods that have been set and can not be restored.",
  "trigger.config.subform.support": "Field of the target form can be assigned with subform fields of the trigger form.",
  "trigger.delete.title": "Are you sure to delete Smart Assistant?",
  "trigger.delete.msg": "The smart assistant will no longer trigger the execution of the action after deletion, the previous execution results are not affected",
  "trigger.config.trigger": "Set the trigger action",
  "trigger.config.run": "Set the execution action",
  "trigger.config.name": "Smart Assistant Name",
  "trigger.config.field.add": "Add field",
  "trigger.config.form": "Trigger form",
  "trigger.config.form.tip": "The data assistant triggers an action to modify the data of other tables.",
  "trigger.config.action": "Trigger action",
  "trigger.config.add.tip": "When the newly added data satisfies the following conditions, trigger the execution action",
  "trigger.config.update.tip": "When the edited data satisfies the following conditions, trigger the execution action",
  "trigger.config.remove.tip": "When the deleted data satisfies the following conditions, trigger the execution action",
  "trigger.config.addFilter": "Add trigger condition",
  "trigger.config.fieldAdd.tip": "Add data to the target form, the field values are set as follows",
  "trigger.config.helpDoc": "How to set Smart Assistant?",
  "trigger.config.next": "Next step: set execution",
  "trigger.config.prev": "Previous step: set trigger",
  "trigger.config.fail.tip1": "Please enter assistant name",
  "trigger.config.fail.tip2": "The name of the assistant can not exceed 10 words",
  "trigger.config.fail.tip3": "Please select the trigger form",
  "trigger.config.fail.tip4": "Please select the trigger action",
  "trigger.config.fail.tip5": "The trigger form is the target form of other smart assistants and is nested more than 3 levels",
  "trigger.config.addData": "Add data",
  "trigger.config.addData.tip1": "Filling new data in the trigger form",
  "trigger.config.addData.tip2": "Add data to the target form",
  "trigger.config.updateData": "Edit existing data",
  "trigger.config.updateData2": "Edit data",
  "trigger.config.updateData.tip1": "Edit existing data in the trigger form, such as flow status, etc.",
  "trigger.config.updateData.tip2": "Find data in the target form and edit it",
  "trigger.config.removeData": "Delete existing data",
  "trigger.config.removeData2": "Delete data",
  "trigger.config.removeData.tip1": "Delete a piece of data in the trigger form, batch deletion not included",
  "trigger.config.removeData.tip2": "Find data in the target form and delete it",
  "trigger.config.removeData.condition": "Which data to delete in the target form",
  "trigger.config.removeData.info": "Filter condition can limit which data in the target form is deleted",
  "trigger.config.target": "Target form",
  "trigger.config.target.tip": "The target form is the form of which the data you want to automatically add, edit or delete with the Smart Assistant",
  "trigger.config.field.set": "Set as",
  "trigger.config.updateData.condition": "Which data to edit in the target form",
  "trigger.config.updateData.info": "Filter condition can limit which data to edit in the target form",
  "trigger.config.filter.add": "Add filter condition",
  "trigger.config.field.updateTip": "For the data that meets the filtering conditions, modify the following fields",
  "trigger.config.field.updateTip1": "For the data that meets the filtering conditions, replace the following fields, and replace the unconfigured field data with null",
  "trigger.config.action.add": "Add execution action",
  "trigger.config.action.addTip": "The execution action can not exceed 5",
  "trigger.config.entry.fieldValue": "Value of field",
  "trigger.config.field.select": "Select field in output data",
  "trigger.config.combo.placeholder": "Please enter content, multiple values separated by enter",
  "trigger.config.leaveConfirm": "Are you sure to close the setting page?",
  "trigger.config.leaveConfirm.msg": "The configuration that has been set after closing is not saved, you need to re-configure the Smart Assistant. this operation can not be restored",
  "trigger.config.tip.form": "{{- form }}{{- action}}{{- afterAction}}",
  "trigger.config.tip.afterAction": ", trigger the set execution action",
  "trigger.config.tip.afterActionWithCond": "When the specified condition is met, trigger the set execution action",
  "trigger.config.tip.dataAdd": "Add data to the form",
  "trigger.config.tip.dataAddWithCond": "Data added to the form",
  "trigger.config.tip.dataUpdate": "Edit data in the form",
  "trigger.config.tip.dataUpdateWithCond": "Data edited in the form",
  "trigger.config.tip.dataRemove": "Delete data in the form",
  "trigger.config.tip.dataRemoveWithCond": "Data deleted in the form",
  "trigger.config.valid.sameAction": "The trigger action is the same as the execution action",
  "trigger.config.valid.circle": "The execution action of current smart assistant's target form is the same as the trigger action of the other smart assistant's trigger form",
  "trigger.config.subform.use.confirm": "Are you sure you want to use this subform field?",
  "trigger.config.subform.both.tip": "Target form and trigger form do not support the use of subform fields at the same time. This operation clears some of the filter conditions and field assignments that have been set and cannot be restored.",
  "trigger.config.subform.onlyOne.tip": "Filtration conditions only allow the addition of fields in the same subform. This operation clears some of the filtered conditions and field assignments that have been set, and cannot be restored.",
  "trigger.config.operation.confirm": "Are you sure you want to do this?",
  "trigger.config.operation.tip": "This action clears some of the field assignments that have been set and cannot be restored.",
  "trigger.config.subformrely": "Subform Link Data",
  "datahelper.trigger.config.subform_to_rely": "Link the current line of the sub-form",
  "datahelper.trigger.config.subform_to_rely.tip": "Control data of the trigger line of the linkage subform",
  "datahelper.trigger.config.subform_fix_rely": "Linked sub-form specified line",
  "datahelper.trigger.config.subform_fix_rely.tip": "Link the control data of the specified row of the sub-form according to the conditions",
  "datahelper.trigger.config.subform_add": "Add data to subform",
  "datahelper.trigger.config.subform_add.tip": "Add eligible data to the end of the subform control",
  "datahelper.trigger.config.subform_delete": "Sub-form delete data",
  "datahelper.trigger.config.subform_delete.tip": "Delete data in sub-form controls based on conditions",
  "update.success": "Edit successfully",
  "update.inProcess.wait": "Editing, please wait",
  "update.inProcess.wait.tip": "You can close the page and the editing will continue",
  "update.record": "Edit log",
  "update.record.none": "No edit log",
  "update.field.label": "Edit field：",
  "update.time.label": "Edit time: ",
  "update.dataCount": "Edit data: {{count}}",
  "update.dataCount.success": "Success: {{count}}",
  "update.dataCount.fail": "Failed: {{count}}",
  "username.valid.empty": "Member ID is required",
  "username.valid.length": "Member ID up to 12 characters",
  "username.valid.regex": "Member IDs only support letters, numbers, and underscores",
  "validCode.fetch": "Get valid code",
  "validCode.email": "Email valid code",
  "validCode.shortMessage": "SMS valid code",
  "variable.available": "Available variable",
  "variable.available.empty": "No available variables",
  "saveInfo.saveTitle": "{{- key}} is changed, whether to save?",
  "saveInfo.saveMsg": "You changed {{- key}} without saving, whether to save {{key}} and continue?",
  "saveInfo.save": "Save and continue",
  "saveInfo.cancel": "No",
  "saveInfo.fail": "Fail to save",
  "saveInfo.success": "Save successfully",
  "saveInfo.update.save": "Changes saved",
  "saveInfo.setting": "Save setting",
  "signature.tip": "Scan QR code to add signature",
  "signature.add": "Add signature",
  "subform.maxCountTip": "The amount of subform data has exceeded {{limit}} maximum limits",
  "subform.dataExistTip": "There is data in this record. After the data is deleted, it can not be recovered. Are you sure to delete?",
  "subform.mobileLocation": "Get the current location on mobile",
  "share.toQQ": "Forward to QQ space",
  "share.toRenRen": "Forward to Renren",
  "share.toSina": "Forward to Sina Weibo",
  "share.toDouBan": "Forward to Douban",
  "share.toMingDao": "Forward to Mingdao",
  "title.appSet": "App setting-{{- name}}",
  "title.dash": "Report design-{{- name}}",
  "title.form": "{{- title}}-{{- name}}",
  "title.page": "{{- title}}",
  "title.profile": "{{- title}}-account center",
  "title.report": "Report design-{{- name}}",
  "upload.browserNotSupportTip": "Your browser doesn't support file upload feature",
  "upload.maxLimitTip": "File size exceeds limit",
  "upload.maxLimitTip0": "Uploading 0KB files is not allowed",
  "upload.maxSizeTip": "File size must not exceed {{size}} MB",
  "upload.failTip": "Fail to upload file",
  "upload.success": "Upload successfully",
  "upload.fail": "Fail to upload",
  "upload.redo": "re-upload",
  "user.select": "Click to select member",
  "user.searchEmpty": "No related member",
  "user.searchEmpty.resigned": "No related deleted",
  "user.empty": "No available member",
  "user.empty.resigned": "No deleted",
  "upload.notSupportFileTip": "The selected file type is not supported",
  "vip.systemLimitTip": "Advanced feature will be limited in {{day}} days",
  "vip.advancedFeatures": "View Advanced Features",
  "vip.error.title.upgrade": "Using this feature requires an upgrade version, do you want to upgrade now?",
  "vip.error.title.limit": "The system usage is limited, do you want to upgrade now?",
  "vip.error.7104.msg": "The number of aggregate tables has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant aggregate tables and create new one.",
  "vip.error.7104.memMsg": "The number of aggregate tables has reached the upper limit. Please contact corporate creator to upgrade version before using it",
  "vip.error.7105.msg": "The number of aggregate tables in the app you install exceeds the current version limit. Please contact corporate creator to upgrade version before installing it",
  "vip.error.7110.msg": "The number of members exceeded the limit, in order not to affect your normal use, please upgrade the system as soon as possible, otherwise the system will be disabled.",
  "vip.error.7110.memMsg": "The number of members exceeded the limit, please contact corporate creator to upgrade version",
  "vip.error.7111.msg": "The number of members exceeds the limit. You can go to Member Center to view version usage details and upgrade version to sync or invite more members.",
  "vip.error.7111.memMsg": "The number of members exceeds the limit. Please contact corporate creator to upgrade version to sync or invite more members.",
  "vip.error.7112.msg": "The version you are currently using does not have custom printing feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7112.memMsg": "The version you are currently using does not have custom printing feature. Please contact corporate creator to upgrade version.",
  "vip.error.7113.msg": "The number of custom print templates has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant custom print templates and create new one.",
  "vip.error.7113.memMsg": "The number of custom print templates has reached the upper limit. Please contact corporate creator to upgrade version before creating new one",
  "vip.error.7114.msg": "The number of custom print templates in the app you install exceeds the current version limit. Please contact corporate creator to upgrade version before installing it",
  "vip.error.7120.msg": "The version you are currently using does not include webhook feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7120.memMsg": "The version you are currently using does not include webhook feature. Please contact corporate creator to upgrade version.",
  "vip.error.7121.msg": "The version you are currently using does not include recycle bin  feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7122.msg": "The version you are currently using does not include attachment export feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7122.memMsg": "The version you are currently using does not include attachment export feature. Please contact corporate creator to upgrade version.",
  "vip.error.7123.msg": "The version you are currently using does not include cross-app feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7123.memMsg": "The version you are currently using does not include cross-app feature. Please contact corporate creator to upgrade version.",
  "vip.error.7124.msg": "The version you are currently using does not include auto-sync feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7125.msg": "The version you are currently using does not include custom submission success page feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7125.memMsg": "The version you are currently using does not include custom submission success page feature. Please contact corporate creator to upgrade version.",
  "vip.error.7130.msg": "The version you are currently using does not include signature feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7130.memMsg": "The version you are currently using does not include signature feature. Please contact corporate creator to upgrade version.",
  "vip.error.7132.msg": "The number of ETLs has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant ETL and create new one.",
  "vip.error.7132.memMsg": "The number of ETLs has reached the upper limit. Please contact corporate creator to upgrade version.",
  "vip.error.7133.msg": "The number of ETLs has exceeded the current version limit. In order to avoid system limitations affecting your normal use, you can click view details and delete redundant ETLs.",
  "vip.error.7133.memMsg": "The number of ETLs has reached the upper limit. Please contact corporate creator to upgrade version or adjust the system usage.",
  "vip.error.7134.msg": "The version you are currently using does not include the smart assistant feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7134.memMsg": "The version you are currently using does not include the smart assistant feature. Please contact corporate creator to upgrade version.",
  "vip.error.7135.msg": "The number of smart assistants has reached the upper limit. You can go to Member Center to view version usage details and upgrade version, or delete redundant smart assistants and create new one.",
  "vip.error.7135.memMsg": "The number of smart assistants has reached the upper limit. You can not create new smart assistant",
  "vip.error.7136.msg": "The number of smart assistants has exceeded the current version limit. In order to avoid system limitations affecting your normal use, you can click view details and delete redundant smart assistants.",
  "vip.error.7136.memMsg": "The number of smart assistants exceeds the limit. Please contact corporate creator to upgrade version or adjust the system usage.",
  "vip.error.7139.msg": "The version you are currently using does not include custom style feature. You can go to Member Center to view version usage details and upgrade version.",
  "vip.error.7139.memMsg": "The version you are currently using does not include custom style feature. Please contact corporate creator to upgrade version.",
  "vip.error.7140.msg": "The version you are currently using does not include a custom login page feature. You can go to the Member Center to view the version usage details and upgrade version.",
  "vip.error.7141.msg": "The version you are currently using does not include single sign-on. You can go to the member center to view the version usage details and upgrade version.",
  "vip.error.7142.msg": "The version you are currently using does not include data alerting. You can go to the Member Center to view version usage details and upgraded versions.",
  "vip.error.7142.memMsg": "The version cannot use the data alert feature, please contact the enterprise creator upgrade version",
  "vip.error.7212.msg": "The number of data in the table has exceeded the data traffic limit of this month. Please upgrade the version.",
  "vip.error.7212.memMsg": "The number of data in the table has exceeded the data traffic limit of this month. Please contact the account creator to upgrade the version.",
  "vip.pack.free": "Free",
  "vip.pack.trial": "Trial",
  "vip.pack.lite": "Lite",
  "vip.pack.std": "Standard",
  "vip.pack.user": "By user amount",
  "vip.pack.pro": "Professional",
  "vip.pack.ent": "Enterprise",
  "vip.pack.logo": "LOGO free",
  "vip.pack.oem": "Customized",
  "vip.pack.title": "What versions are available?",
  "vip.pack.detail": "Version detail",
  "vip.pack.oem.hotLine": "Please call: 400-011-1850",
  "vip.pack.submit.request": "Submit needs",
  "vip.pack.price": "Above {{price}}/year",
  "vip.pack.count.title": "Version capacity",
  "vip.pack.users": "Number of users",
  "vip.pack.userPrice": "Number of users to buy unit price",
  "vip.pack.userPriceUnit": "￥{{price}}/person/year",
  "vip.pack.appCount": "Number of applications",
  "vip.pack.priceLimit": "Not to buy",
  "vip.pack.manager.tip": "Sub manager contains system manager and normal manager. System manager has all management permissions. normal manager can be used for hierarchical management of enterprises, and have management permissions of target apps and departments. If you need to purchase additional sub manager based on the version, please contact us at 400-011-1850.",
  "vip.pack.manager.count": "{{count}} sub managers + {{sysCount}} system managers",
  "vip.pack.manager.sysCount": "{{count}} system managers",
  "vip.pack.formData.tip": "The maximum number of data can be stored in a single form",
  "vip.pack.data.freeTip": "(1000/month)",
  "vip.pack.file.title": "The total amount of attachments can be uploaded each year",
  "vip.pack.file.tip": "After the attachment is uploaded, it is counted in the total amount of attachments. Deleting the uploaded attachments does not reduce the total number of attachments used.",
  "vip.pack.aggregate.tip": "Aggregate the data, the aggregated results can be referred by the form, report.",
  "vip.pack.aggregate.count": "{{count}} per app",
  "vip.pack.dataBackup": "Data Recycling/recovery",
  "vip.pack.dataBackup.tip": "Retain data deleted within a limited number of days to recover data that were accidentally deleted. The data in the Recycle Bin does not count toward the amount of data and is only visible in the Recycle Bin.",
  "vip.pack.etl.tip": "The data view can preprocess the data to complete complex data modeling.",
  "vip.pack.trigger.tip": "Smart Assistant can automatically add or edit data in another form when the form data changes.",
  "vip.pack.feature.basic": "Basic Features",
  "vip.pack.log.tip": "Remove the logo of Platform at the bottom of the form.",
  "vip.pack.userSync": "Auto-sync user",
  "vip.pack.userSync.tip": "The member can be automatically synchronized in the Wechat Work and DingTalk mode, keeping it consistent with the Contacts in integrated account",
  "vip.pack.user.tip": "The maximum number of users per version, the paid version can be purchased separately for the number of subscribers",
  "vip.pack.appBridge.tip": "Retrieve data from forms in other apps within the same account.",
  "vip.pack.signature.tip": "Signatures will consume a very small attachments amount. 1M attachments can be used for signature for approximately 100 times.",
  "vip.pack.sso.tip": "Docking with other systems of the enterprise to achieve a set of account login multiple systems (only for public mode accounts)",
  "vip.pack.service": "Service items",
  "vip.pack.baseService.tip": "Add ¥2500/year to upgrade to advanced service",
  "vip.pack.support.base": "General technical support",
  "vip.pack.support.gold": "Advanced technical support",
  "vip.pack.service.date": "Service Time",
  "vip.pack.service.dateBasic": "Workday: 09:00-17:30",
  "vip.pack.service.dateGold1": "Workday: 09:00-20:00",
  "vip.pack.service.dateGold2": "Weekend: 10:00-17:00",
  "vip.pack.doc": "Document/Application Template",
  "vip.pack.feature": "Available features",
  "vip.pack.contact.title": "Can't find the version that is right for you?",
  "vip.pack.contact.info": "Please submit your version customization requirements and our product consultants will contact you as soon as possible.",
  "vip.pack.contact": "Consult us",
  "vip.pack.submit": "Submit version demand",
  "vip.pack.hotLine": "Consultation number: 400-011-1850",
  "vip.pack.bi.info": "Platform also provides private clouds product(FineReport／FineBI), to help enterprises quickly build a one-stop big data analysis platform for data acquisition, processing and visualization.",
  "vip.pack.wechatTip": "You are not signed in with the corporate creator account, you can not complete the purchase, please enter Platform from the Wechat Work admin panel.",
  "vip.pack.dingtalkTip": "You are not signed in with the corporate creator account, you can not complete the purchase, please enter Platform from the DingTalk admin panel.",
  "vip.pack.error.title": "Please sign in with the corporate creator account and purchase",
  "vip.pack.order.title": "Do you want to deal with it immediately?",
  "vip.pack.order.msg": "There is an unpaid order, please pay or close the existing order before purchase",
  "vip.pack.order.tip": "There is an unpaid order, you need to pay or cancel before you can create a new order",
  "vip.pack.order.ok": "Deal now",
  "vip.pack.order.cancel": "Deal later",
  "vip.service.basic.name": "Basic Service",
  "vip.service.advanced.name": "Advanced Service",
  "vip.service.silver.description": "++2500 yuan upgrade to advanced service",
  "vip.center": "Version Information",
  "vip.center.renewNow": "Renew now",
  "vip.center.trial": "Advanced version trial",
  "vip.center.purchase": "Purchase",
  "vip.center.upgradePack": "Upgrade version",
  "vip.center.service.purchase": "Purchase Advanced Service",
  "vip.center.pack.purchase": "Purchase version",
  "vip.center.contact": "Contact us",
  "vip.center.service": "Service Level",
  "vip.center.service.basicDescription": "Upgrade version to enjoy one-on-one exclusive customer service",
  "vip.center.service.silverDescription": "Premium service level, please contact us if you need help.",
  "vip.center.logo": "LOGO free in external link",
  "vip.center.logo.normal": "Unable to use logo free in external link feature, if in need, please upgrade version.",
  "vip.center.logo.used": "You can use logo free in external link feature.",
  "vip.center.manager": "Sub manager",
  "vip.center.timeStart": "From this day on",
  "vip.center.manager.normal": "You can only use {{managers}} sub manager and {{sysManagers}} system manager in current version. For more sub manager, please contact us to purchase.",
  "vip.center.manager.free": "You can only use {{managers}} system manager in current version. For more sub manager, please upgrade version.",
  "vip.center.aggregate": "Aggregate table",
  "vip.center.aggregate.free": "{{num}} aggregate tables are available for each app. For more aggregate tables, please upgrade version.",
  "vip.center.aggregate.normal": "{{num}} aggregate tables are available for each app. For more aggregate tables, please contact us to purchase.",
  "vip.center.aggregate.trial": "Each app can create one aggregation table in free version. To ensure normal use after the trial expires, please upgrade to appropriate version according to the usage.",
  "vip.center.aggregate.trialOver": "Each app can create {{num}} aggregation tables in trial version. The usage has exceeded the trial version limit, please adjust system usage or upgrade to appropriate version according to the usage.",
  "vip.center.aggregate.used": "{{num}} aggregate tables are available for each app.",
  "vip.center.aggregate.total": "Each app can create {{num}} aggregation tables in current version",
  "vip.center.customLogin": "Custom login page",
  "vip.center.customLogin.normal": "The custom login page feature is not available, if necessary, please contact us to purchase.",
  "vip.center.customLogin.used": "You can use the custom login page feature.",
  "vip.center.formData": "Form data limit",
  "vip.center.formData.normal": "The single form data limit is {{num}}0,000. For higher single form data limit, please contact us to purchase.",
  "vip.center.formData.free": "The single form data limit is {{num}}0,000. For higher single form data limit, please upgrade version.",
  "vip.center.formData.trial": "The single form data limit is 20,000 in free version. To ensure normal use after the trial expires, please upgrade to appropriate version according to the usage.",
  "vip.center.formData.trialOver": "The single form data limit is {{num}}0,000 in trial version. The usage has exceeded the trial version limit, please adjust system usage or upgrade to appropriate version according to the usage.",
  "vip.center.formData.used": "The single form data limit is {{num}}0,000",
  "vip.center.formData.total": "The current version limit is {{num}} ten thousand pieces of data per form",
  "vip.center.dataBackup": "Recycle bin",
  "vip.center.dataBackup.invalid": "Unable to use the data recycle bin function, if necessary, please upgrade the version. After the upgrade, the data and fields deleted within 15 days before the upgrade can be restored.",
  "vip.center.dataBackup.normal": "The deleted data can be kept for {{num}} days. If you need to save longer, please contact us separately.",
  "vip.center.dataBackup.free": "The deleted data can be kept for {{num}} days. If you need to save longer, please contact us separately.",
  "vip.center.dataBackup.trial": "The free version does not include this feature. To ensure normal use after the trial expires, please upgrade the appropriate version according to the usage.",
  "vip.center.dataBackup.used": "The Recycle Bin includes a Data Recycle Bin and a Field Recycle Bin that retains deleted data for {{num}} days.",
  "vip.center.appBridge": "Cross-app",
  "vip.center.appBridge.normal": "The cross-application feature is not available, if in need, please upgrade version.",
  "vip.center.appBridge.used": "Retrieve data by cross-app or executing smart assistants",
  "vip.center.userSync": "Member auto-sync",
  "vip.center.userSync.normal": "The member auto-sync feature is not available, if in need, please upgrade version.",
  "vip.center.userSync.used": "You can use the member auto-sync feature.",
  "vip.center.print": "Custom print",
  "vip.center.print.normal": "The custom print feature is not available, if in need, please upgrade version.",
  "vip.center.print.used": "The number of custom print templates is unlimited in current version, you can set different print templates according to different scenarios",
  "vip.center.print.limit": "You can use one custom print template in current version. for more custom print templates, please upgrade version.",
  "vip.center.print.total": "You can use {{num}} custom print templates in all apps in the current version",
  "vip.center.print.total.empty": "The custom print templates feature is not available in current version",
  "vip.center.print.total.unlimited": "The custom print templates in unlimited in current version",
  "vip.center.print.emptyTip": "No custom print template",
  "vip.center.fileZip.normal": "The batch exporting attachment feature is not available, if in need, please upgrade version.",
  "vip.center.fileZip.used": "You can use the batch exporting attachment feature.",
  "vip.center.sso": "Single sign-on",
  "vip.center.sso.normal": "The single sign-on feature is not available, if necessary, please contact us to purchase.",
  "vip.center.sso.used": "You can use the single sign-on feature.",
  "vip.center.submitPrompt": "Custom submission success page",
  "vip.center.submitPrompt.normal": "The custom submission success page is not available, if in need, please upgrade version.",
  "vip.center.submitPrompt.used": "You can use the custom submission success page feature.",
  "vip.center.signature": "Signature",
  "vip.center.signature.normal": "The signature feature is not available, if in need, please upgrade version.",
  "vip.center.signature.used": "You can use the signature feature.",
  "vip.center.theme": "Custom public link style",
  "vip.center.theme.normal": "The custom submission success page is not available, if in need, please upgrade version.",
  "vip.center.theme.used": "You can use the custom public link style feature.",
  "vip.center.threshold": "Report Data Alert",
  "vip.center.threshold.normal": "Unable to use the report data alert feature, upgrade the version if needed.",
  "vip.center.threshold.used": "Can use report data alerting.",
  "vip.center.dataAPI.normal": "The data api feature is not available, if in need, please contact us to purchase.",
  "vip.center.dataAPI.used": "You can use the data api feature.",
  "vip.center.etl": "Data View",
  "vip.center.etl.free": "You can use {{num}} ETLs in all apps, for more ETLs, please upgrade version.",
  "vip.center.etl.normal": "You can use {{num}} ETLs in all apps, for more ETLs, please contact us to purchase.",
  "vip.center.etl.trial": "You can use {{num}} ETLs in all apps in free version. To ensure normal use after the trial expires, please upgrade to appropriate version according to the usage.",
  "vip.center.etl.trialOver": "You can use {{num}} ETLs in all apps in trial version. The usage has exceeded the trial version limit, please adjust system usage or upgrade to appropriate version according to the usage.",
  "vip.center.etl.total": "You can use {{num}} ETLs in all apps in the current version",
  "vip.center.etl.emptyTip": "No ETL",
  "vip.center.trigger": "Smart assistant",
  "vip.center.trigger.free": "You can use {{num}} smart assistants in all apps, for more smart assistants, please upgrade version.",
  "vip.center.trigger.normal": "You can use {{num}} smart assistants in all apps, for more smart assistants, please contact us to purchase.",
  "vip.center.trigger.trial": "You can use {{num}} smart assistants in all apps in free version. To ensure normal use after the trial expires, please upgrade to appropriate version according to the usage.",
  "vip.center.trigger.trialOver": "You can use {{num}} smart assistants in all apps in trial version. The usage has exceeded the trial version limit, please adjust system usage or upgrade to appropriate version according to the usage.",
  "vip.center.trigger.total": "You can use {{num}} smart assistants in all apps in current version",
  "vip.center.trigger.emptyTip": "There is no smart assistant",
  "vip.center.pack.buffer": "{{pack}}—buffer period",
  "vip.center.pack": "Your version",
  "vip.center.current": "(current version)",
  "vip.center.sysCount": "System Capacity",
  "vip.center.feature": "Advanced feature",
  "vip.center.feature.purchase": "Upgrade version, enjoy more advanced features",
  "vip.center.feature.desc": "Advanced feature introduction",
  "vip.center.serviceLevel": "Current service",
  "vip.center.overflow": "Exceeded",
  "vip.center.limit": "Limited",
  "vip.center.limitTip": "Your system usage has exceeded the current version limit, and some advanced features have been disabled. To avoid system limitations affecting your use, please adjust system usage or upgrade to a higher version as soon as possible.",
  "vip.center.sysOutage": "The system is disabled",
  "vip.center.sysOutageTip": "Your system usage has exceeded the current version limit and the system has been disabled. To avoid system downtime affecting your use, please adjust system usage or upgrade to a higher version as soon as possible.",
  "vip.center.custom": "Customize higher version",
  "vip.center.vip.contact": "Contact technical support",
  "vip.center.service.basic": "Basic service",
  "vip.center.service.get": "Upgrade to advanced service",
  "vip.center.service1Text": "Help center & template center",
  "vip.center.service1Info": "We provides rich information for you to learn",
  "vip.center.service2Text": "General technical support services (online & telephone)",
  "vip.center.service2Text.advance": "Advanced technical support services (online & telephone)",
  "vip.center.service2Info": "A variety of efficient consulting channel to ensure your problems are handled in time",
  "vip.center.service2Info.advance": "A variety of efficient consulting channel & experienced technical staff to ensure that your problems are handled professionally in time",
  "vip.center.service3Text": "Basic service time",
  "vip.center.service3Text.advance": "Extra long service time",
  "vip.center.service3Info": "Workday 9:00-17:30",
  "vip.center.service3Info.advance": "Workday 9:00-17:30, Weekend 10:00-17:00, all year round except legal holidays",
  "vip.center.service.advance.tip": "After upgrading to premium services, you will receive a year-round service (except legal holidays) provided by experienced technical support",
  "vip.center.qrcode": "Scan QR code to follow Platform official account",
  "vip.center.corpText1": "Do not miss every feature update",
  "vip.center.corpText2": "Get the latest customer case",
  "vip.center.corpText3": "Consult online customer service in WeChat",
  "vip.center.hotLine": "Service Hotline: 400-011-1850",
  "vip.center.businessLine": "Marketing cooperation: 400-011-1850",
  "vip.center.pack.start": "Start time: {{startDate}}",
  "vip.center.pack.expireTip": "(will be free version after the version expires)",
  "vip.center.pack.expire": "Expire time: {{expireDate}}",
  "vip.center.user.noLimit": "Unlimited number of people",
  "vip.center.user.trialLimit": "(limit to {{user}} After trial expires, please upgrade in time)",
  "vip.center.user": "{{users}} people",
  "vip.center.users": "User amount",
  "vip.center.user.used": "Used: {{users}} people",
  "vip.center.user.all": "Total: {{users}}",
  "vip.center.user.exceeded": "The limit has been exceeded",
  "vip.center.user.purchase": "Purchase users",
  "vip.center.exceededTip": "The usage has exceeded the current version limit, please upgrade or adjust the usage as soon as possible",
  "vip.center.exceeded": "The usage has exceeded the current version limit, please upgrade as soon as possible",
  "vip.center.version.privilege": "Privilege",
  "vip.center.file": "Attachment upload amount",
  "vip.center.file.used": "Used this year: {{files}}",
  "vip.center.file.all": "Amount per year: {{files}}",
  "vip.center.data": "Total data amount",
  "vip.center.data.used": "Used: {{data}}",
  "vip.center.data.all": "Total: {{data}}",
  "vip.center.monthData": "Data submit amount per month",
  "vip.center.monthData.used": "Used this month: {{monthData}}",
  "vip.center.monthData.all": "Amount per month: {{monthData}}(reset on the 1st of each month)",
  "vip.center.dataCount": "{{count}}",
  "vip.center.dataCount.tenThousands": "{{count}}0,000",
  "vip.center.manager.count": "{{managers}} sub manager",
  "vip.center.sms.used": "Available SMS amount: {{-count}}",
  "vip.center.sms.count": "SMS amount",
  "vip.center.sms.count.tip": "You can get 5 SMS amount on sign up. If you need more SMS amount, you can purchase in the product.",
  "vip.center.sysManager.presented.count": "{{managers}} gifted system managers",
  "vip.center.sysManager.count": "{{managers}} system managers",
  "vip.center.manager.exceededTip": "Your sub manager amount has reached {{managers}}",
  "vip.center.aggregate.count": "{{aggregate}}/per app",
  "vip.center.aggregate.exceededTip": "Your aggregate data amount has reached {{aggregate}}/one app",
  "vip.center.formData.exceededTip": "Your single-form data amount has reached {{count}}0,000",
  "vip.center.dataBackup.count": "{{count}} days",
  "vip.center.print.unlimited": "Unlimited",
  "vip.center.print.exceededTip": "{{count}} custom print templates have been used",
  "vip.center.print.count": "{{count}}",
  "vip.center.etl.count": "{{count}} ETLs",
  "vip.center.etl.exceededTip": "Your ETL amount has reached {{count}}",
  "vip.center.trigger.exceededTip": "{{count}} smart assistants have been used",
  "vip.center.data.purchase": "Purchase total data amount",
  "vip.center.dingTalkTrial.tip": "You need to upgrade in the DingTalk application market.",
  "vip.center.dingTalkTrial.detail": "Please open the DinkTalk on the mobile phone and enter the application market to upgrade.",
  "vip.center.wechatCorpTrial.tip": "You need to upgrade in the WeChat Work application market.",
  "vip.center.wechatCorpTrial.detail": "Please use the computer to visit WeChat Work management platform and upgrade the Platform.",
  "vip.center.renewAddon": "Advanced function renew",
  "vip.center.renewAddon.fail.info": "Your advanced functions are not renewed and cannot purchase.",
  "vip.center.renewAddon.fail.tip": "Please renew the advanced functions and buy again.",
  "vip.center.align.tip": "Advanced functions has expired",
  "vip.center.upgradeTip.dingtalk": "This version will expire in {{count}} days. In order not to affect the use, please upgrade in DingTalk application market.",
  "vip.center.upgradeTip.wechatCorp": "This version will expire in {{count}} days. In order not to affect the use, please upgrade in WeChat Work application market.",
  "vip.center.renewTip.dingtalk": "This version is expired. In order not to affect the use, please renew in the DingTalk application market.",
  "vip.center.renewTip.wechatCorp": "This version is expired. In order not to affect the use, please renew in the WeChat Work application market.",
  "vip.template.title": "Congratulations, receive successfully",
  "vip.template.description": "You have received the {{day}} day trial period, we have prepared an template of advanced feature usage example for you, install it now",
  "vip.template.install": "Install to use",
  "vip.trial.no": "Receive later",
  "vip.trial.success": "Receive successfully",
  "vip.trial.start": "Begin the trial",
  "vip.trial.time": "You have received the {{day}} day trial period",
  "vip.trial.expire.tip": "Your trial version is about to expire, advanced features are not available after expiration, please upgrade version in time",
  "vip.trial.install": "Receive the {{day}} day trial period successfully, you can go back and continue installing the app.",
  "vip.trial.tip": "You are not signed in with the corporate creator account, you can't receive the trial, please sign in with the corporate creator account and receive it.",
  "vip.trial.dingtalkTip": "You are not signed in with the corporate creator account, you can't receive the trial, please enter Platform from the DingTalk admin panel to receive it",
  "vip.trial.wechatTip": "You are not signed in with the corporate creator account, you can't receive the trial, please enter Platform from the WeChat Work admin panel to receive it",
  "vip.trial.error.title": "Please sign in with the corporate creator account and receive it",
  "vip.upgrade.no": "No",
  "vip.upgrade.yes": "Yes",
  "vip.use.start": "Begin to use",
  "vip.usage.aggregate": "Aggregate tables: ",
  "vip.usage.aggregate.tip": "The following are apps where the number of aggregate tables exceeds the limit. Please delete the redundant aggregate tables in each app or upgrade version",
  "vip.usage.aggregate.empty": "Please click here to create aggregate tables",
  "vip.usage.data": "Data amount: ",
  "vip.usage.data.count": "{{count}}0,000",
  "vip.usage.data.tip": "The following are forms where the data amount that exceeds the limit. Please delete the redundant data in each form or upgraded version",
  "vip.usage.etl": "ETLs: ",
  "vip.usage.etl.overflow.tip": "The following are apps where the number of ETLs exceeds the limit. Please delete the redundant ETLs in each app or upgrade version",
  "vip.usage.etl.tip": "The following are apps that use ETLs. Click View to go to the app to see detail.",
  "vip.usage.print": "Print templates: ",
  "vip.usage.print.overflow.tip": "The following are forms where the number of print templates exceeds the limit. Please delete the redundant print templates in each app or upgrade version",
  "vip.usage.print.tip": "The following are forms that use print templates. Click View to go to the form to see detail.",
  "vip.usage.trigger": "Smart assistants: ",
  "vip.usage.trigger.overflow.tip": "The following are apps where the number of smart assistants exceeds the limit. Please delete the redundant smart assistants in each app or upgrade version",
  "vip.usage.trigger.tip": "The following are apps that use smart assistants. Click View to go to the app to see detail.",
  "view.click": "Click to view",
  "view.detail": "View details",
  "view.help": "View help",
  "view.helpCenter": "View help document",
  "view.detailReason": "View detailed reason",
  "weChat.bind": "Bind WeChat",
  "weChat.unBind": "Unbind WeChat Work",
  "weChat.authorization": "WeChat Work Authorization",
  "weChat.contacts.auth.title": "Enterprise WeChat Address Book Authorization",
  "weChat.contacts.auth.tip": "The authorization method of the enterprise WeChat address book has been changed. To ensure the normal synchronization of the address book, please process it as soon as possible.",
  "weChat.contacts.auth.description": "Due to the change of corporate WeChat address book synchronization, you need to authorize synchronization address book. Please enter the following information to complete the authorization.",
  "weChat.contacts.auth.description.id": "Agent_id and agent_secret acquisition method, please refer to ",
  "weChat.contacts.auth.success": "Authorization succeeded",
  "weChat.contacts.auth.fail": "Authorization failed, please try again",
  "weChat.contacts.auth.repeat": "You have successfully authorized, please do not repeat the operation",
  "weChat.contacts.auth.close.tip": "You can complete the authorization later in the Contacts",
  "weChat.contacts.agentId.notEmpty": "agent_id cannot be empty",
  "weChat.contacts.agentSecret.notEmpty": "agent_secret cannot be empty",
  "view.byPass": "View by password",
  "widget.address": "Address",
  "widget.address.district": "District/county",
  "widget.address.district.withMark": "(county/district)",
  "widget.address.detail": "Please fill in the detailed address",
  "widget.address.detail.withMark": "(detail address)",
  "widget.address.province": "Province/autonomous region/municipality",
  "widget.address.province.withMark": "(province/autonomous region/municipality)",
  "widget.address.type.detail": "Province-city-district-detail",
  "widget.address.type.district": "Province-city-district",
  "widget.checkboxgroup": "Checkbox",
  "widget.combo": "Dropdown",
  "widget.combocheck": "Multiselect",
  "widget.datetime": "Date and time",
  "widget.datetime.calendar": "Calendar",
  "widget.dept": "Department",
  "widget.dept.clickToSelect": "Click to select department",
  "widget.dept.notSupportLink": "The external link doesn't support department field",
  "widget.dept.listTitle": "Department list",
  "widget.deptgroup": "Departments",
  "widget.file.empty": "There is no file uploaded",
  "widget.file.maxCount": "Select at most {{num}} files",
  "widget.file.select": "Select file",
  "widget.file.size": "File size: ",
  "widget.file.uploaded": "Upload finished",
  "widget.file.uploading": "Uploading...",
  "widget.file.uploadTime": "Upload time: ",
  "widget.id": "Widget ID",
  "widget.image": "Image",
  "widget.image.empty": "There is no images uploaded",
  "widget.image.maxCount": "Select at most {{num}} images",
  "widget.image.onlyCameraTip": "The only photo by camera feature is enabled, this feature is only available in WeChat service account, WeChat Work and DingTalk mobile client",
  "widget.image.select": "Select images",
  "widget.linkdata": "Link data",
  "widget.linkdata.select": "Select data",
  "widget.linkdata.empty": "There is no data meets the condition",
  "widget.linkquery": "Link query",
  "widget.location": "Location",
  "widget.location.get": "Get current location",
  "widget.location.mobileOpen": "Please open the form on mobile to get location information",
  "widget.location.set": "Location setting",
  "widget.number": "Number",
  "widget.phone": "Phone",
  "widget.phone.sms.disableInPreview": "Do not support phone Valid while previewing",
  "widget.phone.sms.verify": "SMS verify",
  "widget.phone.sms.count": "Available SMS amount: {{count}}",
  "widget.phone.sms.verify.tip": "After SMS Valid enabled, the form that the phone has not passed the Valid cannot be submitted. The SMS Valid will consume SMS amount. When the number of SMS amount is 0, the form will not be able to submitted normally.",
  "widget.phone.sms.dingTalkTrial.tip": "The current trial version will expire in {{- days}} days. After the expiration, the function entrance will be hidden by Dingtalk. If you need to continue using, please contact the enterprise founder to upgrade the version in time.",
  "widget.phone.sms.wechatCorpTrial.tip": "The current trial version will expire in {{- days}} days. After the expiration, the function entrance will be hidden by WeChat Work. If you need to continue using, please contact the enterprise founder to upgrade the version in time.",
  "widget.phone.sms.code": "SMS valid code",
  "widget.phone.sms.getCode": "Get valid code",
  "widget.phone.sms.getCodeAgain": "Retrieve ({{second}})",
  "widget.phone.sms.error": "SMS valid code is incorrect",
  "widget.phone.not.purchase": "Purchase later",
  "widget.phone.now.purchase": "Purchase now",
  "widget.phone.purchase.sms": "Purchase SMS amount",
  "widget.phone.purchase.tip1": "The available SMS amount is too small, do you want to purchase SMS amount immediately?",
  "widget.phone.purchase.tip2": "The number of available SMS for the current account is less than 100, which may affect the form submission. You can choose to purchase SMS amount before using it.",
  "widget.phone.purchase.tip3": "The available SMS amount is too small, please contact the company creator to purchase SMS amount",
  "widget.phone.purchase.tip4": "The number of available SMS for the current account is less than 100, which may affect the form submission. You can contact the corporate creator to purchase SMS amount before using it.",
  "widget.phone.purchase.tip5": "The number of available SMS is 0, ido you want to purchase SMS amount immediately?",
  "widget.phone.purchase.tip6": "The number of available SMS for the current account is 0, and the SMS Valid feature can not be enabled. If you want to continue using this feature, you can choose to purchase SMS amount and then enable it.",
  "widget.phone.purchase.tip7": "The number of available SMS is 0, and the SMS Valid feature can not be enabled.",
  "widget.phone.purchase.tip8": "The number of available SMS for the current account is 0, and the SMS Valid feature can not be enabled. To use this feature, please contact the corporate creator to purchase SMS amount.",
  "widget.phone.purchase.tip9": "Please contact the corporate creator to purchase SMS amount",
  "widget.phone.validate.success": "Verified",
  "widget.radiogroup": "Radio",
  "widget.separator": "Separator",
  "widget.signature": "Signature",
  "widget.signature.rewrite": "Rewrite",
  "widget.signature.useSaved.tip": "Do you want to use the following signature?",
  "widget.sn": "Serial number",
  "widget.sn.count.num": "Count digits",
  "widget.sn.count.numText": "{{num}} digits",
  "widget.sn.count.duration": "Reset period",
  "widget.sn.count.start": "Initial value",
  "widget.sn.count.fix": "Fixed digits",
  "widget.sn.createTime.format": "Display format of submit date",
  "widget.sn.oneTip": "Only one serial number field can be added to the form",
  "widget.sn.placeholder": "Automatically generated",
  "widget.sn.reset.empty": "Manual reset",
  "widget.sn.reset.emptyTip": "Restart counting from 0 only when the count reaches its maximum value.",
  "widget.sn.reset.day": "Reset daily",
  "widget.sn.reset.dayTip": "Automatically restart counting from the initial value at 00:00:00 daily. If the count reaches the maximum value within one day, recount from 0.",
  "widget.sn.reset.week": "Reset weekly",
  "widget.sn.reset.weekTip": "Automatically restart counting from the initial value at 00:00:00 on Monday. If the count reaches the maximum value within one week, recount from 0.",
  "widget.sn.reset.month": "Reset monthly",
  "widget.sn.reset.monthTip": "Automatically restart counting from the initial value at 00:00:00 on the first of a month. If the count reaches the maximum value within one month, recount from 0.",
  "widget.sn.reset.year": "Reset yearly",
  "widget.sn.reset.yearTip": "Automatically restart counting from the initial value at 00:00:00 on the first of a year. If the count reaches the maximum value within one year, recount from 0.",
  "widget.sn.rule": "Serial number rule",
  "widget.sn.rule.confirm": "If you delete the automatic count, the existing count record will not be able to continue. Are you sure to delete?",
  "widget.sn.start.tip": "Please enter the initial value",
  "widget.subform": "Subform",
  "widget.subform.addTip": "Drag from the left to add a field",
  "widget.subform.allowBlank": "Please fill in at least one record",
  "widget.text": "Text",
  "widget.text.error.id": "Please enter the correct ID number",
  "widget.text.error.mobile": "Please enter the correct phone number",
  "widget.text.error.tel": "Please enter the correct phone number",
  "widget.text.error.zip": "Please enter the correct postal code",
  "widget.text.error.email": "Please enter the correct email address",
  "widget.text.error.time": "Please enter the correct time format",
  "widget.number.error.range1": "Please enter a number less than or equal to {{n}}",
  "widget.number.error.range2": "Please enter a number greater than or equal to {{n}}",
  "widget.number.error.range3": "Please enter a number between {{n}}={n1}}",
  "widget.textarea": "Textarea",
  "widget.upload": "Attachment",
  "widget.user": "Member",
  "widget.user.listTitle": "Member list",
  "widget.user.notSupportLink": "The external link doesn't support member field",
  "widget.user.current": "Current user",
  "widget.user.anonymous": "Anonymous",
  "widget.multiText.placeholder": "Add filter value",
  "widget.multiText.placeholder.tip1": "Add custom value",
  "widget.usergroup": "Members",
  "widget.timepicker.placeholder": "Please set a custom range",
  "widget.web.page": "External web page",
  "dashboard.title": "Applications",
  "module": "Plug-in",
  "team.status.owned": 'My team',
  "team.status.joined": 'The team I joined',
  "allapp": 'All Apps',
  "app.creategroup": 'Create a new Group',
  "app.othergroup": 'Other App Groups',
  "login.return": 'back to sign in',
  phoneValidCode: "Received valid code",
  emailValidCode: "Received valid code",
  "time.countdown": "retrieve ",
  "time.receive": "Did not receive?",
  resubmit: "Resend",
  "verification.code": "please enter the Valid code",
  "Under.submission": "Under submission...",
  "Has.sent": "Has been sent",
  "System.error": "System error. Try again later",
  "fill.Email": "Please fill in the Email",
  "fill.account": "Please fill in your account",
  "fill.password": "Please fill in your password",
  "password.long": "The login password is 6-16 characters long",
  "phone.exists": "The current mobile phone number already exists, whether directly binding for account?",
  "contact.technician": "System error, contact technician",
  basics: "Basics",
  "vip.management": "Member Management",
  finance: "Finance",
  recharge: "Recharge",
  "bills.consumption.details": "Bills details",
  "control.over.invoices": "Invoice Record",
  "purchased.module": "Purchased plug-in",
  "data.statistics": "Data statistics",
  security: "Security",
  "operational.log": "Operational Log",
  "security.setting": "Security setting",
  "head.portrait": "Avatar",
  "change.avatar": "edit",
  "replacement.failed": "Failed avatar modification!",
  "replacement.successful": "Successful avatar modification!",
  "picture.preview": "Preview:",
  "picture.reset": "Reset",
  "picture.rotate": "Rotate",
  "picture.rotate.left": "Rotate Left",
  "picture.rotate.right": "Rotate Right",
  "picture.open.org": "Open original images",
  "picture.commutation": "Reverse",
  "current.balance": "Balance",
  "yun.coin": "yun coin",
  replacement: "Update",
  "team.model": "Team model",
  "current.package": "Current package",
  "membership.version": "Membership version",
  "maturity.time": "Maturity time",
  permanent: "Permanent",
  temporary: 'Temporary',
  "buying.Members": "Upgrade",
  "upper.limit.user": "User amount",
  ge: " Piece",
  tiao: " ",
  "number.invited.user": "usered:",
  "upper.form.data": "Upper bound of all form data",
  "total.upload.flow": "Total data amount",
  used: "Used：",
  usedst: "Used",
  "data.view.user": "Data View",
  "total.user": "total:",
  "create.apiKey": "Create API Key",
  "click.view.apiKey": "Click View API Key",
  "api.administrator.account": "webAPI has the same permissions as your administrator account",
  "api.reset": "Reset API Key",
  "api.delete.user": "Delete API Key",
  "enter.login.password": "Please enter your login password",
  "import.excel.size": "Single import Excel file size",
  "maximum.import.execl": "Maximum import: ",
  "single.upload.size": "Single upload attachment size",
  "maximum.upload.size": "Maximum size:",
  "recycling.bin.data": "Recycling bin data",
  "maximum.retention.data": "Maximum Retention Days:",
  "allow.export": "Allow export",
  "not.allow.export": "Export is not allowed",
  "recharge.amount": "Recharge amount",
  "recharge.method": "Recharge method",
  "public.payment": "Public Payment",
  "immediate.recharge": "Recharge",
  "general.error": "{{ error }}",
  General: "General",
  "delete.source.faild": "Failed to delete source file，error message：{{ error }}",
  "delete.log.faild": "Failed to delete log file，error message：{{ error }}",
  "rename.source.faild": "Failed to modify source file name，error message：{{ error }}",
  "rename.log.faild": "Failed to modify log file name，error message：{{ error }}",
  "rename.log.success": "Modify the log file name successfully",
  "rename.source.success": "Modify the source file name successfully",
  "copy.source.faild": "Copying source file failed，error message：{{ error }}",
  "copy.log.faild": "Copying log file failed，error message：{{ error }}",
  "copy.log.success": "Copy log file successfully",
  "copy.source.success": "Copy source file successfully",
  "create.source.faild": "Create source file failed，error message：{{ error }}",
  "create.source.success": "Create source file successfully",
  "old.password": "Original password",
  "confirm.new.password": "Confirm password",
  "confirm": "Save",
  "error.password": "Error in duplicate login password input",
  "true.value": "Please enter the correct value",
  "installation.time": "Installation time",
  "installation.application": "Installation and Application",
  "installation.form": "Installation form",
  "author": "author",
  "version.number": "Version number",
  "sorry.module": "Sorry, you don't have a plug-in yet",
  "type.transaction": "Order type",
  "type.operation": "Operation type",
  "ticket.issue": "Ticket issue",
  "send.out": "Sending",
  "receipt": "Receiving",
  "to": "to",
  "start": "start",
  "end": "end",
  "user": "user",
  "project": "project",
  "content": "content",
  "sorry.log": "Sorry, you haven't operated the log yet.",
  "name.buyer.payee": "name of the buyer or payee",
  "sorry.invoiced": "Sorry, you haven't invoiced yet.",
  "signed": "Signed",
  "check.carefully": "It has been sent out (please check it carefully)",
  "ticketing.progress": "Ticketing in progress",
  "confirmation.receipt": "Confirmation of receipt",
  "refusal.sign": "Refusal to sign",
  "enter.correct.amount": "Please enter the correct amount.",
  "modify.login.password": "Modify login password",
  "installed.module": "Installed plug-in",
  "amount": "Recharge amount",
  "recharge.mode": "Recharge method",
  "recharge.time": "Recharge time",
  "recharge.total": "Total",
  "logon.timeout": "Logon timeout, please log in again",
  "recharge.system.error": "System error",
  "RMB.recharge": "RMB Recharge",
  "cancellation.invoice": "Cancel",
  "correct.order.number": "Enter the correct order number.",
  "transaction.time": "Date",
  "tickets.issued": "Tickets have been issued",
  "no.need.invoice": "No need to invoice",
  "no.ticket.issued": "No invoiced",
  "activity.presentation": "Activities gift",
  "ten.thousand.data": "ten thousand piece of data",
  "G.flow": "G flow",
  "expire": "Expire",
  "sorry.ordered": "Sorry, you haven't ordered yet.",
  "person": "People",
  "bby.group": "User Exchange Group",
  "application.customization": "Apply for Customization",
  "online.service": "Online Service",
  "help.document": "Document",
  "flow.visit.todo": "Todo",
  "flow.visit.create": "Create",
  "flow.visit.cc": "CC",
  "membership.purchase": "Upgrade",
  "membership.upgrade": "Membership upgrade",
  "free.configuration": "Free Configuration",
  "user.number": "user amount/people",
  "contacts.number": "address book number of people",
  "click.details": "Click on Details",
  "already.have": "Already have",
  "correct.tip": "Please enter the correct value,0 means no purchase.",
  "data.volume": "Data limit/ten thousand",
  "total.number": "Total number of data supported for form entry",
  "every.thousand": " ten thousand",
  "flow": "flow",
  "uploaded.tip": "The size of the uploaded pictures and attachments, cleared annually.",
  "correct.tip20": "Please enter the correct value, 0 is not to buy.",
  "more.configuration": "More configuration",
  "existing": "existed",
  "sum.order": "total",
  "aggregate.caching": "Aggregate table caching",
  "batch.export.annex": "Export attachments",
  "use.time": "Usage time",
  "order.price.title": "Order total",
  "account.balance": "Balance",
  "need.recharge": "Recharge",
  "operating.time": "Operating time",
  "discount": "%",
  "whether.payment": "Whether to Turn on Payment Function",
  "my.module": "My plug-in",
  "module.center": "Plug-in Center",
  "verification.img.code": "Please enter the picture validation code",
  "verification.message.code": "Please enter a short message Valid code of 6 length.",
  "immediate.activation": "Immediate activation",
  "successful.activation": "Successful activation",
  "your.mobile.phone": "Please enter your mobile phone number.",
  "correct.validation.code": "Please enter the correct validation code.",
  "mobile.validation.code": "Please enter the mobile phone Valid code.",
  "new.login.password": "Please enter a new login password.",
  "user.login": "User Index",
  "user.activation": "Account activation",
  "wechat.registration": "Wechat Registration",
  "summary.title.alignment": "Summary heading alignment",
  "summary.title.alignment.tip": "The summary title refers to the title in the lower left corner of the perspective",
  "data.table.sticky": "Table Freeze",
  "data.table.sticky.before": "Freeze",
  "data.table.sticky.tip": "The subform field counts as a whole; the mobile does not support freezing the table.",
  "data.display.column": " columns",
  "dash.dataSource.tip.etl": "{{- etl}} can relate, merge and aggregate data from multiple tables and get an output table.",
  "dash.color.defaultTip": "Changing the default item color will change all colors not set independently.",
  "dash.sort.custom": "Custom sort",
  "dash.sort.custom.maxTip": "There are too many current data items, only {{- count}} items before  are displayed.",
  "dash.sort.custom.emptyTip": "There are no sortable data items, please modify the filter or view the data source.",
  "dash.style": "Report style",
  "dash.style.close": "close",
  "dash.style.closeConfirm": "Clost Style Pane",
  "dash.style.closeConfirmMsg": "Clost Style Pane",
  "dash.component.style": "Control style",
  "dash.all": "Overall report",
  "dash.all.style": "Style",
  "datatable.all.style": "Overall style",
  "datatable.title.color": "Title color",
  "dash.component.all": "Control as a whole",
  "dash.component.table": "Form control",
  "etl.update.fail": "Data update failed",
  "etl.update.fail.tip": "Data update failed, not currently up to date.",
  "etl.update.check": "Please check the data stream settings",
  "etl.update.nextRun": "Data to be updated, {{ minutes}} automatic update after minutes",
  "etl.update.nextRun.tip": "The data is to be updated, and the latest data can be viewed after {{ minutes }} minutes",
  "etl.update.success": "The current is the latest data",
  "etl.update.running": "Updating, please wait...",
  "etl.update.running.tip": "Updating, you can view the latest data later",
  "dash.percent.disabled.tip": "The percentage can only be set when summarizing or summing.",
  "dash.conversion.disabled.tip": "Only the funnel chart can set the conversion rate.",
  "filter.date.start": "Start time",
  "filter.date.end": "End time",
  "unpaid.orders": "Unpaid orders",
  "data.helper": "Data helper",
  "data.helper.allow": "Turn on",
  "data.helper.allow1": "Turn on",
  "data.helper.disable1": "disabled",
  "data.helper.allow.tip": "Please confirm whether {{ action }} Data helper",
  "aggregate.table.alias": "Aggregate table alias",
  "aggregate.table.alias.tip": "It is unique under the same application. If the alias is not set or is empty, the alias is the default, and it will be saved after modification",
  cache: "cache",
  "cache.tip": "When enabled, it can speed up the acquisition of aggregate table data, such as data linkage, association data, etc",
  "set.verification.conditions": "Set Valid conditions",
  "cannot.use.system.field.alias": "Cannot use system field alias -",
  "aggregate.table.alias.modification.failed": "Aggregate table alias modification failed",
  "leave.page.tip": "The current page is not saved. Are you sure you want to leave?",
  "page.tip": "The current page is not saved.",
  "leave": "Leave",
  "setting.failed": "Setting failed",
  "click.copy": "Click copy",
  "trigger.event": "Trigger event? (plug-in events / _form events)",
  "operator.tip": "Operator _id, the default is the _id of the application owner",
  "widget.upload.signature": "Files , Signature",
  "system.management": "System management",
  "cloud.application.management": "Cloud application management",
  "incorrect.form.type": "Incorrect form type",
  "picture.upload.failed": "Picture upload failed",
  "aggregate.validation.failed": "Aggregate table validation failed",
  "exception.contact.administrator": "System exception, please contact administrator",
  "empty.recycle.irreversible": "Empty all forms and data in the recycle bin. This operation is irreversible",
  "empty.recycle.forms": "Empty all forms in the recycle bin",
  "empty.recycle.field": "Empty all fields in the recycle bin",
  "emptying.recycle.forms": "Recycle Bin Form is being cleaned up,remaining{{ count1 }} / {{ count2 }}",
  "recycle.has.cleaned": "The recycle bin form has been cleaned up!",
  "clean.tip": "This time to clean up {{ cf }} forms, there are {{ fi }} forms error, please contact the administrator to check",
  "application.more.tip": "There are currently more than {{ formNumberMax }} application forms, and no more forms can be created. Please empty the form recycle bin and useless forms first.",
  "create.blank.flow.form": "Create blank form",
  "unnamed.flow.form": "Unnamed flow form",
  "unnamed.event.form": "Unnamed event form",
  "event.form": "Event",
  "unnamed.new.report": "Unnamed new report",
  "unnamed.dash.report": "Unnamed Analysis Report",
  "unnamed.scenes.report": "Unnamed Scene Report",
  "create.new.report": "Create report",
  "create.old.report": "Create old report",
  "create.dash.report": "Create Analysis Report",
  "create.scenes.report": "Create Scene Report",
  "scenes.report": "Scene Report",
  "successfully.restored.form": "Successfully restored form",
  "failed.restored.form": "Failed to restore form",
  "switch.event.form": "Switch to event form",
  "switch.notEvent.form": "Switch to not-event form",
  "application.exceed": "The number of individual application forms cannot exceed {{ formNumberMax }}",
  "please.enter": "Please enter",
  "confirm.delete.the": "Please confirm whether to delete the \"{{ name }}\" ?",
  "completely.delete.irreversible": "Please confirm whether to delete the \"{{ name }}\" completely? This operation is irreversible.",
  "standard.application": "Standard",
  "scenes.used": "Scenes",
  category: "Category",
  "functional.classification": "Feature",
  "tutorial.case": "Tutorial",
  "search.cloud.office.applications": "Search cloud office applications",
  "app.preview": "App preview",
  "companies.use": "Used by {{ installnum }} companies",
  "installation.package.size.exceeds": "The installation package size exceeds the limit.",
  "selected.it": "Selected【{{ name }}】",
  "import.package.group": "Import installation package to group.",
  "import.package.group.tip": "Whether to keep sample data",
  "select.file": "Select a file",
  "app.access": "Enter app view mode",
  "backend.script": "Script",
  "app.management": "App management",
  "module.design": "Plug-in design",
  "module.source": "Source code",
  "pay.title": "Recharge - ",
  "pay": "Recharge",
  "message.center": "Message Center",
  "no.access.contacts": "No access to contacts",
  "security.strategy": "Security strategy",
  "export.management": "Export management",
  "weChat.sweep": "Open WeChat 'Scanning code' to share with friends",
  "report.alias": "Report alias",
  "widget.alias.duplicate": "Duplicate widget alias",
  "alias": "alias",
  "permissions.settings": "permissions settings",
  "add.data.source": "Add data source",
  "sure.add.form.data": "Are you sure to add this form data?",
  "data.form.information": "Data table color information",
  "data.table.default.sort": "Data table default sort field",
  "data.table.mobile.style": "Data table mobile style",
  "schedule.specific.information": "Schedule specific information",
  "shift.time.field": "Shift time field",
  "calendar.displayed.tip": "The operation calendar is displayed by month or week, and the default is displayed by month calendar.",
  "calendar.mode": "Calendar mode",
  "calendar.month": "Month",
  "calendar.week": "Week",
  "dynamic.row.field": "Dynamic row header field",
  "calendar.specific.information": "Calendar specific information",
  "calendar.color.information": "Calendar color information",
  "calendar.time.field": "Calendar time field",
  "corresponding.time.field": "Corresponding to the time field in the data table",
  "title.show": "Show",
  "add.search.box": "Add search box",
  "right.click.mark": "Right click to mark",
  "display.data.list": "Display data list",
  "map.specific.information": "Map details",
  "click.operate": "Click to operate",
  "no": "NO",
  "trigger.events": "Does it trigger back-end events?",
  "button.events": "Button events",
  "map.effective.range.field": "Radiation radius",
  "map.location.field": "Map location field",
  "report.link.title": "Report link",
  "report.external.link": "Public link",
  "phone.binding": "Phone binding",
  "created.invited": "I created a report and invited everyone to check it out! - ",
  "created.invited.form": "I created a form and invited everyone to check it out! - ",
  "external.link.tip2": "This content is published by users through 「{{ site_name }}」 and does not represent {{ site_name }}'s position.",
  "app.group.name": "App group name",
  "app.group.deleted": "There are applications in the current group and cannot be deleted!",
  "confirm.appGroup.deleted": "Please confirm whether to delete the group - {{ name }}",
  "NoApps.currently.visible": "No apps are currently visible,",
  "share.app.permissions": "Please contact the administrator to share the application permissions for you",
  "appGroup.no.has": "The current group has no apps",
  "clean.data": "Clean data",
  "moveTo.other.group": "Move to other group",
  "share.others.install": "Share to others to install",
  "export.installation.package": "Export installation package",
  "export.installation.package.tip": "Whether to export sample data (the latest 20 data for each form)",
  "export.installation.package.yes": "Download with sample data",
  "export.installation.package.no": "Download without sample data",
  "app.batch.export.options.tip1": 'Prohibit exporting again after user installation',
  "app.batch.export.options.tip2": 'Do you want to export examples',
  "installing.app": "Installing app ...",
  "select.app.group": "Please select an application group first",
  "copy.app": "App copy",
  "delete.app.name": "If you are sure to delete, please enter the application name",
  "want.delete.app": "Are you sure you want to delete the application \" {{appname}} \"?",
  "delete.form.irreversible": "If you delete the application, the form, report and data will also be deleted. This operation is irreversible!",
  "delete.form.data": "If you are sure to clear all data, please enter the form name",
  "want.clear.form.data": "Are you sure you want to clear all the data in the form \"{{ name }}\"?",
  "want.clear.form.data.filter": "Are you sure you want to clear filter the data in the form \"{{ name }}\"?",
  "want.clear.form.data.select": "Are you sure you want to clear the {{index}} data selected in the form \"{{ name }}\"?",
  "want.delete.form.data": "Are you sure you want to delete all the data in the form \"{{ name }}\"?",
  "clear.form.data.irreversible": "The operation of clearing the form will completely delete all the data in the form. This operation is irreversible!",
  "delete.select.form.data": "If you are sure to delete the selected data, please enter the form name",
  "want.clear.select.form.data": "Are you sure you want to delete the {{index}} data selected in the form \"{{ name }}\"?",
  "clear.select.form.data.irreversible": "This operation will completely delete the currently selected data. This operation is irreversible!",
  "select.data.empty.tip": "No data is currently selected, please select data first",
  "clear.field": "If you are sure to empty all fields in the recycle bin, please enter the form name",
  "want.clear.field": "Are you sure you want to clear all the fields in the recycle bin of the form \"{{ name }}\"?",
  "clear.field.irreversible": "This operation will empty the fields in the recycle bin and the data corresponding to the fields. This operation is irreversible!",
  "delete.field": "If you are sure to delete the recycle bin field, please enter the form name",
  "want.delete.field": "Are you sure you want to delete the field in the recycle bin of the form \"{{ name }}\"?",
  "delete.field.irreversible": "This operation will completely delete the field in the recycle bin and the data corresponding to the field. This operation is irreversible!",
  "select.field.empty.tip": "No field is currently selected, please select a field first",
  "clear.app.name": "If you are sure to clear, please enter the application name",
  "clear.data.app": "Are you sure you want to clear all the data in the application {{ appname }} ?",
  "clear.data.irreversible": "All data in the application will be completely deleted after performing the empty operation. This operation is irreversible!",
  "app.data.cleared": "App data is cleared!",
  "download.immediately": "Download",
  "installation.link": "Installation link",
  "installation.app.link": "You can directly install the current application through the installation link",
  "account.no.empty": "Account cannot be empty",
  "app.installation.link": "App installation link",
  "installation.copied.link.successfully": "Installation link copied successfully!",
  "generate.copied.link.successfully": "Generate installation QR code",
  "install.password": "Install with password",
  "limit.password": "Password cannot be empty and less than 24 digits",
  "accounts.allowed.install": "Accounts allowed to install",
  "enter.app.accounts": "Enter the user account that is allowed to install the application, use multiple line input for multiple accounts",
  "view.installed.records": "View installed records",
  "Share.app.install.others": "Share App【{{ appname }}】Install for others",
  "install.account": "Installer account",
  "install.nickname": "Installer Nickname",
  "install.time": "Installation time",
  "no.installation.record": "No installation record",
  "show.latest.record": "Only show the latest 50 records",
  "installation.record": "Installation record",
  "failed.installation.record": "Failed to get installation record!",
  "enter.new.appName": "Please enter a new app name",
  "add.new.source": "Add new data source",
  button: "Button",
  buttonext: "Extended",
  "data.loading": "Data loading",
  "corresponding.field": "Corresponding field",
  "old.perform.action": "Perform Action (Old)",
  "perform.action": "Perform Action",
  "form.source": "Form source",
  "WPSTIP.7102": "The system usage exceeds the limit. The system has been suspended. You can delete some data to restore the system.",
  "WPSTIP.7104": "The number of aggregation tables has reached the upper limit, please delete the original aggregation tables and then create a new one.",
  "WPSTIP.7105": "The number of aggregate tables in the application you installed exceeds the WPS table limit, please reselect the app installation.",
  "WPSTIP.7106": "The number of your aggregate tables has exceeded the limit.",
  "WPSTIP.7107": "Your attachment upload volume this month has exceeded the table limit.",
  "WPSTIP.7108": "The total amount of data in your system has exceeded the table limit.",
  "WPSTIP.7109": "The amount of single-table data in your system has exceeded the table limit.",
  "WPSTIP.7110": "The number of members in your system has exceeded the table limit.",
  "WPSTIP.7111": "The number of members exceeds the limit. You can delete some members to invite more members.",
  "to.minute": " minute",
  "to.hour": " hour",
  "pin.top": "Top Sticky",
  "pin.right": "Right Sticky",
  "pin.none": "Cancel Sticky",
  "file.fetch.failed": "File fetch failed",
  "source.add": "Add File",
  "source.add.python": "Create python file",
  "source.add.lua": "Create lua file",
  "not.alias.jumping": "The current panel does not support in-app form alias jumping",
  "flow.wrong.help": "The flow is wrong, you can contact the link publisher for help",
  "data.saved.submit": "Your data has been saved, please do not submit it again!",
  "not.current.data": "Not current",
  "refresh.in.stop": "Do not refresh",
  "refresh.in.time": "Refresh in time",
  "cyclic.in.refresh": "Cyclic refresh",
  "periodic.in.refresh": "Periodic refresh",
  "view.refresh.notSet": "This view refresh rule is not currently set",
  "update.immediately": "Update",
  "department.sub.department": "Current user's department and sub-department",
  "department.hasCurrentParDept": "Current user's department and parent department",
  "top.department": "Current user's top department",
  "tertiary.department": "Current user's tertiary department",
  "fourth.department": "Current user's fourth department",
  "fifth.department": "Current user's fifth department",
  "equal.to.filter": "Current user's department and equal to filter",
  "pivot.table": "Pivot table",
  "backend.table": "Backend table",
  "back.form.design": "Back",
  "has.been.saved": " has been modified, is it saved?",
  "not.save.continue": "You modified {{ key }} but did not save it. Do you need to save {{ key }} and continue?",
  "lat": "latitude: ",
  "lon": "longitude: ",
  "minute.ago": " minute ago",
  "flow.starting.point": "Flow starting point",
  "not.empty": " cannot be empty",
  "title.len": "{{ title }} cannot be longer than {{ len }} characters",
  "only.be": " can only be Chinese, English, numbers, underscore, (,),-, space",
  "alias.not.empty": " alias cannot be empty",
  "alias.only.be": " aliases can only be Chinese, numbers, letters, underscores",
  "only.be.num": " can only letters, numbers, underscores",
  "category.num": "Category {{ num }}",
  "series.num": "Series {{ num }}",
  "continued": "Continued",
  "schedule": "schedule",
  "data.no.content": "Data has no content",
  "close.full.screen": "Close full screen display",
  "full.screen.show": "Full screen display",
  "shrink.toolbar": "Shrink Toolbar",
  "expand.toolbar": "Expand Toolbar",
  "latLon.not.exist": "Mark latitude and lonitude does not exist",
  "select.positioning.center": "Select positioning center",
  "latLon": 'latitude and lonitude',
  "add.mark": "Add mark",
  "delete.targeting": "Delete this targeting",
  "latLon.marked": "The latitude and longitude of the marked point is :{{ lngNum }},{{ latNum }}",
  "address": "address: ",
  "location.failed1": "Location failed, time not written",
  "current.node": "Current node:",
  "flow.charger.current.map": "Current charger:",
  "view.look": "View",
  "addressing": "ADDR",
  "latLon.empty.tip": "latitude and lonitude are empty can not be positioned",
  "complete.driving.route": "Draw driving route complete",
  "failed.driving.data": "Failed to get driving data :",
  "notLoaded.positioning.permission": "The positioning is not loaded, please check if you have the positioning permission",
  "lonLat.lon.lat": "[lat and lon: lon {{ lon }}, lat {{ lat }}]",
  "select.delete.data": "Select {{ num }} pieces of data, it cannot be recovered after deletion, sure to delete?",
  "filter.delete.data": "Filter {{ num }} pieces of data, it cannot be recovered after deletion, sure to delete?",
  "select.mort.data": "You have currently selected {{ num }} pieces of data, please do the operation after confirming?",
  "data.cleared": "After the data is cleared, it cannot be recovered. Are you sure to clear it?",
  "selected.operation": "Selected operation",
  "all.operation": "All operations",
  "more.operation": "More operation",
  "no.data.selected": "No data selected",
  "not.started": "Not started",
  "over": "Finished",
  "calendar.default.mode": "Calendar default mode",
  "filter.color.settings": "Data filter color settings",
  "set.data.source": "Please set the data source table",
  "set.field": "Set field",
  "table.menu.bar": "Data table menu bar",
  "sheet.menu.bar": "Data sheet menu settings",
  "report.menu.bar": "Report menu bar",
  "add.report.operation.menu": "Add report operation menu",
  "scheduled.tasks": "Scheduled Tasks",
  "module.setting.timing": "Execute according to the set timing",
  "new.edited.cloudApp": "(You must restart the cloud application to take effect.)",
  "restart.app": "Restart cloud app",
  "selecting.source": "Cannot configure extended functions without selecting data source",
  "extensions": "Extensions",
  "map": "Map",
  "data.selection": "Multi-Selection",
  "raw.data": "Raw Data",
  "view.raw.data": "View Raw Data",
  "view.raw.data.tip": "View the original data of the chart. When the data source is Data View/Aggregate Table, the current attribute is invalid",
  "data.menu.sticky": "Data menu freeze",
  "data.menu.sticky.tip": "Only when the width of the data column exceeds the width of the data table, the data menu freeze will take effect",
  "mobile.not.support": "Mobile terminal does not support data multi-select function",
  "report.type": "Report type",
  "chart.linkage.settings": "Chart custom linkage settings",
  "modifying.data.source.tip": "Modifying the data source settings will clear the existing field configuration and condition filtering options. Are you sure to modify?",
  "add.data.source2": "Add data source",
  "first.data.source": "Please add data source first",
  "report.permissions": "Report permissions",
  "source.before.permissions": "Please select the data source table before setting report permission",
  "dimension.length": "{{ name }} only supports {{ len }} dimension , no more dimensions can be added",
  "indicator.length": "{{ name }} only supports {{ len }} indicator , no more indicators can be added",
  "report.menu.settings": "Report menu settings",
  "field.exists.recycle": "Duplicate field alias (The field exists in the field recycle bin)",
  "alias.empty.saving": "The field alias is unique under the same form. If the alias is not set or set to empty, the alias is the default and takes effect after saving the form",
  "function.module.settings": "Function extension settings",
  "select.module.used.tip": "Only one function plug-in and back-end event can be triggered at the same time, please select according to actual needs. The button trigger event, the QR code generation function, the code scanning function, and the three cannot be used at the same time.",
  "backend.event": "Backend event",
  "data.assistant": "Data Assistant",
  "module.interface.settings": "Plug-in interface settings",
  "pop.report.settings": "Popup report settings",
  "pop.form.settings": "Popup form settings",
  "print.doc.settings": "Print document settings",
  "linkage.formula.converted": "The field contains data linkage / formula editing and cannot be converted",
  "formula.converted": "The field contains formula editing and cannot be converted",
  "otherData.converted": "The field in the field are derived from other form data / contain data linkage and cannot be converted",
  "widget.option.associations.converted": "The field  contains option associations and cannot be converted",
  "flow.started.tip": "The flow has been started, and the operation authority in the process is subject to the node settings",
  "excel.import.tip": "Import data from excel",
  "focus.trigger": "Focus trigger",
  "button.trigger": "Button trigger",
  "set.reminder.content": "Please set reminder content",
  "message.empty.triggered": "If the prompt message is empty, the pop-up prompt box will not be triggered",
  "subform.data.title": "Subform data title",
  "mobile.only.title": "The title of a single row of data in the sub-form on the mobile terminal, only one of the same sub-form field",
  "set.data.title": "Set as data title",
  "button.name": "Button name",
  "fill.button.name": "Please fill in the button name",
  "event.button.characters": "Event button name cannot be greater than {{ len }} characters",
  "reminder.box.displayed": "Is a reminder box displayed?",
  "reminder.title": "Reminder title",
  "fill.reminder.title": "Please fill in the title of the reminder box",
  "mode": "mode",
  "list.mode": "List mode",
  "editable.mode": "Editable mode (valid for mobile only)",
  "process.decision": "Process decision",
  "unprocessed": "Unprocessed",
  "pass": "Pass",
  "refuse": "Refuse",
  "flow.current.node": "Flow current node",
  "flow.current.person": "Flow current person in charge",
  "data.association.table": "Link form",
  "current.form": "Current",
  "linkage.displayed.as": "Show",
  "association.table": "Link",
  "corresponding.value": "Value",
  "linkage.trigger.field": "Data linkage condition must have a field of current form as trigger field",
  "linkquery.trigger.field": "关联条件必须有一个当前表单的字段做为触发字段",
  "select.linked.sub": "Please select the linked fields of the subform",
  "widget.width.takes": "The display width is",
  "related.conditions": "Related conditions",
  "HH.mm": "HH:mm",
  "HH.mm.ss": "HH:mm:ss",
  "scan.code.QR": "Scan code",
  "scan.code.QR.tip": "Scan QR code or bar code. The function of scanning QR code, the function of generating QR code and the button triggering event cannot be used at the same time.",
  "generate.code.QR": "Whether allow auto generation",
  "button.text": "text",
  "button.text.tip1": "text modification failed,",
  "association.form.settings": "Association form settings",
  "Current.Form": "[Current Form]",
  "association.form": "Association form",
  "decimal.allowed": "Decimal allowed",
  "height": "Height",
  "height.according.content": "Self-fitting height according to content",
  "other.at.bottom": "Other options are at the bottom",
  "other.sort.field": "Sort field",
  "other.sort.mode": "Collation",
  "other.sort.waterMark": "Select sorted fields",
  "fill.current.time": "Fill in the current time",
  "current.time": "Now Time",
  "yyyy.MM.time": "yyyy-MM",
  "show.detailed.address": "Show detailed address",
  "automatic.trigger.positioning": "Automatic trigger positioning",
  "uploading.multiple.pictures": "Allow uploading multiple pictures",
  "wechat.service.dingding": "This function is only valid for WeChat  work account/ service account and DingTalk mobile client",
  "Picture.Preview": "Picture Preview",
  "picture.hovering": "Is it allowed to preview the big picture when hovering over the picture? Preview the size range of the picture, minimum 100 * 100 pixels, maximum 1200 * 1200 pixels",
  "Real-time.preview.width": "Preview width",
  "Real-time.preview.pixels": "Real-time preview width, the minimum value cannot be less than {{ minNumber }} pixels, and the maximum value cannot exceed {{ maxNumber }} pixels",
  "Real-time.preview.height": "Preview height",
  "multiple.file.uploads": "Allow multiple file uploads",
  "sub.empty.notLinkage": "The sub form field is empty, and data linkage cannot be set",
  "sub.freeze": "Subform freeze",
  "Before.freeze": "PC freeze",
  "Before.freeze.mobile": "Mobile freeze",
  "Subform.data.loading": "Subform data loading",
  "data.loading.enabled": "Is data loading enabled?",
  "sumEmpty.loading.enabled": "Subform field is empty, data loading cannot be enabled",
  "data.loading.settings": "Data loading settings",
  "Formula.Trigger": "Formula Trigger",
  "note.depend": "The formula will be executed automatically after the sub form import data is completed",
  "sub.data.loading.settings": "Subform data loading settings",
  "LINE": "Line type",
  "Popup.report": "Popup report",
  "Form.report": "Popup form",
  "Form.print": "Print document",
  "Form.download": "Download package",
  "button.color": "Color",
  "added.no.more": "{{ name }} has already added {{ num }} indicators ,no more dimensions can be added",
  "added1.no.more": "{{ name }} has already added {{ num }} dimensions ,no more indicators can be added",
  "only.add.dimensions": " can only add up to 2 dimensions",
  "dimensions.address.view": "The editing interface only takes the first 200 data sources as a preview of query data. For complete data, please visit the page to view.",
  "first200.preview.positioning": "Dimensions only support address and positioning field",
  "basic.report": "Basic report",
  "analysis.report": "Analysis report",
  "no.source.conditions": "No data source is added to all charts, and filter conditions cannot be added",
  "no.source.conditions2": "Filtering conditions that are not in the current report cannot be added directly",
  "mobile.style": "Mobile layout",
  "set.filterButton.style": "Set filter button properties",
  "chartData.automatically.loaded": "Chart data is automatically loaded",
  "chartData.automatically.loaded.tip": "When the filter button field closes the automatic loading data selection, all chart data loading must trigger the data loading function by clicking the filter button",
  "no.indicator.data": "No indicator data",
  "no.data.perspective": "No data in pivot table",
  "field.color.setting": "Field color setting",
  "field.color": "Field color",
  "show.name": "show name",
  "picture.realTime.preview": "Preview settings",
  "is.picture.realTime.preview": "Open",
  "Real-time.preview.pixels.height": "Real-time preview height, the minimum value cannot be less than {{ minNumber }} pixels, and the maximum value cannot exceed {{ maxNumber }} pixels",
  "is.editable": "Is it editable",
  "is.preview.time": "Whether to preview in real time",
  "Mobile.data.header": "Mobile data title",
  "deling": "(Deleted)",
  "field.default.value": "Set the current table field value as the default value of the filter condition",
  "current.form1": "Current",
  "field.only.sub-form": "The display field only supports one sub-form",
  "alias.only.saving.tip": "The alias is unique under the same report. If no alias is set or set to empty, the alias is the default and takes effect after saving the report",
  "data.color.tip": "In the data table, the corresponding color identification can be displayed according to the different content conditions of the selected field. Only one color condition identification field can be set",
  "sort.field.set.tip": "By default, the data table is sorted in reverse order according to the creation time of the data. When the sort field is set, the new field will be used to sort the creation time sorting rules",
  "shift.time.field.tip": " In the roster time field, the first field is the roster start time, and the second field is the roster end time. To ensure the display effect of the shift schedule on the mobile terminal, please select the date and time in the format of the date field in the data table",
  "shift.corresponding.field": "Corresponding fields of shift row header",
  "calendar.field.tip": "In the calendar table, the corresponding color identification can be displayed according to the different content conditions of the selected field. Only one color condition identification field can be set",
  "setting.trigger.tip": "The setting will trigger the _reportevent event, which will transfer the current coordinates, manually marked coordinates, searched coordinates, current data items, and positioning activated data items to the backend for processing",
  "number.type.circle": "Number type, centered on the location field, the field value set is the radiation radius of the coordinate",
  "map.type.latLon": "The field used for punctuation on the map, you can choose a positioning field or a text field, the format of the text field is (latitude, longitude)",
  "login.expired.again": "The login status has expired, please log in again",
  "action.bar.style": "Action bar style",
  "operation.menu.tip": "In the common operation menu, only one style can exist for the icon and the text at the same time",
  "Text": "Text",
  "Icon": "Icon",
  "operation.icon": "Operation icon",
  "icon.color": "Icon color",
  "action.bar.name": "Action bar name",
  "action.bar.name.tip": "Please enter the name of the operation bar, up to 5 characters",
  "action.bar.name.tip1": "Action bar names are not allowed to be repeated",
  "action.bar.name.msg": "Action bar name, up to 5 characters",
  "action.bar.name.color": "Operation bar name color",
  "name.color": "Name color",
  "hint": "Tips",
  "enter.prompt": "Please enter a prompt",
  "refresh.mode": "Refresh mode",
  "not.refresh": "Do not refresh",
  "whole.table.refresh": "Whole table refresh",
  "whole.table.custom": "Refresh the specified table",
  "whole.table.custom.form": "Select the chart to refresh",
  "multi.select.operation": "Multi-select operation",
  "multi.all.operation": "Multi-select operation + all operations",
  "operation.mode": "Operating mode",
  "select.docking.mode": "Please select the docking mode",
  "enable.batch.selection": "Whether to enable batch selection",
  "open.all.operations": "Whether to open all operations",
  "drop.selection.form": "Please drop down the selection form",
  "drop.selection.report": "Please drop down the selection report",
  "open.prompt.box": "Whether to open the prompt box",
  "Click.Settings": "(Click Settings)",
  "set.content.prompt": "Please set the content of the prompt",
  "set.operation.field": "Set the field value of the operation form",
  "report.source.data": "Report source data",
  "set.filter.reports": "Set filter criteria for pop-up reports",
  "exist.select.reports": "The report does not exist, please select a new report",
  "filters.available.reports": "There are no filters available for the report",
  "menu.name.empty": "Menu name cannot be empty",
  "menu.name.repeated": "Menu name cannot be repeated",
  "must.selected.report": "Currently in report pop-up mode, a report must be selected",
  "must.selected.form": "Currently in form pop-up mode, a form must be selected",
  "linkable.charts": "Linkable charts",
  "select.charts.linked": "Please select the chart to be linked",
  "set.charts.linked": "Set the conditions for chart linkage",
  "current.report": "Current report",
  "add.linkage.conditions": "Please add linkage conditions",
  "select.association.chart": "Please select a custom association chart",
  "set.associated.chart": "Please set the conditions for customizing the associated chart",
  "field.sorting": "Field sorting",
  "data.before": " conditions before the data",
  "supports.positive.integers": "Only supports 1-500000 positive integers",
  "add.sorting.field": "Add sort field",
  "calculated.field.name": "Calculated field name",
  "unnamed.data.view": "Unnamed data view",
  "unnamed.data.helper": "Unnamed data helper",
  "view.saved.successfully": "Data view saved successfully",
  "data.view.design": "Data view design",
  "data.helper.design": "Data helper design",
  "nodes.view.processes": "The current data view has isolated nodes or isolated processes",
  "input.view.output": "The current data view has no input / output nodes",
  "calculated.field": "Calculated field",
  "original.name": "Original name:",
  "group.field.name": "Group node configuration field name",
  "according.fields.sheet": " sorts according to the specified fields in the single sheet.",
  "enhanced.controls": "Enhanced fields",
  "department.member.controls": "Department member fields",
  "click.set.member": "Click Set Member",
  "fieldAlias.modification.failed": "Field alias modification failed ,",
  "button.width.unit": "Width (unit: px)",
  "button.width.tip": "On the PC side, the bandwidth of the field is related to the overall layout of the form. When the field layout occupies 1/2 of the bandwidth, the maximum width of the is 350px, and the maximum width of other layout is 720px",
  "button.mode": "Button mode",
  "department.by": "Determined by department field",
  "restricted.field.conditions": "Restricted field conditions",
  "add.related.conditions": "Add linkage condition",
  "modified.form.tip": "You modified the form design but did not save it. Do you need to save and continue?",
  "modified.module.tip": "You modified the plug-in design but did not save it. Do you need to save and continue?",
  "module.development.title": "Plug-in Design - Function Plug-in Development",
  "module.development.title.source": "Plug-in Source Code - Function Plug-in Development",
  "condition.setting": "Condition setting",
  "qualified.data.flow": "Qualified data flow goes to the next node",
  "form.link1": "Form link",
  "form.link1.fill": "You can directly fill in the current form through the form link",
  "created.form.invited": "I created a form and invited everyone to fill it out! - ",
  "external.chain.list": "Extended external chain list ({{ extParams }})",
  "value.already.exists": "The value already exists",
  "extensionField.value.empty": "Extension field or value cannot be empty",
  "copy.external.link.tip": "External link copy succeeded",
  "normal.form": "Common",
  "flow.event.form": "Flow Event",
  "form.type.switching": "Form type switching",
  "widget.recycle.bin": "field Recycle Bin",
  "widget.properties": "field properties",
  "widget.sn.only": "Only one serial number field can be added to the form",
  "deleted.widget.tip": "If the field is deleted, the corresponding form data will also be cleared. confirm delete?",
  "deleted.widget.tip2": "The current field is configured with an index and cannot be deleted directly. To delete, please delete the index of the field first.",
  "update.tip": "The version you are currently using does not include the field recycle bin function, you can go to the member center to view the version usage details and upgrade version.",
  "form.edit.tip": "Form alias modification failed ,",
  "widget.none.tip": "The original value of the invisible field remains unchanged",
  "widget.none.tip1": "When the field is hidden, the field submits a null value",
  "widget.none.tip2": "The calculation and submission logic of the field is consistent with that when there is no hidden",
  "form.alias": "Form alias",
  "form.alias.tip": "The form alias is unique under the same application. If the alias is not set or set to blank, the alias is the default and the modification will take effect",
  "form.sub.tip": "Function plug-in or back-end script setting triggered when form is initialized, submitted, edited and deleted",
  "form.sub.tip1": "Function plug-in setting triggered when form is initialized, submitted, edited and deleted",
  "form.initialization": "Form initialization",
  "form.submission.data": "Form submission data",
  "form.edit.data": "Form edit data",
  "form.other.properties": "Form other attribute",
  "save.data": "Save data",
  "allow.submission.data": "Allow data submission",
  "form.data.cache": "Form data cache",
  "form.data.cache.all.field": "Cache all fields",
  "form.data.cache.field": "Cache specified fields",
  "record.user.source": "Record user source",
  "interview.method": "Access  method",
  "interview.type": "Access  type",
  "operating.system": "Operating system",
  "interview.IP": "Access  IP",
  "visitor.browser.type": "Visitor browser type",
  "hidden.widget.assignment": "Hide field assignments",
  "hidden.widget.tip": "Set the processing method of the value of the hidden field according to the business needs for the fields that need to be hidden in the form",
  "trigger.form.event": "Trigger _form event",
  "event.form.communicate": "The current form is an event form, which can communicate with the app",
  "module.setting.layout": "Plug-in setting interface layout",
  "show.loading.animation": "Show loading animation",
  "show.loading.animation.tip": "Whether the loading status animation is displayed when the field triggers the function plug-in (if the function plug-in takes a long time to execute, it is recommended to turn it on to improve the user experience).",
  "module.setting": "Plug-in settings",
  "pre.trigger": "Pre trigger",
  "post.trigger": "Post trigger",
  "pre.trigger.run": "Pre Run",
  "post.trigger.run": "Post Run",
  "show.multiple.labels": "Multi-tab display",
  "close.multiple.labels": "Please confirm whether to close multi-tab",
  "close.multiple.labels.tips": "After the multi-tab is closed, all fields in the tab page will be put back into the form in the order of fields",
  "flow.status.log": "View permissions",
  "allow.view.status.log": "Allow to view flow status / log",
  "allow.view.status.comment": "Allow to view flow comments",
  "flow.decision.tip": "After starting the flow decision, when the flow data of the mobile terminal is viewed, the process will pass / reject, and the title of the approval can be defined by itself, up to 6 characters",
  "flow.decision.switch": "Flow decision switch",
  "passed.title": "Passed title",
  "approved": "Approved",
  "fill.passed.title": "Please fill in the passed title content",
  "fill.rejected.title": "Please fill in the rejected title content",
  "decision.passed.title": "Decision passed title",
  "decision.rejected.title": "Decision rejected title",
  "rejected.title": "Title rejected",
  "approval.rejected": "Approval rejected",
  "close.flow": "Close flow",
  "close.flow.tip": "After the flow is closed, the data already in circulation will terminate the flow, and the newly submitted data will not enter the flow.",
  "save.flow.tip": "The current flow is not saved. Are you sure to close it?",
  "use.form.flow": "Use the form flow",
  "open.formFlow.workflow": "Open the form flow, set the flow conditions and build the workflow",
  "flow.cond2": "Flow condition",
  "print.template": "Print template",
  "print.template.create.online": "Create online mode",
  "print.template.create.word": "Create Word mode",
  "print.op.log": "Print Log",
  "field.index": "Field index",
  "module.release": "Plug-in release",
  "module.icon": "Plug-in icon",
  "module.type": "Plug-in type",
  "module.image.size": "* Recommended images file size is within 200KB, height and width 100 * 100 pixels",
  "module.business.scenario": "Business scenario",
  "module.business.scenario.tip": "* Add new plug-in business scenarios, please contact online customer service",
  "whole.website.installation": "Installation",
  "this.website.installationUse": "This website is installed using",
  "whole.website.installationUse": "Whole website installation using",
  "publishing.check.valid": "When publishing,tick is valid",
  "module.description": "Plug-in description",
  "module.description.URL": "Description URL",
  "save.information": "Save information",
  "module.save.tip": "The plug-in description URL is malformed",
  "publish.module": "Publish plug-in",
  "publish.module.set.tip": "The plug-in type must be set when the plug-in is released",
  "publish.module.set.tip2": "The business scenario must be set when the plug-in is released",
  "publish.module.set.tip3": "The plug-in description URL is malformed",
  "publish.module.set.tip4": "The plug-in center already has the version under review. Please confirm whether to overwrite the version under review?？",
  "data.sub.tip": "{{ tipName }} reminds when new data is submitted",
  "set.reminders": "Click to set reminders",
  "Email.submitted.tip": "Email reminder when new data is submitted",
  "update.success1": "Update success",
  "field.index.tip": "Up to create ten indexes, up to three combined indexes, each combined index supports at least two, and up to three fields",
  "printing.form.tip": "Printing the form will be printed according to the template format in use",
  "server.address": "server address: ",
  "push.time": "Push time :",
  "delete.operation.tip": "The delete operation is irreversible. Are you sure to delete?",
  "reminder.time": "Reminder time :",
  "reminder.condition": "Reminder condition :",
  "reminder.method": "Reminder method :",
  "Email1": "Email",
  "expand.external.link": "Form publish",
  "this.year": "this year",
  "last.seven.day": "The last seven days",
  "reminder.set.tip": "Your reminder settings are not saved. Are you sure you want to leave the current page?",
  "reminder.set.tip1": "Your reminder content settings are not saved. Are you sure you want to leave the current page?",
  "new.scheduled.task": "Create scheduled task",
  "up.planning.modules": "The current account can only install up to {{ num }} mission planning plug-ins",
  "schedule.task.module": "Schedule task plug-in: ",
  "schedule.task.type": "Schedule task type: ",
  "schedule.task.type1": "Schedule task type",
  "timed.execution": "Timed execution",
  "repeat.execution": "Repeat execution",
  "loop.execution": "Loop execution",
  "task.execution.time": "Task execution time: ",
  "task.execution.last.start": "Last execution time:",
  "task.execution.last.end": "Last end time:",
  "task.execution.last.msg": "Result of the last execution:",
  "single.execution": "Single execution",
  "execution.everyDay": "Every day at ",
  "until.the": " until the ",
  "end.of": " end of ",
  "execution.day": "day ",
  "execution.interval": " Execution interval ",
  "execution.minutes": " minutes,",
  "execution.hour": " hour,",
  "execution.day1": " day,",
  "total.execution": " Total execution ",
  "unlimited.execution": " unlimited executions",
  "schedule.task.settings": "Scheduled task settings",
  "schedule.task.name": "Scheduled task name",
  "schedule.task.save.tip": "Your scheduled task settings donot saved. Are you sure you want to leave the current page?",
  "new.index": "Create index",
  "singleColumn.index": "Single-column index",
  "composite.index": "Composite index",
  "index.mode": "Index mode: ",
  "field.type1": "Field type:",
  "common.field": "Common field",
  "index.subform": "Subform-",
  "index.field": "Index field:",
  "set.index": "Set index",
  "new.print.template": "Create print template",
  "del.print.tip": "Are you sure you want to delete this template? After deleting this template, the default print template will be used to print the form where the template was originally used.",
  "upgrade.package.tip": "If you need to use this function, please upgrade your package",
  "backEnd.return.value": "Back-end return value",
  "copy.link.address": "Copy out chain address",
  "create.type.tip": "Please select the type of form you want to create and start the application building",
  "create.form.tip": "New form: used for data submission, data collection, with data management function",
  "create.flowForm.tip": "New flow form: used for process approval, declaration, notification and other scenarios",
  "create.report.tip": "New report: used for data management, summary calculation, trend analysis and other scenarios",
  "create.etl.tip": "Data view: used for multi-table association, summary, grouping and sorting calculation of data",
  "form.recycle.bin": "Form Recycle Bin",
  "form.report": "form/report",
  "department.id": "Department ID",
  "not.configured": "Not configured",
  "configur.invalid": "Configuration invalid",
  "s.alias": " alias",
  "backEnd.virtual.form": "Back-end virtual form",
  "field.setting.field": "Field setting node configuration field",
  "current.view.nodes": "The current data view has {{ title }} nodes",
  "view.nodes.name": "View node name",
  "search.function.module": "Please search for your function plug-in",
  "search.data": "Search Data",
  "new.module": "Create plug-in",
  "back.top.module": "Back to the top of the function plug-in list",
  "empty.module.tip": "Without any functional plug-in, add one now",
  "prompt": "Prompt:",
  "empty.module.tip2": "You have no plug-in function",
  "version": "Version:",
  'search.all': 'Search All',
  'search.field': 'Search Field',
  'search.flow': 'Search Flow',
  "del.tip": "Are you sure you want to delete?",
  "alias.error.tip": "The alias is unique under the same report. If the alias is not set or set to blank, the alias is the default and takes effect after saving the report",
  "nothing.error.tip": "There's nothing to do",
  "nothing.error.tip1": "Not involved in any flow yet",
  "has.timed.out": "Has timed out",
  "file": "file",
  "file.wordtemplate": "word template file",
  "file.upload.wordtemplate.warning.tip": "Please upload word template file",
  "select1": "Select",
  "click.drag.image": "Click or drag to upload pictures",
  "button2": "Button",
  "click.select.data": "Select data",
  "my.todo.status": "My to-do status",
  "processed": "Processed",
  "process.status": "Flow status",
  "no.data.table": "No data in data table",
  "not.query.data.tip": "No eligible data",
  "del.data.tip": "The data deletion operation is irreversible. Are you sure to delete this data?",
  "formula.field": "Formula field",
  "enter.field.alias": "Please enter a field alias",
  "duplicate.field.alias": "Duplicate field alias",
  "drag.field.tip": "Drag the field on the left to add filter criteria",
  "add.filter.field": "Please add filter field first.",
  "filter.condition.setting": "Filter condition setting",
  "filter.condition.relationship": "Set the relationship between filter conditions and current table fields",
  "filter.condition.filled": "After selecting specific data, the data will be filled according to the following rules",
  "source.table.display": "Data source table display",
  "add.operation.menu": "Add operation menu",
  "Menu.Bar": "Menu Bar:",
  "go.configuration": "【Go to configuration】",
  "operation.menus": "You can only add up to {{ num }} operation menus",
  "menus": "Menu",
  "add.linkage.chart": "Add custom linkage chart",
  "add.chart.tip": "The current chart does not have a data source, and it is not possible to add a custom linkage of the chart",
  "no.chart.available": "No chart available",
  "add.quick.query": "Add quick query",
  "ordinary.form.switch": "Ordinary form: used for data submission, data collection, with data management function",
  "flow.form.switch": "Flow form: used for process approval, declaration, notification and other scenarios",
  "event.form.switch": "Event form: normal form + open backend scripting ability",
  "eventFlow.form.switch": "Flow event form: process form + open backend scripting capability",
  "print.template.settings": "Print template settings",
  "print.template.settings.tip1": "Document storage Upload field",
  "print.template.settings.tip2": "Select the Upload field to deposit",
  "print.template.settings.tip3": "Whether to display the document download page",
  "print.template.settings.tip4": "Print check field",
  "print.template.settings.tip41": "(Before generating the print file, you need to verify the required fields and format attributes)",
  "print.template.settings.tip5": "Select the field to be verified",
  "add.permission.group": "Add custom permission group",
  "system.printing.template": "System print template",
  "custom.print.template": "Custom print template",
  "understanding.print.templates": "Understanding print templates",
  "custom.print.name": "Fill in the name of the custom permission group",
  "Sure1": "Sure",
  "view.data.fields": "Can view the data fields",
  "page": "{{ val }}  / page",
  "department.heads": " - Head of Department",
  "node.alias.failed": "Node alias modification failed",
  "node": "Node",
  "node.alias": "Node alias",
  "node.alias.tip": "The node alias is unique under the same process form. If the alias is not set or set to empty, the alias is the default and takes effect after saving the process form",
  "node.alias.tip2": "Nodes without subordinate nodes will be automatically connected to the end node of the process; if you need to end the process halfway, connect the node that needs to end the process to the end node of the process and set the corresponding circulation conditions.",
  "node.permissions": "Node permissions",
  "departments.CC": "Contains subordinate departments of CC",
  "node.print.template": "Node print template",
  "approval.operation": "Fill in approval comments after form operation",
  "approval.operation.tip": "When the user clicks this button when processing the flow, the user's changes to the data in this node will be saved, and the flow data view will be transferred to the subsequent node.",
  "allow.fallback.to": "Allow fallback to",
  "members.transfer.to": "Selectable range of transfer members",
  "flow.module": "Flow plug-in",
  "cannot.triggered": "Function plug-ins or back-end events cannot be triggered at the same time",
  "flow.briefing": "Flow Briefing",
  "bulk.export": "Export",
  "bulk.move": "Adjust department",
  "enterprise.user.id": "User ID",
  "have": " ",
  "not.join": " members did not join",
  "invite.again": " invite all again",
  "move.tip": "Please select a team member who needs a mobile department",
  "jobtitle.set.tip": "Please select the team member whose job title needs to be set",
  "enterprise.tip": "Unique account of enterprise members in organizational structure",
  "enterprise.tip1": "The only logo of members in the enterprise, which can be modified within the enterprise, and cannot be repeated within the enterprise, it is recommended to be used for job number setting",
  "security.policy": "Not restricted by security policy",
  "security.policy1": "Limited by security policy",
  "bulk.removal": "Removal",
  "add.Security.Group": "Add Security Group",
  "IP.restrictions": "IP restrictions",
  "Accessible.IP.settings": "Accessible IP settings",
  "not.Security.Group": "You have not created a security group",
  "IP.address": "IP address:",
  "team.invitation": "Team invitation",
  "mine": "@me",
  "all.news": "All News",
  "unread.message": "Unread",
  "read.message": "Read",
  "mark.all.read": "Mark all as read",
  "del.all.read": "Delete all read messages",
  "System.reminder": "System reminder",
  "Email.reminder": "Email reminder",
  "Set.recipient": "Set recipient",
  "add.recipient": "Add recipient",
  "recipient.management": "Message recipient management",
  "unread1": " unread)",
  "Auto.Start": "Auto Start",
  "application.review": "Application Audit",
  "following.set.tip": "Please tick the following to set up ~",
  "page.sharing": "Page sharing",
  "cross.application": "Cross-application",
  "custom.menu": "Custom menu",
  "Application.publishing": "App publishing",
  "select.app.tip": "Please select the application on the left first ~",
  "Dashboard.mode": "Dashboard mode",
  "traditional.list": "Traditional list",
  "Jiugongge.list": "Jiugongge list",
  "menu.information": "Menu information",
  "del.menu": "Delete menu",
  "name.menu": "Menu name",
  "icon.menu": "Menu icon",
  "mode.menu": "Menu mode",
  "name.menu.tip": "It is recommended that the menu name has 3-4 characters, so as not to affect the appearance",
  "icon.menu.tip": "Please select the corresponding icon in the system icon library",
  "form.view": "Form View",
  "flow.toDo": "Flow to do",
  "flow.toDo.tip": "The flow to-do mode can directly flow all the flow transactions that the current application needs to flow.",
  "Dashboard.tip": "The Dashboard, displaying all the form information, can be displayed in a list or nine-grid mode as needed.",
  "system.icon.library": "System icon library",
  "view.mode.tip": "View mode, you can directly submit data or view specific data information of the report.",
  "view.mode.tip1": "In view mode, data submission and report data viewing are not affected by any permissions and are fully disclosed.",
  "del.menu.tip": "After deleting it, the content set under {{ name }} menu will be deleted",
  "app.brief": "App brief",
  "app.brief.isempty": "Application brief cannot be empty",
  "app.baleing": "App packaging",
  "app.version": "App version: ",
  "Cloud.app.backend": "Cloud App backend: ",
  "log.content": "Log content",
  "log.time": "Log Date",
  "select.operator": "operator",
  "select.operator.type": "operation type",
  "Fuzzy.match.search": "Fuzzy match search",
  "Creation.time": "Creation time:",
  "shut.accidentally": "Accidentally shut down and restart automatically:",
  "Running": "Running ...",
  "NotRunning": "Not running",
  "Stop.backend.services": "Stop backend services",
  "Start.backend.services": "Start backend service",
  "Application.URL.tip": "Custom application URL, you can use the URL to open the application directly",
  "Application.URL": "Application URL",
  "update.management": "Update management",
  "Token.management": "Token management",
  "Token.Access": "Access token",
  "Token.Access.tip": "Are you sure you want to freeze this access token? After freezing, all requests to access this token will be invalid!",
  "Token.Access.tip1": "Are you sure you want to unfreeze this access token?",
  "Token.Generate": "Generate token",
  "Token.Generate1": "Generate Token",
  "quantity.Generate": "Quantity",
  "normal": "Normal",
  "thaw": "Thaw",
  "Freeze": "Freeze",
  "Set.notes": "Set notes",
  "Visit.link": "Visit link",
  "Set.Token.access": "Set Token access notes",
  "Remarks.32.words": "Remarks cannot exceed 32 words",
  "Post.link.words": "Post interface access link:",
  "copy.Post.link.tip": "Successful copy of post interface access link",
  "Form.creation": "Form creation",
  "enter.URL": "Please enter your own URL",
  "all1": "<Select All>",
  "new.Management.Group": "Create Management Group",
  "batch.Import": "Import",
  "Role.ID": "Role ID",
  "Role.New": "Create Role",
  "del.department": "Delete Department",
  "Download.tip": "The sample table format specification is as follows:",
  "Download.title": "Batch Import Roles",
  "Download.btn1": "Sample",
  "Download1": "1. Download the sample, fill it out according to the sample format.",
  "Download2": "2. Only the column with\" account number \"in the first row is needed in the table, the system will automatically recognize it.",
  "Download3": "3. Import a maximum of 500 data in batches.",
  "del.tip1": "Deleting a member will also delete the member's permissions. This operation is irreversible. Are you sure you want to delete the selected member?",
  "prompt1": "Prompt",
  "Export.tip": "Export {{ name }} all members",
  "Export.success": "Export succeeded",
  "Export.failed.tip1": "No data, import failed",
  "remove.user.tip1": "Please select the member to be removed",
  "Normal.mode": "Normal mode",
  "enterprise.userID": "Enterprise user id",
  "invite.Download1": "1. Import account directly takes effect",
  "invite.Download.title": "Download sample form \"sample form file format\"",
  "invite.Download2": "1. Download the form, you cannot add, delete or modify the member information category of this Excel sheet, just leave it blank if you don't fill it in.",
  "invite.Download3": "2. Mobile phone and name are required, and mobile phone area code, enterprise user ID, department, role and email are optional.",
  "invite.Download4": "3. The department format is: use'/' to separate the upper and lower departments, and start from the uppermost department, such as \"head office/Changsha branch\"; English between multiple departments is used', 'Separate.",
  "invite.Download5": "4. The department is empty, and the format is wrong. The default top-level department. Departments that do not exist are automatically created, and roles that do not exist are automatically created.",
  "invite.Download6": "5. Import up to 200 pieces of data in batches. Members with incorrect information will not be imported. If there are more, please import them into multiple files.",
  "invite.Download7": "6. Mobile phone number as the only value, if it exists, modify other field information.",
  "invite.Download9": "7. Password rule for activation-free mode: 6 to 18 digits. If you don’t fill in, the default is: 123456. The mailbox is valid in activation-free mode.",
  "max.length.12": "Maximum 12 characters",
  "max.length.16": "Maximum 16 characters",
  "max.length.32": "Maximum 32 characters",
  "max.length.64": "Maximum 64 characters",
  "phone.tip1": "Fill in the correct mobile phone number and will be notified by SMS",
  "phone.email.tip1": "Fill in the correct mobile email address, and you will receive the notification invitation",
  "enterprise.tip2": "It is recommended to use the ID of the employee and the company's unified one",
  "del.member.tip2": "Please select a team member to be deleted",
  "ip.tip2": "Please check if the IP is incorrectly filled",
  "ip.tip3": "Delete security group will not be restored, are you sure to delete?",
  "ip.name": "Security Group Name",
  "select.application": "Application",
  "select.form": "Form",
  "select.form1": "Form",
  "Data.management.export": "Data management export",
  "Attachment.bulk.export": "Attachment Export",
  "report.table.export": "New report-data table export",
  "report.perspective.export": "New report-perspective export",
  "Installation.package.export": "Installation package export",
  "type.export": "Export type",
  "ing.export": "Export Preparation",
  "download.export": "Downloadable",
  "status.export": "Status",
  "time.export": "Operation date",
  "name.export": "App / Form Name",
  "operating.instructions": "Operating Instructions",
  "record.export.tip": "No export records",
  "no.data.tip": "There is no data yet",
  "Upload.installation.package": "Upload package",
  "select.app.module": "Select App template",
  "Import.installation.package": "Import package",
  "Name.in.team": "Name in team",
  "to.be.verified": "To be verified",
  "setting.recipient.title": "Notification Settings-Recipient Management",
  "Recharge.status": "Recharge Status",
  "noRecharge.tip": "You have no unpaid orders",
  "more.module": "Multi plug-in",
  "more.module.tip": "Multiple plug-in execution can support this number",
  "more.datahelper": "Data Helper",
  "more.datahelper.tip": "Data Helper execution can support this number",
  "form.link.style": "Custom form external link style",
  "CrossApp.access": "Cross-App Access",
  "sys.num": "System Version Number",
  "sumb.num.tip": "Do you want to submit the order immediately",
  "sumb.type": "Order type:",
  "buy.type": "Buy Package",
  "r.type": "Renewal Package",
  "u.type": "Upgrade Package",
  "tip.type": "The current version you are using cannot use the export attachment function. Please upgrade the package if necessary.",
  "logo.del": "Logo removed from outside chain",
  "Expire.date": "Expire Date",
  "del.btn.date": "Delete Order",
  "del.btn.tip": "Whether to delete this order",
  "Total.payable": "Payable",
  "upload.size": "Upload attachment size",
  "more.module.run": "Multi-plug-in execution",
  "sumb.type1": "Order Type",
  "sumb.time": "Order Time",
  "remaining.time": "Remaining time",
  "select.log.type": "log type",
  "select.log.type1": "Invoicing",
  "select.log.type2": "Team Log",
  "select.log.type3": "Personal Log",
  "select.log.type4": "Add / Remove Normal Management Group",
  "select.log.type5": "Add / Remove System Administrator",
  "select.log.type6": "Add / Remove Members",
  "select.log.type7": "Sub-administrator group permission assignment",
  "select.log.type8": "Clean up application data",
  "select.log.type9": "Bind / Untie WeChat Work",
  "select.log.type10": "Bind / Unbind WeChat",
  "select.log.type11": "Members of WeChat members synchronize",
  "select.log.type12": "Modify phone number",
  "select.log.type13": "Bind / Unbind DingTalk",
  "change.email": "Change Email",
  "bing.registered.account": "Bind Registered Account",
  "code.not.empty": "Valid code cannot be empty",
  "bind.new.email": "Bind new mailbox",
  "bind.new.phone": "Bind new phone",
  "code.sent.to": "Valid code has been sent to",
  "wrong.input.enter": "Wrong input of mobile phone number or email address? Re-enter",
  "create.data.view": "Create Data View",
  "set.alias": "Set Alias",
  "last.refresh": "Last refresh:",
  "refresh.rule": "Refresh Rule",
  "repetition.cycle": "Repetition.cycle",
  "column.name": "Column name:",
  "column.name1": "Column Name",
  "alias.name1": "Alias:",
  "alias.set": "Alias ​​Setting",
  "column.name1.tip": "Indicates the original name of the data view output field title.",
  "alias.name1.tip": "Alias ​​is the same in the same data view, alias naming convention.",
  "alias.name1.tip2": "Only within 32 characters composed of Chinese, numbers and letters underline.",
  "alias.name1.tip3": "If no alias is set, the alias is the default alias.",
  "new.data.tip": "Currently the latest data",
  "refreshing.tip": "Refreshing, please wait ...",
  "new.time.tip": "Cycle refresh: refresh every {{time}} hour",
  "data.view.noInput": "There is no output table for the current view",
  "data.view.error1": "Data view refresh failed, please check the data view settings",
  "data.view.error2": "Data view is not saved output node field information",
  "refresh.data.view": "Refresh view list",
  "data.view.del1": "After deleting the data view, this output data of the data view will also be deleted, and the deleted data cannot be restored",
  "data.view.tip": "Data view can associate, aggregate, append and merge one or more data sources to form an output table. \n You can use the output table as a data source in the report.",
  "refresh.rule.tip1": "When the input source form of the view changes, it will be refreshed to the latest data within the set time interval. When the report and form are called, the data of the latest view refresh will be called",
  "refresh.rule.tip12": "Suitable for scenario: the timeliness requirement of calculation is not high, and it is not suitable for analysis business",
  "refresh.rule.tip13": "Not suitable for scenarios: scenarios that need to be calculated in time",
  "refresh.rule.tip2": "The data will be refreshed regularly at a certain time of day / week / month / year, and the latest view refresh data will be called when reports and forms are called. Generally used for big data When measuring, use it for periodic summary analysis ",
  "refresh.rule.tip22": "Suitable for scenario: the scenario of regular data update",
  "refresh.rule.tip3": "The timely refresh mode will calculate and return the latest data when the data view is accessed. The access scenarios include report display, data linkage, back-end script query, etc",
  "refresh.rule.tip32": "Suitable for scenario: conventional business data computing scenario",
  "refresh.rule.tip33": "Not suitable for scenario: analysis scenario of big data computing",
  "cycle.interval": "Cycle interval",
  "data.view.alias": "Data View Alias",
  "refresh.log": "Refresh Log",
  "refresh.log.tip": "(Only cycle refresh and repeat refresh into the log)",
  "sso.tip": "Apply to enterprise account URL",
  "permission.page.tip": "No permission to access this page",
  "my.team.name": "My team name",
  "how.untie.WeChat": "How to unbind wechat authorization?",
  "bills.details.tip": "Please check the billing information clearly, and then confirm",
  "bills.details.tip2": "Header (name) cannot be empty!",
  "bills.details.tip3": "Taxpayer ID cannot be empty!",
  "bills.details.tip4": "Recipient name cannot be empty!",
  "bills.details.tip5": "The recipient's contact information cannot be empty!",
  "bills.details.tip6": "The recipient's email address or address cannot be empty!",
  "bills.details.tip7": "Successful invoice submission, whether to view invoice records",
  "bills.details.tip8": "Continue invoicing",
  "bills.details.tip9": "Please select the orders that need to be combined for invoicing!",
  "Total.data": "Total Data:",
  "Expired": "Expired",
  "renewal.duration": "Renewal Duration",
  "gift.time": "Gift datetime",
  "discounted.price": "Discount Amount",
  "vip.renewal": "Member Version Renewal",
  "vip.buy": "Member Edition Purchase",
  "Advisory.Service": "Consulting Customer Service",
  "Free.forever": "Permanent free use",
  "other.configure": "Other configuration:",
  "vip.function": "Membership Function:",
  "Import.excel.size": "Import excel size",
  "Remove.LOGO.external": "Remove logo from external link",
  "buy.webApi.tip": "(need to be purchased separately, 3000 yuan / year)",
  "Advanced.Features": "Advanced Features:",
  "No.Advanced.Features": "No advanced features",
  "Independent.server.storage": "Independent Server Storage",
  "Independent.IP": "Independent ip",
  "domain.name": "Domain Name (Custom)",
  "domain.name.Logo": "Site name and Logo (custom)",
  "bind.name.public": "Bind Enterprise Public Number",
  "Service.level": "Service Level:",
  "All.apps.available": "All apps are available",
  "Service.time": "Service Time:",
  "Weekdays.time": "Weekdays 09: 00-17: 30",
  "Weekdays.weekends": "Weekdays 09: 00-17: 30; Weekends 10: 00-17: 00",
  "Alipay": "Alipay payment",
  "WeChat.payment": " wechat payment ",
  "Default.package": "Default package",
  "edit.avatar": "Edit Avatar",
  "upload.avatar": "Upload Avatar",
  "Choose.package": "Choose a package",
  "Click.details": "(Click Details)",
  "Website.Terms": "《 Website Terms of Service 》",
  "Legal.Privacy": "《 Legal Statement and Privacy Policy 》",
  "Package.contents": "Package contents",
  "Total.paid": "Total paid",
  "paid.tip1": "By creating views and adding data processing methods to analyze the existing data, and at the same time, you can call the data",
  "paid.tip2": "Meet the needs of multiple people in the enterprise to manage Platform platform and clear division of labor within the enterprise",
  "paid.tip3": "Used to integrate Platform data with any external data",
  "Add.content": "Additional purchase",
  "release.title": "Release new report",
  "Edit.Security.Group": "Edit Security Group",
  "associated.control.settings": "Option associated field settings",
  "Set.multiple.conditions": "Set multiple associated conditions to limit associated data",
  "Watch.video.started": "Watch Formula Getting Started Video",
  "Watch.video.Advanced": "Watch Formula Advanced Video",
  "Current.table.field": "Current table field",
  "add.subform.field": "Add Subform Field",
  "Be.included": "Be included",
  "Current.field": "Current Field",
  "Linkage.table.field": "Linkage table field",
  "subordinate.department.Contains": "Contains the subordinate department of the person in charge",
  "pushmsg.department.Contains": "Include sub-departments of the reminded person",
  "no.flow.log": "There is currently no flow log",
  "Select.file.tip": "The current package does not include bulk import members,",
  "Select.file.tip2": "Do you want to upgrade now?",
  "no.department.widget": "There is no department widget in the form",
  "module.title1": "Category:",
  "module.title2": "Number of installations:",
  "module.title3": "No description",
  "module.title4": "Description:",
  "module.title5": "All loaded",
  "flow.create.n2": "Initiated",
  "Import.data.img": "Is it possible to export pictures with pictures",
  "Import.user": "Import members in bulk",
  "form.scheduled.num": "Number of scheduled tasks in the form",
  "replace.bound.phone": "Replace bound phone",
  "Invited": "Invited",
  "unactivated": "Unactivated",
  "Editable.details": "Editable Details",
  "Non-editable.details": "Non-editable details",
  "Title": "Post",
  "Phone": "Mobile:",
  "EMAIL": "Mailbox:",
  "Status": "Status:",
  "Account": "Account:",
  "Invited.tip1": "Members cannot bind their mobile phone numbers and cannot invite",
  "Invited.tip2": "Whether to invite users with mobile phone number {{mobile}} again",
  "Invited.tip3": "Send Invitation Successfully",
  "dept.tip": "Sub-admin rights cannot operate the administrator rights panel",
  "add.dept.tip": "Successfully added sub-department",
  "dept.name": "Department Name",
  "edit.role.name": "Edit Role Name",
  "dept.show.user": "Show sub-department members",
  "Test.account": "Test Account",
  "role.import.tip": "The format of the sample is incorrect and cannot be imported, please check or download again",
  "edit.Management.Group.tip": "Modify common management group name",
  "edit.dept.name": "Edit Department Name",
  "department.ID": "Department ID",
  "form.data1": "Form Data",
  "phone.scan.signature": "Phone scan code to add signature",
  "my.dept": "My Department",
  "none.dept": "Hide sub-department members",
  "pay.tip": "Please confirm whether to pay for this package?",
  "invite.Download8": "1. Import account needs activation",
  "select.node.tip": "Please select 《current node》 first",
  "empty.app.tip": "Click here to create an application",
  "Set.quick.query": "Set Quick Query Name",
  "Set.enter.query": "Please enter a quick query name",
  "Invited.all.tip": "Do you want to invite all unjoined members again",
  "unbind.wechat.tip": "Remove the current account binding relationship?",
  "sn.config.tip": "Only when the count reaches the maximum value, restart counting from the initial value.",
  "sn.config.tip2": "Daily 00:00:00, automatically restart counting from the initial value. If the count reaches the maximum value within one day, restart counting from the initial value.",
  "sn.config.tip3": "Every Monday at 00:00:00, the count will automatically restart from the initial value. If the count reaches the maximum value within a week, the count will restart from the initial value.",
  "sn.config.tip4": "00:00:00 on the first day of every month, automatically restart counting from the initial value. If the count reaches the maximum value within one month, restart counting from the initial value.",
  "sn.config.tip5": "00:00:00 on the first day of each year, automatically restart counting from the initial value. If the count reaches the maximum value within one year, restart counting from the initial value.",
  "Excel.title.tip": "The uploaded Excel table meets the following specifications:",
  "Excel.title.tip2": "Use",
  "Excel.title.tip3": " standard template",
  "Excel.title.tip4": " to import data",
  "Excel.title.tip5": "Data cannot exceed {{ limit }} lines, at most only import {{ limit }} lines",
  "Excel.title.tip6": "Only (*.xls and *.xlsx) files are supported",
  "Excel.title.tip7": "File size does not exceed {{ size }}MB",
  "Excel.title.tip8": "The data in the file cannot exceed 50,000 rows and 150 columns (the sub-form details also occupy the number of rows)",
  "Excel.title.tip9": "If the imported data contains a picture field, the number of file data lines cannot exceed {{ line }} lines, 150 columns",
  "Excel.title.tip10": "Start with the latest data",
  "Excel.title.tip11": "Start with the oldest data",
  "Excel.title.tip12": "The total size of the pictures in the exported data cannot exceed  {{ max }}M<br>",
  "Excel.title.tip13": "The size of the excel file exported with pictures will be recorded in the total upload traffic statistics",
  "Excel.title.tip14": "Export with pictures",
  "Excel.title.tip15": "Export without pictures",
  "Excel.title.tip16": "Can directly export all data",
  "Excel.title.tip17": "Only one {{ limit }} data can be exported at a time",
  "Excel.title.tip18": "Start data number",
  "Excel.title.tip19": ",Number of data",
  "Excel.title.tip20": "If you check 「Imported data trigger process」, a maximum of 300 data can be imported",
  "Excel.title.tip21": "Sub-form does not participate in data update",
  "clean.data.tip": "The data that can be cleared is the data with permission to delete. It cannot be restored after clearing. Are you sure to clear?",
  "index.title.tip": "Index name",
  "index.title.tip2": "Please enter the name of this index",
  "index.title.tip3": "Index Mode",
  "index.title.tip4": "Index name is not set",
  "index.title.tip5": "Index setting name",
  "index.title.tip6": "Index Field",
  "index.save.tip": "Your index settings were not saved. Are you sure you want to leave the current page?",
  "switch.form.type.tip": "Switch to a non-event form, cloud application interaction will be unavailable, are you sure to switch?",
  "switch.form.type.tip1": "Switch to event form, data submission will interact with the cloud application, are you sure to switch?",
  "switch.form.type.tip2": "Switch to {{ text }}, are you sure to switch?",
  "switch.form.type.tip3": "Event form, data submission will interact with cloud applications",
  "switch.form.type.tip4": "Common form, process related functions will not be available and cloud application interaction will not be available",
  "switch.form.type.tip5": "Process event form, data management permission settings will be unavailable and data submission will interact with cloud applications",
  "switch.form.type.tip6": "Process form, data management permission settings will not be available",
  "schedule.name.tip1": "(Schedule task name must be unique)",
  "schedule.Untitled.task": "Untitled Scheduled Task",
  "schedule.time": "The execution time is not set",
  "schedule.time1": "The execution time cannot be less than the current time",
  "schedule.time2": "The day of the week is not set to execute",
  "schedule.time3": "No specific execution time set",
  "schedule.time4": "End time cannot be less than the current time",
  "schedule.time5": "The number of cycles is not set",
  "schedule.time6": "Plug-in interface not set",
  "schedule.time7": "Plug-in interface parameters not set",
  "schedule.time8": "Data assistant not set",
  "schedule.tip": "(The date and time must be greater than the current date and time to take effect)",
  "schedule.tip1": "(0 means infinite loop execution, will not stop)",
  "schedule.tip2": "Number of repetitions",
  "schedule.tip3": "Repeat interval, not less than 30 minutes",
  "report.edit.tip": "The editing interface only takes the first 200 data sources as a preview of query data. For complete data, please visit the page to view.",
  "filter.add.tip": "Add filter criteria",
  "filter.Default.tip": "Add Field",
  "filter.add.report": "Report`s",
  "field.add.report": " Field Value",
  "report.menu": "Report Operation Menu",
  "phone.email.tip": "Please enter the correct email or mobile phone",
  "money.tip": "Please enter the correct recharge amount",
  "zifu.tip": "Please enter the correct characters",
  "flow.title": "To-do Flow",
  "exit.login": "Logout",
  "switch.team": "Switch Team",
  "waiting": "Waiting for ",
  "processing": " processing",
  "arrival.time": "Time ",
  "flow.num": "Number",
  "detailed.data": "Detailed Data",
  "display.show": "Expand",
  "log.show": "... Expand",
  "Record.data": "Add Record",
  "etlEmpty.tip": "Please click here to create a data view",
  "Province": "Province",
  "City": "City",
  "Province.City.county": "Province/County/City",
  "print.no.tip": "You have not created a print template for this form",
  "create.print.tip": "Create custom print template",
  "add1": "Add",
  "report.menu1": "Data Table Operation Menu",
  "mobile.sumb": "Submit and close",
  "mobile.dept1": "Invalid Department",
  "mobile.no.user": "No members",
  "mobile.loading.more": "Click to load more...",
  "mobile.user.set": "Character Settings",
  "mobile.user.adds": "Add members in bulk",
  "mobile.user.removes": "Bulk delete members",
  "mobile.no.user.tip": "There are currently no members, please add first!",
  "mobile.user.phone": "Total {{ num }} contacts",
  "mobile.user.select": "Please select members!",
  "mobile.ok.len": "OK ({{ len }})",
  "mobile.ok.pc": "Are there any roles, please create a new one on the PC side, the mobile side only supports role member management!",
  "mobile.ok.user.tip": "What is the role? A more flexible and convenient business group outside the organizational structure, suitable for indiscriminate cross-department collaboration tasks and process approval scenarios\n",
  "mobile.user.dept": "Department of the current user",
  "mobile.user.move": "Bulk Move Members",
  "mobile.user.creater.del": "Creator cannot be deleted",
  "mobile.manage": "Management",
  "mobile.Synchronized": "Synchronized Successfully",
  "mobile.Synchronized.user": "Synchronized Members",
  "mobile.manage.set": "Management Group Settings",
  "mobile.Search": "Search:",
  "mobile.account.no.tip": "The current account has no permissions, please contact the system management to open the permissions!",
  "mobile.Search.no.user": "The contact person related to ‘{{ cont }}’ could not be found",
  "mobile.no.user.ind": "No contact yet, please invite colleagues to join",
  "mobile.edit.user": "Edit Member Information",
  "mobile.user.cont": "Member Information",
  "mobile.no.more": "No more",
  "mobile.user.ind": "Invite colleagues",
  "mobile.flow.data": "Flow Data",
  "mobile.num": "Please enter a number",
  "mobile.cont": "Please select content",
  "mobile.read.all": "Mark all as read",
  "not.used.template": "This template is not used anywhere",
  "Template.use.range": "Template use range",
  "dept.or.user": "Department or Member",
  "Custom.permission.group": "Custom Permission Group",
  "pay.mode.title": "Payment Method:",
  "System.Administrator.Group": "System Administrator Group",
  "Del.agg.table": "Delete Aggregate Table",
  "Del.agg.table.tip": "Please confirm whether to delete the aggregate table {{ name }}, this operation is irreversible",
  "Public.access": "Public Access",
  "delete.recycle.bin": "Whether to delete the selected fields in the recycle bin completely",
  "delete.recycle.filed": "Please select the field to be deleted",
  "delete.recycle.bin.tip": "After the field is completely deleted, the corresponding data will be deleted together. Unrecoverable",
  "flow.node.tip": "Only display the nodes of the active process. For other versions of nodes, please print the template, please set it in the node properties.",
  "recover.are.tip": "Are you sure you want to recover ",
  "all.data.tip": "all data?",
  "del.are.tip": "Are you sure you want to delete ",
  "select.data.tip": "Select {{ len }} data, {{ cont }}?",
  "recover.fail.tip": "Recovery failed",
  "recover.field.title": "Whether to restore the selected fields in the recycle bin",
  "recover.field.msg": "After the field is restored, the corresponding data will be restored to normal access",
  "recover.field": "Please select the field to be recovered",
  "token.tip": "Visit Token Link",
  "Trigger.formula": "Trigger formula: ",
  "add.data.mode": "Data Add Mode: ",
  "Append.mode": "Append Mode",
  "Overlay.mode": "Overlay Mode",
  "select.Excel": "Select Excel Sheet",
  "sub.set": "Sub Form Set",
  "dept.move.tip": "Department moved successfully",
  "note.depend.tip": "When the data is filled, the formula will be automatically executed",
  "del.widget.recycle.tip": "Whether to completely delete all fields in the recycle bin",
  "background": "Background",
  "dept.move.tip1": "Department move failed",
  "set.background.tip": "Set field background color display conditions",
  "set.noAuthority.tip": "There is currently no operation authority that can be set",
  "Add.extended.fields": "Add Extension Fields",
  "set.extended.fields": "Set multiple extended fields",
  "title.State": "State",
  "mobile.back.app": "Return to the application homepage",
  "mobile.msg.tip1": "Please contact the application administrator to set the associated form properties.",
  "mobile.msg.tip2": "Please contact the application administrator to set the data source of the association form.",
  "mobile.msg.tip3": "Please contact the application administrator to set the display field of the associated form.",
  "mobile.msg.tip4": "Please contact the application administrator to set the correspondence between the fields of the association form.",
  "mobile.msg.tip5": "Please select the data to load",
  "mobile.msg.tip6": "The amount of data currently selected has exceeded the maximum data limit of the subform, please select again",
  "mobile.msg.tip7": "Failed to trigger event",
  "mobile.msg.tip8": "Character name cannot be empty",
  "mobile.msg.tip9": "Whether to delete the role",
  "mobile.msg.tip10": "No members selected",
  "mobile.msg.tip11": "Delete role?",
  "mobile.msg.tip12": "Character name cannot exceed 32 characters",
  "mobile.msg.tip13": "Signature saved successfully",
  "mobile.msg.tip14": "Failed to save the signature, please contact the official technician of Baibao Cloud for processing",
  "mobile.msg.tip15": "Add Employee",
  "mobile.msg.tip16": "Successfully created department",
  "mobile.msg.tip17": "Please nickname the department cannot be empty",
  "mobile.msg.tip18": "Deleting a department will also delete the permissions associated with the department. This operation is irreversible. Are you sure to delete this department?",
  "mobile.msg.tip19": "Submission failed, the person in charge of the next node could not be found. The process has been temporarily stored in \"My To Do\", please contact the administrator to check the person in charge of the node and resubmit. ",
  "mobile.msg.tip20": "Submission failed, does not meet the transfer conditions. The process has been temporarily stored in \"My To Do\", please contact the administrator to check the transfer conditions and resubmit. ",
  "mobile.msg.tip21": "The rollback failed, the person in charge after the rollback could not be found. The process has been temporarily stored in \"My To Do\", please contact the administrator to check the person in charge of the node and resubmit ",
  "mobile.msg.tip22": "Subflow failed and does not meet the subflow node inflow conditions, the person in charge after the rollback could not be found. The process has been temporarily stored in \"My To Do\", please contact the administrator to check the person in charge of the node and resubmit ",
  "api.error4014": "There are batch operations in progress, the current operation was rejected",
  "api.error4003": "The current package does not include this function",
  "api.error4005": "Package usage exceeds the limit",
  "api.error4006": "Failed to insert data, backend code returned error:",
  "api.error4007": "The images size exceeds the size allowed in the package",
  "api.error4010": "Data insertion succeeded, backend code returned error:",
  "api.error4015": "Current operation only supports team mode as normal mode",
  "api.error4016": "User ID format in the enterprise is incorrect, only letters, numbers, underscores within 32",
  "api.error4017": "User ID already exists in the enterprise",
  "api.error4018": "Remark format is incorrect, within 32 bits",
  "api.error4019": "The title format is incorrect, within 16 digits",
  "api.error4020": "The name format is incorrect, only Chinese, English, numbers, underscores, (,), -, spaces, spaces cannot be within 26 digits at the beginning and end",
  "api.error4021": "Department parameter cannot be empty",
  "api.error4022": "The site does not allow registered users",
  "api.error4023": "The format of the department name is illegal, only Chinese, English, numbers, underscores, (,), -, spaces, spaces cannot be within 16 digits at the beginning and end",
  "api.error4024": "Sub-department with the same name exists at the same level",
  "api.error4025": "The parent department does not exist",
  "api.error4026": "Department ID is invalid",
  "api.error4027": "Duplicate department number and duplicate department number",
  "api.error4028": "Departments with subdepartments cannot be deleted",
  "api.error4029": "Departments with members cannot be deleted",
  "api.error4030": "The number of departments in a single import exceeds the limit",
  "api.error4031": "Department cascading layer number exceeds limit",
  "api.error4032": "Circulation of departmental relations",
  "api.error4033": "At least one sub-department needs to belong to the root department",
  "api.error4034": "The number of members in a single import exceeds the limit",
  "api.error4035": "Duplicate user ID in the enterprise",
  "api.error4046": "The batch creation data exceeds the limit of 100",
  "api.error4047": "Administrator cannot deleted",
  "api.error5001": "The return parameter is not in json format",
  "api.error5002": "Failed to start the execution process",
  "api.error5003": "Failed to get source file",
  "api.error5004": "Script object creation failed",
  "api.error5005": "Failed to read script",
  "api.error5006": "_webapi function does not exist",
  "api.error5007": "Error running script",
  "api.error6001": "Role group does not exist",
  "api.error6002": "role_no already exists",
  "api.error6003": "Role group creation error",
  "api.error6004": "Role group modification error",
  "api.error6005": "Role group deletion error",
  "api.error6006": "Add failed",
  "api.error7001": "External contact group does not exist",
  "api.error7002": "The group name does not conform to the rules",
  "api.error7003": "Same name as an existing group",
  "api.error7004": "Duplicate grouping",
  "api.error7005": "The default group cannot be deleted",
  "api.error7006": "The group has members but not deleted",
  "api.error7007": "External contact already exists",
  "api.error7008": "The modification of external contact information is abnormal",
  "api.error7009": "The user is already a member of the address book and cannot be added to external contacts",
  "api.error7010": "Failed to add external contact does not exist",
  "api.error8001": "Enterprise creator cannot join any management group",
  "api.error8002": "The management group name does not conform to the rules",
  "api.error8003": "The system administrator cannot be removed",
  "api.error8004": "Already in another group",
  "api.error8005": "Management group already exists",
  "api.error10001": "Failed to create application group",
  "api.error10002": "Apply group renaming failed",
  "api.error10003": "The application group name does not conform to the rules",
  "api.error10004": "Application group does not exist",
  "api.error10005": "Apply group deletion failed",
  "api.error10006": "Form does not exist",
  "api.error11001": "Duplicate data",
  "api.error11002": "Transfer not allowed",
  "api.error11003": "The data corresponding to the unique field already exists",
  "api.error12001": "Failed to send message",
  "api.error12002": "Incorrect message content",
  "api.error12003": "No valid message recipients matched",
  "api.error13001": "Key does not exist",
  "api.error13002": "The current package does not contain platform-level interface permissions",
  "api.error13003": "Incorrect team information",
  "api.error13004": "Gift failed",
  "api.error13005": "The account does not exist",
  "api.error13006": "App installation failed",
  "Sharer.information": "Shared by",
  "Installer": "Installer",
  "successfully.imported": "You have successfully imported 1 pieces of data to form [Unnamed form]",
  "Download": "Download now",
  "batch.edit": "Data batch edit will not be revoked, please be careful:",
  "no.repeat": " The field that is configured with no repeat value does not support editing:",
  "don't.support.batch": "appendix,separator widgets,link data,link query,location don't support batch editing。",
  "edit.log": "View edit log",
  "select.data.opreate": "Please select the data you need to opreate",
  "no.edit.log": "No edit log",
  "Node.dealing": "Node dealing deadline",
  "node.arrived": "When node is arrived",
  "After": "After",
  "limit-time.action": "How to set limit-time action?",
  "Action.method": "Action method",
  "Auto-notify.time": "Auto-notify time",
  "action.detail": "Auto action detail",
  "post.Code": "Post interface",
  "post.Code.tip": "app_id in the following interface path represents the application ID, you can go to the API document in the member center to view it.",
  "post.Code.tip1": "POST /api/v2/app/{app_id}/post -post interface",
  "post.Code.tip2": "Can customize the incoming json structure data, send the incoming data to the backend event _webapi, and return the custom json structure data",
  "post.Code.tip3": "Sample request data:",
  "post.Code.tip4": "_webapi event prototype",
  "post.Code.tip5": "Customize the incoming json structure data and convert it to an internally usable array format",
  "post.Code.tip6": "Additional information, currently only contains ip information",
  "post.Code.tip7": "_webapi event receiving and returning sample:",
  "post.Code.tip8": "Custom return value",
  "post.Code.tip9": "Custom return message",
  "text.mode": "Text Mode",
  "text.mode.text": "text",
  "text.mode.password": "password",
  "winxin.write": "Please scan the code in the mobile WeChat to fill in this form",
  "copy.form.link": "Copy link",
  'No.WeChat.public.account.configured': 'WeChat scan code login is not enabled in the current system and WeChat enhancements cannot be turned on',
  "view.data": "View Data",
  "widget.map": " Map",
  "widget.card": " Card",
  "widget.position": "Position",
  "switch.report.type.tip": "Switching the scene type will clear all the settings of this report, please confirm whether to do this?",
  "switch.report.type": "Switch the report type of this scene to:",
  "map.menu.bar": "Map table Menu Bar",
  "sheet.map.menu.bar": "Map table Menu Settings",
  "add.mapScope": "Add radiation radius",
  "add.mapScope.tip": "Number type, used to set the radius of the effective range of the location field on the map, with the location field as the center, and the set field value as the radius of the circle display",
  "Nulllable": "Do Not Write Back",
  "manualMarker": "Manual Marker Write Back",
  "selectMarker": "Search Box Marker Write Back",
  "geolocationMarke": "Write back to current location mark point",
  "FunctionBtn.tip": "The setting will trigger the _reportevent event, which will pass the current coordinates, manually marked coordinates, searched coordinates, current data items, positioning activated data items to the backend processing",
  "mapButton.tip": "used to display the operation button, click to trigger the action, after configuring the write-back type, the configured punctuation coordinates will be written back to the [map location field] of the current data item",
  "select.loc.tip": "Search positioning center",
  "select.loc.list": "Detail list",
  "LAL.set.title": "Coordinate Setting",
  "map.scale.title": "Default scale",
  "map.set.coordinates": "Set COOR",
  "scenes.set.tip": "*Only one type can be selected",
  "map.biaoshi": "Map Mark",
  "map.menu1": "Map Table Operation Menu",
  "map.data.num": "A total of {{num}} data",
  "map.no.num": "There are no numeric fields in the current form",
  "click.view.credentials": "Click to view credentials",
  "userVip.up.tip": "Please choose upgrade or renewal",
  "app.install.tip2": "Successful installation, return to application management",
  "app.install.tip3": "Successful installation, return to application management after 3 seconds",
  "app.install.tip4": "Please enter the installation password:",
  "app.install": "Install",
  "del.Auth.tip": "Delete permission group will not be restored, are you sure to delete?",
  "formula.urlencode.intro": "URLENCODE function can encode text content using URL",
  "formula.urlencode.usage": "URLENCODE(text)",
  "formula.urlencode.example": "URLENCODE (text) returns %E6%96%87%E6%9C%AC",
  "formula.urlencode1.intro": "URLDECODE function can decode the content encoded by URLENCODE() function",
  "formula.urlencode1.usage": "URLDECODE(text)",
  "formula.urlencode1.example": 'URLDECODE("%E6%96%87%E6%9C%AC") returns text',
  "formula.ISNAN.intro": 'ISNAN function determines whether the parameter is a special non-numeric value NaN',
  "formula.ISNAN.usage": 'ISNAN(logical expression 1)',
  "formula.MD5.intro": 'MD5 value of text string',
  yearTitle: "-",
  monthTitle: " ",
  "add.data": "Add Data",
  "cover.data": "Cover data",
  "import.data.tip": "You have successfully imported {{len}} data into the sub-form",
  "subform.import.data.tip": "Subform data importing",
  "entry.other.text": "Please enter other text",
  "setFields.max.length": "Add up to {{ len1 }}, selected <span>{{ len2 }}</span>",
  "edit.field": "Edit Field",
  "edit.field.empty.tip": "Modify the content of the field is empty, the value of the field that meets the conditions will be cleared, please confirm whether you need to modify",
  "install.module.tip": 'Please confirm whether to install the plug-in "{{name}}"? ',
  "del.module.tip": 'Please confirm whether to delete the plug-in "{{name}}"? ',
  "del.datahelper.tip": 'Please confirm whether to delete datahelper "{{name}}"? ',
  "datahelper.output.field.only": 'Keep at least one field as the main table field',
  "install.module": "Plug-in Installation",
  "update.module": "* A new version of the plug-in is detected and can be updated *",
  "update.module.version": "Update Version",
  "no.flow.tip": "No flow yet to be processed",
  "set.flow.tip": "Please enable the process in the process settings, and then set a print template for the process node",
  "open.flow.fail": "Failed to enable flow version!",
  "open.flow.update": "The process is enabled, if you need to add or delete nodes and connections, please add a new version",
  "open.flow.overdue": "The historical version cannot add or delete nodes and connections. If you need to add or delete nodes and connections, please switch to the version in the design or add a new version",
  "left.form.select": "Please select the table on the left",
  "left.form.field": "Left current table field",
  "right.form.field": "Current table field on the right",
  "right.form": "Right Form",
  "left.form": "Left Form",
  "left.relation.form": "Left Relation Table",
  "right.relation.form": "Right Relation Table",
  "left.form.drag": "Please drag a form/report from the list on the left",
  "left.form.click": "Click on the left menu for editing operations",
  "left.form.select.type": "Left form optional field type",
  "right.form.select.type": "Right form optional field type",
  "left.form.noSelect.type": "Left form field type limit",
  "right.form.noSelect.type": "Limit on the right form field type",
  "relation.form.source.mode": "Relation Table Source Mode",
  "left.form.source.mode": "Left table field source mode",
  "del.field.fictitious": "Delete this virtual field",
  "free.no.export": "The free version does not support exporting excel with attachments/image",
  "image.no.upFlow": "Export accounting upload traffic with attachments/image",
  "current.data": "(current data)",
  "map.btn.tip": "used to display the operation button, click to trigger the action, after configuring the write-back type, the configured punctuation coordinates will be written back to the [map location field] of the current data item",
  "field.fictitious": "Virtual Field",
  "add.field.fictitious.form": "Add Virtual Table Field",
  "output.table": "Output ",
  "select.address": "Please select an address",
  "select.address.sub": "Select an address",
  "select.date": "Please select a date",
  "select.start.date": "Please select a start date",
  "select.end.date": "Please select an end date",
  "signature.entry.tip": "Please write your signature horizontally in the blank area",
  "linkageing.tip": "Data linking, please try again later",
  "entry.flow.tip": "Please fill in the flow approval comments...",
  "Approval.signature": "Approval signature",
  "Approval.signature.required": "Approval signature is required",
  "Collapse.all.details": "Collapse all details",
  "show.all.details": "Expand all detail data",
  "data.all.show": "Data is all displayed",
  "mobile.leave.page.tip": "Leaving the page may lose the filled data, are you sure you want to leave the page?",
  "no.process.toMe.tip": "No process copied to me",
  "initiated.process.yet.tip": "No process has been initiated yet",
  "no.data.yet.tip": "No data",
  "msg.all.read.tip": "All messages have been marked as read",
  "set.filter.criteria": "Set filter criteria",
  "set.Custom.filtering": "Custom Filtering",
  "select.no": "No options currently",
  "click.set.read": "Click to read",
  "type.dian": "Type:",
  "Me": "Me",
  "view.all.log": "View all logs",
  "del.user.tip": "Delete member?",
  "del.source.file.tip": "Please confirm whether to delete the source file {{ name }}?",
  "edit.field.fictitious.form": "Edit Virtual Table Field",
  "flow.field": "Flow Field",
  "successfully.uploaded": "Certificate uploaded successfully",
  "entry.phone": "Please enter the binding phone number",
  "edit.user": "Edit by:",
  "wechat.Bind": "Wechat Bind",
  "wechat.unBind": "Wechat Untie",
  "phone.replacement": "Replace Phone",
  "del.app.tip": "Are you sure you want to delete the “{{ name }}” app?",
  "please.del.tip": "Please confirm whether to delete this record",
  "account.Ordinary": "Ordinary Account",
  "recharge.less": "The recharge amount cannot be less than or equal to zero",
  "upload.transfer.voucher": "Please upload transfer voucher",
  "upload.transfer.voucher2": "Contact cannot be empty",
  "upload.transfer.voucher3": "Mobile phone number cannot be empty",
  "upload.transfer.voucher4": "The name of the payment account cannot be empty",
  "upload.transfer.voucher5": "The payment account number cannot be empty",
  "sys.num.tip": "The current system version number is {{num}}",
  "vip.time.tip": "The membership version starts from {{ sTime }} until {{ eTime }} expires",
  "Currently.contains.tip": "Currently Contains",
  "vip.center.sys_manager1": "Your {{ name }} has reached the total amount",
  "vip.center.sys_manager2": "Your {{ name }} has exceeded the total amount",
  "vip.center.sys_manager3": "Your current version {{ name }} has exceeded the total amount. If you need more, please upgrade the package",
  "vip.center.sys_manager4": "Your current version {{ name }} has reached the total amount. If you need more, please upgrade the package",
  "vip.center.sys_manager5": "Your current version does not support {{ name }} configuration, please upgrade the package if necessary",
  "vip.center.sys_manager6": "The total number of {{ name }} is {{ num }}, if you need to configure more {{ name }}, please upgrade the package",
  "vip.center.sys_manager7": "Your current version does not support {{ name }} configuration, please contact the administrator if necessary",
  "vip.center.sys_manager8": "The total number of {{ name }} is {{ num }}, if you need to configure more {{ name }}, please contact the administrator",
  "vip.center.excel": "The maximum value for importing a single Excel file is {{ num }}. If you need to import a larger Excel file, please upgrade the package",
  "vip.center.upload": "The maximum size of a single upload attachment is {{ num }}. If you need to upload a larger attachment, please upgrade the package",
  "vip.center.hszTime": "The longest retention time for recycle bin data is {{ num }} days. If you need to keep longer, please upgrade the package",
  "vip.center.dont": "Your current version does not support {{ name }}, please upgrade the package if necessary",
  "vip.center.yes": "Your current version supports {{ name }}~",
  "vip.center.img": "Export data with pictures",
  "vip.center.style": "Customized style outside the form",
  "vip.center.module": "Multi-plug-in execution can support up to {{ num }}, if you need to support more, please upgrade the package",
  "vip.center.datahelper": "Data Helper execution can support up to {{ num }}, if you need to support more, please upgrade the package",
  "vip.center.scheduled": "The maximum number of form scheduled tasks supported is {{ num }}, if you need to support more, please upgrade the package",
  "vip.center.call": "Please contact the administrator",
  "vip.center.kefu": "Please contact official customer service",
  "LALdimension.length": "{{ name }} only supports {{ len }} location fields, no more can be added",
  "Electronic.invoice": "Electronic Invoice",
  "Electronic.invoice.tip": "Please fill in the correct mobile phone number to receive electronic invoice information",
  "Electronic.invoice.tip2": "Please fill in the correct email address to receive electronic invoice information",
  "Paper.invoice": "Paper Invoice",
  "email.address": "Email Address",
  "phone.entry.tip": "Please fill in the correct phone number",
  "address.entry.tip": "Please fill in the correct recipient address",
  "header.name": "Header (name)",
  "Taxpayer.Number": "Taxpayer Identification Number",
  "phone.address": "Phone, address",
  "Bank.account": "Bank and Account Number",
  "Recipient.address": "Recipient Address",
  "Contact.information": "Contact Information",
  "module.title.source": "Plug-in Source Code",
  "module.development.title.release": "Plug-in Design-Function Plug-in Settings",
  "Cache.tip": "When entering the form, the last filled content is automatically loaded. Permanent cache, the last filled content will be updated in real time, and will not disappear. Submit the cache, when the data is submitted, the last filled content The cache will be emptied",
  "navigation": "NAV",
  "Shared.with": "Shared with",
  "excel.export.tip": "There are selected picture fields, please set [start data number]",
  "excel.export.tip1": "There are selected picture fields, please set [data quantity]",
  "excel.export.tip2": "There are selected images fields, [data quantity] only supports 1-{{ num }}",
  "excel.export.tip3": "Data number <a style='color:#F5222D'>from big to small</a>, the starting number is <a style='color:#F5222D'>{{ start }} </a>, the end number is <a style='color:#F5222D'>{{ end }}</a>, a total of <a style='color:#F5222D'>{{ count }}</a> ",
  "excel.export.tip4": "Data number <a style='color:#F5222D'>from small to big</a>, the starting number is <a style='color:#F5222D'>{{ start }}< /a>, the end number is <a style='color:#F5222D'>{{ end }}</a>, a total of <a style='color:#F5222D'>{{ count }}</a> ",
  "excel.export.tip5": "The current chart data source is the data view",
  "excel.export.tip6": "Starting data sequence number",
  "excel.export.tip7": "There are selected picture fields, please set [initial data number]",
  "excel.export.tip8": "There are optional picture fields, please set [initial data number]",
  "excel.export.tip9": "There is no data in the data number range, please reset the data number range",
  "excel.export.tip10": "The data start serial number is <a style='color:#F5222D'>{{ start }}</a>, and the end serial number is <a style='color:#F5222D'>{{ end }}</a>, a total of <a style='color:#F5222D'>{{ count }}</a>",
  "excel.export.tip11": "Import Excel data to sub-form",
  "excel.export.tip12": "The excel file exceeds {{ limit }} rows of data and cannot be imported into the sub-form. Please modify and re-import",
  "excel.export.tip13": "The data in the excel file contains merged units and cannot be imported into the sub-form",
  "excel.export.tip14": "Worksheet name",
  "excel.export.tip15": "There are {{ count }} errors in your imported data. Please go back to the previous step to check the field type, or modify it in the original excel before importing again. If you don’t modify it, the wrong data will be imported Null after ",
  "excel.export.tip16": "The following members with the same name are matched in the current address book. Please modify the name of the member or edit the excel data in the format of “name (account)” and re-import",
  "excel.export.tip17": "Members whose name does not correspond to the account in the current address book are matched. Please modify the member's name or edit the excel data in the format of “name (account)” and re-import",
  "excel.export.tip18": "The following department names are matched in the current address book. Please modify the department name and import again",
  "excel.export.tip19": "If the following fields have duplicate values, please modify the correct value and re-import",
  "excel.export.tip20": "If the following fields have null values, please modify the correct value and re-import",
  "excel.export.tip21": "Current exported attachments/images size <a style='color:#F5222D'>{{ size }}M</a>，Over <a style='color:#F5222D'>{{ max }}M</a> limit",
  "excel.export.tip22": "Current exported attachments/images size {{ size }}M，The maximum limit for exporting pictures is {{ max }}M",
  "excel.export.tip23": "The current chart data comes from an aggregated table",
  "excel.export.error": "Error",
  "excel.export.tip24": "Workbook is empty, please adjust and re import",
  "excel.export.tip25": "Workbook header is empty, please adjust and re import",
  "date.today1": "Day",
  "my.address": "My location: ",
  "address.seach.empty": "No data found",
  "address.all.show": "Show all",
  "only.show1": "Show only provinces/cities/counties",
  "only.show2": "Show only the province/city",
  "only.show3": "Show only the province",
  "only.show4": "Show administrative level",
  "only.show5": "Enable latitude and longitude positioning",
  "only.select.Map.address": "Select Address",
  "etl.update.tip": "The data view is being updated. After the update is completed, the chart will automatically refresh",
  "down.refresh": "Pull to refresh",
  "append": "Append",
  "cover": "cover",
  "release.refresh.data": "Release refresh data",
  "empty.form.tip": "This is an empty form",
  "administrator.no.permission": "Sub-administrator has no permission",
  "Member.moved.successfully": "Member moved successfully",
  "Department.added.successfully": "Department added successfully",
  "Department.set.successfully": "Department set up successfully",
  "move.members": "Move members",
  "no.data.edit": "There is currently no data to edit",
  "edit.set.department": "Edit/Set Department",
  "team": "Team",
  "new.department": "New Department",
  "department.name.empty": "Department name cannot be empty",
  "department.name.del": "Do you want to delete department {{ name }}?",
  "add.administrator": "Add Administrator",
  "Select.application.edited": "Select an editable application",
  "Select.manageable.departments": "Select manageable departments",
  "Administrative.all.applications": "Administrative permissions for all applications",
  "all.access.functions": "Access to all functions",
  "all.administrative.members": "Administrative permissions for all members",
  "Application.added.successfully": "Application added successfully",
  "Administrator.added.successfully": "Administrator added successfully",
  "Management.group": "Management Group",
  "New.general.management.group": "New General Management Group",
  "General.management.name.empty": "General management group name cannot be empty",
  "del.management.tip": "Do you want to delete the general management group {{ name }}?",
  "add.role.tip": "Please add a role",
  "del.select.user.tip": "Do you want to delete the selected member?",
  "no.operational.data": "No operational data",
  "Rename.role": "Rename Role",
  "phone.email.error.tip": "The phone number/email is entered incorrectly",
  "phone.email.invitation": "Phone/Email invitation",
  "invitation.success": "Invitation successful",
  "invitation.phone.tip": "When inviting users who are not members of mainland China via their mobile phone number, please add the international telephone area code before the mobile number, for example: +886912345689",
  "show.invited.members": "Show only invited members",
  "invitation.phone.tip2": "Enter the phone number or email address to invite members, separate multiple members with English ”,“, or enter in a new line",
  "invitation.phone.tip3": "When inviting members via mobile phone number, please make sure that your mobile phone number is bound to your Baibao Cloud account, otherwise you will not be able to receive member invitation messages. Non-mainland mobile phone number binding to registered accounts is not currently supported",
  "invitation.phone.tip4": "After opening the invitation link, just visit this link to join your team",
  "invitation.phone.tip5": "Public link copied successfully",
  "empty.form.report.tip5": "This is an empty form/report",
  "empty.report.tip6": "This is an empty report",
  "empty.report.tip7": "View filter conditions",
  "empty.report.tip8": "The application name is incorrect",
  "empty.report.tip9": "Please select the minimum value",
  "empty.report.tip10": "Please select the maximum value",
  "empty.report.tip11": "Please confirm whether to perform the operation",
  "show.all": "Show all",
  "empty.report.tip12": "This file type does not support preview",
  "empty.report.tip13": "Only select at most {{ maxFileCount }} files",
  "empty.report.tip14": "After selecting the current node, you can filter the process data through the visible fields of the node",
  "empty.report.tip15": "The filter field is empty, please set the filter field",
  "empty.report.tip16": "The filter field is empty, please set the filter field",
  "empty.report.tip17": "Please select the process form first",
  "date.ago.hours": "{{value}} hours ago",
  "date.ago.day": "{{value}} days ago",
  "empty.report.tip18": "Empty, there is nothing here",
  "empty.report.tip19": "There are currently no approval comments..",
  "empty.report.tip20": "Process has been withdrawn",
  "empty.report.tip21": "Process has ended",
  "empty.report.tip22": "Data has been submitted",
  "empty.report.tip23": "Please select a fallback node",
  "empty.report.tip24": "Are you sure to end the process?",
  "empty.report.tip25": "The forwarding person in charge cannot be empty",
  "empty.report.tip26": "Please select a print template first",
  "empty.report.tip27": "Print template list",
  "empty.report.tip28": "The print template was not found, please contact the administrator to confirm whether the print template is set for the process node",
  "empty.report.tip29": "Print ({{ text }})",
  "empty.report.tip30": "System Template",
  "empty.report.tip31": "Print (System Template)",
  "empty.report.tip32": "Operation Status",
  "empty.report.tip33": "Auto submit after timeout",
  "empty.report.tip34": "Automatically roll back when overtime",
  "empty.report.tip35": "Automatically end",
  "empty.report.tip36": "Automatic end failed",
  "empty.report.tip37": "Cc to:",
  "empty.report.tip38": "No query results yet",
  "empty.report.tip39": "Anonymous",
  "flow.list.multiNode1": "-Multiple Nodes",
  "flow.list.multiNode2": "Unknown status",
  "flow.list.multiNode3": "There are no eligible processes found",
  "flow.list.multiNode4": "Please select a print template",
  "flow.list.multiNode5": "End successfully",
  "flow.list.multiNode6": "Please select the flow node to be activated",
  "flow.list.multiNode7": "The selected picture type is not supported",
  "flow.list.multiNode8": "Image upload failed",
  "flow.list.multiNode9": "Only allow to select at most {{ maxFileCount }} pictures",
  "flow.list.multiNode10": "Locating...",
  "flow.list.multiNode11": "Clear Address",
  "flow.list.multiNode12": "Auto Service|Auto Sales|Car Repair|Motorcycle Service|Restaurant Service|Shopping Service|Life Service|Sports and Leisure Service|Medical and Health Service|Accommodation Service|Scenic Attractions|Business Residence|Government Agency And social groups|Science, Education and Cultural Services|Transportation Facilities Services|Financial Insurance Services|Company Enterprises|Road Auxiliary Facilities|Public Facilities",
  "flow.list.multiNode13": "The searched location does not exist or is out of range",
  "flow.list.multiNode14": "Locating...",
  "flow.list.multiNode15": "Locating failed, please refresh and try again...",
  "flow.list.multiNode16": "Failed to get latitude and longitude",
  "flow.list.multiNode17": "The latitude and longitude of the marker point are:",
  "flow.list.multiNode18": "The location field cannot be located",
  "flow.list.multiNode19": "All read messages have been deleted",
  "flow.list.multiNode20": "Message Content",
  "flow.list.multiNode21": "Click to set department",
  "flow.list.multiNode22": "Print template list is empty",
  "quick.go": "Quick processing",
  "quick": "Quick",
  "time1": "Time:",
  "time2": "Free today",
  "time3": "Query Field",
  "time4": "Please contact your company administrator to share the form/report with you",
  "time5": "Can't operate? Please click here",
  "time6": "Failed to create a new group",
  "time7": "You have no team to switch",
  "time8": "Sharer Account",
  "time9": "Results",
  "time10": "Process Group",
  "time11": "Please select the process form",
  "time12": "Please select the current node",
  "time13": "Change query conditions",
  "time14": "Sorry, your process message has expired",
  "time15": "You are not in the member list yet",
  "time16": "Please contact the administrator to synchronize members",
  "time17": "This content is published by users via {{ site_name }} and does not represent the position of {{ site_name }}. ",
  "time18": "This item is out of scope",
  "time19": "The attachment is being uploaded, please submit it later",
  "time20": "There was an error in the process, please contact the publisher for handling",
  "time21": "Saving",
  "time22": "The handwritten signature QR code does not exist or has expired",
  "subform.data.load.tip": "Please contact the application administrator to set up data loading.",
  "subform.data.load.tip2": "Please contact the application administrator to set the source of data loading.",
  "subform.data.load.tip3": "Please contact the application administrator to set the display fields for data loading.",
  "subform.data.load.tip4": "Please contact the application administrator to set the correspondence between the fields when the data is loaded.",
  "subform.data.load.tip5": "General management group cannot be empty",
  "subform.data.load.tip6": "Please confirm whether to execute the {{ triggerEventButton }} function",
  "subform.data.load.tip7": "The text content is empty, the QR code cannot be generated",
  "subform.data.load.tip8": "Add by scanning",
  "subform.data.load.tip9": "Set the forwarding person in charge",
  "subform.data.load.tip10": "The current environment does not support the scan code function",
  "subform.data.load.tip11": "Please enter the correct value",
  "subform.data.load.tip12": "There is no general management group yet, please create it first!",
  "subform.data.load.tip13": "There is currently no permission management, please contact the system administrator to assign permissions",
  "subform.data.load.tip14": "System administrator (click to edit system administrator)",
  "subform.data.load.tip15": "Address Book Permission",
  "subform.data.load.tip16": "App permissions (only support viewing on mobile phone)",
  "subform.data.load.tip17": "Address book management range (when no department is selected, all departments can be managed by default, and the mobile terminal only supports viewing)",
  "subform.data.load.tip18": "Ordinary administrator (click to edit ordinary administrator)",
  "subform.data.load.tip19": "Ordinary Administrator",
  "subform.data.load.tip20": "The mobile terminal does not support {{ title }} adding, only supports viewing",
  "subform.data.load.tip21": "Post",
  "subform.data.load.tip22": "Enterprise ID",
  "subform.data.load.tip23": "Site notifications for existing accounts, SMS notifications for new users.",
  "subform.data.load.tip24": "Confirm and send",
  "subform.data.load.tip25": "Department Nickname",
  "subform.data.load.tip26": "Department Settings",
  "subform.data.load.tip27": "Add Supervisor",
  "subform.data.load.tip28": "Select Supervisor",
  "subform.data.load.tip29": "Invite colleagues to join",
  "subform.data.load.tip30": "Number View",
  "subform.data.load.tip31": "Address Book Display",
  "subform.data.load.tip32": "No members, please add members first!",
  "subform.data.load.tip33": "What is the role? A more flexible and convenient business group outside the organizational structure, suitable for scenarios such as undifferentiated cross-departmental collaboration tasks and process approvals\n",
  "subform.data.load.tip34": "Department set up successfully",
  "subform.data.load.tip35": "Add member successfully",
  "subform.data.load.tip36": "-Move member",
  "subform.data.load.tip37": "The current data does not have permission to set coordinates",
  "subform.data.load.tip38": "Please contact the application administrator to set up the configuration for the data loading tree menu",
  "subform.data.load.tip39": "Please contact the application administrator to set up the title field in the data loading tree menu configuration",
  "subform.data.load.tip40": "Please contact the application administrator to set up the title node ID field in the data loading tree menu configuration",
  "subform.data.load.tip41": "Please contact the application administrator to set up the title parent node ID field in the data loading tree menu configuration",
  "subform.data.load.tip42": "Please contact the application administrator to set up the title root node in the data loading tree menu configuration",
  "card.show.top.left": "Show the upper left field in the card title",
  "card.show.top.right": "Show the upper right field in the card title",
  "card.show.down.right": "Show the lower right field in the card title",
  "card.show.down.left": "Show the lower left field in the card title",
  "Lng": ", Lon:",
  "new.Date": "Latest Data",
  "user.detail": "Member Details",
  "editer_browser": "Browser",
  "editer_button_add": "Add",
  "editer_button_back_add": "返回添加",
  "editer_button_cancel": "Cancel",
  "editer_button_del": "Delete",
  "editer_button_edit": "Edit",
  "editer_button_not_save": "Don't Save",
  "editer_button_ok": "Ok",
  "editer_button_save": "Save",
  "editer_button_autosave": "Auto save",
  "editer_button_save_all": "All Save",
  "editer_button_select_all": "全选/反选",
  "editer_button_set": "Set",
  "editer_button_submit": "Submit",
  "editer_byte": "Byte",
  "editer_can_not_repeat": "Can't Repeat",
  "editer_char_all_display": "Show invisible characters",
  "editer_clipboard": "查看剪贴板",
  "editer_clipboard_null": "剪贴板为空！",
  "editer_clipboard_state": "剪切板状态:",
  "editer_clone": "Clone",
  "editer_close": "Close",
  "editer_close_all": "All Close",
  "editer_close_others": "Close Other",
  "editer_close_right": "Close right tab",
  "editer_cloud": "云应用",
  "editer_code_mode": "Highlight syntax",
  "editer_code_theme": "Code style",
  "editer_complete_current": "Autocomplete current",
  "editer_contain": "包含",
  "editer_copy": "Copy",
  "editer_copy_not_exists": "来源不存在",
  "editer_createLink": "创建快捷方式",
  "editer_createProject": "添加到编辑器工程",
  "editer_create_error": "新建失败,请检查目录权限！",
  "editer_create_success": "新建成功！",
  "editer_create_time": "创建时间",
  "editer_current_has_parent": "目标文件夹是源文件夹的子文件夹!",
  "editer_cute": "Cut",
  "editer_cute_past_success": "<b>剪切操作完成</b>(源文件被删除,剪贴板清空)",
  "editer_cute_success": "【剪切】—— 覆盖剪贴板成功!",
  "editer_data_error": "数据出错！",
  "editer_data_not_full": "数据提交不完整！",
  "editer_font_size": "Font Size",
  "editer_auto_complete": "Automatic prompt",
  "editer_dialog_close_all": "关闭所有窗口",
  "editer_dialog_display_all": "显示所有窗口",
  "editer_dialog_min": "最小化",
  "editer_dialog_min_all": "最小化所有",
  "editer_edit": "Edit",
  "editer_edit_can_not": "不是文本文件",
  "editer_edit_too_big": "文件太大,不能大于2M",
  "editer_error": "操作失败",
  "editer_error_repeat": "'操作失败，请注意名称不能重复！'",
  "editer_file": "File",
  "editer_file_type": "文件类型",
  "editer_full_screen": "Full screen/Exit Full screen",
  "editer_function_list": "Function list",
  "editer_get_success": "获取成功!",
  "editer_getting": "获取中...",
  "editer_go": "走着!",
  "editer_go_up": "上层",
  "editer_goto": "跳转到",
  "editer_gotoline": "Jump Line",
  "editer_search": "Search",
  "editer_selectAll": "Select All",
  "editer_if_remove": "确认删除",
  "editer_if_save_file": "The file has not been saved yet. Is it saved?",
  "editer_info": "属性",
  "editer_menu_hidden": "隐藏",
  "editer_menu_move_del": "删除",
  "editer_menu_move_down": "下移",
  "editer_menu_move_up": "上移",
  "editer_menu_name": "菜单名",
  "editer_preview": "Preview",
  "editer_redo": "Redo",
  "editer_refresh": "Refresh",
  "editer_reload": "重新载入",
  "editer_remove": "删除",
  "editer_remove_fali": "删除失败!",
  "editer_remove_info": "确认删除选中内容吗？",
  "editer_remove_item": "项内容",
  "editer_remove_success": "删除成功！",
  "editer_remove_title": "删除确认",
  "editer_rename": "Rename",
  "editer_replace": "Replace",
  "editer_rname_success": "重命名成功！",
  "editer_root_path": "云系统",
  "editer_save_path": "保存路径",
  "editer_save_success": "保存成功!",
  "editer_shortcut": "快捷键",
  "editer_show_file": "新页面预览",
  "editer_size": "Size",
  "editer_sort_down": "递减",
  "editer_sort_type": "排序方式",
  "editer_sort_up": "递增",
  // "success": "操作成功",
  "editer_tips": "Tips",
  "editer_tools": "Tools",
  "editer_type": "Type",
  "editer_undo": "Undo",
  "editer_view": "View",
  "editer_warning": "Warning",
  "editer_width": "Width",
  "editer_wordwrap": "Automatic line break",
  "editer_Compile": "Compile",
  "editer_Compile.error": "Compile error",
  "isOk.tip": "Confirm",
  "app.stop": "Stop app",
  "app.start": "Start app",
  "app.restart": "Restart app",
  "app.stop.tip": "Whether to stop app",
  "app.start.tip": "Whether to start app",
  "app.restart.tip": "Whether to restart app",
  "app.notsave.tip": "Please save all source files",
  "create.py.app.tip": "When the cloud application contains python files, the cloud application will be automatically converted to run in python language",
  "create.py.module.tip": "When the plug-in contains python files, the plug-in will be automatically converted to run in python language",
  "custom.language": "Language ：",
  my: "Me",
  "urge": "Urge",
  "flow.wait.time": "Wait time：",
  "flow.dealwith.time": "Deal with time：",
  "flow.total.time": "Total time：",
  "pending": "Pending",
  "flow.node.charger.more.tip": "All the persons in charge of the current node have submitted all submissions before they are allowed to pass",
  "flow.node.charger.single.tip": "Any person in charge of the current node is allowed to pass",
  "flow.action.batchForward": "Batch forward",
  "flow.todo.all": "All ",
  "webApi.lua1": "LUA Language:",
  "webApi.python1": "Python Language:",
  "webApi.sort": "Sort (asc: positive order; desc: reverse order), unlimited number of sort fields, checkbox group, drop-down checkbox, address, location, picture, attachment, handwritten signature, member single selection , Members multiple selection, department single selection, and department multiple selection cannot be used as sort fields",
  "batch.forward.tip": "After turning on, you can click this button while processing the flows to submit batches of flows. Forms are not verified during batch submissions, formulas and linkages are not triggered, please use with caution.",
  "batch.forward.select.all": "Select this page",
  "batch.forward.select.tip": "{{-count}} items have been selected (only flows with batch submission permission can be selected)",
  "batch.forward.empty": "No flows to select",
  "batch.forward.select.tip1": "{{-count}} items selected",
  "batch.forward.select.tip2": "(Only select to-do with batch submission authority)",
  "batch.forward.warning.select": "Please select at least one flow",
  "batch.forward.warning.limit": "Check up to {{count}} flows",
  "batch.forward.progress.title": "Committing, please do not leave the current page",
  "batch.forward.progress.tip": "{{count}} of {{total}} submitted",
  "batch.forward.finish.tip": "Success {{success}}, failure {{fail}}",
  "batch.forward.break.tip": "{{total}} flows submitted ({{success}} successful, {{fail}} failed), {{remain}} unsubmitted",
  "webapi_forward": "Webapi forward",
  "script_forward": "Script forward",
  "script_close": "Script close flow",
  "app.common": "Common Applications",
  "app.empty1": "No App",
  "speedy.entry": "Quick entry",
  "chart.board": "Report board",
  "api.getSortData": "Sort query data",
  "api.query.sort": "Interface to query multiple data according to sorting",
  "api.skip.sort": "Page turning start value index",
  "appEmpty": "Currently you have no application, click on the top to create a new application",
  "app.custom.add.tip": "Add frequently used apps here",
  "entry.speedy.add.tip": "Add a form, process, or report that is commonly used within the app to it",
  "dash.custom.add.tip": "Add the report you care most often to here",
  "dash.custom": "Custom Dashboard",
  "dash.design.company": "Set enterprise default workbench",
  "dash.design.custom": "Set up my workbench",
  "add.common.app": "Click the application below to add",
  "show.dash.common.app": "Show on the Dashboard",
  "edit.common.app": "Edit common applications",
  "add.common.app.title": "Add common applications",
  "flow.todo.empty.tip": "Please select form processing related process information",
  "flow.center": "Process Center",
  "save.data.tip": "Keep sample data (Recommended)",
  "installed.app.tip": "*Current app is installed ",
  "Current.team.name": "Current team name",
  "custom.platform.usage": "Buttons on the right control the visibility of plug-ins, drag buttons on the left can sort them",
  "to.do.management": "To-Do Management",
  "sign.out.tip": "Are you sure to logout?",
  "sign.out.true": "Exit",
  "app.select.mould": "Select a template from the application center",
  "app.select.create.tip": "<span style='color: var(--bsy-base-color)'>{{ t1 }}</span> and <span>{{ t2 }}</span> please operate from the PC ",
  "new.user.registration": "Registered",
  "enter.account.title": "Enter account number",
  "enter.password.title": "Enter password",
  "Remember.login": "Automatic login next time",
  "forgot.login": "Forgot your password?",
  "account.have.tip": "An account already exists,",
  "m.msg.title.phone": "Enter phone number",
  "m.msg.SMS.verification": "Enter SMS Valid code",
  "p.msg.SMS.verification": "Please enter the SMS Valid code",
  "p.nickname.placeholder": "Please enter a nickname",
  "m.code.send": "Send Valid code",
  "m.code.send.seconds": "Resend in {{time}}s",
  "m.code.login.seconds": "Register/Verify code login",
  "m.account.password.login": "Password login",
  "m.reset.password.tip": "Enter your account and we will reset your password for you",
  "m.reset.password": "Reset Password",
  "m.reset.password.account": "The account that sets the password:",
  "m.reset.password.two": "Please enter the password again",
  "m.reset.password.success": "The password is set successfully, please log in again",
  "m.reset.password.success.ok": "I got it",
  "reset.filter": "reset all filters",
  "reset.filter.and.tip": "data matching all filters",
  "reset.filter.or.tip": "Data that matches any of the filters",
  "m.phone.entry.error": "The format of the phone number is incorrect, please re-enter",
  "m.tiaokuan.entry.error": "Please read and check the above terms",
  "m.setting.home.page": "Click on the avatar to enter the \"Custom Dashboard\" setting home page content",
  "quick.access.edit": "Edit quick access",
  "add.already.count": "Added ({{count}}/{{max}})",
  "add.speedy.app": "Click on the content below to add",
  "add.wait": "To be added",
  "add.already": "Already added",
  "add.max.count.tip": "Add at most {{count}}",
  "no.processed": "You currently have no processed process",
  "dash.edit": "Edit report board",
  "dash.edit.1": "Edit report",
  "dept.op.fail.add": "Sub-department can be added in normal account mode",
  "dept.op.fail.rename": "The department name can be modified in normal account mode",
  "dept.op.fail.delete": "Normal account mode can delete department name",
  "import.mode": "Import Mode",
  "import.mode.insert": "Insert data only",
  "import.mode.update": "Update data only",
  "import.mode.upsert": "Update and insert data",
  "import.update.finish.tip": "Import completed, updated {{count}} data",
  "import.upsert.finish.tip": "Import completed, update {{update}} data, add {{add}} data",
  'import_forward': 'Import data submission',
  'import_forwardfail': 'Import data submission failed',
  "speedy.item.empty": "The current category is empty",
  "flow.count.tip": "You have {{ count }} tasks to do",
  "image.upload.empty": "No picture",
  "file.upload.empty": "No attachments",
  "widget.signaturePad.save.tip": "Save signature for next call",
  "dash.sort.add.field": "Add a sort field",
  "module.num.no": "The number of executions of multiple plug-ins in your current package is insufficient",
  "tracking.num": "Tracking number:",
  "datahelper.delete.output.tip": "The output node in the data assistant is not allowed to be deleted",
  "datahelper.run.filter": "Execution condition",
  "datahelper.filter.tip": "Click on the top left to add an execution field to filter by conditions",
  "etl.datasource.field.empty": "Field has been deleted",
  "datahelper.perform.action.add.description1": "The output result set that will be connected to it, according to the specified conditions, perform corresponding operations such as adding, deleting, modifying, and checking the target form",
  "datahelper.perform.action.add.description2": "After data is entered on the page, data operations with other input sources can be performed，",
  "datahelper.perform.action.add.description3": "Write the result as a new record set into the target form",
  "datahelper.perform.action.edit.description2": "After data is entered on the page，",
  "datahelper.perform.action.edit.description3": "Modify the data in other forms to the content currently entered",
  "datahelper.perform.action.delete.description2": "After data is entered on the page，",
  "datahelper.perform.action.delete.description3": "Delete the eligible data of the target form",
  "datahelper.perform.action.dataRely.description2": "After data is entered on the page，",
  "datahelper.perform.action.dataRely.description3": "According to the current input content, query the required content and return the result to the front page",
  "datahelper.perform.action.field.description1": "Main table fields: All fields default to the main table fields. You can set the sub-form fields as the main table fields. After setting the main table fields, the data will be in the main table form Show, it can correspond to common fields when calling",
  "datahelper.perform.action.field.description2": "Sub-form field: You can set the main table field as a sub-form field. After setting it as a sub-form field, all main table fields will be used as conditions to group and display the data In the sub-form, you can correspond to the sub-form field when calling",
  "datahelper.edit.tip": "Edit",
  "datahelper.create.undefine.name": "Unnamed Data Assistant",
  "datahelper.type.event": "Event",
  "datahelper.type.submit": "Submit",
  "datahelper.type.deleteform": "Form Delete data",
  "datahelper.type.updateform": "Form Update data",
  "datahelper.type.editInitialize": "Form edit initialize data ",
  "datahelper.type.floweditInitialize": "Flow edit initialize data",
  "datahelper.type.initialize": "Form initialize data",
  "datahelper.type.flownodesave": "Save",
  "datahelper.type.flownodeforward": "Submit",
  "datahelper.type.flownodeback": "Back",
  "datahelper.type.flownodetransfer": "Transfer",
  "datahelper.type.flownodeclose": "Close",
  "datahelper.type.datatable_menu": "Datatable menu",
  "datahelper.type.batch_menu": "Report menu",
  "datahelper.type.schedule": "Schedule",
  "datahelper.type.import": "Import data extension operation",
  "datahelper.action.sort": "Sequence of actions",
  "datahelper.add.simulationData": "Add simulation data",
  "datahelper.trigger.config.data_to_form": "Master mode",
  "datahelper.trigger.config.data_to_subform": "Only add subform data",
  "datahelper.trigger.config.subform_to_data": "Merge and add to common fields",
  "datahelper.trigger.config.subform_to_subform": "Merge and add to subform",
  "datahelper.trigger.config.update_data_to_form": "Editing data",
  "datahelper.trigger.config.update_data_to_subform": "Only edit subform data",
  "datahelper.trigger.config.update_subform_to_data": "Merge and edit to common fields",
  "datahelper.trigger.config.update_subform_to_subform": "Merge and edit to subform",
  "datahelper.trigger.config.rely_data_to_form": "Data linkage",
  "datahelper.trigger.config.rely_data_to_subform": "Only link to subform data",
  "datahelper.trigger.config.rely_subform_to_data": "Merge link to common fields",
  "datahelper.trigger.config.rely_subform_to_subform": "Merge link to",
  "datahelper.trigger.config.data_to_form.tip": "Common fields correspond to main table fields, and subform fields correspond to subforms",
  "datahelper.trigger.config.data_to_subform.tip": "The main table field is added to the subform field",
  "datahelper.trigger.config.subform_to_data.tip": "Common fields and subform fields of the output table are merged and added to common fields",
  "datahelper.trigger.config.subform_to_subform.tip": "The common fields of the output table and the subform fields are merged and added to the subform fields",
  "datahelper.trigger.config.update_data_to_form.tip": "Common field corresponds to common field",
  "datahelper.trigger.config.update_data_to_subform.tip": "Common field corresponds to common field",
  "datahelper.trigger.config.update_subform_to_data.tip": "The output table common fields and subform fields are merged and modified to common fields",
  "datahelper.trigger.config.update_subform_to_subform.tip": "The output table common fields and subform fields are merged and modified to the subform fields",
  "datahelper.trigger.config.rely_data_to_form.tip": "Common fields correspond to common fields, and subform fields correspond to sub-form field modes",
  "datahelper.trigger.config.rely_data_to_subform.tip": "Link common field data to the subform of the target table",
  "datahelper.trigger.config.rely_subform_to_data.tip": "The output table common fields and subform fields are merged, and the data is linked to the common fields",
  "datahelper.trigger.config.rely_subform_to_subform.tip": "The common fields of the output table and the subform fields are merged, and the data is linked to the subform fields",
  "datahelper.trigger.config.delete_form": "Delete the main table data",
  "datahelper.trigger.config.delete_subform": "Delete subform data",
  "datahelper.trigger.config.delete_form.tip": "Delete the main table data",
  "datahelper.trigger.config.delete_subform.tip": "Delete subform data",
  "datahelper.trigger.config.update_replace_subform": "Replace subform data",
  "datahelper.trigger.config.update_replace_subform.tip": "Replace subform data",
  "datahelper.trigger.config.data_rely_form": "Link data to the main table field",
  "datahelper.trigger.config.data_rely_subform": "Link data to subform fields",
  "datahelper.trigger.config.data_rely_form.tip": "Link data to the main table field",
  "datahelper.trigger.config.data_rely_subform.tip": "Link data to subform fields",
  "datahelper.trigger.config.upsertData.add": "If no data that meets the filter criteria is found, add data to the target form according to the following configuration",
  "datahelper.trigger.config.rely.default": "If there is no linkage to any data, fill in the form field according to the default value",
  "datahelper.trigger.config.run1": "Set field correspondence",
  "datahelper.trigger.config.run1.Valid.tip": "Please set the field correspondence",
  "datahelper.trigger.config.run2": "Set other options",
  "datahelper.trigger.config.run3": "Set the correspondence between new data fields",
  "datahelper.trigger.config.run4": "Set the default value when data linkage fails",
  "datahelper.trigger.config.next": "Next step: set the field correspondence",
  "datahelper.trigger.config.next1": "other settings",
  "datahelper.trigger.config.next2": "Next step: Set up new data",
  "datahelper.trigger.config.next3": "Next step: Set up rely data",
  "datahelper.trigger.config.next4": "Next step: Message push settings",
  "datahelper.trigger.config.prev": "Previous step: Set trigger action",
  "datahelper.trigger.config.prev1": "Previous step: Set the field correspondence",
  "datahelper.trigger.config.prev2": "Previous step: Set the message push mode",
  "datahelper.trigger.config.prev3": "Previous step: Message push settings",
  "datahelper.trigger.config.data_to_news": "Single data push",
  "datahelper.trigger.config.datas_to_news": "Multiple data push",
  "datahelper.trigger.config.data_to_news.tip": "Single data push",
  "datahelper.trigger.config.datas_to_news.tip": "Multiple data push",
  "datahelper.trigger.config.datas_to_news.tip1": "Push each message interval",
  "datahelper.output.field.move.sn.fail": 'The serial number field is not supported in the subform',
  "datahelper.trigger.filter.add.tip1": 'The output table data meets the following',
  "datahelper.trigger.filter.update.tip1": 'The output table data meets the following',
  "datahelper.trigger.filter.delete.tip1": 'The output table data meets the following',
  "datahelper.trigger.filter.rely.tip1": 'The output table data meets the following',
  "datahelper.trigger.filter.datanews.tip1": 'The output table data meets the following',
  "datahelper.trigger.filter.tip2": 'Conditional trigger execution action',
  "datahelper.trigger.filter.add.link.tip1": 'Filter out the following',
  "datahelper.trigger.filter.add.link.tip2": 'Conditional data',
  "datahelper.trigger.filter.delete.filter.tip1": 'Delete the following',
  "datahelper.trigger.filter.delete.filter.tip2": 'Delete subform',
  "datahelper.trigger.filter.delete.filter.tip3": 'Meet the following',
  "datahelper.trigger.config.entry.field": "Output table fields",
  "datahelper.trigger.config.target.field": "Target form",
  "datahelper.trigger.config.target.fieldsubform": "Target subform",
  "datahelper.trigger.add.filter": "Please add filters",
  "datahelper.trigger.delete.filter": "Please add filters",
  "datahelper.trigger.delete.filter.subform": "Please add subform filter",
  "datahelper.trigger.filter.update.filter.tip1": 'Editing the following',
  "datahelper.trigger.filter.update.filter.tip2": 'Edit subform data',
  "datahelper.trigger.filter.update.filter.tip3": 'Meet the following',
  "datahelper.trigger.filter.update.filter.tip4": 'Linkage meets the following',
  "datahelper.trigger.filter.update.filter.tip5": 'Add linkage meets the following',
  "datahelper.trigger.datarely.tip1": "Fill the target table with data according to the following field settings  ",
  "datahelper.trigger.datarely.tip2": ", And fill the target table with data according to the following field settings",
  "datahelper.trigger.datarely.tip3": "Please select sub-form first",
  "datahelper.trigger.datarely.tip4": "，并按以下的字段设置，进行数据新增",
  "datahelper.trigger.datarely.tip5": "Limited scope is imported data (post trigger)",
  "datahelper.trigger.output.tip1": "Data validity judgment",
  "datahelper.trigger.success.tip": "Turn on the prompt message after the execution action is completed",
  "datahelper.trigger.success.tip1": "There is a set in accordance with the data operation",
  "datahelper.trigger.success.tip2": "It does not meet the setting of data operation",
  "datahelper.trigger.success.tip3": "Clear the specified field",
  "datahelper.trigger.success.tip4": "Interrupt execution",
  "datahelper.trigger.success.tip5": "Prompt information",
  "datahelper.trigger.success.tip6": "Trigger specified formula",
  "datahelper.trigger.success.tip7": "log information",
  "datahelper.trigger.success.tip8": "Ignore the field when the field is empty",
  "datahelper.trigger.success.tip9": "When the content of a field in the output table is empty, the target form field is not modified",
  "datahelper.trigger.success.tip10": "When the replaced sub-form is empty, no modification is made",
  "datahelper.trigger.success.tip11": "Return to the number of executed tips",
  "datahelper.trigger.actionsMaxCount.error": "Perform actions cannot exceed {{count}} ",
  "datahelper.trigger.actionsModuleMaxCount.error": "Only {{count}} function plug-ins can be added to perform actions",
  "datahelper.trigger.output.filter.rel.and": "All data",
  "datahelper.trigger.output.filter.rel.or": "Any piece of data",
  "datahelper.trigger.output.filter.error.tip": "Please fill in the wrong information",
  "datahelper.trigger.action.success.tip": "Please fill in the prompt information",
  "datahelper.trigger.action.success.tip1": "Please fill in the log information",
  "datahelper.trigger.output.filter.ok.tip": "Saved successfully",
  "datahelper.trigger.destform": "Please add the target table first",
  "datahelper.trigger.op.mode.tip": "Click to view, detailed description of operation mode",
  "datahelper.trigger.dataoutput.name": "Output table [Data Assistant]",
  "datahelper.trigger.start.flow": "Whether to initiate a new process",
  "datahelper.trigger.dest.form.notsubform": "The target table has no sub-forms and does not support the current operation mode, please select again",
  "datahelper.trigger.action.filter.text": "Execution condition",
  "datahelper.trigger.title1": "Field correspondence",
  "datahelper.output.error.tip1": "Turn on the data validity judgment, when an error occurs, it will return directly without continuing to execute",
  "datahelper.output.error.tip2": "When the result set is empty, prompt the following error message and return directly, do not continue to execute",
  "datahelper.output.error.tip3": "When the result set is empty, return directly without performing subsequent actions",
  "datahelper.output.error.tip4": "Please fill in the specific error information",
  "datahelper.output.error.tip5": "All data: All data in the entire result set does not meet the following conditions <br> Any piece of data: One data in the result set does not meet the following conditions",
  "datahelper.output.error.tip6": "When the results are concentrated",
  "datahelper.output.error.tip7": "Condition, continue to execute",
  "datahelper.output.error.tip8": "Otherwise, prompt the following error message and return directly, do not continue to execute",
  "datahelper.output.error.tip9": "Otherwise, return directly, do not continue to execute",
  "datahelper.output.error.tip10": "Meet the following",
  "datahelper.inputdata.error.tip": "No field found for input data, please save the form field first",
  "datahelper.import.dataExt": "Extended operation",
  "datahelper.import.dataExt.open": "Enable data assistant",
  "datahelper.import.dataExt.tip": "Can edit data assistant in data management",
  "datahelper.node.output.title": "Output table",
  "datahelper.guide.1": "1/5 Select and set input data -> set data processing method -> adjust output table -> add execution action",
  "datahelper.guide.2": "2/5 Select and set the input data [simulation data can be added]",
  "datahelper.guide.3": "3/5 Set the data processing method [Set according to your own needs]",
  "datahelper.guide.4": "4/5 Adjust the output table [main table mode and sub table mode can be set]",
  "datahelper.guide.5": "5/5 Add execution action [multiple can be set and the execution order can be adjusted]",
  "datahelper.module.current.name": "[Data Assistant-Output Table]",
  "datahelper.op.log": "Data Assistant Log",
  "datahelper.op.log.tip": "The log only records the latest 100 entries, and records will be recorded if the running time exceeds the threshold and system errors.",
  "datahelper.help.header.tip1": "Table background color：",
  "datahelper.help.header.tip2": "Text color：",
  "datahelper.help.header.tip3": "New Data",
  "datahelper.help.header.tip4": "Data found according to query criteria",
  "datahelper.help.header.tip5": "Condition field",
  "datahelper.help.header.tip6": "Internal process (invisible)",
  "datahelper.help.header.tip7": "Background data processing process",
  "datahelper.help.header.tip8": "Modified or linked fields",
  "datahelper.trigger.addaction": "Add data",
  "datahelper.trigger.deleteaction": "Delete data",
  "datahelper.trigger.editaction": "Edit data",
  "datahelper.trigger.relyction": "Rely data",
  "adv.set": "Advanced settings",
  "show.title ": "Display title ",
  "border.radius": "Rounded corners",
  "show.title.background": "Fill background",
  "funnel.chart": "Funnel Chart",
  "transformation.ratio": "Conversion",
  "border.width": "Border width",
  "border.color": "Border color",
  "width": "Width",
  "gap.between.each.trapezoid": "Gap between each trapezoid",
  "show.tip.tool": "Show the tooltip component",
  "tooltip": "Tooltip",
  "opacity": "Opacity",
  "mouse.click": "Trigger when mouse moves",
  "mouse.moves": "Trigger when mouse clicks",
  "conditions.trigger.tooltip": "Conditions to trigger tooltip",
  "follow.the.position.of.mouse": "follow the position of mouse",
  "tooltip.prefix": "Custom series name",
  "tip.alert.reset": "Do you want to reset {{ name }} attribute?",
  "tip.reset": "Reset {{ name }} attributes",
  "Label": "Label",
  "inside": "Inside",
  "outside": "Outside",
  "dash.pie.common": "Pie chart",
  "dash.pie.rose": "Rose chart",
  "dash.pie.doughnut": "Doughnut chart",
  "dash.interval.y": "YAxis interval size",
  "dash.interval.y.warning.tip": "YAxis interval must be greater than 0",
  "dash.interval.y.warning.tip1": "The maximum Y-axis interval must be greater than the minimum",
  "dash.interval.y.warning.tip2": "The minimum Y-axis interval must be less than the maximum",
  "dash.interval.y.tip": "The Y-axis interval must be greater than 0. If the Y-axis interval is too small, it will affect the display of the y-axis scale. Please adjust the interval value appropriately",
  "dash.radiusAxis.y": "Polar",
  "dash.Axis.y": "Cartesian",
  "dash.gauge": "Gauge",
  "dash.gaugeChart": "Gauge",
  "dash.gaugeChart.tip": "1 indicator",
  "dash.gaugeChart.range": "Range",
  "dash.gaugeChart.pointer.color": "Pointer color",
  "dash.gantt": "Gantt Chart",
  'dash.gantt.starttime': "Start Time",
  'dash.gantt.enttime': "End Time",
  'dash.gantt.progress': 'Progress',
  'dash.gantt.starttime.tip': 'Only support time field',
  'dash.gantt.progress.tip': 'Only support numeric fields',
  'dash.gantt.starttime.tip1': "Failed to add, only 1 start time can be added",
  'dash.gantt.enttime.tip1': "Adding failed, only 1 end time can be added",
  'dash.gantt.progress.tip1': 'Adding failed, only 1 progress field can be added',
  'dash.gantt.time.tip1': 'Adding failed, start time and end time cannot be the same',
  'dash.gantt.dimension.tip1': 'The sub-form fields of "start time", "end time", "progress" and "dimension" must belong to the same sub-form',
  'dash.gantt.time.precision': 'Precision',
  'dash.gantt.zoomLevel.tip': 'Zoom Level',
  'dash.gantt.zoomLevel.title': '{{ level }}level',
  'dash.gantt.dependencies': 'Task dependencies',
  'dash.gantt.dependencies.tip1': 'Task identification field',
  'dash.gantt.dependencies.tip2': 'Task dependency field',
  'dash.gantt.dependencies.tooltip2': 'The task identification field is used to uniquely identify a task node, and the task dependency field: used to record the completion of which task node this node depends on, which will produce a connection effect',
  'dash.gantt.bar.start': 'Start:',
  'dash.gantt.bar.end': 'End:',
  'dash.gantt.bar.progress': 'Progress:',
  'dash.gantt.field.add.guide': 'Drag the left field to the top "Dimensions", "Start Time", "End Time" to create a Gantt chart',
  'Year': 'Year',
  'Quarterly': 'Quarterly',
  'Month': 'Month',
  'Quarterly Month': 'Quarterly/Month',
  'Week': 'Week',
  'Day': 'Day',
  'Half Day': 'AM/PM',
  'Hour': 'Hour',
  'hourTime':'Hour',
  "schedule.update.start.tip": "The current scheduled task is stopped, whether to start immediately",
  "no.operation.authority": "No operation authority",
  "preview.view.data": "Do not support viewing data during preview",
  "preview.create.data": "New data is not supported during preview",
  "preview.triggerEvent":"Triggering of feature expansion is not supported during preview",
  "preview.buttom.triggerEvent":"Button operations are not supported during preview",
  "data.manager.create.data": "Data management does not support new data",
  "data.manager.view.data": "Data management does not support viewing data",
  "data.manager.not.permission": "No Permission",
  "data.manager.have.permission.data": "Execute only authorized data",
  "data.manager.have.permission.data.tip": "{{total}} has been checked, {{select}} has permission. Unauthorized data is unchecked.",
  "link.form.op": "Association table operations",
  "linkdata.show.data.count": "Display the number of data",
  "link.form.addData": "Allow new association table data",
  "link.form.oneData": "One",
  "link.form.manyData": "Multiple",
  "dingding.phone.placeholder": "Please enter the mobile phone number used for Dingding registration",
  "dingding.empty.team.tip": "You have not joined any Dingding team!<br />Dingding has not been activated yet<a style='color:var(--bsy-base-color);' href='/dingding/login_guide' target= '_blank'>How to activate?</a>",
  "dingding.have.teams.tip": "The system has detected that you have multiple teams, please select a team for the next scan code login",
  "dingding.auto.syn.switch": "Allow automatic synchronization of address book",
  "dingding.user.login": "Dingding member login",
  "form.flow.dingding": "Access Dingding Approval Suite",
  "form.flow.dingding.tip": "The process of opening this function will be pushed to the corresponding person in charge when the process flow occurs. The person in charge can approve the \"OA Approval\" and \"Pending\" of the application on the Dingding Workbench View and process the process under task grouping. ",
  "form.dingding.SSO.Obtain": "Get",
  "SSOsecret.dingding.tip1": "Note: SSOsecret is mainly used for Dingding background to enter the application operation, if there is no such requirement, you can not modify it",
  "SSOsecret.dingding.tip2": "Modify SSOsecret",
  "SSOsecret.dingding.tip3": "(Please follow the steps below)",
  "SSOsecret.dingding.tip4": "Operation steps:",
  "SSOsecret.dingding.tip5": "1. Open the link:",
  "SSOsecret.dingding.tip6": "2. [Click to view] SSOsecret",
  "SSOsecret.dingding.tip7": "(Requires administrator to click to view)",
  "SSOsecret.dingding.tip8": "* SSOsecret is only used to enter the application from the Dingding background",
  "dingding.auto.syn.log": "Address Book Log",
  "dingding.auto.syn.log.edit.after": "Before Modification",
  "dingding.auto.syn.log.edit.before": "After Modification",
  "print.guide.1": "<span style='color: var(--bsy-base-color);font-weight: bold;'>1</span>/6 Click [Edit]> to enter the print template design page",
  "print.guide.2": "<span style='color: var(--bsy-base-color);font-weight: bold;'>2</span>/6 [Paper Settings] Determine the actual printing range> Draw the print style by yourself",
  "print.guide.3": "<span style='color: var(--bsy-base-color);font-weight: bold;'>3</span>/6 Double-click [cell]> drag [form field] to customize [edit Cell Content]",
  "print.guide.4": "<span style='color: var(--bsy-base-color);font-weight: bold;'>4</span>/6 Click [Batch Print]> to set [Pagination Printing] or [Continuous Printing] ",
  "print.guide.5": "<span style='color: var(--bsy-base-color);font-weight: bold;'>5</span>/6 Click [Custom Watermark]> Custom Settings [No Watermark], [ Picture] Watermark or [Text Watermark]",
  "print.guide.6": "<span style='color: var(--bsy-base-color);font-weight: bold;'>6</span>/6 Click [Background Settings]> select upload [Background Image]> by field value [Draw a cell]> Drag the field to the corresponding cell> [Save and configure the use range of the template]> Open a single piece of data, click the [Print] button to print according to the template",
  "edit.content.filed": "Edit content",
  "check.template": "Select a template",
  "check.template.tip1": "(Required)",
  "check.template.tip2": "<i style='color:#f5222d;font-size: 20px;vertical-align: middle;margin-right: 6px;'>*</i>",
  "check.template.table1": "Message form content",
  "color.black": "Black",
  "color.gray": "Gray",
  "color.highlight": "Highlight",
  "refresh.template": "Refresh the list of templates",
  "template.test": "Test",
  "template.test.user": "Please select a test user",
  "template.sms.reminder": "SMS reminder",
  "template.sms.set": "SMS Settings",
  "template.voice.reminder": "Voice Reminder",
  "template.voice.set": "Voice Settings",
  "template.email.set": "Mail Settings",
  "template.dd.set": "Dingding Settings",
  "template.wx.set": "WeChat Settings",
  "template.qywx.set": "Enterprise WeChat Settings",
  "template.reminder.content": "Reminder content",
  "template.send.fail": "Send failed, please check the content",
  "template.voice.sms.id": "template ID",
  "template.voice.sms.btn": "Get message content",
  "template.we.refresh.tip": "Please click the refresh button above to get the message content again!",
  "template.url": "Message Push Entry",
  "template.check.url": "Form link settings",
  "template.check.url.detail": "Data Details",
  "template.add.cont": "Add content",
  "template.create.title": "Please configure {{type}} template here",
  "template.create.title2": "Please create a {{type}} template here",
  "template.create.title3": "How to configure",
  mail: "Mail",
  "template.style.title": "Fill in style preview",
  "template.select": "Select",
  "sms": "SMS",
  "voice": "Voice",
  "qywechat": "Enterprise WeChat",
  "voice.title.tip": "(The content of the template must be consistent with the content of the Alibaba Cloud template, otherwise it will be invalid!)",
  "flow.action.urge": "urge to do",
  "flow.action.cc": "CC",
  "template.mail.tip": "Member users must bind their mailboxes before they can receive reminders.",
  "template.wx.tip": "Member users must follow the WeChat service account before they can receive reminders.",
  "template.phone.tip": "Member users must have a valid mobile phone number to receive reminders.",
  "template.phone.tip1": "Member users must have a valid mobile phone number or a valid text control to receive reminders.",
  "template.urge.tip": "Use process reminder template to remind",
  "template.error.tip": "This feature requires private cloud support, and it will be enabled after configuration",
  "template.error.tip1": "This feature requires private cloud support and is enabled after configuration",
  "check.template.waterMark": "Please enter the voice template ID",
  "check.template.sms.waterMark": "Please enter the SMS template ID",
  "check.template.waterMark1": "Please select a template",
  "title.trigger": "Trigger Condition",
  "sms.num": "Number of SMS messages",
  "voice.num": "Number of voices",
  "empty.template.tip": "Please set {{name}} template first",
  "error.template.tip1": "Please check whether the template content is completely filled in",
  "error.template.tip3": "Please select at least one reminder method",
  "datahelper.subform.tip": "No subform is currently available",
  "datahelper.subform.tip1": "Please select the message push entry",
  "template.id.empty.tip": "Template ID cannot be empty",
  "template.id.empty.tip1": "Please complete {{name}} settings first",
  "template.id.empty.tip2": "Please add a reminder",
  "edit.etl.stage.title": "Edit node name:",
  "template.restore": "Restore Default",
  "template.length.tip": "The content of the message form cannot exceed {{len}} at most",
  "api.add.data.batch": "Add data in batches",
  "api.create.batch": "Create multiple data interfaces",
  "api.create.desc.batch": "Add multiple pieces of data to the specified form.",
  "api.res.create.batch.success": "Successful data result",
  "api.res.create.batch.failed": "Failed original data",
  "api.res.create.batch.failedCode": "Error code corresponding to failure",
  "api.res.create.batch.data": "Response content:",
  "api.create.batch.data.desc": "The limit of 100 items exceeds the error report",
  "qyweixin.set.manage": "Click to configure",
  "qyweixin.set.manage.title": "Enterprise WeChat Address Book Authorization",
  "corp.qyweixin.Step.url": "URL",
  "corp.qyweixin.Step.Token": "Token",
  "corp.qyweixin.Step.EncodingAESKey": "EncodingAESKey",
  "corp.qyweixin.Step.title": "Configure parameters for automatic synchronization of address book",
  "corp.qyweixin.Step.title.tip": "(Please copy and paste the following parameters to <a href='https://work.weixin.qq.com/wework_admin/frame#apps/contactsApi' style='color :var(--bsy-base-color);font-weight: bold;margin: 0 5px;padding-bottom: 1px;border-bottom: 1px solid var(--bsy-base-color);' target='_blank'>The corresponding position of address book synchronization</a>, see details Parameter configuration operation guide)",
  "manage.qyweixin.explain": "Configuration Description",
  "set.password.new": "Set a new password",
  "set.name.new": "Set your name",
  "set.name.new.p": "Please set your name",
  "set.name.new.t": "It is recommended that you use your real name for quick identification in the team",
  "wxbind.tip": "The phone number <a style='color: var(--bsy-base-color);text-decoration: underline;'>{{value}}</a> already exists",
  "wxbind.tip1": "Please bind this account directly and log in",
  "wxbind.login": "Bind and log in",
  "entry.code.tip": "Please enter {{len}} verification code",
  "dingding.code.team.login": "Mobile phone Dingding scan code to log in directly",
  "set.password.tip": 'The password does not meet the specifications, please reset it',
  'feishu.login': 'Feishu login',
  'mobile.login.empty.tip': 'The mobile terminal does not have a suitable login method, please contact the administrator or log in to the computer terminal',
  'reg.login.empty.tip': 'Currently unable to register, please contact the administrator',
  'switch.to.resignation': 'Deleted',
  'addressbook.joined.tip': 'There are <span style="color: #F5222D;margin:0 2px">{{num}}</span> members have not joined, <span class="inv" style=" color: var(--bsy-base-color);cursor: pointer;">Invite all again</span>',
  'batch.error.tip': 'Results of batch import data: {{success}} success, {{exist}} already existed, {{error}} failed',
  'batch.error.btn': 'Download wrong data',
  'dismission': 'Deleted',
  'dismission.error.tip': 'Only ordinary members can be deleted',
  'dismission.error.tip2': 'Please select the members who need to deleted',
  'dismission.alert.tip': 'Are you sure to transfer the selected members to leaving members? ',
  'dismission.alert.tip1': 'After being converted to a deleted member, when you join again with the same member number, you can restore the relevant configuration',
  'handover.work': 'Handover work',
  'handover.work.loading': 'The following work of {{user}} is being transferred to {{to}}, please wait...',
  'handover.auth.group': 'Member of form permission group',
  'handover.notify': 'Push reminder to be reminded',
  'handover.datahelper': 'Data helper is reminded',
  'handover.dash.auth': 'Report authority group member',
  'handover.name.tip': 'There are the following jobs, which can be transferred to other members as needed',
  'handover.finish.tip': 'Handover is complete, you can continue to handover to other work',
  'handover.empty.tip': 'There is no work under this category',
  'handover.empty.tip1': 'No job is currently selected, please confirm whether you have selected the job that needs to be transferred',
  'handover.error.tip': 'Cannot transfer work to yourself',
  'handover.error.tip1': 'Please select a member who needs to be transferred to work',
  "handover.finish": "Success {{success}} items",
  "handover.forward": "Failed {{fail}} items",
  "handover.load.forward": "The transfer is completed, but there are failed job transfers, you can try to transfer again",
  'todo.data': 'todo data',
  'todo.data.tip': 'Transfer content: current user approval process',
  'todo.data.empty.tip': 'No process in progress',
  "todo.dataCount": "{{count}} items",
  'todo.data.tip1': 'Process in progress',
  'creator.data': 'The data current user submitted',
  'creator.data.empty.tip': 'No data submitted by the current user',
  'creator.data.tip': 'Transfer content: The data current user submitted',
  'flow.user': 'Process person in charge',
  'flow.user.tip': 'Transfer content: node person in charge, node CC, reminder for limited time processing, forward candidate',
  'flow.creator.data.tip': 'Transfer content: Process data initiated by the current user',
  'flow.creator.data.empty.tip': 'No process data initiated by the current user',
  'form.dash.config': 'Form, report configuration',
  'form.dash.config.tip': 'Transfer content: permission group, push reminder, regular reminder',
  'role.tip': 'support forwarding [created role], please adjust the other configuration of the address book in the address book',
  'set.name.empty.tip': 'Name cannot be empty',
  'outsider.custom.group': "Custom Group",
  'outsider.custom.all': "All Contacts",
  'outsider.view.custom.all': "View all contacts",
  "outsider.add": "Add external contact group",
  "outsider.name.required": "Please fill in the group name",
  "outsider.name.empty": "The group name cannot be empty",
  "outsider.group.delete.tip": "Deleting an external contact group will delete the associated permissions. This operation is irreversible",
  "outsider.member.delete.tip": "Deleting an external contact will also delete the associated permissions. This operation is irreversible",
  "outsider.group.edit": "Modify group name",
  "outsider.miniapp.seting.tip": 'Group members who share WeChat Mini Program automatically join the group',
  "outsider.member.batch.recover": "Batch Recovery",
  "outsider.member.recover.groupempty.tip": "Select the group to be recovered",
  "outsider.member.remove.empty": "Please select the external contact to be deleted",
  "outsider.member.remove.tip": "Are you sure you want to delete the selected external contact?",
  "outsider.member.recover.empty": "Please select the external contact to be recovered",
  "outsider.member.recover.tip": "Are you sure to recover the selected external contacts?",
  "outsider.member.add": "Add external contact",
  "outsider.member.singleAdd": "Manually add external contacts",
  "outsider.member.batchAdd": "Bulk import of external contacts",
  "outsider.member.in.group": "In the group",
  "outsider.member.import.Download01": "1. Import account takes effect directly",
  "outsider.member.import.Download11": "1. Download the form. You cannot add, delete or modify the member information category of this Excel sheet. Leave it blank if you don't fill it in.",
  "outsider.member.import.Download12": "2. Mobile phone, name and group are required, and mobile phone area code, user ID and email are optional.",
  "outsider.member.import.Download13": "3. If the group does not exist, it will be created automatically",
  "outsider.member.import.Download14": "4. Import up to 200 pieces of data in batches. Members with mobile phone numbers and user IDs already in external contacts or members with incorrect information will not be imported. If there are excess, please divide them into multiple files Import",
  "outsider.member.import.Download15": "5. The password rule for activation-free mode: 6 to 18 digits, if not filled in, the default is: 123456",
  "outsider.member.to.dept": 'Transfer to department member',
  "outsider.member.from.dept": 'Transfer to external contact', //Department member to external contact
  "outsider.miniapp.seting": "WeChat Mini Program Settings",
  "outsider.miniapp.seting.share.autojoin": "Share WeChat Mini Program automatically joins",
  "outsider.miniapp.seting.share.autojoin.tip1": 'After it is turned on, members of the address book or external contact members who share the WeChat applet will automatically register and join the default group',
  "outsider.miniapp.seting.share.autojoin.tip2": 'After it is turned on, members of this group of external contacts who share the WeChat applet will automatically register and join the external contact custom group. The priority of the custom group is higher than the setting of the default group.',
  "outsider.miniapp.seting.share.qr": "QR code entrance",
  "outsider.miniapp.seting.share.qr.tip": "After opening, allow external personnel to scan the QR code to access a specific page, and automatically join the external contact group",
  "outsider.miniapp.seting.share.home": "Set the entry page",
  "outsider.miniapp.seting.share.expiretime": "Sharing link and sharing QR code valid expiration time setting",
  "outsider.miniapp.seting.share.regenerate": "Regenerate",
  "outsider.miniapp.seting.share.qrsize": "Share the QR code size",
  "outsider.miniapp.seting.share.qrsize.8": "8cm*8cm",
  "outsider.miniapp.seting.share.qrsize.12": "12cm*12cm",
  "outsider.miniapp.seting.share.qrsize.15": "15cm*15cm",
  "outsider.miniapp.seting.share.qrsize.30": "30cm*30cm",
  "outsider.miniapp.seting.share.qrsize.50": "50cm*50cm",
  "outsider.miniapp.seting.share.Invalidation": "The QR code is invalid, please regenerate",
  "outsider.miniapp.seting.share.EffectiveTimeire": "QR code effective time",
  "outsider.miniapp.seting.share.permanentTime": "Permanent Time",
  "outsider.miniapp.seting.share.limitTime.tip1": "The valid time of the QR code must be 30 minutes greater than the current time",
  "outsider.miniapp.seting.share.limitTime.tip2": "The valid time of the QR code cannot be greater than 30 days from the current time",
  "outsider.miniapp.seting.launcher": "Set the entry page",
  "outsider.miniapp.seting.launcher.clear": "Clear the entry page",
  "approve.list.header.1": 'Applicant',
  "approve.list.header.2": 'Mobile phone or email',
  "approve.list.header.3": 'application time',
  "approve.list.header.4": 'Reason for application',
  "handover.create.role": "Create role group",
  "resign.user": "Deleting Member",
  "resign.user.1": "no longer a member of the address book",
  "resign.time": "Deleted Time",
  "resign.user.tip": "Please select the member who needs to be deleted",
  "resign.alert.tip": "Are you sure you want to restore the selected deleting members as active?",
  "reinstatement": "Deleted users",
  "outsider.miniapp.seting.launcher.home": "Application Homepage",
  "resigned.user": "Deleted",
  "off.on.use": "Is it {{ dos }} this {{ type }}?",
  "scan.qr.signature": "Scan the QR code and add a handwritten signature",
  "scan.qr.image": "Scan the QR code with your mobile phone to upload the image",
  "corp.feishu.authorization": "Feishu Application Authorization",
  "corp.feishu.explain": "Feishu application binding description",
  "corp.feishu.href": "Need to contact [Team Administrator] to log in to Feishu Open Platform<a href='{{url}}' target='_blank' style='color: #00FFD2;'>{{url }}</a> for binding configuration",
  "corp.feishu.text1": "The Feishu application binding adopts Feishu's [internal development] mode of docking",
  "corp.feishu.text2": "Why use the [enterprise internal development] model",
  "corp.feishu.text3": "Using the [Enterprise Internal Development] model can obtain more capabilities: for example, automatic synchronization of the address book, etc., saving a lot of time",
  "corp.feishu.help": "Please follow <a href='/feishu/guide' target='_blank' style='color: #FFB200;'><i class='icon-bsy-guide'/>Parameter configuration operation guide</a> to complete the operation",
  "corp.feishu.Step.unbin.btn": "Remove Feishu Authorization",
  "corp.feishu.Step.unbind": "Do you want to remove Feishu authorization?",
  "corp.feishu.Step.unbind.tip": "After unbinding Feishu, the account will be restored to the original address book information of this account, the application and data information will be retained, and the original Feishu application can be restored by rebinding it.",
  feishu: "Flying Book",
  "dash.thresholds.msg.feishu": "Feishu reminder",
  "template.feishu.set": "Feishu Setting",
  "corp.feishu.h5.url": "H5 trusted domain name",
  "corp.feishu.redirect.url": "Redirect URL",
  "corp.feishu.redirect2.url": "Request URL",
  "corp.feishu.ip.url": "IP whitelist",
  "corp.feishu.pc.url": "Desktop homepage",
  "corp.feishu.mobile.url": "Mobile homepage",
  "corp.feishu.omp.url": "Management background homepage",
  "corp.feishu.app.url": "2. Configure application permissions and publish applications",
  "sign.out.team": "Sign out of the current team",
  "sign.out.team.waterMark": "Please enter the current team name",
  "sign.out.team.tip1": "Please enter the correct team name",
  "sign.out.team.tip": "Sign out {{teamName}}",
  "outsider.miniapp.seting.share.qrsize.tip": "Click the icon below to select the corresponding QR code size to download",
  "role.empty.tip": "There is currently no role, please create one",
  "role.empty.tip1": "There are currently no roles for third-party teams",
  "create.role": "Create Role",
  "node_has_loop":"The multi branch process has a loop and cannot flow normally. Please contact the administrator to check the process design",
  "flow-exception":"Flow Exception",
  "manager.delete.warning1": "Delete the general management group, the related administrators and permissions will also be deleted, and cannot be restored.",
  'handover.work.empty': 'There is currently no work to be handed over',
  'app.store.search': 'Search application system',
  'app.store.search.tip': 'The system where the application is located',
  'app.store.search.title': 'The following are the current search results',
  'app.store.list.empty': 'No apps in the current category',
  'app.store.search.empty': 'Please enter the content that needs to be searched',
  "form.select": "Form Selection",
  "push.event": "Push Event",
  "activated.setting": "Settings enabled",
  "stoped.setting": "Settings disabled",
  "deactivate": "Deactivate",
  "push.log.type": "Push log type",
  "push.logging": "Push Logging",
  "pending.log": "Pending log",
  "abandon.log": "Abandon Push Log",
  "data.api.logTip.day": "Only keep {{day}} days of push logs",
  "push.content": "Push Content",
  "push.event.tip": "Please check at least one push event",
  "secret.tip": "Please fill in secret",
  "activated.webhook.tip": "Do you want to enable this push?",
  "deactivated.webhook.tip": "Do you want to deactivate this push?",
  "delete.webhook.tip": "Do you want to delete this push?",
  "retry.webhook.tip": "Do you want to push again?",
  "abandon.webhook.tip": "Abandon push?",
  "retry.webhook.tip1": "The push has been requested again",
  "pending.status": "Pending Send",
  "open.platform": "Open Platform",
  "server.url.tip": "The server address does not start with http://https:// or is not a URL",
  "server.url.tip1": "For example: http://www.xxxxx.com or https://www.xxxxx.com",
  "open.platform.empty.tip": "There is currently no data push, go and create a new one~",
  "member.change": "Member Change",
  "dept.change": "Department Change",
  "role.change": "Role Change",
  "external.contact.change": "External Contact Change",
  "member.contact.add": "Members of the address book add",
  "member.contact.edit": "Contact Member Change",
  "member.contact.del": "Contact member resigns",
  "member.contact.recover": "Recovery of Contacts Member deleted",
  "member.to.external": "Member of Address Book to External Contact",
  "member.to.dept": "Member Mobile Department of Address Book",
  "dept.create": "Create Address Book Enterprise Department",
  "dept.edit": "Corporate department modification of address book",
  "dept.del": "Delete the corporate department of the address book",
  "add.role": "Add role group",
  "edit.role": "Edit role group",
  "edit.add.user": "Add role group members",
  "edit.del": "Delete role group",
  "edit.del.user": "Delete role group members",
  "external.add.group": "Add external contact group",
  "external.edit.group": "Delete external contact group",
  "external.del.group": "Modify external contact group",
  "external.add": "Add external contacts",
  "external.del": "Delete external contacts",
  "external.edit": "Modify External Contact",
  "external.to.dept": "External contact transfer to department member",
  "url.server.tip1": "The server address is connected normally",
  "url.server.tip2": "The server address is abnormally connected, the error code is {{code}}",
  "delete.webhook.tip1": "Delete the webhook callback setting of the address book, no longer trigger the interface?",
  "deactivated.webhook.tip1": "Stop the callback of the address book webhook interface, and resume after startup",
  "activated.webhook.tip1": "Start address book webhook callback",
  "purview.webhook.tip1": "The open platform permission has not been obtained yet",
  "push.event.flow": "Process event",
  "outsider.to.user.tip": 'It is a special operation to transfer an external contact to a member, please check your identity, so as not to cause some settings and data abnormalities after the conversion',
  "user.to.outsider.tip": 'It is a special operation for a member to transfer to an external contact. Please check your identity to avoid some settings and data abnormalities after the conversion',
  "outdiser.subadmin.tip1": 'When the subadministrator is an external contact, this attribute is invalid',
  "deactivated.form.tip1": "Stop the form webhook interface callback, resume after startup",
  "activated.form.tip1": "Start form webhook callback",
  "searchApp": "Search for application / form",
  "searchAppForm": "Search application or form names",
  "recycle.bin": "Recycle Bin",
  "delete.webhook.form.tip1": "Delete the form webhook callback setting, no longer trigger the interface?",
  "edit.form": "Edit Form",
  "move.app.toGroup": "Move the application to the following group",
  "name.form.report": "Search for form/report",
  "input.app.name": "Please enter the application name",
  "input.form.name": "Please enter the form or report name",
  "corpid.Enter.title": "please bind the team's Corpid first",
  "corpid.Enter.inputTip": "please fill in the enterprise Corpid",
  "corpid.edit": "Modify Corporate ID",
  "form.dash.empty": "Form or report does not exist",
  "app.dash.form.empty": "The current application has no available forms or reports",
  "dash.not.select": "No report is currently selected",
  "dash.form.empty": "No matching form or report is currently found",
  "app.all.empty": "No matching apps are currently found",
  "add.already.num": "{{num}} have been added",
  'Block.invalid': 'The report has been deleted',
  'Block.invalid.1': 'The report does not have permission to access',
  "app.empty.tip1": 'There is no application yet, create an application to start your work journey',
  "platform.system": "Platform System",
  "address.book.system": "Address Book System",
  "application.system": "application system",
  "key.management": "api Key",
  "api.res.params": "Return parameters:",
  "api.res.noParams": "Return parameters: None",
  "webhook.key": "Key:",
  "webhook.key.name": "Key name:",
  "webhook.key.name1": "Key Name",
  "webhook.key.all.placeholder": "Please enter the key name",
  "webhook.key.all.error": "Please enter a correct key name",
  "webhook.key.all.detail.tip": "Have all interface permissions for contacts and applications",
  "webhook.key.all": "All interfaces",
  "webhook.key.all.msg": "*This key has the interface permissions of the address book interface and all applications",
  "webhook.key.detail": "Key Details",
  "webhook.key.create": "Create key",
  "webhook.key.customize": "Customize Key",
  "webhook.key.app.select.title": "App Selection",
  "webhook.key.del.title": "Please confirm whether to delete the permission of {{name}}?",
  "webhook.key.customize.del.title": "Are you sure you want to delete this custom permission?",
  "webhook.key.customize.menu": "Customize System",
  "webhook.key.customize.empty": "There is currently no custom application system, go and create a new one~",
  "webhook.key.customize.create": "New custom system",
  "webhook.key.customize.edit": "Edit custom system",
  "webhook.key.customize.title": "Form custom permission group",
  "webhook.key.app.empty.title": "There is currently no application system, let's create a new one~",
  "webhook.key.auth.empty.title": "There is currently no platform system permission, please contact the administrator",
  "webhook.key.create.first.app": "Start creating your first application",
  "webhook.key.create.app": "New App",
  "webhook.create.app.blank.application": "New blank application",
  "webhook.create.app.office.apps": "Build your own office apps",
  "webhook.create.app.select.application.template": "Select the application template",
  "webhook.create.applications.from.template.center": "Install existing applications from the template center",
  "webhook.create.app.importing.installation.package": "Importing the installation package",
  "webhook.create.app.import.application.installation.package.system": "Import an application installation package to the system",
  "webhook.key.create.tip": "Create key (custom key)",
  "webhook.re.key": "Please confirm whether to reset the Api Key of the key \"{{name}}\"?",
  "webhook.re.key.placeholder": "Please enter the key name",
  "webhook.re.key.tip": "The key name entered is incorrect, please confirm and re-enter",
  "flow.ding.max.len": "You can only pin {{num}} forms at most",
  "flow.min.len": "The current menu needs to keep at least {{num}} forms",
  "no.set.page": "No entry page is currently set",
  "form.backflowidName": "Backflow from {{name}}",
  "form.backflowidName.title": "Backflow from {{name}}",
  "form.backflowidName.end": " .",
  "dash.agree": 'agree',
  "dash.agree1": 'Data of filter condition',
  "dash.full.autoRefresh.tip": "Data will be automatically refreshed in full screen mode",
  "webhook.key.empty.tip": "There is currently no key, go and create a new one~",
  "login.mirror.access": "Access mirror",
  "login.mirror.access.quit": "Quit mirror access mode",
  "login.mirror.access.title": "Mirror Access",
  "login.mirror.access.title.mobile": "Mirror Access Mode",
  "login.mirror.access.tip.title": "Mirror Mode",
  "login.mirror.system.tip.title": "{{time}}system mirror",
  "login.mirror.access.msg": "Read-only mode, which can be downloaded and cannot be edited. It is used to retrieve data that has been misoperated.",
  "login.mirror.access.tip": "Access to the system mirror of {{time}}, read-only mode, downloadable, for retrieving mis-operated data.",
  "login.mirror.header.msg": "Mirror data of {{time}}, only administrator login",
  "login.mirror.access.msg1": "Read-only mode, which can be downloaded and cannot be edited. It is used to retrieve data that has been misused, only the team's system administrator can access.",
  "login.mirror.title.msg": "Admin only login",
  "login.mirror.signin": "Administrator login",
  "dashboard.flow.todo.set": "Drag the following components to the right to set the workbench",
  "dashboard.page.components": "Page Components",
  "latest.to.do": "Latest To Do",
  "all.to.do": "All To Do",
  "latest.to.do.urge": "The latest reminder",
  "about.to.time.out": "About to time out",
  "todo.from": "from",
  "todo.empty.msg": "No todo messages yet",
  "dashboard.all.app.tip": "Only some applications are displayed during the configuration process, and all applications are displayed when accessing the workbench",
  "dashboard.all.entry.tip": "Only some forms are displayed during the configuration process, and all forms are displayed when accessing the workbench",
  "self.build": "self-build",
  "close.custom.dash": "Close Custom Dash",
  "login.qywechat.self": "Enterprise WeChat self-built login",
  "design.close.msg": "Your frequently used applications, forms, and reports can be freely laid out and added to the workbench! Improve your work efficiency faster!",
  "design.custom.open": "Open custom workbench",
  "design.close.alert.title": "Are you sure you want to close the custom workbench?",
  "dash.map.window.title": "Information List",
  "dash.map.marker.empty.tip": "Please add the coordinate points to be set on the map report (click the map or add the coordinate points by searching the address)",
  "design.close.alert.msg": "This will return your workbench to the default style, which cannot be undone.",
  "address.book.dept.set.title": "Job Seting",
  'jobtitle.set': "Set the title of the member's department",
  'address.book.dept.set.title.select': "Please select a job title",
  'address.book.dept.jobtitle.add': "Add a job title",
  'address.book.dept.jobtitle.addnew': "Add new job title",
  'address.book.dept.jobtitle.addnew.tip': "Each line represents a position and must not exceed 16 characters",
  'address.book.dept.jobtitle.addnew.no-permission': "User is not in current department",
  "qywechat.bind.activation.tip": "There are {{ day }} days left in the enterprise WeChat experience time. In order not to affect your normal experience, please activate it immediately",
  "qywechat.bind.select.user": "Please select the team that needs to be logged in",
  "install.app.title": "Install [{{appName}}] application",
  "install.app.tip": "You can customize it after getting it",
  "install.app.wechat.title": "Contact customer service online",
  "install.app.ok": "Confirm installation",
  "install.app.cancel": "Cancel installation",
  "package.base.title": "Basic function purchase",
  "package.buy.title": "Custom Package Purchase",
  "package.base.dataview.grouptable.begin": "{{num}} starting upgrades",
  "package.base.member.begin": "{{num}} people start to upgrade",
  "package.base.flow.begin": "{{num}}G start upgrade",
  "package.base.data.begin": "{{num}} million data start upgrade",
  "package.base.flow.num": "{{num}}G",
  "package.base.data": "Data volume",
  "package.base.member": "Number of users",
  "package.base.dataview.grouptable.unit": "{{num}}yuan/unit/year",
  "package.base.member.unit": "{{num}}yuan/person/year",
  "package.base.flow.unit": "{{num}}unit/G",
  "package.base.data.unit": "{{num}} yuan/10,000 data/year",
  "package.base.purchased": "Purchased:",
  "package.base.not.purchased": "Unpurchased:",
  "package.base.check.order": "Check Order",
  "package.base.update": "Upgrade",
  "package.details": "Package Details",
  "package.details.base": "Base configuration:",
  "package.app.install.num": "Number of applications installed",
  "package.site.webapi": "Open Platform-Platform Interface",
  "num.ge": "{{num}}",
  "appstore.guide.step1.title": "Create your <span>first app</span>",
  "appstore.guide.step1.desc": "You can <span>create a blank app</span> and build it yourself",
  "appstore.guide.step2.desc": "Alternatively, you can <span>install the app in the app center</span>, use it directly or personalize it yourself",
  "sso.empty.config.tip": "Single sign-on has not been configured yet. After configuration, it will be more convenient for you to log in",
  "purview.sso.tip": "Single sign-on permission has not been obtained yet",
  "sso.config.content.title": "Single sign-on configuration content",
  "sso.other.team.tip": "Single sign-on is not supported for third-party teams",
  "qiyewechat.custom": "Enterprise WeChat address book activation",
  "qiyewechat.custom.tip": "Enterprise WeChat address book is activated. After activation, the address book information of enterprise WeChat can be obtained normally",
  "qiyewechat.custom.active": "Deactivate",
  "qiyewechat.custom.active.code": "Open the enterprise WeChat and scan the QR code below, authorize the self-built application to be developed, and activate the address book",
  "qiyewechat.custom.active.code2": "After the authorization is completed, please wait for the official review. After the review is passed, the address book can be activated",
  "qiyewechat.phone.entry.tip": "Please fill in the mobile phone number bound to the company's WeChat",
  'clean.select.item': 'Clear All',
  'outlink.tip.user': 'Form external chain does not support member control',
  'outlink.tip.usergroup': 'Form external chain does not support members to choose multiple controls',
  'outlink.tip.dept': 'Form external chain does not support department control',
  'outlink.tip.deptgroup': 'Form external chain does not support the department\'s multiple controls',
  'data.manager.alldata.edit': 'All data',
  'data.manager.filterdata.edit': 'The screened data',
  'data.manager.alldata.exportfile': 'All data of all data',
  'data.manager.filterdata.exportfile': 'Attachment of the data after screening',
  'data.manager.alldata.qrcode': 'All data of all data',
  'data.manager.filterdata.qrcode': 'The two -dimensional code of the data after screening',
  'field.widget.name': 'Field original alias',
  'deleted.outdiser': 'The deleted external contact person',
  'default.group': 'Default group',
  'waiting.new': 'Waiting ',
  'wps.xlsx.name1': 'External contact bulk import template.xlsx',
  'wps.xlsx.name2': 'Connect enterprises to batch import template.xlsx',
  'wps.xlsx.file.name': 'Template for batch import of address book.xlsx',
  'invite.phone.required': 'You must fill in the correct mobile phone number',
  'invite.email.required': 'You must fill in the correct email',
  "email.entry.tip": "Please fill in the correct email address",
  'member.invitation.import': 'Member invitation import',
  'consolidate.departments.groups': 'Department/Role group processing method',
  'consolidate.departments.groups.tip': 'When importing existing members, whether the department/role group is in overwrite mode or consolidation mode, and other information that does not need to be verified is overwritten',
  'department.ownership': 'Department',
  'before.del': 'Before deletion',
  'consolidate.departments.groups.title': 'The user already exists, Do you want to merge departments and roles?',
  merge: 'Merge',
  "dept.entry.tip": "Please fill in the department to join",
  'url.join.dept.tip': 'Visit the link to join the department directly',
  'dept.entry.tip1 ': ' At least one department needs to be selected ',
  'personnel.invitation': 'Personnel invitation',
  'personnel.invitation.tip': 'Have the right to invite all people',
  'member.invitation': 'Member invitation',
  'external.contact.invitation': 'External contact invitation',
  'personnel.deletion': 'Personnel deletion',
  'personnel.deletion.tip': 'Have the permission to delete all personnel',
  'member.deletion': 'Member deletion',
  'external.contact.deletion': 'External contact deletion',
  'department.external.group.deletion': 'Department/external contact group deletion',
  'department.external.group.deletion.tip': 'Have the permission to delete all department/external contact groups',
  'department.deletion': 'Department deletion',
  'group.deletion': 'External contact group deletion',
  "member.not.verify.tip1": 'There are <span style="color: #F5222D;margin:0 2px">{{num}}</span> mobile phones/email that have not been verified. <span class="inv" style="color: var(--bsy-base-color);cursor: pointer;">Verify them all again</span>',
  "click.ver": "Click to verify",
  "contact.note.title": "Title",
  manager1: "Admin",
  'join.time': 'Join time',
  'verified.phone.tip': 'Your phone has been verified. You cannot modify it. If you need to modify it, please contact the member to rebind it on the personal settings page.',
  'verified.email.tip': 'Your email has been verified. You cannot modify it. If you need to modify it, please contact the member to rebind it on the personal settings page.',
  "verify.all.tip": "Do you want to verify all unverified mobile mailboxes again?",
  "corp.management": "Corp management",
  "select.loginer.placeholder": "Select the login person",
  "applications.object.placeholder": "Select an application/object",
  "enter.old.password": "Enter the old password",
  "enter.new.password": "Enter a new password",
  "enter.again.new.password": "Re-enter the new password",
  "app.belong": "Application",
  "corp.log.tip": "Save the operation log of the last {{num}} months",
  "remind.setting": "Reminder settings",
  "operate.detail": "Operation details",
  "corp.login.time": "Log in time",
  "corp.login.member": "Login",
  "corp.login.city": "Login location",
  "corp.login.platform": "Login platform",
  "corp.login.info.tip": "Save login log for the last {{num}} months",
  "corp.login.statistics.info": "Statistics of the login status in the last 30 days",
  "corp.op.statistics.info": "Statistics of the operation situation in the last 30 days",
  "corp.op.statistics": "Operation statistics",
  "corp.login.statistics": "Login Statistics",
  "corp.usage.range": "Statistical scope",
  "corp.usage.counts": "Number of people",
  "corp.usage.loginStats": "Daily logins",
  "corp.usage.times": "Frequency",
  "corp.usage.dataCreateStats": "Daily data creation number & times",
  "corp.usage.dataDownStats": "Daily file downloads & times",
  "corp.usage.dataExportStats": "Daily data export number & times",
  "corp.usage.dataUpdateStats": "Daily data modification number & frequency",
  "corp.usage.stats": "Daily users",
  "operate.object": "Operation object",
  "applications.object": "Object",
  "corp.log.app.filter": "Filter this app",
  "corp.log.object.filter": "Filter this object",
  "member.deleted": "Deleted member",
  "outsider.deleted": "Deleted outsider",
  "login.log": "Login log",
  "enterprise.log": "Enterprise Log",
  "platform.log": "Platform log",
  "application.log": "Application Log",
  "export.logs": "Export logs",
  "log.range": "Range",
  "log.type": "Type",
  "all.data.print": "Splice printing",
  "one.data.print": "Print one by one",
  "all.data.print.tip": "(All data is combined into a print file)",
  "one.data.print.tip": "(Each data is combined into a print file)",
  "data.printTemplate1": "Print Template",
  "data.printTemplate1.tip": "Please select a print template",
  "print.method": "Print method",
  "data.word": "Word Preview",
  "corp.coop": "Enterprise Interconnection",
  "corp.coop.authorization": "Enterprise Interconnection Authorization",
  "corp.coop.authorization.subtitle": "Enter and verify the mobile phone to authorize, and after authorization, you can realize online business collaboration with partners based on this platform.",
  "corp.coop.contact.request.already": "The other party has taken over your address book permissions, no need to repeat the operation.",
  "corp.coop.contact.request.already.title": "Contacts permissions have been handed over",
  "corp.coop.contact.request.fail": "The link is invalid and the address book permission cannot be transferred. Please contact the person in charge of the other company to resend it.",
  "corp.coop.contact.request.success": "The other party can help you manage members, and you can also take over the permissions again in the &quot;Contacts&quot;.",
  "corp.coop.contact.request.success.title": "Address Book Permissions Transferred Successfully",
  "corp.coop.manage.prev.tip": "The address book of the other party can be preset to host, and members can be added to the address book of the other party independently in the host state.",
  "contact.corp.all": "All companies",
  "contact.corp.connect.establish": "Establish a connection",
  "contact.corp.connect.established": "Connection established",
  "contact.corp.connect.expired.tip": "The link is invalid and the collaboration relationship cannot be established. Please contact the person in charge of the other party to resend the link.",
  "contact.corp.connect.expired.title": "Link has expired",
  "contact.corp.connect.fail": "Connection establishment failed",
  "contact.corp.connect.fail.creator": "Your mobile phone number is not the identity of the enterprise creator, and you cannot establish a connection relationship through this link, please contact the other party to confirm.",
  "contact.corp.connect.fail.detail": "Connection establishment failed",
  "contact.corp.connect.fail.permission": "The other party company no longer has the right to connect, please contact the other party to deal with it",
  "contact.corp.connect.fail.phone": "The mobile phone number is not matched, please contact the other party to confirm.",
  "contact.corp.connect.fail.tip": "The remaining connection quota of the other party's enterprise connection is insufficient, please contact the other party for processing.",
  "external.dept": "External company",
  "contact.handover": "External docking person",
  "contact.handover.add": "Add docking person",
  "contact.handover.add.again": "Add again",
  "contact.handover.add.again.fail": "The creator of this enterprise has not been authorized, and this member cannot be added temporarily. Please invite the creator to establish a connection before adding",
  "corp.coop.empty.tip1": "Through the [Internet Organization] function, external partners such as distributors, suppliers, parent companies and subsidiaries can be connected",
  "corp.coop.empty.tip2": "After connecting, you can assign your form/process authority to the other party, and complete inter-enterprise data reporting, process approval, etc. online",
  "corp.coop.empty.tip3": "Come and connect with partners to improve the efficiency of inter-enterprise collaboration",
  "contact.connection.new": "New connection",
  "contact.connection.new.link": "Public link invitation",
  "contact.connection.new.multi": "Bulk import invitations",
  "contact.connection.remove": "Disconnect",
  "contact.connection.remove.confirm.tip": "After the connection is disconnected, business collaboration with the enterprise cannot be carried out, and this operation cannot be restored.",
  "contact.connection.remove.confirm.title": "Are you sure you want to disconnect?",
  "contact.connection.remove.empty": "Please select the company to be disconnected",
  "contact.connection.selected.remove": "Determined and selected companies to disconnect?",
  "contact.connection.selected.remove.tip": "After the connection is disconnected, business collaboration with the corresponding enterprise cannot be carried out, and this operation cannot be restored.",
  "contact.connection.tip.url.msg": "You need to send an invitation link when connecting to the other party. You currently have no link available. Please configure it and try again.",
  "contact.connection.tip.url.title": "No invite link available",
  "contact.connection.upgrade.tip.manager": "The number of connected companies has reached the upper limit. You can contact the company creator to upgrade the version, or remove useless connections and create a new one.",
  "contact.connection.upgrade.tip.owner": "System usage is restricted. Do you want to upgrade now?",
  "contact.connection.vip.upgrade": "The version you are currently using does not include the enterprise interconnection function. You can go to 「Enterprise Management-Version Information」 to view version usage details and upgrade versions.",
  "contact.connection.vip.upgrade.manager": "The version you are currently using does not include the enterprise interconnection function, please contact the company creator to upgrade the version.",
  "dept.label.add": "Add corporate tags",
  "contact.handover.all": "All docking people",
  "contact.handover.click.select": "Click to select the docking person",
  "contact.handover.corp": "Owned Enterprise",
  "contact.handover.corp.empty": "Please select the company to which the counterparty belongs",
  "contact.handover.corp.placeholder": "Required, please select the company to which the partner belongs",
  "contact.handover.current": "Our counterpart",
  "contact.handover.current.add.tip": "Setting up our docking person allows different employees to dock with different connected companies and facilitate business collaboration.",
  "contact.handover.empty": "No jobs in this category",
  "contact.handover.export.all": "Export all",
  "contact.handover.guest": "Managed external contacts",
  "contact.handover.guest.empty": "The docking person is generally responsible for business collaboration between enterprises. You can assign the company's application/form permissions to the docking person of the connected company to carry out related collaboration matters. Please contact the person in charge of the other party to set up a docking person.",
  "contact.handover.host": "View-only external docking person",
  "contact.handover.host.empty": "The manager of the other party has not set up a docking person",
  "contact.handover.invite.tip": "There are {{count}} matchers in the hosting address book company who have not joined",
  "contact.handover.list": "Matching people list",
  "contact.handover.name": "Contact person&#39;s name",
  "contact.handover.name.required": "Please enter the name of the matcher",
  "contact.handover.name.too.lang": "The name of the docking party can be up to 80 characters long",
  "contact.handover.not.join.tip": "{{count}} matchers are not authorized to join the company",
  "contact.handover.other": "Counterparty",
  "contact.handover.phone.required": "Please enter phone number",
  "contact.handover.role": "Docker role",
  "contact.handover.role.empty": "There is currently no role, please create",
  "contact.handover.title": " has the following jobs, which can be transferred to other members as needed",
  "contact.is.owner": "Is the creator",
  "label.list": "Label list",
  "label.name": "Label name",
  "label.name.input": "Please enter a label name",
  "label.name.notEmpty": "Label name cannot be empty",
  "label.name.notSame": "Label name cannot be repeated",
  "label.name.tooLong": "Label name cannot exceed {{length}} characters",
  "label.select1": "Click to select the enterprise label",
  "label.target.add.max": "Add up to {{count}} business tags",
  enterprise: "Enterprise",
  "contact.docker.empty": "No matchmaking",
  "contact.docker.empty.tip": "No related match",
  "contact.docker.invite.success.tip": "Add invitation sent successfully",
  "contact.docker.our.edit.tip": "Our docking person can directly participate in the collaboration of interconnected enterprises, and it cannot be restored after modification.",
  "contact.docker.our.edit.title": "Are you sure to modify our docking person?",
  "contact.docker.remove.tip": "After removal, the docking person can no longer participate in the business collaboration with this connected company, and this operation cannot be restored.",
  "contact.docker.remove.title": "Are you sure to remove this matcher?",
  "contact.docking.corp": "Docking enterprise",
  "contact.docking.corp.tip": "Docking all companies that have established a connection relationship with the future",
  "contact.docking.people": "Docking people",
  "contact.docking.people.require": "Please select the docking person",
  "member.invite.phoneOrEmail.placeholder": "Please enter mobile numbers or emails to invite members. Use commas, semicolons, or line breaks to separate multiple members. You can send up to 3 invitations to a mobile number or email",
  "member.invite.public.link": "Invite by link",
  "member.invite.public.setLink": "Set Up Links",
  "member.invite.public.setLink.text": "It is recommended to define the business label, role, and other attributes before sharing, which reduces the maintenance cost after connection established.",
  "member.invite.public.tip.title": "Applicable scenarios for public invite links",
  "member.invite.public.tip1": "If partners already have {{productName}} accounts, they can only be invited via public links. It is recommended to send links via WeCom.",
  "member.invite.public.tip2": "If partners want to use {{productName}} on DingTalk/WeCom/Lark, they need to first complete the docking on the corresponding platform before inviting them through public links.",
  "member.invite.public.tip3": "If partners have no {{productName}} accounts, they can be invited via public links for signup.",
  "member.invite.qrcode.brief": "Dear Partner, please kindly scan the QR code to establish collaboration (via {{productName}}) with my company. This will enable us with across-businesses data submit, workflow approval, etc.",
  "member.invite.report": "You can publish a report for him/her to view.",
  "member.invite.role": "You can assign different roles to him/her for participating in the business management.",
  "member.invite.send": "Send Invitation",
  "member.invite.sms.send": "Send Invitation via SMS",
  "member.invite.success": "Invited successfully!",
  "member.invite.tip": "Invite members to manage your business together",
  "member.invite.title": "There\'s no member in this company/team. Would you like to invite someone?",
  "contact.connection.link.tip": "The default settings for partner companies/contacts invited through this link are as follows",
  "persona.corp.dept.label": "Tag",
  "manager.contactAuth": "Contacts",
  "link.add": "Add Link",
  "link.address": "Link",
  "link.copy.success": "Link copied",
  "link.edit": "Edit Link",
  "link.edit.fail": "Editing multiple links at the same time is not allowed. Please save the changes and try again",
  "link.failure": "Link expired",
  "link.qrcode": "Link QR code",
  "link.share": "Share link",
  "openLink.auth.name.enterprise": "Company name",
  "corp.search": "Search for companies",
  "corp.team.name": "Company/Team Name",
  "corp.coop.delete.tip": "Deleting the enterprise tag will not delete the docking enterprise contained in this enterprise tag.",
  "corp.role.delete.tip": "Deleting a role will delete the role's permissions at the same time, but will not delete the docking person contained in this role.",
  "contact.corp.panel.tip": "This page displays the partner companies you invited. After the invitation is successful, you can assign form/workflow permissions to them to collaborate",
  "contact.handover.panel.tip": "This page displays the partner companies you invited. After the invitation is successful, you can assign form/workflow permissions to them to collaborate",
  "function.intro.detail": "Function detail",
  "label.dept.new": "Add company",
  "label.set": "Set Tag",
  "role.set": "Set Role",
  "remove.out": "Remove",
  "invite.link": "Link invitation",
  "qrCode.download": "Download QR code",
  "contact.escrow.setting.tip": "You can manage contacts of the partner company and add members to their contact list",
  "label.setting": "Set up corporate labels",
  "contact.corp.handover.set": "Set up the docking person",
  "link.state":"Link Status",
  "links.at.least.one":"Keep at least a link",
  "corp.coop.manage.apply.tip":"You don\'t have permission to manage the partner company\'s contact list. Unable to add contact.Please contact them to add or apply to manage their contact list",
  "corp.coop.dept.manage.apply.tip":"You don\'t have permission to manage the department company\'s contact list. Unable to add contact.Please contact them to add or apply to manage their contact list",
  "wechat.official.account.follow.instruction":"Search or scan the QR code to follow the {{productName}} official account, to view information and handle tasks in real time on mobile.",
  "wechat.qrcode.instruction":"Scan the code with WeChat</br>\\nLong press the code to identify it in WeChat.",
  "wechat.rebind.tip":"Current account has already been linked with other WeChat account. Would you like to link to this WeChat account instead?",
  "contact.corp.connect.fail.title":"Failed to set up collaboration with business",
  "contact.corp.connect.fail.wrong.phone":"The mobile number you are using doesn\'t belong to the business owner or has already been used to sign up accounts. Unable to establish a connection with this link, please reach out to the other business.",
  "contact.corp.connect.member.tip1":"You are not a super admin/business owner of the business, or don\'t have permissions on Customers and Clients. Unable to connect",
  "contact.corp.connect.member.tip2":"Please switch to the business in which you are the owner, a super admin, or have permissions on Customers and Clients if you\'d like to proceed",
  "contact.corp.connect.no.corp":"There\'s no business under this account. Please create or join a new business before continuing",
  "contact.corp.connect.query.tip":"Once connection established, internal members will be allowed to access permitted apps/forms from collaborators. This helps with data submit, workflow approvals and other tasks between businesses.",
  "contact.corp.connect.query.title":"\"{{name}}\" would like to connect to your business and collaborate with you. Establish a connection?",
  "contact.corp.connect.self.tip1":"The link is shared from the current business. You can\'t establish connections with your own business",
  "contact.corp.connect.self.tip2":"Please select another business if you\'d like to continue",
  "contact.corp.connect.success":"Connection successfully established",
  "contact.corp.connect.success.register":"Signed up and built collaboration relationship successfully.",
  "contact.corp.connect.success.tip":"You business partners are already using {{productName}} to carry out internal business management tasks. You can start collaborating on tasks using {{productName}}. Best regards!",
  "contact.corp.connect.success.tip1":"Business collaborators (in {{productName}}, \"Contacts\") need to be configured",
  "contact.corp.connect.success.tip2":"You can set up contacts now, or update them later in Contact -> Customers and Clients",
  "contact.corp.connect.success.title":"Business collaboration successfully established",
  "contact.corp.docker.set.success":"Completed contact setup",
  "contact.corp.empty":"This type of business is not connected yet",
  "contact.corp.empty.tab":"There\'s no business yet",
  "contact.corp.link.query.tip":"After the connection relationship is established, you can use applications/forms and other content produced by the other party to complete inter-enterprise data filling, process approval, etc. If you already have a {{productName}} account, please Log in directly to establish a connection. If you don’t have an account, please register first.",
  "contact.corp.link.query.title":"Enterprise \"{{name}}\" would like to establish an enterprise connection with you based on {{productName}} for business collaboration. ",
  "contact.corp.list":"Corporate list",
  "contact.corp.not.connection.single":"The creator of this company has not authorized the establishment of a connection relationship",
  "contact.corp.owner.info":"Creator: {{name}}",
  "contact.corp.link.query.login":"Already have an account. Sign in",
  "contact.corp.link.query.register":"Sign up",
  "contact.corp.handover.set.not": "Not set temporarily",
  "contact.corp.has.connect.tip1": "Connected to the business \"{{name}}\"",
  "contact.corp.has.connect.tip2": "Please contact the admin of the other party to share app/form permissions with you for data submission, workflow approval and other tasks between businesses.",
  "contact.learn.bs": "What is {{productName}}",
  "receiver.enter.homepage": "Go to {{productName}}",
  "corp.joined1": "You have successfully joined {{corp}}",
  "contact.corp.not.connection.tip": "<b style=\"color:#FF634E;font-weight: normal; \">{{count}}</b> imported businesses did not agree to connect",
  "member.invite.link.change": "Edit invitation link",
  "member.invite.link.copy": "Copy the invitation link",
  "contact.docker.email.verify.tip": "The email is not verified and cannot receive messages. Please contact the member to log in to {{productName}} for verification.",
  "contact.docker.phone.verify.tip": "The mobile phone is not verified and cannot receive messages. Please contact the member to log in to {{productName}} for verification.",
  "label.select": "Click to select the enterprise label",
  "member.invite.copy.link": "Dear partners, I sincerely invite you to establish a connection relationship with me, and realize inter-enterprise data reporting, process approval, etc. based on {{productName}}. Look forward to working with you! \nInvited by: {{name}} \nInvitation Link: {{link}}",
  "member.invite.copy.link.brief": "Dear partners, I sincerely invite you to establish a connection relationship with me, and realize inter-enterprise data reporting, process approval, etc. based on {{productName}}.",
  "contact.corp.host": "Connected to Me",
  "contact.corp.some": "Some companies",
  "contact.escrow": "Hosting Address Book",
  "escrow.disabled": "Not hosted",
  "docker.role.setting": "Set the docking person role",
  "member.invite.public.link.success.tip": "Try linking a chief administrator to better arrange the details and permission for the collaboration.",
  "configuration.success": "Successfully Configured.",
  "link.not.yet": "Do Not Link",
  "label.dept.empty.corp.tip": "Categorize the invited partners by tabs, such as suppliers, distributors, etc. No connected partner under the tab. Please add.",
  "label.dept.empty.tip": "No connected business under the current label",
  "role.current.member.empty.add": "There’ no member in the current role. Please add members",
  "contact.external.role.list": "List of external roles",
  "organization.internal": "Internal",
  "organization.external": "External",
  "organization.interconnected": "External",
  "contact.template.corp.cooperation.tip.1": "You can batch import partners when they don\'t have {{productName}} accounts and prefer not to sign up themselves.",
  "contact.template.corp.cooperation.title": "Applicable scenarios for batch import invitations",
  "contact.template.corp.import.tip": "Maximum {{corpCount}} can be imported at a time, and each business allows importing up to {{memberCount}} members",
  "contact.template.download": "Download Template",
  "contact.template.download.tip": "Please download {{link}} and edit it as per the format before importing",
  "contact.template.import.after": "Invitations will be sent via SMS once successfully imported. Collaborators can establish connections by simply clicking on the link contained in the SMS message",
  "contact.template.import.link": "You can share the link below with the owner of your partner via WeChat. The partner can then follow the official account and establish the collaboration with you.",
  "file.select.detail": "Select or drag to upload files, within {{num}}MB of a single",
  "create.after.excel.import": "Generated after successfully imported into Excel",
  "error.19004": "There\'s no connection with the target business",
  "error.19008": "This name already exists. Please choose a different name and try again",
  "error.19013": "Add up to 20 contacts",
  "error.19014": "No partner to import from the file. Fix it and try again.\\n",
  "error.19017": "This user is already the business contact, no need to add again",
  "error.19019": "Role name can\'t be the same",
  "error.19020": "Add up to 200 roles",
  "error.19021": "You can send invitation once a day. Please try again tomorrow",
  "corp.import.complete": "{{count}} companies successfully imported",
  "corp.import.complete.docker.fail": "Successfully imported {{count}} companies, but some members were not imported",
  "corp.import.not.complete": "{{successCount}} companies were successfully imported, but <i style=\"color: var(--bsy-base-error-color)\">{{failCount}}</i> companies failed",
  "app.dock": "External application",
  "corp.label.empty.tip": "Enterprise label name cannot be empty",
  "corp.role.empty.tip": "The recipient name cannot be empty",
  "corp.label.max.tip": "Enterprise label names cannot exceed {{length}} characters in length",
  "corp.role.max.tip": "The maximum length of the recipient name cannot exceed {{length}} characters",
  "contact.role.notEmpty": "The recipient role name cannot be empty",
  "contact.manage.auth.request": "Apply for Hosting Directory",
  "contact.manage.auth.request.success": "Escrow application sent",
  "contact.manage.auth.transfer": "Transfer escrow authority",
  "contact.manage.auth.transfer.msg": "After the handover, the right to add the counterparty will be lost, and the connected company will independently add the counterparty. This operation cannot be restored.",
  "contact.manage.auth.transfer.title": "Are you sure you want to transfer the escrow authority?",
  "contact.member.join.success.tip": "You can fill in data, approval process, etc. together with colleagues in [{{productName}}], and work collaboratively online to improve work efficiency.",
  "contact.member.join.success.title": "Successfully joined the company",
  "message.sended": "The added message has been sent",
  "contact.handover.add.all.again": "Add all again",
  "contact.connect.host.corp": "Connect with other companies",
  "label.dept.remove.empty": "Please select the docking company to be moved out",
  "label.dept.selected.remove": "Are you sure to remove the selected docking company from this company label?",
  "label.dept.selected.remove.tip": "Removing the selected docking company from this tab will not release the connection established with it.",
  "contact.our.docker.remove.empty": "Please select the matcher to remove",
  "contact.our.docker.remove.out.empty": "Please select the matcher to be removed",
  "contact.our.docker.remove.tip": "After the removal, the docking person can no longer participate in the collaboration of the interconnected enterprise, and this operation cannot be undone.",
  "contact.our.docker.remove.title": "Are you sure to remove the selected matcher?",
  "contact.role.docker.remove.tip": "After being moved out, the docking person can no longer participate in the external enterprise collaboration related to this role, and this operation cannot be restored.",
  "contact.role.docker.remove.title": "Are you sure to remove the selected matchmaker from this role?",
  "contact.handover.role.add": "Add the role of the contact person",
  "contact.take.over": "Self-management of address book",
  "contact.take.over.msg": "After self-management, the cooperative enterprise will lose the relevant authority, and the person who cooperates with the other party's business cooperation needs you to maintain it independently. This operation cannot be undone.",
  "contact.take.over.tip1": "Your address book is temporarily managed by the collaborative company 「{corp}」, and you don’t have operation authority",
  "contact.take.over.tip2": "Click the button below to get permission, and then you can invite members, add departments, etc.",
  "contact.take.over.title": "Are you sure you want to manage the address book independently?",
  "contact.dailog.over.title": "Are you sure you want to leave the current page?",
  "contact.dailog.over.tip": "When you leave the page, the changes you make are not saved",
  "external.member.invite.tip1": "Once turned on, just visit this link to join the business and automatically become a matchmaker",
  "external.member.invite.tip2": "This link can be shared with the creator of the other enterprise, so that it can be distributed to relevant employees within the enterprise",
  "organization.external.user": "External user",
  "organization.internal.user": "Internal user",
  "organization.external.flow": "External flow",
  "organization.internal.flow": "Internal flow",
  "contact.search.name": "Search name",
  "corp.coop.manage.integrated.tip": "This business integrates {{productName}} with WeChat/DingTalk/Lark, and cannot add contact, please contact them to add it.",
  "dock.flow.todo": "External to-do",
  "signin.qrcode": "QR code login",
  "mobile.num.login": "Phone number login",
  "crm.authority": "Authority",
  "app.edit.child.group.create": "New subgroup",
  "app.edit.move.tip": "There are sub-groups in this group, which cannot be sorted by 「move」, please drag and drop to sort.",
  "main.department": "Main department",
  "system": "system",
  "trigger.create.app": "Push when new app is created",
  "trigger.create.form": "Push when creating a new form",
  "max.two.level.group": "Currently, only two levels of grouping can be supported at most",
  "page.error.tip": 'The System is having a little issue. Please contact the administrator for assistance.',
  "custom.dashboard.subtitle.layout": "Layout Components",
  "custom.dashboard.subtitle.left.bar": "Left Sidebar",
  "custom.dashboard.subtitle.middle.bar": "Single Column",
  "custom.dashboard.subtitle.page": "Page Components",
  "custom.dashboard.subtitle.right.bar": "Right Sidebar",
  "custom.dashboard.toast.empty": "Failed to save the configuration. Add a page component first.",
  "custom.dashboard.subtitle.tab.bar": "Tab container",
  "manage.dashboard.design": "Management Workbench",
  "set.worker.dashboard.design": "Set enterprise workbench",
  "create.dashboard.design": "New workbench",
  "create.dashboard.design.tip": "Please enter the workbench name",
  "select.dashboard.design": "Select workbench",
  "set.dashboard.design.auth": "Configuration permissions",
  "set.dashboard.design.auth.msg": "Add members and authorize them to view and use the workbench",
  "set.dashboard.design": "Set the workbench",
  "dashboard.design.delete.title": "Are you sure you want to delete the workbench \"{{name}}\"?",
  "dashboard.design.delete.tip": "Deleting the workbench will also delete the layout, forms, reports and data. This operation is irreversible!",
  "dashboard.design.auth.title": "Configure viewing permissions",
  "dashboard.design.auth.msg": "Members in this group can view and use this workbench",
  "close.custom.design": "Close my workbench",
  "design.custom.close.alert.title": "Are you sure you want to close my workbench?",
  "design.custom.close.alert.msg": "This will return my workbench to its default style and cannot be undone.",
  "design.custom.create.alert.title": "If you need to perform this operation, please save the current workbench first",
  "speedy.entry.settings": "Set quick entry",
  "speedy.entry.tab.component": "Component Properties",
  "speedy.entry.tab.entryItem": "Entry Attribute",
  "speedy.entry.tab.entryItem.emptyTip": "Click on the left to select the entry to set properties",
  "speedy.entry.title.overLength": "The title cannot exceed {{count}} characters",
  "speedy.entry.unnamed": "Unnamed quick entry",
  "speedy.entry.displayStyle": "entry style",
  "speedy.entry.entryList": "entry list",
  "speedy.entry.add.entry": "Add entry",
  "speedy.entry.add.title": "Add form application",
  "speedy.entry.add.max": "Add at most {count}",
  "app.form": "Form application",
  "print.file.name.custom": "custom name",
  "speedy.entry.entryItem.customIcon": "Custom icon",
  "speedy.entry.entryItem.openType": "Open method",
  "speedy.entry.entryItem.openType.current": "Current page",
  "speedy.entry.entryItem.openType.newPage": "New Page",
  "speedy.entry.entryItem.openType.tips": "Only effective on the computer side, the mobile side opens for the current page",
  "speedy.entry.entryItem.source": "entry source",
  "dash.report": "Analysis Report",
  "change.icon": "Change icon",
  "modify.system.icon": "System icon",
  "modify.upload.maxLimit": "Please select a jpg, jpeg，gif or png image within 5MB",
  "image.upload.size.tip": "Recommended size {{width}}*{{height}} pixels",
  "modify.upload.icon": "Choose to upload a new image",
  "avatar.image.change": "Change image",
  "change.switch.design": "Switch workbench",
  "dashboard.design.error.tip": "The workbench name cannot be empty",
  "my.dash": "My report",
  "add.my.dash": "Add my report",
  "my.chart.view.desc": "No unified configuration is required, members can add commonly used reports by themselves",
  "my.chart.favorites.desc": "No unified configuration is required, members can add commonly used reports by themselves",
  "icon.replacement.failed": "Custom icon replacement failed!",
  "icon.replacement.successful": "Custom icon replacement successful!",
  "speedyEntry.empty.tip": "Please add the entry in the component properties on the right side",
  "speedyEntry.card.style.horizontal":"Card style horizontal",
  "speedyEntry.card.style.row":"Card style vertical row",
  "speedyEntry.card.list.style":"List style",
  "design.warning.msg": "The custom workbench name cannot be empty",
  "design.warning.msg1": "The length of the custom workbench name cannot exceed 26 characters",
  "flow.time.start": "Process initiation time",
  "flow.my.transactors.time": "The time of the node I recently processed",
  "flow.my.cc.time": "Node CC Time",
  "user.relation": "Membership",
  "add.user.relation": "Click to add members",
  "add.relation.user": "Add membership",
  "add.relation": "New membership relationship name",
  "new.relation": "New relationship",
  "relation.duplicate.name": "Relationship names cannot be repeated",
  "relation.empty.name": "Relationship name cannot be empty",
  "join.all.tip": "Do you want to invite all unjoined members again?",
  "contact.handover.other.dept": "Other contact department",
  "contact.handover.current.dept": "Our docking department",
  "contact.docker.dept.empty": "No docking department yet",
  "removal1": "remove",
  "close.detail": "Close details",
  "contact.docker.dept.user.empty": "There are currently no members in the docking department",
  "relation.save.user.tip": "There is an incomplete membership relationship, please check before saving",
  "relation.name": "relationship name",
  "user.relation.list": "Member relationship list",
  "widget.dept.clickToSelect1": "Select department",
  "widget.user.clickToSelect1": "Select members",
  "change.flow.node.tip":"Change the current node of the process and the person in charge of the node.",
  "flow.transfer.tip":"Adjust the person in charge of the current node of the process.",
  "reference.relationship.query":"Reference relationship query",
  "referenceByFormList.label":"Referenced object",
  "referenceExtend.label":"plug-in",
  "referenceFormList.label":"reference object",
  "referenceMode.label":"location",
  "referenceType.label":"relationship",
  "byReference.label": "Reference method:",
  "byReference.item1": "This table refers to other objects",
  "byReference.item2": "Reference this table elsewhere",
  "byFormInfo.label":"Referenced object",
  "extendInfo.label":"Plug-in information",
  "formInfo.label":"Reference object",
  "modeInfo.label":"Reference location",
  "typeInfo.label":"Reference relationship",
  "detailsInfo.label": "Details",
  "form.filter": "Query this form",
  "reference.filter": "Query this plug-in",
  "view.reference.detail": "View reference details",
  "reference.relationship": "reference relationship",
  "reference.empty.text": "In some complex businesses, a form is usually used in association with other forms, data views, aggregate tables, data assistants, plug-ins, etc. for data collaboration and reference. Through the \"reference relationship\", that is The relationship between forms can be viewed, making it easier for administrators to manage and maintain. ",
  "reference.open.text": "Open reference object query",
  "reference.opening.text": "The reference object query is being opened, please wait a moment...",
  "byReference.form.item1": "The current form refers to other objects",
  "byReference.form.item2": "Other objects reference the current form",
  "byReference.dash.item1": "The current report refers to other objects",
  "byReference.dash.item2": "Other objects reference the current report",
  "byReference.etl.item1": "The current view refers to other objects",
  "byReference.etl.item2": "Other objects reference the current view",
  "byReference.aggregate.item1": "The current aggregate table references other objects",
  "byReference.aggregate.item2": "Other objects reference the current aggregate table",
  "reference.relationship.view":"view mode",
  "relationship.detail":"citation details",
  "reference.relationship.view.tip":"This \"View Mode\" displays all the results of the current \"Query Mode\" page. If you want to see more, please use the \"Query Mode\" page turning function to view",
  "position.management":"position management",
  "position.name":"position name",
  "position.duplicate.name": "Position names cannot be repeated",
  "position.empty.name": "Position name cannot be empty",
  "position.length.max.name": "Position name cannot exceed 16 characters",
  "position.placeholder.name": "Please enter the position name",
  "relation.placeholder.name": "Please enter the relationship name",
  "position.add.batch": "Add new positions in batches",
  "position.del.tip.title": "Are you sure you want to delete the current position?",
  "position.del.tip.msg": "If the deletion is confirmed, the member's corresponding position will also be deleted",
  "position.add.tip1":"Position [{{name}}] has more than {{max}} characters",
  "position.add.tip2":"Position [{{name}}] already exists",
  "position.select.tip":"Please select a position",
  "config.info": "Configuration information",
  "push.method": "Push method:",
  "encryption.aes_key": "Encryption aes_key:",
  "signature.token": "Signature token:",
  "request.URL": "Request URL:",
  "event.subscription": "Event subscription:",
  "create.role.group": "Create role group",
  "role.group.name": "Role group name",
  "role.group.name.placeholder": "Please enter the role group name",
  "role.group.name.notEmpty": "The role group name cannot be empty",
  "role.group.name.tooLong": "The role group name cannot exceed {{length}} characters",
  "target.group": "target group",
  "role.group.remove.tip": "Non-empty role groups cannot be deleted",
  "and.sub.group": "And the role of the subgroup",
  "role.edit.group.moveTo": "Move to the \"{{- groupName}}\" group",
  "Role.group.ID": "Role group ID",
  "gzt": "GanZhengTong",
  "user.in.dept": "Member's department",
  "all.dept": "All departments",
  "deactivated": "Deactivated",
  'deactivate.error.tip': 'Creator/Administrator/Inviting Members cannot perform deactivation operation',
  'deactivate.error.tip2': 'There are no deactivated members',
  'deactivate.alert.tip': 'Are you sure you want to deactivate the selected member? ',
  'deactivate.alert.tip1': 'After deactivating a member, the member cannot access this enterprise(Selected: {{length1}} members, deactivable: {{length2}} members)',
  'enable.error.tip': 'Creator/Administrator/Inviting Members cannot perform enablement operation',
  'enable.error.tip2': 'No enabled members',
  'enable.alert.tip': 'Are you sure you want to enable the selected member? ',
  'enable.alert.tip1': 'After enabling a member, the member can access the enterprise and restore all permissions(Selected: {{length1}} members, enabled: {{length2}} members)',
  'frozen.switch.tip': 'The default authorization status of the synchronized new member account is',
  'enable.success.tip': 'Successfully enabled {{length}} members ({{users}}), and the members\' access rights will be restored',
  'deactivate.success.tip': 'Successfully deactivated {{length}} members ({{users}}), and the deactivated members\' access rights will be restricted',
  'select.approval.dept': 'Select approval department',
  'select.approval.dept.tip': 'You are a member of multiple departments, please select the department that needs the approval process',
  'select.approval.dept.tip1': 'Please select the department that needs the approval process',
  'select.approval.dept.tip2': 'Please select the department',
  'group.id': "group ID",
  'dashboard.see.more':'See More',
  'dashboard.link.type':'Link Yype',
  'dashboard.open.internal.page':'Open internal pages',
  'dashboard.open.external.link':'Open external links',
  'dashboard.dynamic.data.source':'Dynamic data source',
  'dashboard.static.data.source':'Static data source',
  "dataload.tree.tip1":"Expand the folder to view more data content",
  "dataload.tree.tip2":"Result",
  "installation.package.update": "Installation package updates application",
  "installation.package.update.title": "Please click to upload the installation package to update this application",
  "installation.package.update.re": "Replace the installation package",
  "installation.package.update.tip": "Please re-upload the installation package to update this application",
  "virtual.address.book": "Virtual address book",
  "virtual.address.book.msg": "*Virtual address book is used for the design of standard applications. You need to publish and update the mapping relationship of the virtual address book before you can use it.",
  "name.correspondence.settings": "Name correspondence settings",
  "outsider.member": "External contact member",
  "virtual.add": "Add {{name}}",
  "virtual.add.title": "Add {{name}} information",
  "virtual.add.name.placeholder": "Please enter the name of {{name}}",
  "virtual.add.describe.placeholder": "Please enter the description",
  "virtual.add.name.tip": "The name can only contain Chinese, English, numbers and underscores, and the maximum length is 128 characters",
  "virtual.edit.title": "Edit {{name}} information",
  "virtual.delete.title": "Confirm to delete \"{{name}}\" {{type}}? ",
  "virtual.name.correspondence.settings": "Virtual address book name correspondence settings",
  "corresponding.address.book.dept": "Corresponding address book department",
  "select.role": "Select role",
  "select.outsiderGroup": "Select external contact group",
  "select.outsider.member": "Select external contact member",
  "corresponding.member": "Corresponding address book member",
  "corresponding.role": "Corresponding address book role",
  "corresponding.outsiderGroup": "Corresponding address book external contact group",
  "corresponding.outsider.member": "Corresponding address book external contact member",
  "test.version": "Test version",
  "test.app.edit": "Standard application editing",
  "release.management": "Release management",
  "release.set": "Release settings",
  "release.install.update.log": "Installation update log",
  "release.user.management": "Installation user management",
  "install.package.mode": "Installation package mode",
  "download.install.package": "Download installation package",
  "custom.user.install": "Custom user installation",
  "custom.user.install.msg": "*Only allow certain users on certain sites to use the installation package",
  "install.package.mode.msg": "*Export the installation package and install it at will",
  "project.release.management": "Release project management",
  "project.release.management.list": "Release project list",
  "add.project.release.management": "Release new project",
  "add.project.release.management.type": "Add category",
  "project.name": "Project name",
  "project.remark": "Project description",
  "Project.name": "Project name:",
  "Project.remark": "Project description:",
  "Select.release.standard.app": "Application packaged in the current version:",
  "project.name.placeholder": "Please enter the project name",
  "project.remark.placeholder": "Please enter the project description",
  "project.group.name": "Project category name",
  "project.info.enter": "Fill in project information",
  "project.info": "Project information",
  "project.management": "Management",
  "project.create": "Application creation",
  "unbind.key": "Generate key to unbind",
  "unbind.key.not.empty": "key cannot be empty",
  "unbind.key.hint": "Please enter the unbind key",
  "unbind.key.error": "Unbinding key error, please re-enter",
  "unbind.validate.hit": "Please enter [Confirm unbind] to complete the last operation",
  "unbind.validate.text": "Confirm unbind",
  "select.release.standard.app": "Select the standard application to be released",
  "select.release.standard.app.waterMark": "Please select the standard application to be released",
  "project.set": "Project settings",
  "project.init.version": "Project initialization version number:",
  "init.set": "Initial settings",
  "select.user.install": "Select installable users:",
  "allow.anyone.install": "Allow anyone to install",
  "only.allow.user.install": "Only allow specified users to install",
  "user.management": "User management",
  "trial.time.after.first.installation": "Trial time after first installation:",
  "installation.notes": "Installation notes",
  "installation.notes.placeholder": "Please enter installation instructions",
  "not.limited": "Unlimited",
  "release.new.version": "Release new version",
  "install.log": "Installation log",
  "history.version": "Historical version",
  "project.version": "Version ",
  "project.site": "Site",
  "project.user.account": "User account",
  "project.user.name": "User nickname",
  "current.version": "Current version",
  "add.user": "Add user",
  postpone: "Postpone",
  "disable.restore": "Disable/Restore",
  "unbind.management": "Unbind management",
  "project.user.detail": "User details",
  "user.site": "User site",
  "user.account": "User account",
  "user.name": "User nickname",
  "begin.install.time": "Start installation time",
  "end.update.time": "Last update time",
  "project.note": "Note",
  "project.state": "State",
  "project.unbind.key": "Unbind key",
  "project.unbind.key.clear": "Clear unbind key",
  "project.debug": "Debug",
  "project.debug.token.title": "Debug permission",
  "project.debug.token": "token：{{token}}",
  "project.debug.token.time": "Valid time：{{time}} hours",
  "project.debug.token.permanent": "Valid time：Permanent",
  "project.debug.token.clear": "Clear debug token",
  "project.debug.token.generate": "Generate debug token",
  "project.debug.token.effective.time.error": "Effective time cannot be 0",
  "project.debug.token.empty": "Token not empty",
  "project.debug.token.error": "Token Error",
  "project.debug.token.tip": "Please enter the token to enable debugging functionality.",
  "effective.time": "Effective time",
  "project.update.state": "Whether to allow updates",
  "project.update.state.ing": "Allow",
  "project.update.stop.ing": "Allow", 
  "project.update.stop": "Stop",
  "project.update.restart": "Allow",
  "project.update.stop.tip": "Do you want to stop application updates?",
  "project.update.restart.tip": "Do you want to resume application updates?",
  "edit.note": "Edit note",
  "Operating.time": "Operating time:",
  "Operating.type": "Operation type:",
  "operating.cont": "Operation content",
  "please.enter.keyword": "Please enter keywords",
  "edit.project.release.management": "Edit name",
  "placeholder.project.site": "Please enter site name",
  "placeholder.project.user.account": "Please enter user account",
  "placeholder.project.user.name": "Please enter your user nickname",
  "placeholder.maturity.time": "Please select expiration time",
  "search.data.operation.record":"Search operation record",
  "placeholder.contact.note": "Please enter notes",
  "user.postpone": "User extension",
  "postpone.note": "Extension description",
  "postpone.time": "Extension time",
  "placeholder.postpone.note": "Please enter extension description",
  "placeholder.postpone.time": "Please select extension time",
  "placeholder.operating.time": "Please select operation time",
  "restore": "Restore",
  "query.restore.title": "Confirm to restore user \"{{name}}\"? ",
  "query.disable.title": "Confirm to disable user \"{{name}}\"? ",
  "query.disable.msg": "User disabling does not take effect immediately and will stop the user from using it within 24 hours. ",
  "unbind.management.msg": "Note: This mode will unbind the user's standard application management, allowing users to build their own. Users can enter the editing interface to design and edit applications, but cannot perform update operations. ",
  "install.version": "Installation version",
  "release.time": "Release time",
  "update.cont": "Update content",
  "doc.link": "Document link",
  "version.download": "Version download",
  "Latest.version.number": "Current latest version number:",
  "Applications.packaged.latest.version": "Latest version of packaged applications:",
  "Update.cont": "Update content:",
  "Doc.link": "Document link:",
  "placeholder.update.cont": "Please enter the update content",
  "placeholder.doc.link": "Please enter the document link",
  "maturity.time.msg": "*Selecting an empty value means permanent",
  "only.allow.user.install.msg": "*Switch to the [User Management] page to add users",
  "create.new.standard": "Create a new blank standard application",
  "create.new.standard1": "Select an existing application to convert to a standard application",
  "copy.standard.msg": "*Copy the normal application mode without affecting the use of the original normal application",
  "standard.search.placeholder": "Enter keywords to quickly search for apps",
  "has.standard.app.update": "There are apps to update",
  "go.update": "Go to update",
  "app.package.import.export": "Import and export app packages",
  "update.app": "Update apps",
  "update.project.app": "Update project apps",
  "Apps.need.update": "Apps that need to be updated:",
  "batch.export.app": "Batch export apps",
  "batch.import.app": "Batch import app installation packages",
  "app.batch.import-export":"Import and export app packages",
  "app.batch.import":"Import app package installation packages",
  "app.batch.import.tip":"Importing app packages",
  "app.batch.import.set":'Import settings',
  "app.batch.import.subtitle":"Import app package installation files",
  "app.batch.export":"Export app packages",
  "app.batch.export1": "Export App",
  "app.batch.export.title":"Batch export applications",
  "app.batch.export.set":"Export settings",
  "app.batch.export.title.tip":"Batch import and export multiple applications, views, aggregate tables and cross-application settings",
  "update.cont.tip": "Update content cannot be empty",
  "trial.time.after.first.tip": "The trial time after the first installation can only be between 0 and 99999",
  "all.standard.application": "All standard applications",
  "select.user.relation": "Select a member relationship",
  "corresponding.user.relation": "Corresponding address book member relationship",
  "select.release.app": "Select the application to be released",
  "select.release.app.waterMark": "Please select the application to be released",
  "batch.export.app.msg": "*Batch export applications do not include standard applications",
  "new.export.app": "New import",
  "del.project.group.title": "Do you want to delete this project category? ",
  "del.project.group.tip": "Only empty project categories can be deleted",
  "amap.sdk.load.fail":"Amap SDK failed to load, please contact the administrator for handling",
  "workbench.img.link":"Skip specified link",
  "workbench.noticeBoard.no":"The bulletin board is not configured",
  "workbench.noticeBoard.thare.style":"Other styles",
  "workbench.noticeBoard.title":"Title bar",
  "workbench.noticeBoard.dataSource":"Announcement content",
  "workbench.noticeBoard.setting":"Configuration bulletin",
  "workbench.noticeBoard.add":"Add bulletin",
  "workbench.noticeBoard.add.img":"Announcement drawing",
  "workbench.noticeBoard.add.outlin":"Content source",
  "workbench.noticeBoard.add.number":"Number of data bars",
  "workbench.noticeBoard.add.title":"Bulletin board title",
  "workbench.carouselMap.bg.title":"Picture fill mode",
  "workbench.myApp.title":"I manage the application",
  "app.group.repeat":"Group name cannot be repeated",
  "not.create.report": "You have not created any reports",
  "not.create.app.form.dash": "You have not created any app/form/dash",
  "setting.app.group": "Setting application group",
  "Graffiti": "Graffiti",
};
if (window.hasJarvisbim) {

  // 贾维斯本地版语言包的调整
  langEN['department.external.group.deletion'] = "Contract/external contact group deletion";
  langEN['department.deletion'] = "Contract deletion";
  langEN['enterprise.user.id'] = "Unique ID(Email)";
  langEN['disabled'] = "Disable";
  langEN['confirm'] = "confirm";
  langEN['my.dept'] = "My Contract";
  langEN['dash.mapChart.drilling.none'] = "Disable";
  langEN['department'] = 'Project/Contract';
  langEN['widget.dept'] = 'Project/Contract';
  langEN['switch.to.resignation'] = 'Disable User';
  langEN['dept.sub.add'] = 'Add Branch';
  langEN['del.department'] = 'Delete Branch';
  langEN['department.ID'] = 'Branch Id';
  langEN['reinstatement'] = 'Enable User';
  langEN['resign.user'] = 'Disabled Member';
  langEN['resign.time'] = 'Disable Time';
  langEN['resigned.user'] = 'Inactive';
  langEN['enterprise.userID'] = 'Unique ID(Email)';
  langEN['enterprise.tip2'] = "Please input user's email";
  langEN['email.entry.tip'] = "Please input user's email";
  langEN['phone.entry.tip'] = "Please input user's phone number";
  langEN['address.book.dept.set.title'] = "Set Job Title";
  langEN['dept.show.user'] = "Show Sub members";
  langEN['member.dept.alter'] = "Set-Proj./Contract";
  langEN['organization'] = "Proj./contract";
  langEN['member.select.list'] = "List of Project/Contract members";
  langEN['consolidate.departments.groups'] = 'Project/Contract/Role group processing method'
  langEN['dismission'] = 'Disabled'
  langEN['manager'] = 'Contract Admin'
  langEN['manager.normal'] = 'Contract Admin group'
  langEN['dismission.alert.tip'] = 'Are you sure to disable the selected members? '
  langEN['dismission.alert.tip1'] = 'After being converted to a disable member, when you join again with the same member number, you can restore the relevant configuration'
  langEN['resign.alert.tip'] = "Are you sure you want to restore the selected disabled members as active?"
  langEN['flow.Urge'] = 'Urgent'
  langEN['urge'] = 'Urgent'
  langEN['name.form.report'] = 'Form template'
  langEN['searchApp'] = 'Contract'
  langEN['current.node'] = 'Current Step:'
  langEN['error.4015'] = 'Operation failed, the candidate does not exist on the current step'
  langEN['error.5025'] = 'The current step has been transferred'
  langEN['field.chargers'] = '"Current Step/Action Party'
  langEN['flow.node.current'] = 'Current Step'
  langEN['flow.node.required'] = 'Current step can not be empty'
  langEN['platform.flow.currentNode.select'] = 'Please select the current step first'
  langEN['flow.current.node'] = 'Flow current step'
  langEN['select.node.tip'] = 'Please select 《current step first'
  langEN['empty.report.tip14'] = 'After selecting the current step, you can filter the process data through the visible fields of the node'
  langEN['flow.node.charger.more.tip'] = 'All the persons in charge of the current step have submitted all submissions before they are allowed to pass'
  langEN['"flow.node.charger.single.tip'] = 'Any person in charge of the current step is allowed to pass'
  langEN['flow.charger.current'] = 'Current action party'
  langEN['flow.transferTip'] = 'Only transfer the current action party of this data, and it does not affect the flow configuration.'
  langEN['flow.transfer.noChange'] = 'Current action party has not changed'
  langEN['flow.transfer.required'] = 'Current action party can not be empty'
  langEN['flow.currentTransfer'] = 'Current action party of this node'
  langEN['app.mine'] = 'My Project/Contract'
  langEN['app.template.owned'] = 'My Project/Contract templates'
  langEN['allapp'] = 'My Project/Contract'
  langEN['app.create.new'] = 'Create a new Project/Contract'
  langEN['app.create.empty.tip'] = 'Create a new Project/Contract from scratch'
  langEN['appEmpty'] = 'Currently you have no application, click on the top to create a new Project/Contract'
  langEN['app.set'] = 'Project/Contract settings'
  langEN['title.appSet'] = 'Project/Contract settings setting-{{- name}}'
  langEN['app.log'] = 'Project/Contract log'
  langEN['app.edit.appBridge'] = 'Cross-Project/Contract'
  langEN['app.set.bridge.emptyTip'] = 'Please select the form that needs to be used Cross-Project/Contract'
  langEN['role'] = 'Global Role'
  langEN['current.department'] = 'Current Group'
  langEN['current.department.sub'] = 'Current Group and sub-department'
  langEN['current.department.sub.heads'] = 'Current Group and sub-department heads'
  langEN['error.1102'] = 'The current group is not within the manageable range of the management group'
  langEN['member.search.emptyTip.public'] = 'There is no search result in the current group. Please check the search value or search in all members'
  langEN['widget.dept.listTitle'] = 'Project/Contract List'
  langEN['flow.close'] = 'Flow Mgt'
  langEN['vip.center.appBridge'] = 'Cross-Project/Contract'
  langEN['flow.transfer'] = 'Delegate';
  langEN['flow.activate'] = 'Revert';
  langEN["flow.state.closed"] = 'Flow Mgt';
  langEN["data.comment.placeholder"] = '{{key}}+Enter to send comments.';
  langEN["formula.remark"] = 'In view/assistant/data management formulas, when the formula parameter is a constant of string type, it must be marked with English single quotation marks. English double quotation marks are not supported';

}


export default langEN